import React from 'react';

const Trope4: React.FC = () => {
  return (
    <g
      className="prefix__trope-decor-4 prefix__trope-decor"
      transform="translate(135, 205)"
    >
      <g>
        <g>
          <g>
            <g>
              <path
                d="M1339.74,132.67c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1339.74,132.67Z"
                fill="#2f6840"
              />
              <path
                d="M1339.23,132.33c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.23-2.77,2.92-2.15,3.63,3.55,2.65,3.44-4.69,0-4.69,0,6,.86,4,1.54-3.31,2-4.36,1.72-1.17-2.9-1.17-2.9-.91,3.33-3,2.54-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1339.23,132.33Z"
                fill="#3ba525"
              />
              <path
                d="M1340,132.3a2.15,2.15,0,0,0-.79-.94c-.33-.26-.71-.45-1.07-.73a2.26,2.26,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A.93.93,0,0,1,1340,132.3Z"
                fill="#2f6840"
              />
              <path
                d="M1343.46,131.5c-.25,0-.49.05-.72.1a4,4,0,0,0-.68.18,11.31,11.31,0,0,0-1.35.52,2.42,2.42,0,0,1,1.24-.86A2.12,2.12,0,0,1,1343.46,131.5Z"
                fill="#2f6840"
              />
              <path
                d="M1342.09,134.71a1.9,1.9,0,0,0-.66-1c-.28-.28-.63-.5-1-.8a2.15,2.15,0,0,1,1.22.54,1.78,1.78,0,0,1,.4.57A.94.94,0,0,1,1342.09,134.71Z"
                fill="#2f6840"
              />
              <path
                d="M1340.14,132.76c-.25.06-.48.09-.7.16a3.15,3.15,0,0,0-.65.23,9.87,9.87,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,1340.14,132.76Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1337.08,141.4c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1337.08,141.4Z"
                fill="#2f6840"
              />
              <path
                d="M1336.57,141.06c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.92-2.15,3.63,3.55,2.65,3.44-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1336.57,141.06Z"
                fill="#3ba525"
              />
              <path
                d="M1337.32,141a2.15,2.15,0,0,0-.79-.94c-.33-.26-.71-.45-1.07-.74a2.32,2.32,0,0,1,1.28.46,1.71,1.71,0,0,1,.47.53A.93.93,0,0,1,1337.32,141Z"
                fill="#2f6840"
              />
              <path
                d="M1340.8,140.23c-.25,0-.49.05-.72.1a4,4,0,0,0-.68.18,12,12,0,0,0-1.35.52,2.54,2.54,0,0,1,1.24-.87A2.12,2.12,0,0,1,1340.8,140.23Z"
                fill="#2f6840"
              />
              <path
                d="M1339.43,143.44a1.9,1.9,0,0,0-.66-1c-.28-.28-.63-.5-1-.81a2.24,2.24,0,0,1,1.21.55,1.78,1.78,0,0,1,.4.57A.94.94,0,0,1,1339.43,143.44Z"
                fill="#2f6840"
              />
              <path
                d="M1337.48,141.49c-.25.06-.48.09-.7.16a3.83,3.83,0,0,0-.65.22,10,10,0,0,0-1.25.65,2.34,2.34,0,0,1,1.12-1A2,2,0,0,1,1337.48,141.49Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1331.72,136.44c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.55,14.55,0,0,1,1331.72,136.44Z"
                fill="#2f6840"
              />
              <path
                d="M1331.22,136.1c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1331.22,136.1Z"
                fill="#3ba525"
              />
              <path
                d="M1332,136.07a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1332,136.07Z"
                fill="#2f6840"
              />
              <path
                d="M1335.45,135.28c-.26,0-.49,0-.73.09a3.67,3.67,0,0,0-.67.18,11.31,11.31,0,0,0-1.35.52,2.42,2.42,0,0,1,1.24-.86A2.07,2.07,0,0,1,1335.45,135.28Z"
                fill="#2f6840"
              />
              <path
                d="M1334.08,138.49a1.82,1.82,0,0,0-.66-1c-.28-.29-.63-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.81,1.81,0,0,1,.41.57A1,1,0,0,1,1334.08,138.49Z"
                fill="#2f6840"
              />
              <path
                d="M1332.12,136.53c-.24.06-.47.09-.69.16a3,3,0,0,0-.65.23,9.87,9.87,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,1332.12,136.53Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1323.38,133.07c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.92,3.34-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1323.38,133.07Z"
                fill="#2f6840"
              />
              <path
                d="M1322.88,132.73c4.42-.25-4.33.45-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.72-1.16-2.91-1.16-2.91-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,1322.88,132.73Z"
                fill="#3ba525"
              />
              <path
                d="M1323.63,132.7a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.26,2.26,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1323.63,132.7Z"
                fill="#2f6840"
              />
              <path
                d="M1327.11,131.9c-.26,0-.5,0-.73.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.45,2.45,0,0,1,1.24-.87A2.13,2.13,0,0,1,1327.11,131.9Z"
                fill="#2f6840"
              />
              <path
                d="M1325.74,135.11a2,2,0,0,0-.66-1c-.28-.28-.64-.5-1-.81a2.21,2.21,0,0,1,1.21.55,1.64,1.64,0,0,1,.4.57A.89.89,0,0,1,1325.74,135.11Z"
                fill="#2f6840"
              />
              <path
                d="M1323.78,133.16c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,8.22,8.22,0,0,0-1.25.64,2.24,2.24,0,0,1,1.11-1A2,2,0,0,1,1323.78,133.16Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1338.09,148.56c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1338.09,148.56Z"
                fill="#2f6840"
              />
              <path
                d="M1337.58,148.22c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.92-2.15,3.63,3.55,2.65,3.44-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1337.58,148.22Z"
                fill="#3ba525"
              />
              <path
                d="M1338.33,148.19a2.15,2.15,0,0,0-.79-.94c-.33-.26-.71-.45-1.07-.74a2.35,2.35,0,0,1,1.28.46,1.71,1.71,0,0,1,.47.53A.93.93,0,0,1,1338.33,148.19Z"
                fill="#2f6840"
              />
              <path
                d="M1341.81,147.39c-.25,0-.49.05-.72.1a4,4,0,0,0-.68.18,11.31,11.31,0,0,0-1.35.52,2.54,2.54,0,0,1,1.24-.87A2.12,2.12,0,0,1,1341.81,147.39Z"
                fill="#2f6840"
              />
              <path
                d="M1340.44,150.6a1.9,1.9,0,0,0-.66-1c-.28-.28-.63-.5-1-.81a2.24,2.24,0,0,1,1.22.55,1.78,1.78,0,0,1,.4.57A.94.94,0,0,1,1340.44,150.6Z"
                fill="#2f6840"
              />
              <path
                d="M1338.49,148.65c-.25.06-.48.09-.7.16a3.83,3.83,0,0,0-.65.22,10,10,0,0,0-1.25.65,2.34,2.34,0,0,1,1.12-1A2,2,0,0,1,1338.49,148.65Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1324.63,143c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1324.63,143Z"
                fill="#2f6840"
              />
              <path
                d="M1324.12,142.65c4.43-.25-4.32.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.36,1.72-1.16-2.91-1.16-2.91-.91,3.34-3,2.55-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,1324.12,142.65Z"
                fill="#3ba525"
              />
              <path
                d="M1324.88,142.62a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.21,2.21,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A.94.94,0,0,1,1324.88,142.62Z"
                fill="#2f6840"
              />
              <path
                d="M1328.35,141.82c-.25,0-.49.05-.72.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.47,2.47,0,0,1,1.23-.87A2.12,2.12,0,0,1,1328.35,141.82Z"
                fill="#2f6840"
              />
              <path
                d="M1327,145a2,2,0,0,0-.66-1c-.29-.28-.64-.5-1-.81a2.24,2.24,0,0,1,1.21.55,1.64,1.64,0,0,1,.4.57A.94.94,0,0,1,1327,145Z"
                fill="#2f6840"
              />
              <path
                d="M1325,143.08c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,8.22,8.22,0,0,0-1.25.64,2.2,2.2,0,0,1,1.11-1A2,2,0,0,1,1325,143.08Z"
                fill="#2f6840"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M1352,108.39c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1352,108.39Z"
                fill="#2f6840"
              />
              <path
                d="M1351.47,108c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.44-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1351.47,108Z"
                fill="#3ba525"
              />
              <path
                d="M1352.23,108a2.15,2.15,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1352.23,108Z"
                fill="#2f6840"
              />
              <path
                d="M1355.7,107.22a5.43,5.43,0,0,0-.72.1,3.22,3.22,0,0,0-.68.17,12,12,0,0,0-1.34.53,2.41,2.41,0,0,1,1.23-.87A2.07,2.07,0,0,1,1355.7,107.22Z"
                fill="#2f6840"
              />
              <path
                d="M1354.34,110.43a2,2,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.16,2.16,0,0,1,1.21.54,1.73,1.73,0,0,1,.4.57A1,1,0,0,1,1354.34,110.43Z"
                fill="#2f6840"
              />
              <path
                d="M1352.38,108.47c-.25.06-.48.09-.7.16a3.48,3.48,0,0,0-.64.23,10.08,10.08,0,0,0-1.26.65,2.24,2.24,0,0,1,1.12-1A2,2,0,0,1,1352.38,108.47Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1349.32,117.12c4.43-.26-4.33.45-4.35-.62s4.35-2.62,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.34,14.34,0,0,1,1349.32,117.12Z"
                fill="#2f6840"
              />
              <path
                d="M1348.81,116.77c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1348.81,116.77Z"
                fill="#3ba525"
              />
              <path
                d="M1349.57,116.74a2.09,2.09,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1349.57,116.74Z"
                fill="#2f6840"
              />
              <path
                d="M1353,116c-.25,0-.49,0-.72.09a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.45,2.45,0,0,1,1.23-.86A2.07,2.07,0,0,1,1353,116Z"
                fill="#2f6840"
              />
              <path
                d="M1351.68,119.16a1.94,1.94,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.16,2.16,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A1,1,0,0,1,1351.68,119.16Z"
                fill="#2f6840"
              />
              <path
                d="M1349.72,117.2c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,9.24,9.24,0,0,0-1.25.64,2.2,2.2,0,0,1,1.11-1A2,2,0,0,1,1349.72,117.2Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1344,112.16c4.42-.25-4.33.45-4.35-.61s4.34-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1344,112.16Z"
                fill="#2f6840"
              />
              <path
                d="M1343.46,111.81c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.92,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1343.46,111.81Z"
                fill="#3ba525"
              />
              <path
                d="M1344.21,111.78a2.13,2.13,0,0,0-.79-.93c-.33-.27-.71-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1344.21,111.78Z"
                fill="#2f6840"
              />
              <path
                d="M1347.69,111c-.25,0-.49,0-.72.1a3.22,3.22,0,0,0-.68.17,12.12,12.12,0,0,0-1.35.53,2.48,2.48,0,0,1,1.24-.87A2.07,2.07,0,0,1,1347.69,111Z"
                fill="#2f6840"
              />
              <path
                d="M1346.32,114.2a1.9,1.9,0,0,0-.65-1c-.29-.29-.64-.51-1-.81a2.16,2.16,0,0,1,1.21.54,1.9,1.9,0,0,1,.4.57A1,1,0,0,1,1346.32,114.2Z"
                fill="#2f6840"
              />
              <path
                d="M1344.37,112.24c-.25.06-.48.09-.7.16a5,5,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.24,2.24,0,0,1,1.12-1A2,2,0,0,1,1344.37,112.24Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1335.63,108.79c4.42-.25-4.33.45-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,1335.63,108.79Z"
                fill="#2f6840"
              />
              <path
                d="M1335.12,108.44c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1335.12,108.44Z"
                fill="#3ba525"
              />
              <path
                d="M1335.87,108.41a2.08,2.08,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1335.87,108.41Z"
                fill="#2f6840"
              />
              <path
                d="M1339.35,107.62a5.21,5.21,0,0,0-.72.1,3,3,0,0,0-.68.17,9.91,9.91,0,0,0-1.35.53,2.44,2.44,0,0,1,1.24-.87A2.07,2.07,0,0,1,1339.35,107.62Z"
                fill="#2f6840"
              />
              <path
                d="M1338,110.83a1.82,1.82,0,0,0-.66-1c-.28-.29-.63-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.81,1.81,0,0,1,.41.57A1,1,0,0,1,1338,110.83Z"
                fill="#2f6840"
              />
              <path
                d="M1336,108.87c-.24.06-.47.09-.69.16a3.15,3.15,0,0,0-.65.23,11.39,11.39,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,1336,108.87Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1350.33,124.28c4.43-.26-4.33.45-4.35-.62s4.35-2.62,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.34,14.34,0,0,1,1350.33,124.28Z"
                fill="#2f6840"
              />
              <path
                d="M1349.82,123.93c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1349.82,123.93Z"
                fill="#3ba525"
              />
              <path
                d="M1350.58,123.9a2.09,2.09,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1350.58,123.9Z"
                fill="#2f6840"
              />
              <path
                d="M1354.05,123.11c-.25,0-.49,0-.72.09a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.39,2.39,0,0,1,1.23-.86A2.07,2.07,0,0,1,1354.05,123.11Z"
                fill="#2f6840"
              />
              <path
                d="M1352.69,126.32a1.94,1.94,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.16,2.16,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A1,1,0,0,1,1352.69,126.32Z"
                fill="#2f6840"
              />
              <path
                d="M1350.73,124.36c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,9.24,9.24,0,0,0-1.25.64,2.2,2.2,0,0,1,1.11-1A2,2,0,0,1,1350.73,124.36Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1336.87,118.71c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,1336.87,118.71Z"
                fill="#2f6840"
              />
              <path
                d="M1336.37,118.36c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1336.37,118.36Z"
                fill="#3ba525"
              />
              <path
                d="M1337.12,118.33a2.08,2.08,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1337.12,118.33Z"
                fill="#2f6840"
              />
              <path
                d="M1340.6,117.54c-.26,0-.49,0-.73.09a4,4,0,0,0-.68.18,10.33,10.33,0,0,0-1.34.53,2.4,2.4,0,0,1,1.24-.87A2.07,2.07,0,0,1,1340.6,117.54Z"
                fill="#2f6840"
              />
              <path
                d="M1339.23,120.75a1.88,1.88,0,0,0-.66-1c-.28-.29-.64-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A.92.92,0,0,1,1339.23,120.75Z"
                fill="#2f6840"
              />
              <path
                d="M1337.27,118.79c-.24.06-.47.09-.7.16a2.87,2.87,0,0,0-.64.23,10.56,10.56,0,0,0-1.25.64,2.24,2.24,0,0,1,1.11-1A2,2,0,0,1,1337.27,118.79Z"
                fill="#2f6840"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M1343.28,82.15c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1343.28,82.15Z"
                fill="#2f6840"
              />
              <path
                d="M1342.78,81.8c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45S1344,81,1344,81s1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1342.78,81.8Z"
                fill="#3ba525"
              />
              <path
                d="M1343.53,81.77a2.15,2.15,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.88,1.88,0,0,1,.48.53A1,1,0,0,1,1343.53,81.77Z"
                fill="#2f6840"
              />
              <path
                d="M1347,81a5.36,5.36,0,0,0-.73.1,3.22,3.22,0,0,0-.68.17,12,12,0,0,0-1.34.53,2.4,2.4,0,0,1,1.24-.87A2.07,2.07,0,0,1,1347,81Z"
                fill="#2f6840"
              />
              <path
                d="M1345.64,84.19a2,2,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.73,1.73,0,0,1,.4.57A.92.92,0,0,1,1345.64,84.19Z"
                fill="#2f6840"
              />
              <path
                d="M1343.68,82.23c-.25.06-.48.09-.7.16a3.48,3.48,0,0,0-.64.23,9.33,9.33,0,0,0-1.25.65,2.22,2.22,0,0,1,1.11-1A2,2,0,0,1,1343.68,82.23Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1340.62,90.88c4.43-.26-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.78,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.92,3.34-3,2.55-2.26-2.27-2.08-2.36A14.34,14.34,0,0,1,1340.62,90.88Z"
                fill="#2f6840"
              />
              <path
                d="M1340.12,90.53c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1340.12,90.53Z"
                fill="#3ba525"
              />
              <path
                d="M1340.87,90.5a2.09,2.09,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,2,2,0,0,1,.47.53A1,1,0,0,1,1340.87,90.5Z"
                fill="#2f6840"
              />
              <path
                d="M1344.35,89.71c-.26,0-.5,0-.73.09a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.44,2.44,0,0,1,1.24-.86A2.07,2.07,0,0,1,1344.35,89.71Z"
                fill="#2f6840"
              />
              <path
                d="M1343,92.92a1.94,1.94,0,0,0-.66-1c-.28-.29-.64-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A.92.92,0,0,1,1343,92.92Z"
                fill="#2f6840"
              />
              <path
                d="M1341,91c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,9.24,9.24,0,0,0-1.25.64,2.24,2.24,0,0,1,1.11-1A2,2,0,0,1,1341,91Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1335.27,85.92c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1335.27,85.92Z"
                fill="#2f6840"
              />
              <path
                d="M1334.76,85.57c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1334.76,85.57Z"
                fill="#3ba525"
              />
              <path
                d="M1335.52,85.54a2.15,2.15,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1335.52,85.54Z"
                fill="#2f6840"
              />
              <path
                d="M1339,84.75c-.25,0-.49,0-.72.1a3.22,3.22,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.41,2.41,0,0,1,1.23-.87A2.07,2.07,0,0,1,1339,84.75Z"
                fill="#2f6840"
              />
              <path
                d="M1337.63,88a2,2,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.1,2.1,0,0,1,1.21.55,1.6,1.6,0,0,1,.4.56A1,1,0,0,1,1337.63,88Z"
                fill="#2f6840"
              />
              <path
                d="M1335.67,86c-.25.06-.48.09-.7.16a4.41,4.41,0,0,0-.64.23,10.08,10.08,0,0,0-1.26.65,2.24,2.24,0,0,1,1.12-1A2,2,0,0,1,1335.67,86Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1326.93,82.55c4.42-.25-4.33.45-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,1326.93,82.55Z"
                fill="#2f6840"
              />
              <path
                d="M1326.42,82.2c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.92-2.16,3.63,3.56,2.65,3.44-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1326.42,82.2Z"
                fill="#3ba525"
              />
              <path
                d="M1327.17,82.17a2.13,2.13,0,0,0-.79-.93c-.33-.27-.71-.46-1.07-.74a2.34,2.34,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A.94.94,0,0,1,1327.17,82.17Z"
                fill="#2f6840"
              />
              <path
                d="M1330.65,81.38a5.43,5.43,0,0,0-.72.1,3.22,3.22,0,0,0-.68.17,9.91,9.91,0,0,0-1.35.53,2.48,2.48,0,0,1,1.24-.87A2.07,2.07,0,0,1,1330.65,81.38Z"
                fill="#2f6840"
              />
              <path
                d="M1329.28,84.59a1.82,1.82,0,0,0-.66-1c-.28-.29-.63-.51-1-.81a2.15,2.15,0,0,1,1.22.54,1.78,1.78,0,0,1,.4.57A1,1,0,0,1,1329.28,84.59Z"
                fill="#2f6840"
              />
              <path
                d="M1327.33,82.63c-.25.06-.48.09-.7.16a3.15,3.15,0,0,0-.65.23,11.39,11.39,0,0,0-1.25.64,2.27,2.27,0,0,1,1.12-1A2,2,0,0,1,1327.33,82.63Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1341.63,98c4.43-.26-4.33.45-4.35-.62s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.92,3.34-3,2.55-2.26-2.27-2.08-2.36A14.34,14.34,0,0,1,1341.63,98Z"
                fill="#2f6840"
              />
              <path
                d="M1341.13,97.69c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1341.13,97.69Z"
                fill="#3ba525"
              />
              <path
                d="M1341.88,97.66a2.09,2.09,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,2,2,0,0,1,.47.53A1,1,0,0,1,1341.88,97.66Z"
                fill="#2f6840"
              />
              <path
                d="M1345.36,96.87c-.26,0-.5,0-.73.09a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.44,2.44,0,0,1,1.24-.86A2.07,2.07,0,0,1,1345.36,96.87Z"
                fill="#2f6840"
              />
              <path
                d="M1344,100.08a1.94,1.94,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A.92.92,0,0,1,1344,100.08Z"
                fill="#2f6840"
              />
              <path
                d="M1342,98.12c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,9.24,9.24,0,0,0-1.25.64,2.24,2.24,0,0,1,1.11-1A2,2,0,0,1,1342,98.12Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1328.17,92.47c4.43-.25-4.32.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.55,14.55,0,0,1,1328.17,92.47Z"
                fill="#2f6840"
              />
              <path
                d="M1327.67,92.12c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1327.67,92.12Z"
                fill="#3ba525"
              />
              <path
                d="M1328.42,92.09a2.08,2.08,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1328.42,92.09Z"
                fill="#2f6840"
              />
              <path
                d="M1331.9,91.3a5.21,5.21,0,0,0-.72.1,3,3,0,0,0-.68.17,9.91,9.91,0,0,0-1.35.53,2.44,2.44,0,0,1,1.24-.87A2.07,2.07,0,0,1,1331.9,91.3Z"
                fill="#2f6840"
              />
              <path
                d="M1330.53,94.51a1.82,1.82,0,0,0-.66-1c-.28-.29-.63-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.81,1.81,0,0,1,.41.57A1,1,0,0,1,1330.53,94.51Z"
                fill="#2f6840"
              />
              <path
                d="M1328.57,92.55c-.24.06-.47.09-.69.16a3,3,0,0,0-.65.23,11.39,11.39,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,1328.57,92.55Z"
                fill="#2f6840"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M1320.66,65.16c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.92-2.16,3.63,3.56,2.65,3.44-4.69.05-4.69.05,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1320.66,65.16Z"
                fill="#2f6840"
              />
              <path
                d="M1320.16,64.82c4.42-.25-4.33.45-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,1320.16,64.82Z"
                fill="#3ba525"
              />
              <path
                d="M1320.91,64.79a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.74a2.29,2.29,0,0,1,1.28.46,1.88,1.88,0,0,1,.48.53A1,1,0,0,1,1320.91,64.79Z"
                fill="#2f6840"
              />
              <path
                d="M1324.39,64c-.26,0-.5.05-.73.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.45,2.45,0,0,1,1.24-.87A2.13,2.13,0,0,1,1324.39,64Z"
                fill="#2f6840"
              />
              <path
                d="M1323,67.2a2,2,0,0,0-.66-1c-.29-.28-.64-.5-1-.81a2.21,2.21,0,0,1,1.21.55,1.64,1.64,0,0,1,.4.57A.89.89,0,0,1,1323,67.2Z"
                fill="#2f6840"
              />
              <path
                d="M1321.06,65.25c-.25.06-.48.09-.7.16a3.45,3.45,0,0,0-.64.22,9.33,9.33,0,0,0-1.25.65,2.31,2.31,0,0,1,1.11-1A2,2,0,0,1,1321.06,65.25Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1318,73.89c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.92-2.16,3.63,3.56,2.65,3.44-4.69,0-4.69,0,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.92,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1318,73.89Z"
                fill="#2f6840"
              />
              <path
                d="M1317.5,73.55c4.42-.25-4.33.45-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,1317.5,73.55Z"
                fill="#3ba525"
              />
              <path
                d="M1318.25,73.52a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.29.46,2,2,0,0,1,.47.53A1,1,0,0,1,1318.25,73.52Z"
                fill="#2f6840"
              />
              <path
                d="M1321.73,72.72c-.26,0-.5,0-.73.1a5.2,5.2,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.45,2.45,0,0,1,1.24-.87A2.13,2.13,0,0,1,1321.73,72.72Z"
                fill="#2f6840"
              />
              <path
                d="M1320.36,75.93a2,2,0,0,0-.66-1c-.29-.29-.64-.5-1-.81a2.21,2.21,0,0,1,1.21.55,1.64,1.64,0,0,1,.4.57A.89.89,0,0,1,1320.36,75.93Z"
                fill="#2f6840"
              />
              <path
                d="M1318.4,74a6.56,6.56,0,0,0-.7.16,3.45,3.45,0,0,0-.64.22,9.33,9.33,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2,2,0,0,1,1318.4,74Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1312.65,68.93c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1312.65,68.93Z"
                fill="#2f6840"
              />
              <path
                d="M1312.14,68.59c4.43-.25-4.32.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.64,3.44-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.72-1.16-2.91-1.16-2.91-.91,3.34-3,2.55-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,1312.14,68.59Z"
                fill="#3ba525"
              />
              <path
                d="M1312.9,68.56a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.21,2.21,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1312.9,68.56Z"
                fill="#2f6840"
              />
              <path
                d="M1316.37,67.76c-.25,0-.49,0-.72.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.39,2.39,0,0,1,1.23-.86A2.12,2.12,0,0,1,1316.37,67.76Z"
                fill="#2f6840"
              />
              <path
                d="M1315,71a2,2,0,0,0-.66-1c-.29-.28-.64-.5-1-.81a2.24,2.24,0,0,1,1.21.55,1.64,1.64,0,0,1,.4.57A.94.94,0,0,1,1315,71Z"
                fill="#2f6840"
              />
              <path
                d="M1313.05,69c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,8.8,8.8,0,0,0-1.26.64,2.27,2.27,0,0,1,1.12-1A2,2,0,0,1,1313.05,69Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1304.31,65.56c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1304.31,65.56Z"
                fill="#2f6840"
              />
              <path
                d="M1303.8,65.22c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.23-2.77,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1303.8,65.22Z"
                fill="#3ba525"
              />
              <path
                d="M1304.55,65.19a2.15,2.15,0,0,0-.79-.94c-.33-.26-.71-.46-1.07-.74A2.27,2.27,0,0,1,1304,64a1.71,1.71,0,0,1,.47.53A.93.93,0,0,1,1304.55,65.19Z"
                fill="#2f6840"
              />
              <path
                d="M1308,64.39c-.25,0-.49,0-.72.1a4,4,0,0,0-.68.18,11.31,11.31,0,0,0-1.35.52,2.54,2.54,0,0,1,1.24-.87A2.12,2.12,0,0,1,1308,64.39Z"
                fill="#2f6840"
              />
              <path
                d="M1306.66,67.6a1.9,1.9,0,0,0-.66-1c-.28-.29-.63-.5-1-.81a2.24,2.24,0,0,1,1.22.55,1.78,1.78,0,0,1,.4.57A.94.94,0,0,1,1306.66,67.6Z"
                fill="#2f6840"
              />
              <path
                d="M1304.71,65.65a6.56,6.56,0,0,0-.7.16,3.83,3.83,0,0,0-.65.22,10,10,0,0,0-1.25.65,2.31,2.31,0,0,1,1.11-1A2.07,2.07,0,0,1,1304.71,65.65Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1319,81.05c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.92-2.16,3.63,3.56,2.65,3.44-4.69,0-4.69,0,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.92,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1319,81.05Z"
                fill="#2f6840"
              />
              <path
                d="M1318.51,80.71c4.42-.25-4.33.45-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,1318.51,80.71Z"
                fill="#3ba525"
              />
              <path
                d="M1319.26,80.68a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.29.46,2,2,0,0,1,.47.53A1,1,0,0,1,1319.26,80.68Z"
                fill="#2f6840"
              />
              <path
                d="M1322.74,79.88c-.26,0-.5.05-.73.1a5.2,5.2,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.45,2.45,0,0,1,1.24-.87A2.13,2.13,0,0,1,1322.74,79.88Z"
                fill="#2f6840"
              />
              <path
                d="M1321.37,83.09a2,2,0,0,0-.66-1c-.29-.29-.64-.5-1-.81a2.21,2.21,0,0,1,1.21.55,1.55,1.55,0,0,1,.4.57A.89.89,0,0,1,1321.37,83.09Z"
                fill="#2f6840"
              />
              <path
                d="M1319.41,81.14a6.56,6.56,0,0,0-.7.16,3.45,3.45,0,0,0-.64.22,9.33,9.33,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2,2,0,0,1,1319.41,81.14Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1305.55,75.48c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.55,14.55,0,0,1,1305.55,75.48Z"
                fill="#2f6840"
              />
              <path
                d="M1305.05,75.14c4.42-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1305.05,75.14Z"
                fill="#3ba525"
              />
              <path
                d="M1305.8,75.11a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.29.46,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1305.8,75.11Z"
                fill="#2f6840"
              />
              <path
                d="M1309.28,74.31c-.26,0-.49,0-.73.1a3.67,3.67,0,0,0-.67.18,11.31,11.31,0,0,0-1.35.52,2.5,2.5,0,0,1,1.24-.87A2.12,2.12,0,0,1,1309.28,74.31Z"
                fill="#2f6840"
              />
              <path
                d="M1307.91,77.52a1.9,1.9,0,0,0-.66-1c-.28-.29-.64-.5-1-.81a2.21,2.21,0,0,1,1.21.55,1.81,1.81,0,0,1,.41.57A.94.94,0,0,1,1307.91,77.52Z"
                fill="#2f6840"
              />
              <path
                d="M1306,75.57a7,7,0,0,0-.69.16,3.55,3.55,0,0,0-.65.22,10,10,0,0,0-1.25.65,2.31,2.31,0,0,1,1.11-1A2,2,0,0,1,1306,75.57Z"
                fill="#2f6840"
              />
            </g>
          </g>
        </g>
        <g>
          <path
            d="M1310.31,88l3.53,2.19a1.18,1.18,0,0,0,1.08.07l8.47-3.79a1.14,1.14,0,0,0,.28-1.91h0a1.1,1.1,0,0,0-.9-.27l-12,1.59A1.15,1.15,0,0,0,1310.31,88Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="1316.58 79.27 1311.8 80.28 1307.59 83.52 1314.64 86.34 1323.28 82.81 1316.58 79.27"
              fill="#ffedc8"
            />
            <polygon
              points="1307.59 83.52 1307.59 86.34 1314.36 89.25 1323.47 85.55 1323.28 82.81 1314.64 86.34 1307.59 83.52"
              fill="#ccae79"
            />
            <polygon
              points="1314.64 86.34 1314.36 89.25 1323.47 85.55 1323.28 82.81 1314.64 86.34"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1309.61,84.33a1.28,1.28,0,0,1,0,1.45c.31-.46.39-1.3.53-1.24Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1312.58,85.52a4.06,4.06,0,0,0,1.78-1.81l-1.28,2Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1318.21,84.88a1.3,1.3,0,0,1,.7,1.15l-.21-1.35Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1321.37,81.8a8.58,8.58,0,0,1-2.81,0,4,4,0,0,1-2,.14s1.5-.14,2,.37A12.31,12.31,0,0,1,1321.37,81.8Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M1326.41,79.89l4.74,2.94a1.54,1.54,0,0,0,1.44.1L1344,77.84a1.54,1.54,0,0,0,.39-2.57h0a1.55,1.55,0,0,0-1.22-.36L1327,77.05A1.54,1.54,0,0,0,1326.41,79.89Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="1334.83 68.12 1328.41 69.48 1322.76 73.82 1332.23 77.62 1343.83 72.87 1334.83 68.12"
              fill="#ffedc8"
            />
            <polygon
              points="1322.76 73.82 1322.76 77.62 1331.85 81.51 1344.08 76.55 1343.83 72.87 1332.23 77.62 1322.76 73.82"
              fill="#ccae79"
            />
            <polygon
              points="1332.23 77.62 1331.85 81.51 1344.08 76.55 1343.83 72.87 1332.23 77.62"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1325.46,74.9a1.71,1.71,0,0,1,0,1.95c.43-.61.53-1.74.73-1.66Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1329.46,76.51a5.43,5.43,0,0,0,2.39-2.43l-1.72,2.69Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1337,75.65a1.75,1.75,0,0,1,.94,1.54l-.28-1.81Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1341.26,71.51c-.12-.06-2.4.46-3.76,0a5.46,5.46,0,0,1-2.75.19s2-.19,2.75.49A16.59,16.59,0,0,1,1341.26,71.51Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M1349,125l4,2.52a1.33,1.33,0,0,0,1.24.08l9.72-4.34a1.32,1.32,0,0,0,.32-2.2h0a1.29,1.29,0,0,0-1-.31l-13.77,1.83A1.31,1.31,0,0,0,1349,125Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="1356.22 114.91 1350.74 116.07 1345.91 119.78 1354.01 123.03 1363.91 118.97 1356.22 114.91"
              fill="#ffedc8"
            />
            <polygon
              points="1345.91 119.78 1345.91 123.03 1353.68 126.35 1364.13 122.11 1363.91 118.97 1354.01 123.03 1345.91 119.78"
              fill="#ccae79"
            />
            <polygon
              points="1354.01 123.03 1353.68 126.35 1364.13 122.11 1363.91 118.97 1354.01 123.03"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1348.22,120.71a1.44,1.44,0,0,1,0,1.66c.37-.52.45-1.48.62-1.41Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1351.64,122.08a4.64,4.64,0,0,0,2-2.08l-1.47,2.31Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1358.1,121.35a1.5,1.5,0,0,1,.8,1.31l-.24-1.54Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1361.72,117.81a9.9,9.9,0,0,1-3.22,0,4.58,4.58,0,0,1-2.34.16s1.72-.16,2.34.42A14.19,14.19,0,0,1,1361.72,117.81Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M1324.05,120.61l4,2.52a1.33,1.33,0,0,0,1.24.08l9.71-4.34a1.32,1.32,0,0,0,.33-2.2h0a1.31,1.31,0,0,0-1-.31l-13.76,1.83A1.31,1.31,0,0,0,1324.05,120.61Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="1331.23 110.56 1325.75 111.72 1320.92 115.43 1329.01 118.67 1338.92 114.62 1331.23 110.56"
              fill="#ffedc8"
            />
            <polygon
              points="1320.92 115.43 1320.92 118.67 1328.69 122 1339.14 117.76 1338.92 114.62 1329.01 118.67 1320.92 115.43"
              fill="#ccae79"
            />
            <polygon
              points="1329.01 118.67 1328.69 122 1339.14 117.76 1338.92 114.62 1329.01 118.67"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1323.23,116.36a1.44,1.44,0,0,1,0,1.66c.37-.52.45-1.48.62-1.41Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1326.65,117.73a4.64,4.64,0,0,0,2-2.08l-1.47,2.31Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1333.11,117a1.5,1.5,0,0,1,.8,1.31l-.24-1.54Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1336.73,113.46a9.9,9.9,0,0,1-3.22,0,4.58,4.58,0,0,1-2.34.16s1.72-.16,2.34.42A14.19,14.19,0,0,1,1336.73,113.46Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M1325.2,99l4.74,2.94a1.54,1.54,0,0,0,1.44.1l11.38-5.09a1.54,1.54,0,0,0,.38-2.57h0a1.52,1.52,0,0,0-1.21-.36l-16.12,2.14A1.54,1.54,0,0,0,1325.2,99Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="1333.62 87.18 1327.2 88.54 1321.55 92.88 1331.02 96.68 1342.62 91.93 1333.62 87.18"
              fill="#ffedc8"
            />
            <polygon
              points="1321.55 92.88 1321.55 96.68 1330.64 100.57 1342.87 95.61 1342.62 91.93 1331.02 96.68 1321.55 92.88"
              fill="#ccae79"
            />
            <polygon
              points="1331.02 96.68 1330.64 100.57 1342.87 95.61 1342.62 91.93 1331.02 96.68"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1324.25,94a1.7,1.7,0,0,1,0,1.94c.43-.61.53-1.73.73-1.65Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1328.25,95.57a5.48,5.48,0,0,0,2.39-2.43l-1.72,2.7Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1335.81,94.72a1.73,1.73,0,0,1,.94,1.53l-.28-1.8Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1340.05,90.57c-.12-.06-2.4.46-3.77,0a5.42,5.42,0,0,1-2.74.19s2-.19,2.74.5A16.36,16.36,0,0,1,1340.05,90.57Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M1347.51,91.08l3.53,2.19a1.13,1.13,0,0,0,1.07.07l8.48-3.79a1.14,1.14,0,0,0,.28-1.91h0a1.11,1.11,0,0,0-.9-.27L1348,89A1.15,1.15,0,0,0,1347.51,91.08Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="1353.78 82.31 1349 83.33 1344.79 86.56 1351.84 89.39 1360.48 85.85 1353.78 82.31"
              fill="#ffedc8"
            />
            <polygon
              points="1344.79 86.56 1344.79 89.39 1351.56 92.29 1360.67 88.59 1360.48 85.85 1351.84 89.39 1344.79 86.56"
              fill="#ccae79"
            />
            <polygon
              points="1351.84 89.39 1351.56 92.29 1360.67 88.59 1360.48 85.85 1351.84 89.39"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1346.8,87.37a1.26,1.26,0,0,1,0,1.45c.32-.46.4-1.3.54-1.24Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1349.78,88.56a4.06,4.06,0,0,0,1.78-1.81l-1.28,2Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1355.41,87.93a1.29,1.29,0,0,1,.7,1.14l-.21-1.35Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1358.57,84.84a8.58,8.58,0,0,1-2.81,0,4,4,0,0,1-2,.14s1.5-.14,2,.37A12.22,12.22,0,0,1,1358.57,84.84Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M1328,131.36s1.85,3.68,4.43,4.3,6.47-1.94,5.87.18,4.85,3.06,7.19,2.49,7.48-5.58,7.45-7.17S1328,131.36,1328,131.36Z"
            fill="#131b8c"
            opacity="0.63"
          />
          <g>
            <path
              d="M1328,128.35l.09,3,4.44,3.09,5.75-.15,1.36,2.21s4,1.85,6.62-.18a21.59,21.59,0,0,0,4.65-5.58l-.08-3Z"
              fill="#ccae79"
            />
            <path
              d="M1332.58,126.26l-4.63,2.09,4.77,3.07,5.49-.15,1.85,2.27s5.41,1.45,6.06-.17,4.66-5.64,4.66-5.64l-4.33-1.84Z"
              fill="#ffedc8"
            />
            <polygon
              points="1332.72 131.42 1332.48 134.46 1338.23 134.3 1338.21 131.27 1332.72 131.42"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1344.76,134.1s.94,2.75.08,2.94a13.25,13.25,0,0,0,6-6.29l-.08-3S1346,134.08,1344.76,134.1Z"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1341,133.77l1.09.2s-.68-.18-.51,1.09A3.08,3.08,0,0,0,1341,133.77Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1343.54,134.16c-.12,0,.21,0,1.19-1a6.48,6.48,0,0,0,1.34-2.08s-2.33,2.7-1.76,3.07Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1330.74,130.14a19.2,19.2,0,0,1,.06,2.19s-.13-1.65.33-1.93Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1339.19,126.08l2.19-.06c.16,0-1.72,0-2.16,1l0-1"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1330.28,127.3l1.15-.52s-.65.41-.39.5,1.29.49,1.69.28a1.69,1.69,0,0,1,1.1,0Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
      </g>
      <g>
        <g>
          <g>
            <g>
              <path
                d="M1077.42,185.61c4.42-.25-4.33.45-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.36,1.72-1.16-2.91-1.16-2.91-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,1077.42,185.61Z"
                fill="#2f6840"
              />
              <path
                d="M1076.91,185.26c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1076.91,185.26Z"
                fill="#3ba525"
              />
              <path
                d="M1077.66,185.23a2.08,2.08,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,2,2,0,0,1,.47.53A1,1,0,0,1,1077.66,185.23Z"
                fill="#2f6840"
              />
              <path
                d="M1081.14,184.44c-.26,0-.49,0-.72.1a3.76,3.76,0,0,0-.68.17,13.44,13.44,0,0,0-1.35.53,2.44,2.44,0,0,1,1.24-.87A2.07,2.07,0,0,1,1081.14,184.44Z"
                fill="#2f6840"
              />
              <path
                d="M1079.77,187.65a1.86,1.86,0,0,0-.66-1c-.28-.29-.63-.51-1-.81a2.08,2.08,0,0,1,1.21.55,1.76,1.76,0,0,1,.41.56A1,1,0,0,1,1079.77,187.65Z"
                fill="#2f6840"
              />
              <path
                d="M1077.81,185.69c-.24.06-.47.09-.69.16a5,5,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2,2,0,0,1,1077.81,185.69Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1074.76,194.34c4.42-.25-4.33.45-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,1074.76,194.34Z"
                fill="#2f6840"
              />
              <path
                d="M1074.25,194c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1074.25,194Z"
                fill="#3ba525"
              />
              <path
                d="M1075,194a2.08,2.08,0,0,0-.8-.93c-.32-.27-.7-.46-1.06-.74a2.34,2.34,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1075,194Z"
                fill="#2f6840"
              />
              <path
                d="M1078.48,193.17a5.21,5.21,0,0,0-.72.1,3.22,3.22,0,0,0-.68.17,11.41,11.41,0,0,0-1.35.53,2.44,2.44,0,0,1,1.24-.87A2.07,2.07,0,0,1,1078.48,193.17Z"
                fill="#2f6840"
              />
              <path
                d="M1077.11,196.38a1.86,1.86,0,0,0-.66-1c-.28-.29-.63-.51-1-.81a2.18,2.18,0,0,1,1.22.54,1.9,1.9,0,0,1,.4.57A1,1,0,0,1,1077.11,196.38Z"
                fill="#2f6840"
              />
              <path
                d="M1075.15,194.42c-.24.06-.47.09-.69.16a5,5,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2,2,0,0,1,1075.15,194.42Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1069.4,189.38c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.64,3.44-4.69.05-4.69.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.54-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,1069.4,189.38Z"
                fill="#2f6840"
              />
              <path
                d="M1068.9,189c4.42-.25-4.33.46-4.35-.61s4.34-2.62,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1068.9,189Z"
                fill="#3ba525"
              />
              <path
                d="M1069.65,189a2.06,2.06,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,2,2,0,0,1,.47.53A1,1,0,0,1,1069.65,189Z"
                fill="#2f6840"
              />
              <path
                d="M1073.13,188.21c-.26,0-.49,0-.73.1a4,4,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.45,2.45,0,0,1,1.24-.87A2.07,2.07,0,0,1,1073.13,188.21Z"
                fill="#2f6840"
              />
              <path
                d="M1071.76,191.42a1.92,1.92,0,0,0-.66-1c-.28-.29-.64-.5-1-.81a2.08,2.08,0,0,1,1.21.55,1.55,1.55,0,0,1,.4.57A.89.89,0,0,1,1071.76,191.42Z"
                fill="#2f6840"
              />
              <path
                d="M1069.8,189.47c-.24.05-.47.08-.7.15a4.41,4.41,0,0,0-.64.23,9.33,9.33,0,0,0-1.25.65,2.22,2.22,0,0,1,1.11-1A2,2,0,0,1,1069.8,189.47Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1061.06,186c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.23-2.77,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1061.06,186Z"
                fill="#2f6840"
              />
              <path
                d="M1060.56,185.66c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1060.56,185.66Z"
                fill="#3ba525"
              />
              <path
                d="M1061.31,185.63a2.15,2.15,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.88,1.88,0,0,1,.48.53A1,1,0,0,1,1061.31,185.63Z"
                fill="#2f6840"
              />
              <path
                d="M1064.79,184.84a5.36,5.36,0,0,0-.73.1,3.22,3.22,0,0,0-.68.17,12,12,0,0,0-1.34.53,2.41,2.41,0,0,1,1.23-.87A2.1,2.1,0,0,1,1064.79,184.84Z"
                fill="#2f6840"
              />
              <path
                d="M1063.42,188.05a2,2,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.73,1.73,0,0,1,.4.57A.92.92,0,0,1,1063.42,188.05Z"
                fill="#2f6840"
              />
              <path
                d="M1061.46,186.09c-.25.06-.48.09-.7.16a4.41,4.41,0,0,0-.64.23,9.33,9.33,0,0,0-1.25.65,2.22,2.22,0,0,1,1.11-1A2,2,0,0,1,1061.46,186.09Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1075.77,201.5c4.42-.25-4.33.45-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,1075.77,201.5Z"
                fill="#2f6840"
              />
              <path
                d="M1075.26,201.15c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1075.26,201.15Z"
                fill="#3ba525"
              />
              <path
                d="M1076,201.12a2.08,2.08,0,0,0-.8-.93c-.32-.27-.7-.46-1.06-.74a2.34,2.34,0,0,1,1.28.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1076,201.12Z"
                fill="#2f6840"
              />
              <path
                d="M1079.49,200.33a5.21,5.21,0,0,0-.72.1,3.22,3.22,0,0,0-.68.17,11.41,11.41,0,0,0-1.35.53,2.44,2.44,0,0,1,1.24-.87A2.07,2.07,0,0,1,1079.49,200.33Z"
                fill="#2f6840"
              />
              <path
                d="M1078.12,203.54a1.86,1.86,0,0,0-.66-1c-.28-.29-.63-.51-1-.81a2.18,2.18,0,0,1,1.22.54,1.9,1.9,0,0,1,.4.57A1,1,0,0,1,1078.12,203.54Z"
                fill="#2f6840"
              />
              <path
                d="M1076.16,201.58c-.24.06-.47.09-.69.16a5,5,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2,2,0,0,1,1076.16,201.58Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1062.31,195.93c4.42-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1062.31,195.93Z"
                fill="#2f6840"
              />
              <path
                d="M1061.8,195.58c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1061.8,195.58Z"
                fill="#3ba525"
              />
              <path
                d="M1062.56,195.55a2.15,2.15,0,0,0-.8-.93c-.32-.27-.71-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1062.56,195.55Z"
                fill="#2f6840"
              />
              <path
                d="M1066,194.76a5.43,5.43,0,0,0-.72.1,3.22,3.22,0,0,0-.68.17,12,12,0,0,0-1.34.53,2.41,2.41,0,0,1,1.23-.87A2.07,2.07,0,0,1,1066,194.76Z"
                fill="#2f6840"
              />
              <path
                d="M1064.67,198a2,2,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.16,2.16,0,0,1,1.21.54,1.9,1.9,0,0,1,.4.57A1,1,0,0,1,1064.67,198Z"
                fill="#2f6840"
              />
              <path
                d="M1062.71,196c-.25.06-.48.09-.7.16a4.41,4.41,0,0,0-.64.23,9.43,9.43,0,0,0-1.26.65,2.24,2.24,0,0,1,1.12-1A2,2,0,0,1,1062.71,196Z"
                fill="#2f6840"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M1091.05,168.66c4.43-.26-4.33.45-4.35-.62s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.27-2.07-2.36A14.24,14.24,0,0,1,1091.05,168.66Z"
                fill="#2f6840"
              />
              <path
                d="M1090.55,168.31c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1090.55,168.31Z"
                fill="#3ba525"
              />
              <path
                d="M1091.3,168.28a2,2,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1091.3,168.28Z"
                fill="#2f6840"
              />
              <path
                d="M1094.78,167.49c-.26,0-.49,0-.73.09a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.38,2.38,0,0,1,1.24-.86A2.07,2.07,0,0,1,1094.78,167.49Z"
                fill="#2f6840"
              />
              <path
                d="M1093.41,170.7a1.88,1.88,0,0,0-.66-1c-.28-.29-.64-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A.92.92,0,0,1,1093.41,170.7Z"
                fill="#2f6840"
              />
              <path
                d="M1091.45,168.74c-.24.06-.47.09-.7.16a2.87,2.87,0,0,0-.64.23,9.24,9.24,0,0,0-1.25.64,2.24,2.24,0,0,1,1.11-1A2,2,0,0,1,1091.45,168.74Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1088.39,177.38c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1088.39,177.38Z"
                fill="#2f6840"
              />
              <path
                d="M1087.89,177c4.42-.25-4.33.46-4.35-.61s4.34-2.63,5.28-2.45.26,2.24.26,2.24,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1087.89,177Z"
                fill="#3ba525"
              />
              <path
                d="M1088.64,177a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1088.64,177Z"
                fill="#2f6840"
              />
              <path
                d="M1092.12,176.22c-.26,0-.49,0-.73.09a3.67,3.67,0,0,0-.67.18,11.31,11.31,0,0,0-1.35.52,2.42,2.42,0,0,1,1.24-.86A2.07,2.07,0,0,1,1092.12,176.22Z"
                fill="#2f6840"
              />
              <path
                d="M1090.75,179.43a1.88,1.88,0,0,0-.66-1c-.28-.29-.64-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.81,1.81,0,0,1,.41.57A1,1,0,0,1,1090.75,179.43Z"
                fill="#2f6840"
              />
              <path
                d="M1088.79,177.47c-.24.06-.47.09-.7.16a2.87,2.87,0,0,0-.64.23,9.87,9.87,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,1088.79,177.47Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1083,172.43c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1083,172.43Z"
                fill="#2f6840"
              />
              <path
                d="M1082.54,172.08c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1082.54,172.08Z"
                fill="#3ba525"
              />
              <path
                d="M1083.29,172.05a2.15,2.15,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.88,1.88,0,0,1,.48.53A1,1,0,0,1,1083.29,172.05Z"
                fill="#2f6840"
              />
              <path
                d="M1086.77,171.26a5.36,5.36,0,0,0-.73.1,3.22,3.22,0,0,0-.68.17,10.33,10.33,0,0,0-1.34.53,2.4,2.4,0,0,1,1.24-.87A2.07,2.07,0,0,1,1086.77,171.26Z"
                fill="#2f6840"
              />
              <path
                d="M1085.4,174.47a1.94,1.94,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A.92.92,0,0,1,1085.4,174.47Z"
                fill="#2f6840"
              />
              <path
                d="M1083.44,172.51c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,10.56,10.56,0,0,0-1.25.64,2.24,2.24,0,0,1,1.11-1A2,2,0,0,1,1083.44,172.51Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1074.7,169.05c4.42-.25-4.33.46-4.35-.61s4.35-2.62,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A15,15,0,0,1,1074.7,169.05Z"
                fill="#2f6840"
              />
              <path
                d="M1074.19,168.71c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.44-4.69,0-4.69,0,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1074.19,168.71Z"
                fill="#3ba525"
              />
              <path
                d="M1075,168.68a2.09,2.09,0,0,0-.8-.93c-.32-.27-.71-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1075,168.68Z"
                fill="#2f6840"
              />
              <path
                d="M1078.42,167.89c-.25,0-.49,0-.72.09a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.39,2.39,0,0,1,1.23-.86A2.07,2.07,0,0,1,1078.42,167.89Z"
                fill="#2f6840"
              />
              <path
                d="M1077.06,171.1a1.94,1.94,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.16,2.16,0,0,1,1.21.54,1.78,1.78,0,0,1,.4.57A1,1,0,0,1,1077.06,171.1Z"
                fill="#2f6840"
              />
              <path
                d="M1075.1,169.14c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,9.34,9.34,0,0,0-1.26.64,2.27,2.27,0,0,1,1.12-1A2,2,0,0,1,1075.1,169.14Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1089.4,184.54c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1089.4,184.54Z"
                fill="#2f6840"
              />
              <path
                d="M1088.9,184.2c4.42-.25-4.33.46-4.35-.61s4.34-2.63,5.28-2.45.26,2.24.26,2.24,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1088.9,184.2Z"
                fill="#3ba525"
              />
              <path
                d="M1089.65,184.17a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1089.65,184.17Z"
                fill="#2f6840"
              />
              <path
                d="M1093.13,183.38c-.26,0-.49,0-.73.09a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.38,2.38,0,0,1,1.24-.86A2.07,2.07,0,0,1,1093.13,183.38Z"
                fill="#2f6840"
              />
              <path
                d="M1091.76,186.59a1.88,1.88,0,0,0-.66-1c-.28-.29-.64-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A.92.92,0,0,1,1091.76,186.59Z"
                fill="#2f6840"
              />
              <path
                d="M1089.8,184.63c-.24.06-.47.09-.7.16a2.87,2.87,0,0,0-.64.23,9.87,9.87,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,1089.8,184.63Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1076,179c4.42-.25-4.33.46-4.36-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.87,14.87,0,0,1,1076,179Z"
                fill="#2f6840"
              />
              <path
                d="M1075.44,178.63c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.23-2.78,2.92-2.16,3.63,3.56,2.65,3.44-4.69.05-4.69.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.17-2.9-1.17-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1075.44,178.63Z"
                fill="#3ba525"
              />
              <path
                d="M1076.19,178.6a2.07,2.07,0,0,0-.79-.93c-.33-.27-.71-.46-1.07-.74a2.34,2.34,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A.93.93,0,0,1,1076.19,178.6Z"
                fill="#2f6840"
              />
              <path
                d="M1079.67,177.81c-.25,0-.49,0-.72.09a4,4,0,0,0-.68.18,11.31,11.31,0,0,0-1.35.52,2.42,2.42,0,0,1,1.24-.86A2.07,2.07,0,0,1,1079.67,177.81Z"
                fill="#2f6840"
              />
              <path
                d="M1078.3,181a1.82,1.82,0,0,0-.66-1c-.28-.29-.63-.51-1-.81a2.15,2.15,0,0,1,1.22.54,1.78,1.78,0,0,1,.4.57A1,1,0,0,1,1078.3,181Z"
                fill="#2f6840"
              />
              <path
                d="M1076.35,179.06c-.25.06-.48.09-.7.16a3.15,3.15,0,0,0-.65.23,9.87,9.87,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,1076.35,179.06Z"
                fill="#2f6840"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M1119.44,170.81c4.42-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.54-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1119.44,170.81Z"
                fill="#2f6840"
              />
              <path
                d="M1118.93,170.46c4.43-.25-4.33.46-4.35-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.92,3.34-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1118.93,170.46Z"
                fill="#3ba525"
              />
              <path
                d="M1119.69,170.44a2.18,2.18,0,0,0-.8-.94c-.32-.27-.71-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.83,1.83,0,0,1,.47.53A1,1,0,0,1,1119.69,170.44Z"
                fill="#2f6840"
              />
              <path
                d="M1123.16,169.64c-.25,0-.49,0-.72.1a4,4,0,0,0-.68.17c-.45.13-.87.34-1.35.53a2.54,2.54,0,0,1,1.24-.87A2.07,2.07,0,0,1,1123.16,169.64Z"
                fill="#2f6840"
              />
              <path
                d="M1121.8,172.85a2,2,0,0,0-.66-1c-.29-.29-.64-.5-1-.81a2.1,2.1,0,0,1,1.21.55,1.68,1.68,0,0,1,.4.57A1,1,0,0,1,1121.8,172.85Z"
                fill="#2f6840"
              />
              <path
                d="M1119.84,170.9a6.61,6.61,0,0,0-.7.15,5,5,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.24,2.24,0,0,1,1.12-1A2,2,0,0,1,1119.84,170.9Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1116.78,179.54c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1116.78,179.54Z"
                fill="#2f6840"
              />
              <path
                d="M1116.27,179.19c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1116.27,179.19Z"
                fill="#3ba525"
              />
              <path
                d="M1117,179.16a2.15,2.15,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1117,179.16Z"
                fill="#2f6840"
              />
              <path
                d="M1120.5,178.37c-.25,0-.49,0-.72.1a3.22,3.22,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.41,2.41,0,0,1,1.23-.87A2.07,2.07,0,0,1,1120.5,178.37Z"
                fill="#2f6840"
              />
              <path
                d="M1119.14,181.58a2,2,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.1,2.1,0,0,1,1.21.55,1.74,1.74,0,0,1,.4.56A1,1,0,0,1,1119.14,181.58Z"
                fill="#2f6840"
              />
              <path
                d="M1117.18,179.62c-.25.06-.48.09-.7.16a4.41,4.41,0,0,0-.64.23,9.43,9.43,0,0,0-1.26.65,2.24,2.24,0,0,1,1.12-1A2,2,0,0,1,1117.18,179.62Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1111.43,174.58c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1111.43,174.58Z"
                fill="#2f6840"
              />
              <path
                d="M1110.92,174.23c4.43-.25-4.33.46-4.35-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.23-2.78,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.37A15,15,0,0,1,1110.92,174.23Z"
                fill="#3ba525"
              />
              <path
                d="M1111.67,174.21a2.1,2.1,0,0,0-.79-.94c-.33-.27-.71-.46-1.07-.74a2.34,2.34,0,0,1,1.28.45,2,2,0,0,1,.47.53A1,1,0,0,1,1111.67,174.21Z"
                fill="#2f6840"
              />
              <path
                d="M1115.15,173.41c-.25,0-.49.05-.72.1a5.2,5.2,0,0,0-.68.17,13.44,13.44,0,0,0-1.35.53,2.5,2.5,0,0,1,1.24-.87A2.12,2.12,0,0,1,1115.15,173.41Z"
                fill="#2f6840"
              />
              <path
                d="M1113.78,176.62a1.86,1.86,0,0,0-.66-1c-.28-.29-.63-.5-1-.81a2.17,2.17,0,0,1,1.22.55,1.68,1.68,0,0,1,.4.57A.94.94,0,0,1,1113.78,176.62Z"
                fill="#2f6840"
              />
              <path
                d="M1111.83,174.67a6.61,6.61,0,0,0-.7.15,5,5,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2,2,0,0,1,1111.83,174.67Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1103.08,171.21c4.43-.25-4.32.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.36,1.72-1.16-2.91-1.16-2.91-.91,3.34-3,2.55-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,1103.08,171.21Z"
                fill="#2f6840"
              />
              <path
                d="M1102.58,170.86c4.42-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1102.58,170.86Z"
                fill="#3ba525"
              />
              <path
                d="M1103.33,170.83a2.08,2.08,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,2,2,0,0,1,.47.53A1,1,0,0,1,1103.33,170.83Z"
                fill="#2f6840"
              />
              <path
                d="M1106.81,170c-.26,0-.49,0-.73.1a3.65,3.65,0,0,0-.67.17,13.44,13.44,0,0,0-1.35.53,2.44,2.44,0,0,1,1.24-.87A2.07,2.07,0,0,1,1106.81,170Z"
                fill="#2f6840"
              />
              <path
                d="M1105.44,173.25a1.92,1.92,0,0,0-.66-1c-.28-.29-.64-.51-1-.81a2.08,2.08,0,0,1,1.21.55,1.76,1.76,0,0,1,.41.56A1,1,0,0,1,1105.44,173.25Z"
                fill="#2f6840"
              />
              <path
                d="M1103.48,171.29c-.24.06-.47.09-.7.16a4.41,4.41,0,0,0-.64.23,10,10,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2,2,0,0,1,1103.48,171.29Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1117.79,186.7c4.42-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1117.79,186.7Z"
                fill="#2f6840"
              />
              <path
                d="M1117.28,186.35c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1117.28,186.35Z"
                fill="#3ba525"
              />
              <path
                d="M1118,186.32a2.15,2.15,0,0,0-.8-.93c-.32-.27-.71-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1118,186.32Z"
                fill="#2f6840"
              />
              <path
                d="M1121.51,185.53c-.25,0-.49,0-.72.1a3.22,3.22,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.41,2.41,0,0,1,1.23-.87A2.07,2.07,0,0,1,1121.51,185.53Z"
                fill="#2f6840"
              />
              <path
                d="M1120.15,188.74a2,2,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.1,2.1,0,0,1,1.21.55,1.74,1.74,0,0,1,.4.56A1,1,0,0,1,1120.15,188.74Z"
                fill="#2f6840"
              />
              <path
                d="M1118.19,186.78c-.25.06-.48.09-.7.16a4.41,4.41,0,0,0-.64.23,9.43,9.43,0,0,0-1.26.65,2.24,2.24,0,0,1,1.12-1A2,2,0,0,1,1118.19,186.78Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1104.33,181.13c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.92-2.15,3.63,3.55,2.65,3.44-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.72-1.16-2.91-1.16-2.91-.92,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1104.33,181.13Z"
                fill="#2f6840"
              />
              <path
                d="M1103.83,180.78c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1103.83,180.78Z"
                fill="#3ba525"
              />
              <path
                d="M1104.58,180.75a2.15,2.15,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,2.18,2.18,0,0,1,.47.53A1,1,0,0,1,1104.58,180.75Z"
                fill="#2f6840"
              />
              <path
                d="M1108.06,180c-.26,0-.5,0-.73.1a4,4,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.4,2.4,0,0,1,1.24-.87A2.07,2.07,0,0,1,1108.06,180Z"
                fill="#2f6840"
              />
              <path
                d="M1106.69,183.17a2,2,0,0,0-.66-1c-.28-.29-.64-.51-1-.81a2.08,2.08,0,0,1,1.21.55,1.6,1.6,0,0,1,.4.56A.92.92,0,0,1,1106.69,183.17Z"
                fill="#2f6840"
              />
              <path
                d="M1104.73,181.21c-.25.06-.48.09-.7.16a4.41,4.41,0,0,0-.64.23,9.33,9.33,0,0,0-1.25.65,2.22,2.22,0,0,1,1.11-1A2,2,0,0,1,1104.73,181.21Z"
                fill="#2f6840"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M1146.84,164.26c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1146.84,164.26Z"
                fill="#2f6840"
              />
              <path
                d="M1146.34,163.92c4.42-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1146.34,163.92Z"
                fill="#3ba525"
              />
              <path
                d="M1147.09,163.89a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.29.46,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1147.09,163.89Z"
                fill="#2f6840"
              />
              <path
                d="M1150.57,163.09c-.26,0-.49,0-.73.1a4.69,4.69,0,0,0-.67.17,13.44,13.44,0,0,0-1.35.53,2.5,2.5,0,0,1,1.24-.87A2.12,2.12,0,0,1,1150.57,163.09Z"
                fill="#2f6840"
              />
              <path
                d="M1149.2,166.3a1.9,1.9,0,0,0-.66-1c-.28-.29-.64-.5-1-.81a2.21,2.21,0,0,1,1.21.55,1.81,1.81,0,0,1,.41.57A.94.94,0,0,1,1149.2,166.3Z"
                fill="#2f6840"
              />
              <path
                d="M1147.24,164.35a7,7,0,0,0-.69.16,3.31,3.31,0,0,0-.65.22,10,10,0,0,0-1.25.65,2.31,2.31,0,0,1,1.11-1A2,2,0,0,1,1147.24,164.35Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1144.19,173c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1144.19,173Z"
                fill="#2f6840"
              />
              <path
                d="M1143.68,172.65c4.43-.26-4.33.45-4.35-.62s4.35-2.62,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.34,14.34,0,0,1,1143.68,172.65Z"
                fill="#3ba525"
              />
              <path
                d="M1144.43,172.62a2.11,2.11,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,2,2,0,0,1,.47.54A1,1,0,0,1,1144.43,172.62Z"
                fill="#2f6840"
              />
              <path
                d="M1147.91,171.82c-.26,0-.49.05-.72.1a4.83,4.83,0,0,0-.68.17,13.44,13.44,0,0,0-1.35.53,2.5,2.5,0,0,1,1.24-.87A2.12,2.12,0,0,1,1147.91,171.82Z"
                fill="#2f6840"
              />
              <path
                d="M1146.54,175a1.86,1.86,0,0,0-.66-1c-.28-.29-.63-.5-1-.81a2.14,2.14,0,0,1,1.21.55,1.7,1.7,0,0,1,.41.57A.94.94,0,0,1,1146.54,175Z"
                fill="#2f6840"
              />
              <path
                d="M1144.58,173.08a7,7,0,0,0-.69.15,5,5,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.31,2.31,0,0,1,1.11-1A2,2,0,0,1,1144.58,173.08Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1138.83,168c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.44-4.69.05-4.69.05,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1138.83,168Z"
                fill="#2f6840"
              />
              <path
                d="M1138.33,167.69c4.42-.25-4.33.45-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,1138.33,167.69Z"
                fill="#3ba525"
              />
              <path
                d="M1139.08,167.66a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.74a2.28,2.28,0,0,1,1.29.46,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1139.08,167.66Z"
                fill="#2f6840"
              />
              <path
                d="M1142.56,166.86c-.26,0-.49,0-.73.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.45,2.45,0,0,1,1.24-.87A2.12,2.12,0,0,1,1142.56,166.86Z"
                fill="#2f6840"
              />
              <path
                d="M1141.19,170.07a2,2,0,0,0-.66-1c-.28-.28-.64-.5-1-.81a2.21,2.21,0,0,1,1.21.55,1.64,1.64,0,0,1,.4.57A.89.89,0,0,1,1141.19,170.07Z"
                fill="#2f6840"
              />
              <path
                d="M1139.23,168.12c-.24.06-.47.09-.7.16a3.45,3.45,0,0,0-.64.22,9.33,9.33,0,0,0-1.25.65,2.31,2.31,0,0,1,1.11-1A2,2,0,0,1,1139.23,168.12Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1130.49,164.66c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.69.05-4.69.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.17-2.9-1.17-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1130.49,164.66Z"
                fill="#2f6840"
              />
              <path
                d="M1130,164.32c4.43-.25-4.32.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,1130,164.32Z"
                fill="#3ba525"
              />
              <path
                d="M1130.74,164.29a2.17,2.17,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.87,1.87,0,0,1,.47.54A.94.94,0,0,1,1130.74,164.29Z"
                fill="#2f6840"
              />
              <path
                d="M1134.21,163.49c-.25,0-.49,0-.72.1a5.2,5.2,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.47,2.47,0,0,1,1.23-.87A2.12,2.12,0,0,1,1134.21,163.49Z"
                fill="#2f6840"
              />
              <path
                d="M1132.85,166.7a2,2,0,0,0-.66-1c-.29-.29-.64-.5-1-.81a2.17,2.17,0,0,1,1.21.55,1.55,1.55,0,0,1,.4.57A.94.94,0,0,1,1132.85,166.7Z"
                fill="#2f6840"
              />
              <path
                d="M1130.89,164.75a6.56,6.56,0,0,0-.7.16,3.45,3.45,0,0,0-.64.22,9.33,9.33,0,0,0-1.25.65,2.22,2.22,0,0,1,1.11-1A2,2,0,0,1,1130.89,164.75Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1145.19,180.15c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.24.27,2.24,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.55,14.55,0,0,1,1145.19,180.15Z"
                fill="#2f6840"
              />
              <path
                d="M1144.69,179.81c4.43-.26-4.33.45-4.35-.62s4.35-2.62,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.34,14.34,0,0,1,1144.69,179.81Z"
                fill="#3ba525"
              />
              <path
                d="M1145.44,179.78a2.11,2.11,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,2.16,2.16,0,0,1,.47.53A1,1,0,0,1,1145.44,179.78Z"
                fill="#2f6840"
              />
              <path
                d="M1148.92,179c-.26,0-.49.05-.72.1a4.51,4.51,0,0,0-.68.17,13.44,13.44,0,0,0-1.35.53,2.5,2.5,0,0,1,1.24-.87A2.12,2.12,0,0,1,1148.92,179Z"
                fill="#2f6840"
              />
              <path
                d="M1147.55,182.19a1.86,1.86,0,0,0-.66-1c-.28-.29-.63-.5-1-.81a2.14,2.14,0,0,1,1.21.55,1.7,1.7,0,0,1,.41.57A.94.94,0,0,1,1147.55,182.19Z"
                fill="#2f6840"
              />
              <path
                d="M1145.59,180.24a7,7,0,0,0-.69.15,5,5,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2,2,0,0,1,1145.59,180.24Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1131.74,174.58c4.42-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1131.74,174.58Z"
                fill="#2f6840"
              />
              <path
                d="M1131.23,174.24c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.64,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.92,3.34-3,2.55-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,1131.23,174.24Z"
                fill="#3ba525"
              />
              <path
                d="M1132,174.21a2.24,2.24,0,0,0-.8-.94c-.33-.27-.71-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.87,1.87,0,0,1,.47.54A1,1,0,0,1,1132,174.21Z"
                fill="#2f6840"
              />
              <path
                d="M1135.46,173.41c-.25,0-.49.05-.72.1a5.2,5.2,0,0,0-.68.17c-.45.13-.87.34-1.35.53a2.54,2.54,0,0,1,1.24-.87A2.12,2.12,0,0,1,1135.46,173.41Z"
                fill="#2f6840"
              />
              <path
                d="M1134.09,176.62a1.9,1.9,0,0,0-.65-1c-.29-.29-.64-.5-1-.81a2.17,2.17,0,0,1,1.21.55,1.68,1.68,0,0,1,.4.57A.94.94,0,0,1,1134.09,176.62Z"
                fill="#2f6840"
              />
              <path
                d="M1132.14,174.67a6.56,6.56,0,0,0-.7.16,3.83,3.83,0,0,0-.65.22,10,10,0,0,0-1.25.65,2.29,2.29,0,0,1,1.12-1A2,2,0,0,1,1132.14,174.67Z"
                fill="#2f6840"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M1174.26,157.06c4.43-.26-4.32.45-4.35-.62s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.24,14.24,0,0,1,1174.26,157.06Z"
                fill="#2f6840"
              />
              <path
                d="M1173.76,156.71c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1173.76,156.71Z"
                fill="#3ba525"
              />
              <path
                d="M1174.51,156.68a2,2,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1174.51,156.68Z"
                fill="#2f6840"
              />
              <path
                d="M1178,155.89c-.26,0-.49,0-.72.09a3.57,3.57,0,0,0-.68.18,11.31,11.31,0,0,0-1.35.52,2.42,2.42,0,0,1,1.24-.86A2.07,2.07,0,0,1,1178,155.89Z"
                fill="#2f6840"
              />
              <path
                d="M1176.62,159.1a1.82,1.82,0,0,0-.66-1c-.28-.29-.63-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.81,1.81,0,0,1,.41.57A1,1,0,0,1,1176.62,159.1Z"
                fill="#2f6840"
              />
              <path
                d="M1174.66,157.14c-.24.06-.47.09-.69.16a3,3,0,0,0-.65.23,9.87,9.87,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,1174.66,157.14Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1171.61,165.78c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1171.61,165.78Z"
                fill="#2f6840"
              />
              <path
                d="M1171.1,165.44c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.24.26,2.24,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.31,2-4.37,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1171.1,165.44Z"
                fill="#3ba525"
              />
              <path
                d="M1171.85,165.41a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1171.85,165.41Z"
                fill="#2f6840"
              />
              <path
                d="M1175.33,164.62c-.26,0-.49,0-.72.09a4,4,0,0,0-.68.18,11.31,11.31,0,0,0-1.35.52,2.42,2.42,0,0,1,1.24-.86A2.07,2.07,0,0,1,1175.33,164.62Z"
                fill="#2f6840"
              />
              <path
                d="M1174,167.83a1.82,1.82,0,0,0-.66-1c-.28-.29-.63-.51-1-.81a2.18,2.18,0,0,1,1.22.54,1.78,1.78,0,0,1,.4.57A1,1,0,0,1,1174,167.83Z"
                fill="#2f6840"
              />
              <path
                d="M1172,165.87c-.24.06-.47.09-.69.16a3.15,3.15,0,0,0-.65.23,9.87,9.87,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,1172,165.87Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1166.25,160.83c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.64,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,1166.25,160.83Z"
                fill="#2f6840"
              />
              <path
                d="M1165.75,160.48c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1165.75,160.48Z"
                fill="#3ba525"
              />
              <path
                d="M1166.5,160.45a2.08,2.08,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1166.5,160.45Z"
                fill="#2f6840"
              />
              <path
                d="M1170,159.66a5.58,5.58,0,0,0-.73.1,3.22,3.22,0,0,0-.68.17,10.33,10.33,0,0,0-1.34.53,2.4,2.4,0,0,1,1.24-.87A2.07,2.07,0,0,1,1170,159.66Z"
                fill="#2f6840"
              />
              <path
                d="M1168.61,162.87a1.88,1.88,0,0,0-.66-1c-.28-.29-.64-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A.92.92,0,0,1,1168.61,162.87Z"
                fill="#2f6840"
              />
              <path
                d="M1166.65,160.91c-.24.06-.47.09-.7.16a2.87,2.87,0,0,0-.64.23,10.56,10.56,0,0,0-1.25.64,2.24,2.24,0,0,1,1.11-1A2,2,0,0,1,1166.65,160.91Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1157.91,157.45c4.43-.25-4.33.46-4.35-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.23-2.78,2.92-2.16,3.62,3.56,2.65,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A15,15,0,0,1,1157.91,157.45Z"
                fill="#2f6840"
              />
              <path
                d="M1157.4,157.11c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1157.4,157.11Z"
                fill="#3ba525"
              />
              <path
                d="M1158.16,157.08a2.09,2.09,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.88,1.88,0,0,1,.48.53A1,1,0,0,1,1158.16,157.08Z"
                fill="#2f6840"
              />
              <path
                d="M1161.64,156.29c-.26,0-.5,0-.73.09a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.39,2.39,0,0,1,1.23-.86A2.1,2.1,0,0,1,1161.64,156.29Z"
                fill="#2f6840"
              />
              <path
                d="M1160.27,159.5a1.94,1.94,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.16,2.16,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A1,1,0,0,1,1160.27,159.5Z"
                fill="#2f6840"
              />
              <path
                d="M1158.31,157.54c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,9.24,9.24,0,0,0-1.25.64,2.2,2.2,0,0,1,1.11-1A2,2,0,0,1,1158.31,157.54Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1172.62,172.94c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1172.62,172.94Z"
                fill="#2f6840"
              />
              <path
                d="M1172.11,172.6c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.24.26,2.24,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1172.11,172.6Z"
                fill="#3ba525"
              />
              <path
                d="M1172.86,172.57a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1172.86,172.57Z"
                fill="#2f6840"
              />
              <path
                d="M1176.34,171.78c-.26,0-.49,0-.72.09a4,4,0,0,0-.68.18,11.31,11.31,0,0,0-1.35.52,2.42,2.42,0,0,1,1.24-.86A2.07,2.07,0,0,1,1176.34,171.78Z"
                fill="#2f6840"
              />
              <path
                d="M1175,175a1.82,1.82,0,0,0-.66-1c-.28-.29-.63-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.81,1.81,0,0,1,.41.57A1,1,0,0,1,1175,175Z"
                fill="#2f6840"
              />
              <path
                d="M1173,173c-.24.06-.47.09-.69.16a3.15,3.15,0,0,0-.65.23,9.87,9.87,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,1173,173Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1159.16,167.37c4.42-.25-4.33.46-4.35-.61s4.35-2.62,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A15,15,0,0,1,1159.16,167.37Z"
                fill="#2f6840"
              />
              <path
                d="M1158.65,167c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.44-4.69.05-4.69.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1158.65,167Z"
                fill="#3ba525"
              />
              <path
                d="M1159.41,167a2.15,2.15,0,0,0-.8-.93c-.32-.27-.71-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1159.41,167Z"
                fill="#2f6840"
              />
              <path
                d="M1162.88,166.21c-.25,0-.49,0-.72.09a4,4,0,0,0-.68.18,12.79,12.79,0,0,0-1.35.52,2.46,2.46,0,0,1,1.24-.86A2.07,2.07,0,0,1,1162.88,166.21Z"
                fill="#2f6840"
              />
              <path
                d="M1161.52,169.42a1.94,1.94,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.16,2.16,0,0,1,1.21.54,1.78,1.78,0,0,1,.4.57A1,1,0,0,1,1161.52,169.42Z"
                fill="#2f6840"
              />
              <path
                d="M1159.56,167.46c-.25.06-.48.09-.7.16a3.15,3.15,0,0,0-.65.23,9.87,9.87,0,0,0-1.25.64,2.27,2.27,0,0,1,1.12-1A2,2,0,0,1,1159.56,167.46Z"
                fill="#2f6840"
              />
            </g>
          </g>
        </g>
        <g>
          <g>
            <g>
              <path
                d="M1172.37,396.33c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.92-2.15,3.63,3.55,2.65,3.44-4.69.05-4.69.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.17-2.9-1.17-2.9-.91,3.33-3,2.54-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1172.37,396.33Z"
                fill="#2f6840"
              />
              <path
                d="M1171.87,396c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1171.87,396Z"
                fill="#3ba525"
              />
              <path
                d="M1172.62,396a2.12,2.12,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,2.18,2.18,0,0,1,.47.53A1,1,0,0,1,1172.62,396Z"
                fill="#2f6840"
              />
              <path
                d="M1176.1,395.16c-.26,0-.5,0-.73.1a4,4,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.4,2.4,0,0,1,1.24-.87A2.07,2.07,0,0,1,1176.1,395.16Z"
                fill="#2f6840"
              />
              <path
                d="M1174.73,398.37a2,2,0,0,0-.66-1c-.29-.29-.64-.5-1-.81a2.08,2.08,0,0,1,1.21.55,1.55,1.55,0,0,1,.4.57A.89.89,0,0,1,1174.73,398.37Z"
                fill="#2f6840"
              />
              <path
                d="M1172.77,396.41c-.25.06-.48.09-.7.16a4.41,4.41,0,0,0-.64.23,9.33,9.33,0,0,0-1.25.65,2.22,2.22,0,0,1,1.11-1A2,2,0,0,1,1172.77,396.41Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1169.71,405.06c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.64,3.44-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.92,3.34-3,2.55-2.25-2.27-2.07-2.36A14.46,14.46,0,0,1,1169.71,405.06Z"
                fill="#2f6840"
              />
              <path
                d="M1169.21,404.71c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1169.21,404.71Z"
                fill="#3ba525"
              />
              <path
                d="M1170,404.68a2.15,2.15,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1170,404.68Z"
                fill="#2f6840"
              />
              <path
                d="M1173.44,403.89c-.26,0-.5,0-.73.1a3.22,3.22,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.4,2.4,0,0,1,1.24-.87A2.07,2.07,0,0,1,1173.44,403.89Z"
                fill="#2f6840"
              />
              <path
                d="M1172.07,407.1a2,2,0,0,0-.66-1c-.28-.29-.64-.51-1-.81a2.08,2.08,0,0,1,1.21.55,1.6,1.6,0,0,1,.4.56A.92.92,0,0,1,1172.07,407.1Z"
                fill="#2f6840"
              />
              <path
                d="M1170.11,405.14c-.25.06-.48.09-.7.16a4.41,4.41,0,0,0-.64.23,9.33,9.33,0,0,0-1.25.65,2.22,2.22,0,0,1,1.11-1A2,2,0,0,1,1170.11,405.14Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1164.36,400.1c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.31,2-4.37,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1164.36,400.1Z"
                fill="#2f6840"
              />
              <path
                d="M1163.85,399.75c4.43-.25-4.32.46-4.35-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.27-2.07-2.37A14.86,14.86,0,0,1,1163.85,399.75Z"
                fill="#3ba525"
              />
              <path
                d="M1164.61,399.73a2.12,2.12,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,2,2,0,0,1,.47.53A1,1,0,0,1,1164.61,399.73Z"
                fill="#2f6840"
              />
              <path
                d="M1168.08,398.93c-.25,0-.49.05-.72.1a5.2,5.2,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.47,2.47,0,0,1,1.23-.87A2.12,2.12,0,0,1,1168.08,398.93Z"
                fill="#2f6840"
              />
              <path
                d="M1166.72,402.14a2,2,0,0,0-.66-1c-.29-.29-.64-.5-1-.81a2.1,2.1,0,0,1,1.21.55,1.55,1.55,0,0,1,.4.57A.94.94,0,0,1,1166.72,402.14Z"
                fill="#2f6840"
              />
              <path
                d="M1164.76,400.19a6.61,6.61,0,0,0-.7.15,4.41,4.41,0,0,0-.64.23,10.08,10.08,0,0,0-1.26.65,2.24,2.24,0,0,1,1.12-1A2,2,0,0,1,1164.76,400.19Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1156,396.73c4.42-.25-4.33.45-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.72-1.16-2.91-1.16-2.91-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,1156,396.73Z"
                fill="#2f6840"
              />
              <path
                d="M1155.51,396.38c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1155.51,396.38Z"
                fill="#3ba525"
              />
              <path
                d="M1156.26,396.35a2.13,2.13,0,0,0-.79-.93c-.33-.27-.71-.46-1.07-.74a2.31,2.31,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1156.26,396.35Z"
                fill="#2f6840"
              />
              <path
                d="M1159.74,395.56c-.25,0-.49,0-.72.1a3.22,3.22,0,0,0-.68.17,14.45,14.45,0,0,0-1.35.53,2.48,2.48,0,0,1,1.24-.87A2.07,2.07,0,0,1,1159.74,395.56Z"
                fill="#2f6840"
              />
              <path
                d="M1158.37,398.77a1.86,1.86,0,0,0-.66-1c-.28-.29-.63-.51-1-.81a2.1,2.1,0,0,1,1.21.55,1.74,1.74,0,0,1,.4.56A1,1,0,0,1,1158.37,398.77Z"
                fill="#2f6840"
              />
              <path
                d="M1156.42,396.81c-.25.06-.48.09-.7.16a5,5,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.24,2.24,0,0,1,1.12-1A2,2,0,0,1,1156.42,396.81Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1170.72,412.22c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.92-2.15,3.63,3.55,2.65,3.44-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.92,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1170.72,412.22Z"
                fill="#2f6840"
              />
              <path
                d="M1170.22,411.87c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1170.22,411.87Z"
                fill="#3ba525"
              />
              <path
                d="M1171,411.84a2.15,2.15,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,2,2,0,0,1,.47.53A1,1,0,0,1,1171,411.84Z"
                fill="#2f6840"
              />
              <path
                d="M1174.45,411.05c-.26,0-.5,0-.73.1a3.22,3.22,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.4,2.4,0,0,1,1.24-.87A2.07,2.07,0,0,1,1174.45,411.05Z"
                fill="#2f6840"
              />
              <path
                d="M1173.08,414.26a2,2,0,0,0-.66-1c-.28-.29-.64-.51-1-.81a2.08,2.08,0,0,1,1.21.55,1.6,1.6,0,0,1,.4.56A.92.92,0,0,1,1173.08,414.26Z"
                fill="#2f6840"
              />
              <path
                d="M1171.12,412.3c-.25.06-.48.09-.7.16a4.41,4.41,0,0,0-.64.23,9.33,9.33,0,0,0-1.25.65,2.22,2.22,0,0,1,1.11-1A2,2,0,0,1,1171.12,412.3Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1157.27,406.65c4.42-.25-4.33.45-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,1157.27,406.65Z"
                fill="#2f6840"
              />
              <path
                d="M1156.76,406.3c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1156.76,406.3Z"
                fill="#3ba525"
              />
              <path
                d="M1157.51,406.27a2.08,2.08,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1157.51,406.27Z"
                fill="#2f6840"
              />
              <path
                d="M1161,405.48c-.26,0-.49,0-.72.1a3,3,0,0,0-.68.17,13.44,13.44,0,0,0-1.35.53,2.44,2.44,0,0,1,1.24-.87A2.07,2.07,0,0,1,1161,405.48Z"
                fill="#2f6840"
              />
              <path
                d="M1159.62,408.69a1.86,1.86,0,0,0-.66-1c-.28-.29-.63-.51-1-.81a2.08,2.08,0,0,1,1.21.55,1.76,1.76,0,0,1,.41.56A1,1,0,0,1,1159.62,408.69Z"
                fill="#2f6840"
              />
              <path
                d="M1157.66,406.73c-.24.06-.47.09-.69.16a5,5,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2,2,0,0,1,1157.66,406.73Z"
                fill="#2f6840"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M1198.37,384.88c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1198.37,384.88Z"
                fill="#2f6840"
              />
              <path
                d="M1197.86,384.54c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1197.86,384.54Z"
                fill="#3ba525"
              />
              <path
                d="M1198.61,384.51a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.46-1.06-.74a2.27,2.27,0,0,1,1.28.46,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1198.61,384.51Z"
                fill="#2f6840"
              />
              <path
                d="M1202.09,383.71c-.26,0-.49.05-.72.1a5.2,5.2,0,0,0-.68.17,13.44,13.44,0,0,0-1.35.53,2.5,2.5,0,0,1,1.24-.87A2.12,2.12,0,0,1,1202.09,383.71Z"
                fill="#2f6840"
              />
              <path
                d="M1200.72,386.92a1.9,1.9,0,0,0-.66-1c-.28-.29-.63-.5-1-.81a2.27,2.27,0,0,1,1.22.55,1.78,1.78,0,0,1,.4.57A.94.94,0,0,1,1200.72,386.92Z"
                fill="#2f6840"
              />
              <path
                d="M1198.76,385a7,7,0,0,0-.69.16,3.83,3.83,0,0,0-.65.22,10,10,0,0,0-1.25.65,2.31,2.31,0,0,1,1.11-1A2,2,0,0,1,1198.76,385Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1195.71,393.61c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1195.71,393.61Z"
                fill="#2f6840"
              />
              <path
                d="M1195.2,393.27c4.43-.26-4.33.45-4.35-.62s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.23-2.78,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.34,14.34,0,0,1,1195.2,393.27Z"
                fill="#3ba525"
              />
              <path
                d="M1196,393.24a2.15,2.15,0,0,0-.79-.94c-.33-.27-.71-.46-1.07-.74a2.34,2.34,0,0,1,1.28.45,1.87,1.87,0,0,1,.47.54A.93.93,0,0,1,1196,393.24Z"
                fill="#2f6840"
              />
              <path
                d="M1199.43,392.44c-.25,0-.49.05-.72.1a5.2,5.2,0,0,0-.68.17,13.44,13.44,0,0,0-1.35.53,2.5,2.5,0,0,1,1.24-.87A2.12,2.12,0,0,1,1199.43,392.44Z"
                fill="#2f6840"
              />
              <path
                d="M1198.06,395.65a1.86,1.86,0,0,0-.66-1c-.28-.29-.63-.5-1-.81a2.17,2.17,0,0,1,1.22.55,1.68,1.68,0,0,1,.4.57A.94.94,0,0,1,1198.06,395.65Z"
                fill="#2f6840"
              />
              <path
                d="M1196.11,393.7a6.61,6.61,0,0,0-.7.15,5,5,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.31,2.31,0,0,1,1.11-1A2,2,0,0,1,1196.11,393.7Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1190.35,388.65c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1190.35,388.65Z"
                fill="#2f6840"
              />
              <path
                d="M1189.85,388.31c4.42-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1189.85,388.31Z"
                fill="#3ba525"
              />
              <path
                d="M1190.6,388.28a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.74a2.28,2.28,0,0,1,1.29.46,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1190.6,388.28Z"
                fill="#2f6840"
              />
              <path
                d="M1194.08,387.48c-.26,0-.49,0-.73.1a3.67,3.67,0,0,0-.67.18,11.31,11.31,0,0,0-1.35.52,2.5,2.5,0,0,1,1.24-.87A2.12,2.12,0,0,1,1194.08,387.48Z"
                fill="#2f6840"
              />
              <path
                d="M1192.71,390.69a1.9,1.9,0,0,0-.66-1c-.28-.28-.64-.5-1-.81a2.21,2.21,0,0,1,1.21.55,1.81,1.81,0,0,1,.41.57A.94.94,0,0,1,1192.71,390.69Z"
                fill="#2f6840"
              />
              <path
                d="M1190.75,388.74c-.24.06-.47.09-.7.16a3.45,3.45,0,0,0-.64.22,10,10,0,0,0-1.25.65,2.36,2.36,0,0,1,1.11-1A2,2,0,0,1,1190.75,388.74Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1182,385.28c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.92-2.16,3.63,3.56,2.65,3.44-4.69.05-4.69.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.92,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1182,385.28Z"
                fill="#2f6840"
              />
              <path
                d="M1181.51,384.94c4.42-.25-4.33.45-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,1181.51,384.94Z"
                fill="#3ba525"
              />
              <path
                d="M1182.26,384.91a2.17,2.17,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,2.23,2.23,0,0,1,.47.54A1,1,0,0,1,1182.26,384.91Z"
                fill="#2f6840"
              />
              <path
                d="M1185.74,384.11c-.26,0-.5.05-.73.1a5.2,5.2,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.45,2.45,0,0,1,1.24-.87A2.13,2.13,0,0,1,1185.74,384.11Z"
                fill="#2f6840"
              />
              <path
                d="M1184.37,387.32a2,2,0,0,0-.66-1c-.29-.29-.64-.5-1-.81a2.14,2.14,0,0,1,1.21.55,1.55,1.55,0,0,1,.4.57A.89.89,0,0,1,1184.37,387.32Z"
                fill="#2f6840"
              />
              <path
                d="M1182.41,385.37a6.56,6.56,0,0,0-.7.16,3.45,3.45,0,0,0-.64.22,9.33,9.33,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2,2,0,0,1,1182.41,385.37Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1196.72,400.77c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.24.27,2.24,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1196.72,400.77Z"
                fill="#2f6840"
              />
              <path
                d="M1196.21,400.43c4.43-.26-4.33.45-4.35-.62s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.23-2.78,2.92-2.16S1204,401,1203,400.9s-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.34,14.34,0,0,1,1196.21,400.43Z"
                fill="#3ba525"
              />
              <path
                d="M1197,400.4a2.15,2.15,0,0,0-.79-.94c-.33-.27-.71-.46-1.07-.74a2.34,2.34,0,0,1,1.28.45,2,2,0,0,1,.47.53A1,1,0,0,1,1197,400.4Z"
                fill="#2f6840"
              />
              <path
                d="M1200.44,399.6c-.25,0-.49,0-.72.1a5.2,5.2,0,0,0-.68.17,13.44,13.44,0,0,0-1.35.53,2.5,2.5,0,0,1,1.24-.87A2.12,2.12,0,0,1,1200.44,399.6Z"
                fill="#2f6840"
              />
              <path
                d="M1199.07,402.81a1.86,1.86,0,0,0-.66-1c-.28-.29-.63-.5-1-.81a2.17,2.17,0,0,1,1.22.55,1.68,1.68,0,0,1,.4.57A.94.94,0,0,1,1199.07,402.81Z"
                fill="#2f6840"
              />
              <path
                d="M1197.12,400.86a6.61,6.61,0,0,0-.7.15,5,5,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2,2,0,0,1,1197.12,400.86Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1183.26,395.2c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1183.26,395.2Z"
                fill="#2f6840"
              />
              <path
                d="M1182.75,394.86c4.43-.25-4.32.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,1182.75,394.86Z"
                fill="#3ba525"
              />
              <path
                d="M1183.51,394.83a2.17,2.17,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.87,1.87,0,0,1,.47.54A1,1,0,0,1,1183.51,394.83Z"
                fill="#2f6840"
              />
              <path
                d="M1187,394c-.25,0-.49.05-.72.1a5.2,5.2,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.47,2.47,0,0,1,1.23-.87A2.12,2.12,0,0,1,1187,394Z"
                fill="#2f6840"
              />
              <path
                d="M1185.62,397.24a2,2,0,0,0-.66-1c-.29-.29-.64-.5-1-.81a2.17,2.17,0,0,1,1.21.55,1.55,1.55,0,0,1,.4.57A.94.94,0,0,1,1185.62,397.24Z"
                fill="#2f6840"
              />
              <path
                d="M1183.66,395.29a6.56,6.56,0,0,0-.7.16,3.45,3.45,0,0,0-.64.22,10.08,10.08,0,0,0-1.26.65,2.29,2.29,0,0,1,1.12-1A2,2,0,0,1,1183.66,395.29Z"
                fill="#2f6840"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M1224.48,373.47c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1224.48,373.47Z"
                fill="#2f6840"
              />
              <path
                d="M1224,373.13c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.23-2.77,2.92-2.16,3.62,3.56,2.65,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1224,373.13Z"
                fill="#3ba525"
              />
              <path
                d="M1224.72,373.1a2.15,2.15,0,0,0-.79-.94c-.33-.26-.71-.46-1.07-.74a2.27,2.27,0,0,1,1.28.46,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1224.72,373.1Z"
                fill="#2f6840"
              />
              <path
                d="M1228.2,372.3c-.25,0-.49.05-.72.1a5.2,5.2,0,0,0-.68.17,13.44,13.44,0,0,0-1.35.53,2.5,2.5,0,0,1,1.24-.87A2.12,2.12,0,0,1,1228.2,372.3Z"
                fill="#2f6840"
              />
              <path
                d="M1226.83,375.51a1.9,1.9,0,0,0-.66-1c-.28-.29-.63-.5-1-.81a2.24,2.24,0,0,1,1.22.55,1.78,1.78,0,0,1,.4.57A.94.94,0,0,1,1226.83,375.51Z"
                fill="#2f6840"
              />
              <path
                d="M1224.88,373.56a6.56,6.56,0,0,0-.7.16,3.83,3.83,0,0,0-.65.22,10,10,0,0,0-1.25.65,2.31,2.31,0,0,1,1.11-1A2.07,2.07,0,0,1,1224.88,373.56Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1221.82,382.2c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.24.27,2.24,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1221.82,382.2Z"
                fill="#2f6840"
              />
              <path
                d="M1221.31,381.86c4.43-.26-4.33.45-4.35-.62s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.34,14.34,0,0,1,1221.31,381.86Z"
                fill="#3ba525"
              />
              <path
                d="M1222.06,381.83a2.15,2.15,0,0,0-.79-.94c-.33-.27-.71-.46-1.07-.74a2.31,2.31,0,0,1,1.28.45,2,2,0,0,1,.47.53A1,1,0,0,1,1222.06,381.83Z"
                fill="#2f6840"
              />
              <path
                d="M1225.54,381c-.25,0-.49.05-.72.1a5.2,5.2,0,0,0-.68.17,13.44,13.44,0,0,0-1.35.53A2.54,2.54,0,0,1,1224,381,2.12,2.12,0,0,1,1225.54,381Z"
                fill="#2f6840"
              />
              <path
                d="M1224.17,384.24a1.86,1.86,0,0,0-.66-1c-.28-.29-.63-.5-1-.81a2.17,2.17,0,0,1,1.22.55,1.68,1.68,0,0,1,.4.57A.94.94,0,0,1,1224.17,384.24Z"
                fill="#2f6840"
              />
              <path
                d="M1222.22,382.29a6.61,6.61,0,0,0-.7.15,5,5,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.24,2.24,0,0,1,1.12-1A2,2,0,0,1,1222.22,382.29Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1216.46,377.24c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.55,14.55,0,0,1,1216.46,377.24Z"
                fill="#2f6840"
              />
              <path
                d="M1216,376.9c4.42-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1216,376.9Z"
                fill="#3ba525"
              />
              <path
                d="M1216.71,376.87a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.29.46,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1216.71,376.87Z"
                fill="#2f6840"
              />
              <path
                d="M1220.19,376.07c-.26,0-.49.05-.73.1a3.67,3.67,0,0,0-.67.18,11.31,11.31,0,0,0-1.35.52,2.5,2.5,0,0,1,1.24-.87A2.12,2.12,0,0,1,1220.19,376.07Z"
                fill="#2f6840"
              />
              <path
                d="M1218.82,379.28a1.9,1.9,0,0,0-.66-1c-.28-.29-.64-.5-1-.81a2.21,2.21,0,0,1,1.21.55,1.81,1.81,0,0,1,.41.57A.94.94,0,0,1,1218.82,379.28Z"
                fill="#2f6840"
              />
              <path
                d="M1216.86,377.33c-.24.06-.47.09-.69.16a3.55,3.55,0,0,0-.65.22,10,10,0,0,0-1.25.65,2.36,2.36,0,0,1,1.11-1A2,2,0,0,1,1216.86,377.33Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1208.12,373.87c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.44-4.69.05-4.69.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.92,3.33-3,2.55-2.25-2.28-2.08-2.37A14.65,14.65,0,0,1,1208.12,373.87Z"
                fill="#2f6840"
              />
              <path
                d="M1207.62,373.53c4.42-.25-4.33.45-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,1207.62,373.53Z"
                fill="#3ba525"
              />
              <path
                d="M1208.37,373.5a2.17,2.17,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,2,2,0,0,1,.47.54A1,1,0,0,1,1208.37,373.5Z"
                fill="#2f6840"
              />
              <path
                d="M1211.85,372.7c-.26,0-.5.05-.73.1a5.2,5.2,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.45,2.45,0,0,1,1.24-.87A2.13,2.13,0,0,1,1211.85,372.7Z"
                fill="#2f6840"
              />
              <path
                d="M1210.48,375.91a2,2,0,0,0-.66-1c-.28-.29-.64-.5-1-.81a2.14,2.14,0,0,1,1.21.55,1.55,1.55,0,0,1,.4.57A.89.89,0,0,1,1210.48,375.91Z"
                fill="#2f6840"
              />
              <path
                d="M1208.52,374c-.25.06-.48.08-.7.15a4.41,4.41,0,0,0-.64.23,9.33,9.33,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2,2,0,0,1,1208.52,374Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1222.83,389.36c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1222.83,389.36Z"
                fill="#2f6840"
              />
              <path
                d="M1222.32,389c4.43-.26-4.33.45-4.35-.62s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.23-2.78,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.37A14.77,14.77,0,0,1,1222.32,389Z"
                fill="#3ba525"
              />
              <path
                d="M1223.07,389a2.15,2.15,0,0,0-.79-.94c-.33-.27-.71-.46-1.07-.74a2.34,2.34,0,0,1,1.28.45,2,2,0,0,1,.47.53A1,1,0,0,1,1223.07,389Z"
                fill="#2f6840"
              />
              <path
                d="M1226.55,388.19c-.25,0-.49.05-.72.1a5.2,5.2,0,0,0-.68.17,13.44,13.44,0,0,0-1.35.53,2.54,2.54,0,0,1,1.24-.87A2.12,2.12,0,0,1,1226.55,388.19Z"
                fill="#2f6840"
              />
              <path
                d="M1225.18,391.4a1.86,1.86,0,0,0-.66-1c-.28-.29-.63-.5-1-.81a2.17,2.17,0,0,1,1.22.55,1.68,1.68,0,0,1,.4.57A.94.94,0,0,1,1225.18,391.4Z"
                fill="#2f6840"
              />
              <path
                d="M1223.23,389.45a6.61,6.61,0,0,0-.7.15,5,5,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.24,2.24,0,0,1,1.12-1A2,2,0,0,1,1223.23,389.45Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1209.37,383.79c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.69.05-4.69.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.17-2.9-1.17-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1209.37,383.79Z"
                fill="#2f6840"
              />
              <path
                d="M1208.86,383.45c4.43-.25-4.32.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,1208.86,383.45Z"
                fill="#3ba525"
              />
              <path
                d="M1209.62,383.42a2.17,2.17,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.87,1.87,0,0,1,.47.54A1,1,0,0,1,1209.62,383.42Z"
                fill="#2f6840"
              />
              <path
                d="M1213.09,382.62c-.25,0-.49.05-.72.1a5.2,5.2,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.47,2.47,0,0,1,1.23-.87A2.12,2.12,0,0,1,1213.09,382.62Z"
                fill="#2f6840"
              />
              <path
                d="M1211.73,385.83a2,2,0,0,0-.66-1c-.29-.29-.64-.5-1-.81a2.17,2.17,0,0,1,1.21.55,1.55,1.55,0,0,1,.4.57A.94.94,0,0,1,1211.73,385.83Z"
                fill="#2f6840"
              />
              <path
                d="M1209.77,383.88c-.25.06-.48.08-.7.15a4.41,4.41,0,0,0-.64.23,9.33,9.33,0,0,0-1.25.65,2.22,2.22,0,0,1,1.11-1A2,2,0,0,1,1209.77,383.88Z"
                fill="#2f6840"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M1246.87,357.13c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1246.87,357.13Z"
                fill="#2f6840"
              />
              <path
                d="M1246.36,356.79c4.43-.26-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.23-2.78,2.92-2.16,3.62,3.56,2.65,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.34,14.34,0,0,1,1246.36,356.79Z"
                fill="#3ba525"
              />
              <path
                d="M1247.11,356.76a2.15,2.15,0,0,0-.79-.94c-.33-.27-.71-.46-1.07-.74a2.34,2.34,0,0,1,1.28.45,1.87,1.87,0,0,1,.47.54A1,1,0,0,1,1247.11,356.76Z"
                fill="#2f6840"
              />
              <path
                d="M1250.59,356c-.25,0-.49.05-.72.1a5.2,5.2,0,0,0-.68.17,13.44,13.44,0,0,0-1.35.53,2.5,2.5,0,0,1,1.24-.87A2.12,2.12,0,0,1,1250.59,356Z"
                fill="#2f6840"
              />
              <path
                d="M1249.22,359.17a1.86,1.86,0,0,0-.66-1c-.28-.29-.63-.5-1-.81a2.17,2.17,0,0,1,1.22.55,1.68,1.68,0,0,1,.4.57A.94.94,0,0,1,1249.22,359.17Z"
                fill="#2f6840"
              />
              <path
                d="M1247.27,357.22a6.61,6.61,0,0,0-.7.15,5,5,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.31,2.31,0,0,1,1.11-1A2,2,0,0,1,1247.27,357.22Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1244.21,365.86c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1244.21,365.86Z"
                fill="#2f6840"
              />
              <path
                d="M1243.7,365.51c4.43-.25-4.33.46-4.35-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A15,15,0,0,1,1243.7,365.51Z"
                fill="#3ba525"
              />
              <path
                d="M1244.45,365.49a2.1,2.1,0,0,0-.79-.94c-.33-.27-.71-.46-1.07-.74a2.34,2.34,0,0,1,1.28.45,1.83,1.83,0,0,1,.47.53A1,1,0,0,1,1244.45,365.49Z"
                fill="#2f6840"
              />
              <path
                d="M1247.93,364.69c-.25,0-.49,0-.72.1a5.2,5.2,0,0,0-.68.17,13.44,13.44,0,0,0-1.35.53,2.54,2.54,0,0,1,1.24-.87A2.07,2.07,0,0,1,1247.93,364.69Z"
                fill="#2f6840"
              />
              <path
                d="M1246.56,367.9a1.86,1.86,0,0,0-.66-1c-.28-.29-.63-.5-1-.81a2.1,2.1,0,0,1,1.22.55,1.68,1.68,0,0,1,.4.57A.94.94,0,0,1,1246.56,367.9Z"
                fill="#2f6840"
              />
              <path
                d="M1244.61,366a6.61,6.61,0,0,0-.7.15,5,5,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.24,2.24,0,0,1,1.12-1A2,2,0,0,1,1244.61,366Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1238.85,360.9c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1238.85,360.9Z"
                fill="#2f6840"
              />
              <path
                d="M1238.35,360.56c4.42-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1238.35,360.56Z"
                fill="#3ba525"
              />
              <path
                d="M1239.1,360.53a2.11,2.11,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,2,2,0,0,1,.47.54A1,1,0,0,1,1239.1,360.53Z"
                fill="#2f6840"
              />
              <path
                d="M1242.58,359.73c-.26,0-.49,0-.73.1a4.69,4.69,0,0,0-.67.17,13.44,13.44,0,0,0-1.35.53,2.5,2.5,0,0,1,1.24-.87A2.12,2.12,0,0,1,1242.58,359.73Z"
                fill="#2f6840"
              />
              <path
                d="M1241.21,362.94a1.86,1.86,0,0,0-.66-1c-.28-.29-.64-.5-1-.81a2.21,2.21,0,0,1,1.21.55,1.7,1.7,0,0,1,.41.57A.94.94,0,0,1,1241.21,362.94Z"
                fill="#2f6840"
              />
              <path
                d="M1239.25,361a7,7,0,0,0-.69.16,3.55,3.55,0,0,0-.65.22,10,10,0,0,0-1.25.65,2.31,2.31,0,0,1,1.11-1A2,2,0,0,1,1239.25,361Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1230.51,357.53c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.92-2.15,3.63,3.56,2.65,3.44-4.69.05-4.69.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.92,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1230.51,357.53Z"
                fill="#2f6840"
              />
              <path
                d="M1230,357.18c4.42-.25-4.33.46-4.36-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.87,14.87,0,0,1,1230,357.18Z"
                fill="#3ba525"
              />
              <path
                d="M1230.76,357.16a2.12,2.12,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,2.16,2.16,0,0,1,.47.53A1,1,0,0,1,1230.76,357.16Z"
                fill="#2f6840"
              />
              <path
                d="M1234.24,356.36c-.26,0-.5.05-.73.1a5.2,5.2,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.45,2.45,0,0,1,1.24-.87A2.07,2.07,0,0,1,1234.24,356.36Z"
                fill="#2f6840"
              />
              <path
                d="M1232.87,359.57a2,2,0,0,0-.66-1c-.28-.29-.64-.5-1-.81a2.08,2.08,0,0,1,1.21.55,1.55,1.55,0,0,1,.4.57A.89.89,0,0,1,1232.87,359.57Z"
                fill="#2f6840"
              />
              <path
                d="M1230.91,357.62a6.61,6.61,0,0,0-.7.15,4.41,4.41,0,0,0-.64.23,9.33,9.33,0,0,0-1.25.65,2.22,2.22,0,0,1,1.11-1A2,2,0,0,1,1230.91,357.62Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1245.22,373c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.54-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,1245.22,373Z"
                fill="#2f6840"
              />
              <path
                d="M1244.71,372.67c4.43-.25-4.33.46-4.35-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.23-2.78,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A15,15,0,0,1,1244.71,372.67Z"
                fill="#3ba525"
              />
              <path
                d="M1245.46,372.65a2.1,2.1,0,0,0-.79-.94c-.33-.27-.71-.46-1.07-.74a2.34,2.34,0,0,1,1.28.45,1.83,1.83,0,0,1,.47.53A1,1,0,0,1,1245.46,372.65Z"
                fill="#2f6840"
              />
              <path
                d="M1248.94,371.85c-.25,0-.49,0-.72.1a4,4,0,0,0-.68.17,13.44,13.44,0,0,0-1.35.53,2.54,2.54,0,0,1,1.24-.87A2.07,2.07,0,0,1,1248.94,371.85Z"
                fill="#2f6840"
              />
              <path
                d="M1247.57,375.06a1.86,1.86,0,0,0-.66-1c-.28-.29-.63-.5-1-.81a2.1,2.1,0,0,1,1.22.55,1.68,1.68,0,0,1,.4.57A.94.94,0,0,1,1247.57,375.06Z"
                fill="#2f6840"
              />
              <path
                d="M1245.62,373.11a6.61,6.61,0,0,0-.7.15,5,5,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2,2,0,0,1,1245.62,373.11Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1231.76,367.45c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.69.05-4.69.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.17-2.9-1.17-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1231.76,367.45Z"
                fill="#2f6840"
              />
              <path
                d="M1231.25,367.1c4.43-.25-4.32.46-4.35-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.28-2.07-2.37A14.86,14.86,0,0,1,1231.25,367.1Z"
                fill="#3ba525"
              />
              <path
                d="M1232,367.08a2.12,2.12,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,2,2,0,0,1,.47.53A1,1,0,0,1,1232,367.08Z"
                fill="#2f6840"
              />
              <path
                d="M1235.48,366.28c-.25,0-.49,0-.72.1a5.2,5.2,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.47,2.47,0,0,1,1.23-.87A2.07,2.07,0,0,1,1235.48,366.28Z"
                fill="#2f6840"
              />
              <path
                d="M1234.12,369.49a2,2,0,0,0-.66-1c-.29-.29-.64-.5-1-.81a2.1,2.1,0,0,1,1.21.55,1.55,1.55,0,0,1,.4.57A.94.94,0,0,1,1234.12,369.49Z"
                fill="#2f6840"
              />
              <path
                d="M1232.16,367.54a6.61,6.61,0,0,0-.7.15,4.41,4.41,0,0,0-.64.23,9.33,9.33,0,0,0-1.25.65,2.18,2.18,0,0,1,1.11-1A2,2,0,0,1,1232.16,367.54Z"
                fill="#2f6840"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M1246.48,329c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1246.48,329Z"
                fill="#2f6840"
              />
              <path
                d="M1246,328.64c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.23-2.77,2.92-2.15,3.62,3.55,2.65,3.44-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.72-1.17-2.91-1.17-2.91-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1246,328.64Z"
                fill="#3ba525"
              />
              <path
                d="M1246.72,328.61a2.15,2.15,0,0,0-.79-.94c-.33-.26-.71-.45-1.07-.73a2.26,2.26,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1246.72,328.61Z"
                fill="#2f6840"
              />
              <path
                d="M1250.2,327.81c-.25,0-.49.05-.72.1a4,4,0,0,0-.68.18,11.31,11.31,0,0,0-1.35.52,2.42,2.42,0,0,1,1.24-.86A2.12,2.12,0,0,1,1250.2,327.81Z"
                fill="#2f6840"
              />
              <path
                d="M1248.83,331a1.9,1.9,0,0,0-.66-1c-.28-.28-.63-.5-1-.81a2.24,2.24,0,0,1,1.22.55,1.78,1.78,0,0,1,.4.57A.94.94,0,0,1,1248.83,331Z"
                fill="#2f6840"
              />
              <path
                d="M1246.88,329.07c-.25.06-.48.09-.7.16a3.15,3.15,0,0,0-.65.23,8.71,8.71,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,1246.88,329.07Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1243.82,337.71c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1243.82,337.71Z"
                fill="#2f6840"
              />
              <path
                d="M1243.31,337.37c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1243.31,337.37Z"
                fill="#3ba525"
              />
              <path
                d="M1244.06,337.34a2.15,2.15,0,0,0-.79-.94c-.33-.26-.71-.46-1.07-.74a2.27,2.27,0,0,1,1.28.46,1.71,1.71,0,0,1,.47.53A.93.93,0,0,1,1244.06,337.34Z"
                fill="#2f6840"
              />
              <path
                d="M1247.54,336.54c-.25,0-.49,0-.72.1a4,4,0,0,0-.68.18,11.31,11.31,0,0,0-1.35.52,2.54,2.54,0,0,1,1.24-.87A2.12,2.12,0,0,1,1247.54,336.54Z"
                fill="#2f6840"
              />
              <path
                d="M1246.17,339.75a1.9,1.9,0,0,0-.66-1c-.28-.29-.63-.5-1-.81a2.24,2.24,0,0,1,1.22.55,1.78,1.78,0,0,1,.4.57A.94.94,0,0,1,1246.17,339.75Z"
                fill="#2f6840"
              />
              <path
                d="M1244.22,337.8c-.25.06-.48.09-.7.16a3.83,3.83,0,0,0-.65.22,10,10,0,0,0-1.25.65,2.34,2.34,0,0,1,1.12-1A2,2,0,0,1,1244.22,337.8Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1238.46,332.75c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1238.46,332.75Z"
                fill="#2f6840"
              />
              <path
                d="M1238,332.41c4.42-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1238,332.41Z"
                fill="#3ba525"
              />
              <path
                d="M1238.71,332.38a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1238.71,332.38Z"
                fill="#2f6840"
              />
              <path
                d="M1242.19,331.59c-.26,0-.49,0-.73.09a3.67,3.67,0,0,0-.67.18,11.31,11.31,0,0,0-1.35.52,2.42,2.42,0,0,1,1.24-.86A2.07,2.07,0,0,1,1242.19,331.59Z"
                fill="#2f6840"
              />
              <path
                d="M1240.82,334.8a1.88,1.88,0,0,0-.66-1c-.28-.28-.64-.5-1-.8a2.13,2.13,0,0,1,1.21.54,1.81,1.81,0,0,1,.41.57A1,1,0,0,1,1240.82,334.8Z"
                fill="#2f6840"
              />
              <path
                d="M1238.86,332.84c-.24.06-.47.09-.69.16a3,3,0,0,0-.65.23,9.87,9.87,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,1238.86,332.84Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1230.12,329.38c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.92-2.16,3.63,3.56,2.65,3.44-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.92,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1230.12,329.38Z"
                fill="#2f6840"
              />
              <path
                d="M1229.62,329c4.42-.25-4.33.45-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,1229.62,329Z"
                fill="#3ba525"
              />
              <path
                d="M1230.37,329a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.74a2.35,2.35,0,0,1,1.29.46,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1230.37,329Z"
                fill="#2f6840"
              />
              <path
                d="M1233.85,328.21c-.26,0-.5.05-.73.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.45,2.45,0,0,1,1.24-.87A2.13,2.13,0,0,1,1233.85,328.21Z"
                fill="#2f6840"
              />
              <path
                d="M1232.48,331.42a2,2,0,0,0-.66-1c-.28-.28-.64-.5-1-.81a2.21,2.21,0,0,1,1.21.55,1.64,1.64,0,0,1,.4.57A.89.89,0,0,1,1232.48,331.42Z"
                fill="#2f6840"
              />
              <path
                d="M1230.52,329.47c-.25.06-.48.09-.7.16a3.45,3.45,0,0,0-.64.22,9.33,9.33,0,0,0-1.25.65,2.31,2.31,0,0,1,1.11-1A2,2,0,0,1,1230.52,329.47Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1244.83,344.87c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1244.83,344.87Z"
                fill="#2f6840"
              />
              <path
                d="M1244.32,344.53c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.23-2.77,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1244.32,344.53Z"
                fill="#3ba525"
              />
              <path
                d="M1245.07,344.5a2.15,2.15,0,0,0-.79-.94c-.33-.26-.71-.46-1.07-.74a2.27,2.27,0,0,1,1.28.46,1.71,1.71,0,0,1,.47.53A.93.93,0,0,1,1245.07,344.5Z"
                fill="#2f6840"
              />
              <path
                d="M1248.55,343.7c-.25,0-.49.05-.72.1a4,4,0,0,0-.68.18,11.31,11.31,0,0,0-1.35.52,2.54,2.54,0,0,1,1.24-.87A2.12,2.12,0,0,1,1248.55,343.7Z"
                fill="#2f6840"
              />
              <path
                d="M1247.18,346.91a1.9,1.9,0,0,0-.66-1c-.28-.29-.63-.5-1-.81a2.24,2.24,0,0,1,1.22.55,1.78,1.78,0,0,1,.4.57A.94.94,0,0,1,1247.18,346.91Z"
                fill="#2f6840"
              />
              <path
                d="M1245.23,345c-.25.06-.48.09-.7.16a3.83,3.83,0,0,0-.65.22,10,10,0,0,0-1.25.65,2.36,2.36,0,0,1,1.11-1A2.07,2.07,0,0,1,1245.23,345Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1231.37,339.3c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.69.05-4.69.05,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1231.37,339.3Z"
                fill="#2f6840"
              />
              <path
                d="M1230.86,339c4.43-.25-4.32.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,1230.86,339Z"
                fill="#3ba525"
              />
              <path
                d="M1231.62,338.93a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.74a2.29,2.29,0,0,1,1.28.46,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1231.62,338.93Z"
                fill="#2f6840"
              />
              <path
                d="M1235.09,338.13c-.25,0-.49.05-.72.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.47,2.47,0,0,1,1.23-.87A2.12,2.12,0,0,1,1235.09,338.13Z"
                fill="#2f6840"
              />
              <path
                d="M1233.73,341.34a2,2,0,0,0-.66-1c-.29-.28-.64-.5-1-.81a2.24,2.24,0,0,1,1.21.55,1.64,1.64,0,0,1,.4.57A.94.94,0,0,1,1233.73,341.34Z"
                fill="#2f6840"
              />
              <path
                d="M1231.77,339.39c-.25.06-.48.09-.7.16a3.45,3.45,0,0,0-.64.22,9.33,9.33,0,0,0-1.25.65,2.27,2.27,0,0,1,1.11-1A2,2,0,0,1,1231.77,339.39Z"
                fill="#2f6840"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M1239.85,301.57c4.43-.26-4.33.45-4.35-.62s4.35-2.62,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.34,14.34,0,0,1,1239.85,301.57Z"
                fill="#2f6840"
              />
              <path
                d="M1239.34,301.22c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.44-4.69.05-4.69.05,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1239.34,301.22Z"
                fill="#3ba525"
              />
              <path
                d="M1240.1,301.19a2.09,2.09,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1240.1,301.19Z"
                fill="#2f6840"
              />
              <path
                d="M1243.57,300.4c-.25,0-.49,0-.72.09a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.45,2.45,0,0,1,1.23-.86A2.07,2.07,0,0,1,1243.57,300.4Z"
                fill="#2f6840"
              />
              <path
                d="M1242.21,303.61a1.94,1.94,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.16,2.16,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A1,1,0,0,1,1242.21,303.61Z"
                fill="#2f6840"
              />
              <path
                d="M1240.25,301.65c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,10,10,0,0,0-1.26.64,2.27,2.27,0,0,1,1.12-1A2,2,0,0,1,1240.25,301.65Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1237.19,310.29c4.43-.25-4.33.46-4.35-.61s4.35-2.62,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A15,15,0,0,1,1237.19,310.29Z"
                fill="#2f6840"
              />
              <path
                d="M1236.68,310c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1236.68,310Z"
                fill="#3ba525"
              />
              <path
                d="M1237.44,309.92a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.28,2.28,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1237.44,309.92Z"
                fill="#2f6840"
              />
              <path
                d="M1240.91,309.13c-.25,0-.49,0-.72.09a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.39,2.39,0,0,1,1.23-.86A2.07,2.07,0,0,1,1240.91,309.13Z"
                fill="#2f6840"
              />
              <path
                d="M1239.55,312.34a1.94,1.94,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.16,2.16,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A1,1,0,0,1,1239.55,312.34Z"
                fill="#2f6840"
              />
              <path
                d="M1237.59,310.38c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,9.24,9.24,0,0,0-1.25.64,2.2,2.2,0,0,1,1.11-1A2,2,0,0,1,1237.59,310.38Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1231.84,305.34c4.42-.25-4.33.45-4.35-.61s4.34-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1231.84,305.34Z"
                fill="#2f6840"
              />
              <path
                d="M1231.33,305c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.92-2.16,3.63,3.56,2.65,3.44-4.69.05-4.69.05,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.92,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1231.33,305Z"
                fill="#3ba525"
              />
              <path
                d="M1232.08,305a2.13,2.13,0,0,0-.79-.93c-.33-.27-.71-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A.94.94,0,0,1,1232.08,305Z"
                fill="#2f6840"
              />
              <path
                d="M1235.56,304.17a5.43,5.43,0,0,0-.72.1,3.22,3.22,0,0,0-.68.17,10.45,10.45,0,0,0-1.35.53,2.48,2.48,0,0,1,1.24-.87A2.07,2.07,0,0,1,1235.56,304.17Z"
                fill="#2f6840"
              />
              <path
                d="M1234.19,307.38a1.9,1.9,0,0,0-.65-1c-.29-.29-.64-.51-1-.81a2.16,2.16,0,0,1,1.21.54,1.78,1.78,0,0,1,.4.57A1,1,0,0,1,1234.19,307.38Z"
                fill="#2f6840"
              />
              <path
                d="M1232.24,305.42c-.25.06-.48.09-.7.16a3.87,3.87,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.24,2.24,0,0,1,1.12-1A2,2,0,0,1,1232.24,305.42Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1223.5,302c4.42-.25-4.33.46-4.36-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.87,14.87,0,0,1,1223.5,302Z"
                fill="#2f6840"
              />
              <path
                d="M1223,301.62c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1223,301.62Z"
                fill="#3ba525"
              />
              <path
                d="M1223.74,301.59a2,2,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1223.74,301.59Z"
                fill="#2f6840"
              />
              <path
                d="M1227.22,300.8c-.26,0-.49,0-.72.09a3.57,3.57,0,0,0-.68.18,11.31,11.31,0,0,0-1.35.52,2.42,2.42,0,0,1,1.24-.86A2.07,2.07,0,0,1,1227.22,300.8Z"
                fill="#2f6840"
              />
              <path
                d="M1225.85,304a1.82,1.82,0,0,0-.66-1c-.28-.29-.63-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.81,1.81,0,0,1,.41.57A1,1,0,0,1,1225.85,304Z"
                fill="#2f6840"
              />
              <path
                d="M1223.89,302.05c-.24.06-.47.09-.69.16a3.15,3.15,0,0,0-.65.23,9.87,9.87,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,1223.89,302.05Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1238.2,317.45c4.43-.25-4.33.46-4.35-.61s4.35-2.62,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1238.2,317.45Z"
                fill="#2f6840"
              />
              <path
                d="M1237.69,317.11c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.24.27,2.24,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1237.69,317.11Z"
                fill="#3ba525"
              />
              <path
                d="M1238.45,317.08a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.28,2.28,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1238.45,317.08Z"
                fill="#2f6840"
              />
              <path
                d="M1241.92,316.29c-.25,0-.49,0-.72.09a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.39,2.39,0,0,1,1.23-.86A2.07,2.07,0,0,1,1241.92,316.29Z"
                fill="#2f6840"
              />
              <path
                d="M1240.56,319.5a1.94,1.94,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.16,2.16,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A1,1,0,0,1,1240.56,319.5Z"
                fill="#2f6840"
              />
              <path
                d="M1238.6,317.54c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,10,10,0,0,0-1.26.64,2.27,2.27,0,0,1,1.12-1A2,2,0,0,1,1238.6,317.54Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1224.74,311.88c4.43-.25-4.33.46-4.35-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.28-2.07-2.37A14.86,14.86,0,0,1,1224.74,311.88Z"
                fill="#2f6840"
              />
              <path
                d="M1224.24,311.54c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1224.24,311.54Z"
                fill="#3ba525"
              />
              <path
                d="M1225,311.51a2,2,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1225,311.51Z"
                fill="#2f6840"
              />
              <path
                d="M1228.47,310.72c-.26,0-.49,0-.73.09a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.38,2.38,0,0,1,1.24-.86A2.07,2.07,0,0,1,1228.47,310.72Z"
                fill="#2f6840"
              />
              <path
                d="M1227.1,313.93a1.88,1.88,0,0,0-.66-1c-.28-.29-.64-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A.92.92,0,0,1,1227.1,313.93Z"
                fill="#2f6840"
              />
              <path
                d="M1225.14,312c-.24.06-.47.09-.7.16a2.87,2.87,0,0,0-.64.23,9.24,9.24,0,0,0-1.25.64,2.24,2.24,0,0,1,1.11-1A2,2,0,0,1,1225.14,312Z"
                fill="#2f6840"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M1212.75,296.43c4.42-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1212.75,296.43Z"
                fill="#2f6840"
              />
              <path
                d="M1212.24,296.09c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.64,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.92,3.34-3,2.55-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,1212.24,296.09Z"
                fill="#3ba525"
              />
              <path
                d="M1213,296.06a2.24,2.24,0,0,0-.8-.94c-.33-.26-.71-.46-1.07-.74a2.22,2.22,0,0,1,1.28.46,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1213,296.06Z"
                fill="#2f6840"
              />
              <path
                d="M1216.47,295.26c-.25,0-.49.05-.72.1a5.2,5.2,0,0,0-.68.17c-.45.13-.87.34-1.35.53a2.54,2.54,0,0,1,1.24-.87A2.12,2.12,0,0,1,1216.47,295.26Z"
                fill="#2f6840"
              />
              <path
                d="M1215.1,298.47a1.94,1.94,0,0,0-.65-1c-.29-.29-.64-.5-1-.81a2.24,2.24,0,0,1,1.21.55,1.78,1.78,0,0,1,.4.57A.94.94,0,0,1,1215.1,298.47Z"
                fill="#2f6840"
              />
              <path
                d="M1213.15,296.52a6.56,6.56,0,0,0-.7.16,3.83,3.83,0,0,0-.65.22,10,10,0,0,0-1.25.65,2.29,2.29,0,0,1,1.12-1A2,2,0,0,1,1213.15,296.52Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1210.09,305.16c4.42-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1210.09,305.16Z"
                fill="#2f6840"
              />
              <path
                d="M1209.58,304.82c4.43-.26-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.27-2.07-2.36A14.24,14.24,0,0,1,1209.58,304.82Z"
                fill="#3ba525"
              />
              <path
                d="M1210.34,304.79a2.17,2.17,0,0,0-.8-.94c-.32-.27-.71-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.87,1.87,0,0,1,.47.54A1,1,0,0,1,1210.34,304.79Z"
                fill="#2f6840"
              />
              <path
                d="M1213.81,304c-.25,0-.49.05-.72.1a5.2,5.2,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.47,2.47,0,0,1,1.23-.87A2.12,2.12,0,0,1,1213.81,304Z"
                fill="#2f6840"
              />
              <path
                d="M1212.45,307.2a2,2,0,0,0-.66-1c-.29-.29-.64-.5-1-.81a2.17,2.17,0,0,1,1.21.55,1.68,1.68,0,0,1,.4.57A.94.94,0,0,1,1212.45,307.2Z"
                fill="#2f6840"
              />
              <path
                d="M1210.49,305.25a6.61,6.61,0,0,0-.7.15,4.41,4.41,0,0,0-.64.23,9.43,9.43,0,0,0-1.26.65,2.29,2.29,0,0,1,1.12-1A2,2,0,0,1,1210.49,305.25Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1204.74,300.2c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1204.74,300.2Z"
                fill="#2f6840"
              />
              <path
                d="M1204.23,299.86c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.23-2.77,2.92-2.15,3.62,3.55,2.65,3.44-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1204.23,299.86Z"
                fill="#3ba525"
              />
              <path
                d="M1205,299.83a2.15,2.15,0,0,0-.79-.94c-.33-.26-.71-.45-1.07-.74a2.27,2.27,0,0,1,1.28.46,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1205,299.83Z"
                fill="#2f6840"
              />
              <path
                d="M1208.46,299c-.25,0-.49.05-.72.1a4,4,0,0,0-.68.18,11.31,11.31,0,0,0-1.35.52A2.5,2.5,0,0,1,1207,299,2.12,2.12,0,0,1,1208.46,299Z"
                fill="#2f6840"
              />
              <path
                d="M1207.09,302.24a1.9,1.9,0,0,0-.66-1c-.28-.28-.63-.5-1-.81a2.24,2.24,0,0,1,1.22.55,1.78,1.78,0,0,1,.4.57A.94.94,0,0,1,1207.09,302.24Z"
                fill="#2f6840"
              />
              <path
                d="M1205.14,300.29c-.25.06-.48.09-.7.16a3.83,3.83,0,0,0-.65.22,10,10,0,0,0-1.25.65,2.36,2.36,0,0,1,1.11-1A2.07,2.07,0,0,1,1205.14,300.29Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1196.39,296.83c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1196.39,296.83Z"
                fill="#2f6840"
              />
              <path
                d="M1195.89,296.49c4.42-.25-4.33.45-4.35-.61s4.34-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1195.89,296.49Z"
                fill="#3ba525"
              />
              <path
                d="M1196.64,296.46a2.11,2.11,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,2,2,0,0,1,.47.54A1,1,0,0,1,1196.64,296.46Z"
                fill="#2f6840"
              />
              <path
                d="M1200.12,295.66c-.26,0-.49,0-.73.1a4.69,4.69,0,0,0-.67.17,13.44,13.44,0,0,0-1.35.53,2.5,2.5,0,0,1,1.24-.87A2.12,2.12,0,0,1,1200.12,295.66Z"
                fill="#2f6840"
              />
              <path
                d="M1198.75,298.87a1.92,1.92,0,0,0-.66-1c-.28-.29-.64-.5-1-.81a2.14,2.14,0,0,1,1.21.55,1.7,1.7,0,0,1,.41.57A.94.94,0,0,1,1198.75,298.87Z"
                fill="#2f6840"
              />
              <path
                d="M1196.79,296.92c-.24.06-.47.08-.7.16a3.45,3.45,0,0,0-.64.22,10,10,0,0,0-1.25.65,2.31,2.31,0,0,1,1.11-1A2,2,0,0,1,1196.79,296.92Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1211.1,312.32c4.42-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.24.26,2.24,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1211.1,312.32Z"
                fill="#2f6840"
              />
              <path
                d="M1210.59,312c4.43-.26-4.33.45-4.35-.62s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.27-2.07-2.36A14.24,14.24,0,0,1,1210.59,312Z"
                fill="#3ba525"
              />
              <path
                d="M1211.35,312a2.24,2.24,0,0,0-.8-.94c-.32-.27-.71-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,2,2,0,0,1,.47.53A1,1,0,0,1,1211.35,312Z"
                fill="#2f6840"
              />
              <path
                d="M1214.82,311.15c-.25,0-.49.05-.72.1a5.2,5.2,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.47,2.47,0,0,1,1.23-.87A2.12,2.12,0,0,1,1214.82,311.15Z"
                fill="#2f6840"
              />
              <path
                d="M1213.46,314.36a2,2,0,0,0-.66-1c-.29-.29-.64-.5-1-.81a2.17,2.17,0,0,1,1.21.55,1.68,1.68,0,0,1,.4.57A1,1,0,0,1,1213.46,314.36Z"
                fill="#2f6840"
              />
              <path
                d="M1211.5,312.41a6.61,6.61,0,0,0-.7.15,5,5,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.29,2.29,0,0,1,1.12-1A2,2,0,0,1,1211.5,312.41Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1197.64,306.75c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.92-2.16,3.63,3.56,2.65,3.44-4.69,0-4.69,0,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.92,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1197.64,306.75Z"
                fill="#2f6840"
              />
              <path
                d="M1197.14,306.41c4.42-.25-4.33.45-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,1197.14,306.41Z"
                fill="#3ba525"
              />
              <path
                d="M1197.89,306.38a2.17,2.17,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,2.23,2.23,0,0,1,.47.54A1,1,0,0,1,1197.89,306.38Z"
                fill="#2f6840"
              />
              <path
                d="M1201.37,305.58c-.26,0-.5.05-.73.1a5.2,5.2,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.45,2.45,0,0,1,1.24-.87A2.13,2.13,0,0,1,1201.37,305.58Z"
                fill="#2f6840"
              />
              <path
                d="M1200,308.79a2,2,0,0,0-.66-1c-.29-.29-.64-.5-1-.81a2.14,2.14,0,0,1,1.21.55,1.55,1.55,0,0,1,.4.57A.89.89,0,0,1,1200,308.79Z"
                fill="#2f6840"
              />
              <path
                d="M1198,306.84a6.56,6.56,0,0,0-.7.16,3.45,3.45,0,0,0-.64.22,9.33,9.33,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2,2,0,0,1,1198,306.84Z"
                fill="#2f6840"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M1184.27,295.48c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.24.26,2.24,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1184.27,295.48Z"
                fill="#2f6840"
              />
              <path
                d="M1183.76,295.14c4.43-.26-4.32.45-4.35-.62s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.27-2.07-2.36A14.24,14.24,0,0,1,1183.76,295.14Z"
                fill="#3ba525"
              />
              <path
                d="M1184.52,295.11a2.17,2.17,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,2,2,0,0,1,.47.53A1,1,0,0,1,1184.52,295.11Z"
                fill="#2f6840"
              />
              <path
                d="M1188,294.31c-.25,0-.49.05-.72.1a5.2,5.2,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.47,2.47,0,0,1,1.23-.87A2.12,2.12,0,0,1,1188,294.31Z"
                fill="#2f6840"
              />
              <path
                d="M1186.63,297.52a2,2,0,0,0-.66-1c-.29-.29-.64-.5-1-.81a2.17,2.17,0,0,1,1.21.55,1.55,1.55,0,0,1,.4.57A.94.94,0,0,1,1186.63,297.52Z"
                fill="#2f6840"
              />
              <path
                d="M1184.67,295.57a6.61,6.61,0,0,0-.7.15,4.41,4.41,0,0,0-.64.23,10.08,10.08,0,0,0-1.26.65,2.24,2.24,0,0,1,1.12-1A2,2,0,0,1,1184.67,295.57Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1181.61,304.21c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.69.05-4.69.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.17-2.9-1.17-2.9-.91,3.33-3,2.54-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1181.61,304.21Z"
                fill="#2f6840"
              />
              <path
                d="M1181.1,303.86c4.43-.25-4.32.46-4.35-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1181.1,303.86Z"
                fill="#3ba525"
              />
              <path
                d="M1181.86,303.84a2.12,2.12,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.83,1.83,0,0,1,.47.53A1,1,0,0,1,1181.86,303.84Z"
                fill="#2f6840"
              />
              <path
                d="M1185.33,303c-.25,0-.49,0-.72.1a4,4,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.41,2.41,0,0,1,1.23-.87A2.07,2.07,0,0,1,1185.33,303Z"
                fill="#2f6840"
              />
              <path
                d="M1184,306.25a2,2,0,0,0-.66-1c-.29-.29-.64-.5-1-.81a2.1,2.1,0,0,1,1.21.55,1.55,1.55,0,0,1,.4.57A.94.94,0,0,1,1184,306.25Z"
                fill="#2f6840"
              />
              <path
                d="M1182,304.29c-.25.06-.48.09-.7.16a4.41,4.41,0,0,0-.64.23,9.33,9.33,0,0,0-1.25.65,2.18,2.18,0,0,1,1.11-1A2,2,0,0,1,1182,304.29Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1176.26,299.25c4.42-.25-4.33.46-4.35-.61s4.34-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1176.26,299.25Z"
                fill="#2f6840"
              />
              <path
                d="M1175.75,298.91c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.92,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1175.75,298.91Z"
                fill="#3ba525"
              />
              <path
                d="M1176.5,298.88a2.15,2.15,0,0,0-.79-.94c-.33-.27-.71-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.87,1.87,0,0,1,.47.54A.93.93,0,0,1,1176.5,298.88Z"
                fill="#2f6840"
              />
              <path
                d="M1180,298.08c-.25,0-.49.05-.72.1a5.2,5.2,0,0,0-.68.17,14.45,14.45,0,0,0-1.35.53,2.54,2.54,0,0,1,1.24-.87A2.12,2.12,0,0,1,1180,298.08Z"
                fill="#2f6840"
              />
              <path
                d="M1178.61,301.29a1.9,1.9,0,0,0-.65-1c-.29-.29-.64-.5-1-.81a2.17,2.17,0,0,1,1.21.55,1.68,1.68,0,0,1,.4.57A.94.94,0,0,1,1178.61,301.29Z"
                fill="#2f6840"
              />
              <path
                d="M1176.66,299.34a6.56,6.56,0,0,0-.7.16,3.83,3.83,0,0,0-.65.22,10,10,0,0,0-1.25.65,2.29,2.29,0,0,1,1.12-1A2,2,0,0,1,1176.66,299.34Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1167.92,295.88c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1167.92,295.88Z"
                fill="#2f6840"
              />
              <path
                d="M1167.41,295.53c4.43-.25-4.33.46-4.35-.61s4.35-2.62,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A15,15,0,0,1,1167.41,295.53Z"
                fill="#3ba525"
              />
              <path
                d="M1168.16,295.51a2.06,2.06,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,2.16,2.16,0,0,1,.47.53A1,1,0,0,1,1168.16,295.51Z"
                fill="#2f6840"
              />
              <path
                d="M1171.64,294.71c-.26,0-.49,0-.72.1a4.51,4.51,0,0,0-.68.17,13.44,13.44,0,0,0-1.35.53,2.5,2.5,0,0,1,1.24-.87A2.07,2.07,0,0,1,1171.64,294.71Z"
                fill="#2f6840"
              />
              <path
                d="M1170.27,297.92a1.86,1.86,0,0,0-.66-1c-.28-.29-.63-.5-1-.81a2.08,2.08,0,0,1,1.21.55,1.7,1.7,0,0,1,.41.57A.94.94,0,0,1,1170.27,297.92Z"
                fill="#2f6840"
              />
              <path
                d="M1168.31,296a7,7,0,0,0-.69.15,5,5,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2,2,0,0,1,1168.31,296Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1182.62,311.37c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.69.05-4.69.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.17-2.91-1.17-2.91-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1182.62,311.37Z"
                fill="#2f6840"
              />
              <path
                d="M1182.11,311c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1182.11,311Z"
                fill="#3ba525"
              />
              <path
                d="M1182.87,311a2.12,2.12,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.83,1.83,0,0,1,.47.53A1,1,0,0,1,1182.87,311Z"
                fill="#2f6840"
              />
              <path
                d="M1186.34,310.2c-.25,0-.49,0-.72.1a4,4,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.41,2.41,0,0,1,1.23-.87A2.07,2.07,0,0,1,1186.34,310.2Z"
                fill="#2f6840"
              />
              <path
                d="M1185,313.41a2,2,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.1,2.1,0,0,1,1.21.55,1.6,1.6,0,0,1,.4.56A1,1,0,0,1,1185,313.41Z"
                fill="#2f6840"
              />
              <path
                d="M1183,311.45c-.25.06-.48.09-.7.16a4.41,4.41,0,0,0-.64.23,10.08,10.08,0,0,0-1.26.65,2.24,2.24,0,0,1,1.12-1A2,2,0,0,1,1183,311.45Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1169.16,305.8c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.56,2.64,3.44-4.69.05-4.69.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1169.16,305.8Z"
                fill="#2f6840"
              />
              <path
                d="M1168.66,305.45c4.42-.25-4.33.46-4.36-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.87,14.87,0,0,1,1168.66,305.45Z"
                fill="#3ba525"
              />
              <path
                d="M1169.41,305.43a2.06,2.06,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,2.16,2.16,0,0,1,.47.53A1,1,0,0,1,1169.41,305.43Z"
                fill="#2f6840"
              />
              <path
                d="M1172.89,304.63c-.26,0-.49,0-.73.1a5.2,5.2,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.45,2.45,0,0,1,1.24-.87A2.07,2.07,0,0,1,1172.89,304.63Z"
                fill="#2f6840"
              />
              <path
                d="M1171.52,307.84a1.92,1.92,0,0,0-.66-1c-.28-.29-.64-.5-1-.81a2.08,2.08,0,0,1,1.21.55,1.55,1.55,0,0,1,.4.57A.89.89,0,0,1,1171.52,307.84Z"
                fill="#2f6840"
              />
              <path
                d="M1169.56,305.89c-.24.05-.47.08-.7.15a4.41,4.41,0,0,0-.64.23,9.33,9.33,0,0,0-1.25.65,2.22,2.22,0,0,1,1.11-1A2,2,0,0,1,1169.56,305.89Z"
                fill="#2f6840"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M1161.92,282.85c4.42-.25-4.33.46-4.36-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.87,14.87,0,0,1,1161.92,282.85Z"
                fill="#2f6840"
              />
              <path
                d="M1161.41,282.51c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.92-2.16,3.63,3.56,2.65,3.44-4.69,0-4.69,0,6,.86,4,1.54-3.31,2-4.36,1.72-1.17-2.9-1.17-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1161.41,282.51Z"
                fill="#3ba525"
              />
              <path
                d="M1162.16,282.48a2.07,2.07,0,0,0-.79-.93c-.33-.27-.71-.46-1.07-.74a2.31,2.31,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A.93.93,0,0,1,1162.16,282.48Z"
                fill="#2f6840"
              />
              <path
                d="M1165.64,281.69c-.25,0-.49,0-.72.09a4,4,0,0,0-.68.18,11.31,11.31,0,0,0-1.35.52,2.46,2.46,0,0,1,1.24-.86A2.07,2.07,0,0,1,1165.64,281.69Z"
                fill="#2f6840"
              />
              <path
                d="M1164.27,284.9a1.82,1.82,0,0,0-.66-1c-.28-.29-.63-.51-1-.81a2.15,2.15,0,0,1,1.22.54,1.78,1.78,0,0,1,.4.57A1,1,0,0,1,1164.27,284.9Z"
                fill="#2f6840"
              />
              <path
                d="M1162.32,282.94c-.25.06-.48.09-.7.16a3.15,3.15,0,0,0-.65.23,9.87,9.87,0,0,0-1.25.64,2.27,2.27,0,0,1,1.12-1A2,2,0,0,1,1162.32,282.94Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1159.26,291.58c4.42-.25-4.33.46-4.35-.61s4.34-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1159.26,291.58Z"
                fill="#2f6840"
              />
              <path
                d="M1158.75,291.24c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.92-2.15,3.63,3.56,2.65,3.44-4.69.05-4.69.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.92,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1158.75,291.24Z"
                fill="#3ba525"
              />
              <path
                d="M1159.5,291.21a2.15,2.15,0,0,0-.79-.94c-.33-.26-.71-.45-1.07-.73a2.28,2.28,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A.93.93,0,0,1,1159.5,291.21Z"
                fill="#2f6840"
              />
              <path
                d="M1163,290.42c-.25,0-.49,0-.72.09a4,4,0,0,0-.68.18,12,12,0,0,0-1.35.52,2.46,2.46,0,0,1,1.24-.86A2.07,2.07,0,0,1,1163,290.42Z"
                fill="#2f6840"
              />
              <path
                d="M1161.61,293.63a1.93,1.93,0,0,0-.65-1c-.29-.28-.64-.5-1-.8a2.16,2.16,0,0,1,1.21.54,1.78,1.78,0,0,1,.4.57A1,1,0,0,1,1161.61,293.63Z"
                fill="#2f6840"
              />
              <path
                d="M1159.66,291.67c-.25.06-.48.09-.7.16a3.15,3.15,0,0,0-.65.23,9.87,9.87,0,0,0-1.25.64,2.27,2.27,0,0,1,1.12-1A2,2,0,0,1,1159.66,291.67Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1153.91,286.63c4.42-.26-4.33.45-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.25,14.25,0,0,1,1153.91,286.63Z"
                fill="#2f6840"
              />
              <path
                d="M1153.4,286.28c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1153.4,286.28Z"
                fill="#3ba525"
              />
              <path
                d="M1154.15,286.25a2,2,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1154.15,286.25Z"
                fill="#2f6840"
              />
              <path
                d="M1157.63,285.46c-.26,0-.49,0-.72.09a4,4,0,0,0-.68.18,11.31,11.31,0,0,0-1.35.52,2.48,2.48,0,0,1,1.24-.86A2.07,2.07,0,0,1,1157.63,285.46Z"
                fill="#2f6840"
              />
              <path
                d="M1156.26,288.67a1.82,1.82,0,0,0-.66-1c-.28-.29-.63-.51-1-.81a2.18,2.18,0,0,1,1.22.54,2,2,0,0,1,.4.57A1,1,0,0,1,1156.26,288.67Z"
                fill="#2f6840"
              />
              <path
                d="M1154.3,286.71c-.24.06-.47.09-.69.16a3.15,3.15,0,0,0-.65.23,9.87,9.87,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,1154.3,286.71Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1145.56,283.25c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1145.56,283.25Z"
                fill="#2f6840"
              />
              <path
                d="M1145.06,282.91c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.24.27,2.24,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1145.06,282.91Z"
                fill="#3ba525"
              />
              <path
                d="M1145.81,282.88a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1145.81,282.88Z"
                fill="#2f6840"
              />
              <path
                d="M1149.29,282.09c-.26,0-.49,0-.73.09a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.38,2.38,0,0,1,1.24-.86A2.07,2.07,0,0,1,1149.29,282.09Z"
                fill="#2f6840"
              />
              <path
                d="M1147.92,285.3a1.88,1.88,0,0,0-.66-1c-.28-.29-.64-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A.92.92,0,0,1,1147.92,285.3Z"
                fill="#2f6840"
              />
              <path
                d="M1146,283.34c-.24.06-.47.09-.7.16a2.87,2.87,0,0,0-.64.23,9.24,9.24,0,0,0-1.25.64,2.24,2.24,0,0,1,1.11-1A2,2,0,0,1,1146,283.34Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1160.27,298.74c4.42-.25-4.33.46-4.35-.61s4.34-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1160.27,298.74Z"
                fill="#2f6840"
              />
              <path
                d="M1159.76,298.4c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.92-2.15,3.63,3.56,2.65,3.44-4.69.05-4.69.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.92,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1159.76,298.4Z"
                fill="#3ba525"
              />
              <path
                d="M1160.51,298.37a2.15,2.15,0,0,0-.79-.94c-.33-.26-.71-.45-1.07-.73a2.28,2.28,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A.93.93,0,0,1,1160.51,298.37Z"
                fill="#2f6840"
              />
              <path
                d="M1164,297.58c-.25,0-.49,0-.72.09a4,4,0,0,0-.68.18,12,12,0,0,0-1.35.52,2.46,2.46,0,0,1,1.24-.86A2.07,2.07,0,0,1,1164,297.58Z"
                fill="#2f6840"
              />
              <path
                d="M1162.62,300.79a1.93,1.93,0,0,0-.65-1c-.29-.28-.64-.5-1-.8a2.16,2.16,0,0,1,1.21.54,1.78,1.78,0,0,1,.4.57A1,1,0,0,1,1162.62,300.79Z"
                fill="#2f6840"
              />
              <path
                d="M1160.67,298.83c-.25.06-.48.09-.7.16a3.15,3.15,0,0,0-.65.23,9.87,9.87,0,0,0-1.25.64,2.27,2.27,0,0,1,1.12-1A2,2,0,0,1,1160.67,298.83Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1146.81,293.17c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.23-2.78,2.92-2.16,3.62,3.56,2.65,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1146.81,293.17Z"
                fill="#2f6840"
              />
              <path
                d="M1146.3,292.83c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.24.27,2.24,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.55,14.55,0,0,1,1146.3,292.83Z"
                fill="#3ba525"
              />
              <path
                d="M1147.06,292.8a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.28,2.28,0,0,1,1.28.45,1.88,1.88,0,0,1,.48.53A1,1,0,0,1,1147.06,292.8Z"
                fill="#2f6840"
              />
              <path
                d="M1150.54,292c-.26,0-.5,0-.73.09a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.39,2.39,0,0,1,1.23-.86A2.1,2.1,0,0,1,1150.54,292Z"
                fill="#2f6840"
              />
              <path
                d="M1149.17,295.22a1.94,1.94,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.16,2.16,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A1,1,0,0,1,1149.17,295.22Z"
                fill="#2f6840"
              />
              <path
                d="M1147.21,293.26c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,9.24,9.24,0,0,0-1.25.64,2.2,2.2,0,0,1,1.11-1A2,2,0,0,1,1147.21,293.26Z"
                fill="#2f6840"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M1174.05,267.69c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.54-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,1174.05,267.69Z"
                fill="#2f6840"
              />
              <path
                d="M1173.54,267.34c4.43-.25-4.33.46-4.35-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1173.54,267.34Z"
                fill="#3ba525"
              />
              <path
                d="M1174.29,267.32a2.1,2.1,0,0,0-.79-.94c-.33-.27-.71-.46-1.07-.74a2.34,2.34,0,0,1,1.28.45,1.83,1.83,0,0,1,.47.53A1,1,0,0,1,1174.29,267.32Z"
                fill="#2f6840"
              />
              <path
                d="M1177.77,266.52c-.25,0-.49,0-.72.1a4,4,0,0,0-.68.17,13.44,13.44,0,0,0-1.35.53,2.54,2.54,0,0,1,1.24-.87A2.07,2.07,0,0,1,1177.77,266.52Z"
                fill="#2f6840"
              />
              <path
                d="M1176.4,269.73a1.86,1.86,0,0,0-.66-1c-.28-.29-.63-.5-1-.81a2.1,2.1,0,0,1,1.22.55,1.68,1.68,0,0,1,.4.57A.94.94,0,0,1,1176.4,269.73Z"
                fill="#2f6840"
              />
              <path
                d="M1174.45,267.78a6.61,6.61,0,0,0-.7.15,5,5,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.24,2.24,0,0,1,1.12-1A2,2,0,0,1,1174.45,267.78Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1171.39,276.42c4.42-.25-4.33.45-4.35-.61s4.34-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1171.39,276.42Z"
                fill="#2f6840"
              />
              <path
                d="M1170.88,276.07c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.92,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1170.88,276.07Z"
                fill="#3ba525"
              />
              <path
                d="M1171.63,276a2.13,2.13,0,0,0-.79-.93c-.33-.27-.71-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1171.63,276Z"
                fill="#2f6840"
              />
              <path
                d="M1175.11,275.25c-.25,0-.49,0-.72.1a3.22,3.22,0,0,0-.68.17,14.45,14.45,0,0,0-1.35.53,2.48,2.48,0,0,1,1.24-.87A2.07,2.07,0,0,1,1175.11,275.25Z"
                fill="#2f6840"
              />
              <path
                d="M1173.74,278.46a1.9,1.9,0,0,0-.65-1c-.29-.29-.64-.51-1-.81a2.1,2.1,0,0,1,1.21.55,1.74,1.74,0,0,1,.4.56A1,1,0,0,1,1173.74,278.46Z"
                fill="#2f6840"
              />
              <path
                d="M1171.79,276.5c-.25.06-.48.09-.7.16a5,5,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.24,2.24,0,0,1,1.12-1A2,2,0,0,1,1171.79,276.5Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1166,271.46c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1166,271.46Z"
                fill="#2f6840"
              />
              <path
                d="M1165.53,271.11c4.43-.25-4.33.46-4.35-.61s4.35-2.62,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.37A15,15,0,0,1,1165.53,271.11Z"
                fill="#3ba525"
              />
              <path
                d="M1166.28,271.09a2.06,2.06,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,2.16,2.16,0,0,1,.47.53A1,1,0,0,1,1166.28,271.09Z"
                fill="#2f6840"
              />
              <path
                d="M1169.76,270.29c-.26,0-.49,0-.72.1a4.83,4.83,0,0,0-.68.17,13.44,13.44,0,0,0-1.35.53,2.5,2.5,0,0,1,1.24-.87A2.12,2.12,0,0,1,1169.76,270.29Z"
                fill="#2f6840"
              />
              <path
                d="M1168.39,273.5a1.86,1.86,0,0,0-.66-1c-.28-.29-.63-.5-1-.81a2.14,2.14,0,0,1,1.21.55,1.7,1.7,0,0,1,.41.57A.94.94,0,0,1,1168.39,273.5Z"
                fill="#2f6840"
              />
              <path
                d="M1166.43,271.55a7,7,0,0,0-.69.15,5,5,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2,2,0,0,1,1166.43,271.55Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1157.69,268.09c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.64,3.44-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.72-1.16-2.91-1.16-2.91-.91,3.34-3,2.55-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,1157.69,268.09Z"
                fill="#2f6840"
              />
              <path
                d="M1157.19,267.74c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1157.19,267.74Z"
                fill="#3ba525"
              />
              <path
                d="M1157.94,267.71a2.08,2.08,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,2,2,0,0,1,.47.53A1,1,0,0,1,1157.94,267.71Z"
                fill="#2f6840"
              />
              <path
                d="M1161.42,266.92c-.26,0-.49,0-.73.1a4,4,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.4,2.4,0,0,1,1.24-.87A2.07,2.07,0,0,1,1161.42,266.92Z"
                fill="#2f6840"
              />
              <path
                d="M1160.05,270.13a1.92,1.92,0,0,0-.66-1c-.28-.29-.64-.51-1-.81a2.08,2.08,0,0,1,1.21.55,1.6,1.6,0,0,1,.4.56A.92.92,0,0,1,1160.05,270.13Z"
                fill="#2f6840"
              />
              <path
                d="M1158.09,268.17c-.24.06-.48.09-.7.16a4.41,4.41,0,0,0-.64.23,9.33,9.33,0,0,0-1.25.65,2.22,2.22,0,0,1,1.11-1A2,2,0,0,1,1158.09,268.17Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1172.4,283.58c4.42-.25-4.33.45-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,1172.4,283.58Z"
                fill="#2f6840"
              />
              <path
                d="M1171.89,283.23c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.92,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1171.89,283.23Z"
                fill="#3ba525"
              />
              <path
                d="M1172.64,283.2a2.13,2.13,0,0,0-.79-.93c-.33-.27-.71-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1172.64,283.2Z"
                fill="#2f6840"
              />
              <path
                d="M1176.12,282.41c-.25,0-.49,0-.72.1a3.22,3.22,0,0,0-.68.17,14.45,14.45,0,0,0-1.35.53,2.48,2.48,0,0,1,1.24-.87A2.07,2.07,0,0,1,1176.12,282.41Z"
                fill="#2f6840"
              />
              <path
                d="M1174.75,285.62a1.9,1.9,0,0,0-.65-1c-.29-.29-.64-.51-1-.81a2.1,2.1,0,0,1,1.21.55,1.74,1.74,0,0,1,.4.56A1,1,0,0,1,1174.75,285.62Z"
                fill="#2f6840"
              />
              <path
                d="M1172.8,283.66c-.25.06-.48.09-.7.16a5,5,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.24,2.24,0,0,1,1.12-1A2,2,0,0,1,1172.8,283.66Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1158.94,278c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.23-2.77,2.92-2.15,3.62,3.55,2.65,3.44-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.72-1.17-2.91-1.17-2.91-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1158.94,278Z"
                fill="#2f6840"
              />
              <path
                d="M1158.43,277.66c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.55,14.55,0,0,1,1158.43,277.66Z"
                fill="#3ba525"
              />
              <path
                d="M1159.19,277.63a2.15,2.15,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,2,2,0,0,1,.48.53A1,1,0,0,1,1159.19,277.63Z"
                fill="#2f6840"
              />
              <path
                d="M1162.67,276.84c-.26,0-.5,0-.73.1a4,4,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.41,2.41,0,0,1,1.23-.87A2.1,2.1,0,0,1,1162.67,276.84Z"
                fill="#2f6840"
              />
              <path
                d="M1161.3,280.05a2,2,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.1,2.1,0,0,1,1.21.55,1.6,1.6,0,0,1,.4.56A1,1,0,0,1,1161.3,280.05Z"
                fill="#2f6840"
              />
              <path
                d="M1159.34,278.09c-.25.06-.48.09-.7.16a4.41,4.41,0,0,0-.64.23,9.33,9.33,0,0,0-1.25.65,2.18,2.18,0,0,1,1.11-1A2,2,0,0,1,1159.34,278.09Z"
                fill="#2f6840"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M1202.51,267.25c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1202.51,267.25Z"
                fill="#2f6840"
              />
              <path
                d="M1202,266.91c4.42-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1202,266.91Z"
                fill="#3ba525"
              />
              <path
                d="M1202.76,266.88a2.11,2.11,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,2,2,0,0,1,.47.54A1,1,0,0,1,1202.76,266.88Z"
                fill="#2f6840"
              />
              <path
                d="M1206.24,266.08c-.26,0-.49.05-.73.1a4.69,4.69,0,0,0-.67.17,13.44,13.44,0,0,0-1.35.53,2.5,2.5,0,0,1,1.24-.87A2.12,2.12,0,0,1,1206.24,266.08Z"
                fill="#2f6840"
              />
              <path
                d="M1204.87,269.29a1.86,1.86,0,0,0-.66-1c-.28-.29-.64-.5-1-.81a2.14,2.14,0,0,1,1.21.55,1.7,1.7,0,0,1,.41.57A.94.94,0,0,1,1204.87,269.29Z"
                fill="#2f6840"
              />
              <path
                d="M1202.91,267.34c-.24.06-.47.08-.7.16a3.45,3.45,0,0,0-.64.22,10,10,0,0,0-1.25.65,2.31,2.31,0,0,1,1.11-1A2,2,0,0,1,1202.91,267.34Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1199.85,276c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.55,14.55,0,0,1,1199.85,276Z"
                fill="#2f6840"
              />
              <path
                d="M1199.35,275.63c4.43-.25-4.33.46-4.35-.61s4.35-2.62,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.37A15,15,0,0,1,1199.35,275.63Z"
                fill="#3ba525"
              />
              <path
                d="M1200.1,275.61a2.06,2.06,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,2.16,2.16,0,0,1,.47.53A1,1,0,0,1,1200.1,275.61Z"
                fill="#2f6840"
              />
              <path
                d="M1203.58,274.81c-.26,0-.49.05-.73.1a4.69,4.69,0,0,0-.67.17,13.44,13.44,0,0,0-1.35.53,2.5,2.5,0,0,1,1.24-.87A2.07,2.07,0,0,1,1203.58,274.81Z"
                fill="#2f6840"
              />
              <path
                d="M1202.21,278a1.86,1.86,0,0,0-.66-1c-.28-.29-.63-.5-1-.81a2.08,2.08,0,0,1,1.21.55,1.7,1.7,0,0,1,.41.57A.94.94,0,0,1,1202.21,278Z"
                fill="#2f6840"
              />
              <path
                d="M1200.25,276.07a7,7,0,0,0-.69.15,4.54,4.54,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2,2,0,0,1,1200.25,276.07Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1194.5,271c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.44-4.69.05-4.69.05,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.92,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1194.5,271Z"
                fill="#2f6840"
              />
              <path
                d="M1194,270.68c4.42-.25-4.33.45-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,1194,270.68Z"
                fill="#3ba525"
              />
              <path
                d="M1194.75,270.65a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.29.46,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1194.75,270.65Z"
                fill="#2f6840"
              />
              <path
                d="M1198.23,269.85c-.26,0-.5,0-.73.1a5.2,5.2,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.45,2.45,0,0,1,1.24-.87A2.12,2.12,0,0,1,1198.23,269.85Z"
                fill="#2f6840"
              />
              <path
                d="M1196.86,273.06a2,2,0,0,0-.66-1c-.28-.29-.64-.5-1-.81a2.21,2.21,0,0,1,1.21.55,1.64,1.64,0,0,1,.4.57A.89.89,0,0,1,1196.86,273.06Z"
                fill="#2f6840"
              />
              <path
                d="M1194.9,271.11a6.56,6.56,0,0,0-.7.16,3.45,3.45,0,0,0-.64.22,9.33,9.33,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2,2,0,0,1,1194.9,271.11Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1186.16,267.65c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.69.05-4.69.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.17-2.9-1.17-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1186.16,267.65Z"
                fill="#2f6840"
              />
              <path
                d="M1185.65,267.3c4.43-.25-4.32.46-4.35-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.27-2.07-2.37A14.86,14.86,0,0,1,1185.65,267.3Z"
                fill="#3ba525"
              />
              <path
                d="M1186.41,267.28a2.12,2.12,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,2,2,0,0,1,.47.53A1,1,0,0,1,1186.41,267.28Z"
                fill="#2f6840"
              />
              <path
                d="M1189.88,266.48c-.25,0-.49,0-.72.1a5.2,5.2,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.47,2.47,0,0,1,1.23-.87A2.12,2.12,0,0,1,1189.88,266.48Z"
                fill="#2f6840"
              />
              <path
                d="M1188.52,269.69a2,2,0,0,0-.66-1c-.29-.29-.64-.5-1-.81a2.17,2.17,0,0,1,1.21.55,1.55,1.55,0,0,1,.4.57A.94.94,0,0,1,1188.52,269.69Z"
                fill="#2f6840"
              />
              <path
                d="M1186.56,267.74a6.61,6.61,0,0,0-.7.15,4.41,4.41,0,0,0-.64.23,9.33,9.33,0,0,0-1.25.65,2.18,2.18,0,0,1,1.11-1A2,2,0,0,1,1186.56,267.74Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1200.86,283.14c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1200.86,283.14Z"
                fill="#2f6840"
              />
              <path
                d="M1200.36,282.79c4.42-.25-4.33.46-4.35-.61s4.35-2.62,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A15,15,0,0,1,1200.36,282.79Z"
                fill="#3ba525"
              />
              <path
                d="M1201.11,282.77a2.06,2.06,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,2.16,2.16,0,0,1,.47.53A1,1,0,0,1,1201.11,282.77Z"
                fill="#2f6840"
              />
              <path
                d="M1204.59,282c-.26,0-.49,0-.73.1a4.69,4.69,0,0,0-.67.17,13.44,13.44,0,0,0-1.35.53,2.5,2.5,0,0,1,1.24-.87A2.07,2.07,0,0,1,1204.59,282Z"
                fill="#2f6840"
              />
              <path
                d="M1203.22,285.18a1.86,1.86,0,0,0-.66-1c-.28-.29-.64-.5-1-.81a2.08,2.08,0,0,1,1.21.55,1.7,1.7,0,0,1,.41.57A.94.94,0,0,1,1203.22,285.18Z"
                fill="#2f6840"
              />
              <path
                d="M1201.26,283.23a7,7,0,0,0-.69.15,4.54,4.54,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2,2,0,0,1,1201.26,283.23Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1187.41,277.57c4.42-.25-4.33.46-4.35-.61s4.34-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1187.41,277.57Z"
                fill="#2f6840"
              />
              <path
                d="M1186.9,277.22c4.43-.25-4.33.46-4.35-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.92,3.34-3,2.55-2.26-2.27-2.08-2.37A15,15,0,0,1,1186.9,277.22Z"
                fill="#3ba525"
              />
              <path
                d="M1187.65,277.2a2.1,2.1,0,0,0-.79-.94c-.33-.27-.71-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,2,2,0,0,1,.47.53A1,1,0,0,1,1187.65,277.2Z"
                fill="#2f6840"
              />
              <path
                d="M1191.13,276.4c-.25,0-.49.05-.72.1a5.2,5.2,0,0,0-.68.17,14.45,14.45,0,0,0-1.35.53,2.54,2.54,0,0,1,1.24-.87A2.12,2.12,0,0,1,1191.13,276.4Z"
                fill="#2f6840"
              />
              <path
                d="M1189.76,279.61a1.9,1.9,0,0,0-.65-1c-.29-.29-.64-.5-1-.81a2.17,2.17,0,0,1,1.21.55,1.68,1.68,0,0,1,.4.57A.94.94,0,0,1,1189.76,279.61Z"
                fill="#2f6840"
              />
              <path
                d="M1187.81,277.66a6.61,6.61,0,0,0-.7.15,5,5,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.24,2.24,0,0,1,1.12-1A2,2,0,0,1,1187.81,277.66Z"
                fill="#2f6840"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M1221.85,256.1c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1221.85,256.1Z"
                fill="#2f6840"
              />
              <path
                d="M1221.34,255.76c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.56,2.64,3.44-4.69,0-4.69,0,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1221.34,255.76Z"
                fill="#3ba525"
              />
              <path
                d="M1222.1,255.73a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.21,2.21,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1222.1,255.73Z"
                fill="#2f6840"
              />
              <path
                d="M1225.57,254.93c-.25,0-.49,0-.72.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.39,2.39,0,0,1,1.23-.86A2.12,2.12,0,0,1,1225.57,254.93Z"
                fill="#2f6840"
              />
              <path
                d="M1224.21,258.14a2,2,0,0,0-.66-1c-.29-.28-.64-.5-1-.8a2.16,2.16,0,0,1,1.21.54,1.78,1.78,0,0,1,.4.57A.94.94,0,0,1,1224.21,258.14Z"
                fill="#2f6840"
              />
              <path
                d="M1222.25,256.19c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,10,10,0,0,0-1.26.64,2.27,2.27,0,0,1,1.12-1A2,2,0,0,1,1222.25,256.19Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1219.19,264.83c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.55-3.31,2-4.37,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1219.19,264.83Z"
                fill="#2f6840"
              />
              <path
                d="M1218.68,264.49c4.43-.25-4.32.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,1218.68,264.49Z"
                fill="#3ba525"
              />
              <path
                d="M1219.44,264.46a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.21,2.21,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1219.44,264.46Z"
                fill="#2f6840"
              />
              <path
                d="M1222.91,263.66c-.25,0-.49,0-.72.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.47,2.47,0,0,1,1.23-.87A2.12,2.12,0,0,1,1222.91,263.66Z"
                fill="#2f6840"
              />
              <path
                d="M1221.55,266.87a2,2,0,0,0-.66-1c-.29-.28-.64-.5-1-.81a2.24,2.24,0,0,1,1.21.55,1.64,1.64,0,0,1,.4.57A.94.94,0,0,1,1221.55,266.87Z"
                fill="#2f6840"
              />
              <path
                d="M1219.59,264.92c-.25.06-.48.09-.7.16a3.45,3.45,0,0,0-.64.22,10.08,10.08,0,0,0-1.26.65,2.34,2.34,0,0,1,1.12-1A2,2,0,0,1,1219.59,264.92Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1213.84,259.87c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1213.84,259.87Z"
                fill="#2f6840"
              />
              <path
                d="M1213.33,259.53c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.24.27,2.24,1.24-2.77,2.92-2.15,3.63,3.56,2.65,3.44-4.69.05-4.69.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.17-2.9-1.17-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1213.33,259.53Z"
                fill="#3ba525"
              />
              <path
                d="M1214.08,259.5a2.15,2.15,0,0,0-.79-.94c-.33-.26-.71-.45-1.07-.73a2.28,2.28,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A.93.93,0,0,1,1214.08,259.5Z"
                fill="#2f6840"
              />
              <path
                d="M1217.56,258.71c-.25,0-.49,0-.72.09a4,4,0,0,0-.68.18,12,12,0,0,0-1.35.52,2.46,2.46,0,0,1,1.24-.86A2.07,2.07,0,0,1,1217.56,258.71Z"
                fill="#2f6840"
              />
              <path
                d="M1216.19,261.92a1.86,1.86,0,0,0-.65-1c-.29-.29-.64-.51-1-.81a2.16,2.16,0,0,1,1.21.54,1.78,1.78,0,0,1,.4.57A1,1,0,0,1,1216.19,261.92Z"
                fill="#2f6840"
              />
              <path
                d="M1214.24,260c-.25.06-.48.09-.7.16a3.15,3.15,0,0,0-.65.23,9.87,9.87,0,0,0-1.25.64,2.27,2.27,0,0,1,1.12-1A2,2,0,0,1,1214.24,260Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1205.49,256.5c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.55,14.55,0,0,1,1205.49,256.5Z"
                fill="#2f6840"
              />
              <path
                d="M1205,256.16c4.42-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.72-1.16-2.91-1.16-2.91-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1205,256.16Z"
                fill="#3ba525"
              />
              <path
                d="M1205.74,256.13a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.26,2.26,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1205.74,256.13Z"
                fill="#2f6840"
              />
              <path
                d="M1209.22,255.33c-.26,0-.49,0-.73.1a3.67,3.67,0,0,0-.67.18,11.31,11.31,0,0,0-1.35.52,2.42,2.42,0,0,1,1.24-.86A2.07,2.07,0,0,1,1209.22,255.33Z"
                fill="#2f6840"
              />
              <path
                d="M1207.85,258.54a1.9,1.9,0,0,0-.66-1c-.28-.28-.64-.5-1-.81a2.21,2.21,0,0,1,1.21.55,1.81,1.81,0,0,1,.41.57A.94.94,0,0,1,1207.85,258.54Z"
                fill="#2f6840"
              />
              <path
                d="M1205.89,256.59c-.24.06-.47.09-.69.16a3,3,0,0,0-.65.23,8.71,8.71,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,1205.89,256.59Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1220.2,272c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1220.2,272Z"
                fill="#2f6840"
              />
              <path
                d="M1219.69,271.65c4.43-.25-4.32.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,1219.69,271.65Z"
                fill="#3ba525"
              />
              <path
                d="M1220.45,271.62a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.74a2.29,2.29,0,0,1,1.28.46,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1220.45,271.62Z"
                fill="#2f6840"
              />
              <path
                d="M1223.92,270.82c-.25,0-.49.05-.72.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.47,2.47,0,0,1,1.23-.87A2.12,2.12,0,0,1,1223.92,270.82Z"
                fill="#2f6840"
              />
              <path
                d="M1222.56,274a2,2,0,0,0-.66-1c-.29-.28-.64-.5-1-.81a2.24,2.24,0,0,1,1.21.55,1.64,1.64,0,0,1,.4.57A.94.94,0,0,1,1222.56,274Z"
                fill="#2f6840"
              />
              <path
                d="M1220.6,272.08c-.25.06-.48.09-.7.16a3.45,3.45,0,0,0-.64.22,10.08,10.08,0,0,0-1.26.65,2.34,2.34,0,0,1,1.12-1A2,2,0,0,1,1220.6,272.08Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1206.74,266.42c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1206.74,266.42Z"
                fill="#2f6840"
              />
              <path
                d="M1206.24,266.08c4.42-.25-4.33.45-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.72-1.16-2.91-1.16-2.91-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,1206.24,266.08Z"
                fill="#3ba525"
              />
              <path
                d="M1207,266.05a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.26,2.26,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1207,266.05Z"
                fill="#2f6840"
              />
              <path
                d="M1210.47,265.25c-.26,0-.49.05-.73.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.38,2.38,0,0,1,1.24-.86A2.07,2.07,0,0,1,1210.47,265.25Z"
                fill="#2f6840"
              />
              <path
                d="M1209.1,268.46a2,2,0,0,0-.66-1c-.28-.28-.64-.5-1-.81a2.21,2.21,0,0,1,1.21.55,1.64,1.64,0,0,1,.4.57A.89.89,0,0,1,1209.1,268.46Z"
                fill="#2f6840"
              />
              <path
                d="M1207.14,266.51c-.24.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,8.22,8.22,0,0,0-1.25.64,2.24,2.24,0,0,1,1.11-1A2,2,0,0,1,1207.14,266.51Z"
                fill="#2f6840"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M1203.1,234.67c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1203.1,234.67Z"
                fill="#2f6840"
              />
              <path
                d="M1202.6,234.33c4.42-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.91-1.16-2.91-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1202.6,234.33Z"
                fill="#3ba525"
              />
              <path
                d="M1203.35,234.3a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.26,2.26,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1203.35,234.3Z"
                fill="#2f6840"
              />
              <path
                d="M1206.83,233.5c-.26,0-.49.05-.73.1a3.67,3.67,0,0,0-.67.18,11.31,11.31,0,0,0-1.35.52,2.42,2.42,0,0,1,1.24-.86A2.12,2.12,0,0,1,1206.83,233.5Z"
                fill="#2f6840"
              />
              <path
                d="M1205.46,236.71a1.9,1.9,0,0,0-.66-1c-.28-.28-.64-.5-1-.81a2.21,2.21,0,0,1,1.21.55,1.81,1.81,0,0,1,.41.57A.94.94,0,0,1,1205.46,236.71Z"
                fill="#2f6840"
              />
              <path
                d="M1203.5,234.76c-.24.06-.47.09-.69.16a2.78,2.78,0,0,0-.65.23,9.87,9.87,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,1203.5,234.76Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1200.45,243.4c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1200.45,243.4Z"
                fill="#2f6840"
              />
              <path
                d="M1199.94,243.06c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1199.94,243.06Z"
                fill="#3ba525"
              />
              <path
                d="M1200.69,243a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.74a2.35,2.35,0,0,1,1.29.46,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1200.69,243Z"
                fill="#2f6840"
              />
              <path
                d="M1204.17,242.23c-.26,0-.49.05-.72.1a3.57,3.57,0,0,0-.68.18,11.31,11.31,0,0,0-1.35.52,2.5,2.5,0,0,1,1.24-.87A2.12,2.12,0,0,1,1204.17,242.23Z"
                fill="#2f6840"
              />
              <path
                d="M1202.8,245.44a1.9,1.9,0,0,0-.66-1c-.28-.28-.63-.5-1-.81a2.21,2.21,0,0,1,1.21.55,1.81,1.81,0,0,1,.41.57A.94.94,0,0,1,1202.8,245.44Z"
                fill="#2f6840"
              />
              <path
                d="M1200.84,243.49c-.24.06-.47.09-.69.16a3.83,3.83,0,0,0-.65.22,10,10,0,0,0-1.25.65,2.36,2.36,0,0,1,1.11-1A2,2,0,0,1,1200.84,243.49Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1195.09,238.44c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1195.09,238.44Z"
                fill="#2f6840"
              />
              <path
                d="M1194.59,238.1c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1194.59,238.1Z"
                fill="#3ba525"
              />
              <path
                d="M1195.34,238.07a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1195.34,238.07Z"
                fill="#2f6840"
              />
              <path
                d="M1198.82,237.28c-.26,0-.49,0-.73.09a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.38,2.38,0,0,1,1.24-.86A2.07,2.07,0,0,1,1198.82,237.28Z"
                fill="#2f6840"
              />
              <path
                d="M1197.45,240.49a1.94,1.94,0,0,0-.66-1c-.28-.28-.64-.5-1-.8a2.13,2.13,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A.92.92,0,0,1,1197.45,240.49Z"
                fill="#2f6840"
              />
              <path
                d="M1195.49,238.53c-.24.06-.47.09-.7.16a2.87,2.87,0,0,0-.64.23,9.24,9.24,0,0,0-1.25.64,2.24,2.24,0,0,1,1.11-1A2,2,0,0,1,1195.49,238.53Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1186.75,235.07c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.69.05-4.69.05,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1186.75,235.07Z"
                fill="#2f6840"
              />
              <path
                d="M1186.24,234.73c4.43-.25-4.32.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,1186.24,234.73Z"
                fill="#3ba525"
              />
              <path
                d="M1187,234.7a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.21,2.21,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1187,234.7Z"
                fill="#2f6840"
              />
              <path
                d="M1190.47,233.9c-.25,0-.49,0-.72.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.47,2.47,0,0,1,1.23-.87A2.12,2.12,0,0,1,1190.47,233.9Z"
                fill="#2f6840"
              />
              <path
                d="M1189.11,237.11a2,2,0,0,0-.66-1c-.29-.28-.64-.5-1-.81a2.24,2.24,0,0,1,1.21.55,1.64,1.64,0,0,1,.4.57A.94.94,0,0,1,1189.11,237.11Z"
                fill="#2f6840"
              />
              <path
                d="M1187.15,235.16c-.25.06-.48.09-.7.16a3.45,3.45,0,0,0-.64.22,9.33,9.33,0,0,0-1.25.65,2.27,2.27,0,0,1,1.11-1A2,2,0,0,1,1187.15,235.16Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1201.45,250.56c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.55,14.55,0,0,1,1201.45,250.56Z"
                fill="#2f6840"
              />
              <path
                d="M1201,250.22c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1201,250.22Z"
                fill="#3ba525"
              />
              <path
                d="M1201.7,250.19a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.29.46,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1201.7,250.19Z"
                fill="#2f6840"
              />
              <path
                d="M1205.18,249.39c-.26,0-.49.05-.72.1a3.57,3.57,0,0,0-.68.18,11.31,11.31,0,0,0-1.35.52,2.5,2.5,0,0,1,1.24-.87A2.12,2.12,0,0,1,1205.18,249.39Z"
                fill="#2f6840"
              />
              <path
                d="M1203.81,252.6a1.9,1.9,0,0,0-.66-1c-.28-.29-.63-.5-1-.81a2.21,2.21,0,0,1,1.21.55,1.81,1.81,0,0,1,.41.57A.94.94,0,0,1,1203.81,252.6Z"
                fill="#2f6840"
              />
              <path
                d="M1201.85,250.65c-.24.06-.47.09-.69.16a3.55,3.55,0,0,0-.65.22,10,10,0,0,0-1.25.65,2.36,2.36,0,0,1,1.11-1A2,2,0,0,1,1201.85,250.65Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1188,245c4.42-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1188,245Z"
                fill="#2f6840"
              />
              <path
                d="M1187.49,244.65c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.64,3.44-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.92,3.34-3,2.55-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,1187.49,244.65Z"
                fill="#3ba525"
              />
              <path
                d="M1188.25,244.62a2.24,2.24,0,0,0-.8-.94c-.33-.26-.71-.45-1.07-.73a2.21,2.21,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1188.25,244.62Z"
                fill="#2f6840"
              />
              <path
                d="M1191.72,243.82c-.25,0-.49.05-.72.1a4,4,0,0,0-.68.18,12.79,12.79,0,0,0-1.35.52,2.54,2.54,0,0,1,1.24-.87A2.12,2.12,0,0,1,1191.72,243.82Z"
                fill="#2f6840"
              />
              <path
                d="M1190.35,247a1.94,1.94,0,0,0-.65-1c-.29-.28-.64-.5-1-.81a2.24,2.24,0,0,1,1.21.55,1.78,1.78,0,0,1,.4.57A.94.94,0,0,1,1190.35,247Z"
                fill="#2f6840"
              />
              <path
                d="M1188.4,245.08c-.25.06-.48.09-.7.16a3.83,3.83,0,0,0-.65.22,10,10,0,0,0-1.25.65,2.34,2.34,0,0,1,1.12-1A2,2,0,0,1,1188.4,245.08Z"
                fill="#2f6840"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M1183.41,214.09c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.92-2.16,3.63,3.56,2.65,3.44-4.69.05-4.69.05,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1183.41,214.09Z"
                fill="#2f6840"
              />
              <path
                d="M1182.91,213.75c4.42-.25-4.33.45-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,1182.91,213.75Z"
                fill="#3ba525"
              />
              <path
                d="M1183.66,213.72a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.74a2.29,2.29,0,0,1,1.28.46,1.88,1.88,0,0,1,.48.53A1,1,0,0,1,1183.66,213.72Z"
                fill="#2f6840"
              />
              <path
                d="M1187.14,212.92c-.26,0-.5.05-.73.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.45,2.45,0,0,1,1.24-.87A2.13,2.13,0,0,1,1187.14,212.92Z"
                fill="#2f6840"
              />
              <path
                d="M1185.77,216.13a2,2,0,0,0-.66-1c-.29-.28-.64-.5-1-.81a2.21,2.21,0,0,1,1.21.55,1.64,1.64,0,0,1,.4.57A.89.89,0,0,1,1185.77,216.13Z"
                fill="#2f6840"
              />
              <path
                d="M1183.81,214.18c-.25.06-.48.09-.7.16a3.45,3.45,0,0,0-.64.22,9.33,9.33,0,0,0-1.25.65,2.31,2.31,0,0,1,1.11-1A2,2,0,0,1,1183.81,214.18Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1180.75,222.82c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.92-2.16,3.63,3.56,2.65,3.44-4.69.05-4.69.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.92,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1180.75,222.82Z"
                fill="#2f6840"
              />
              <path
                d="M1180.25,222.48c4.42-.25-4.33.45-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,1180.25,222.48Z"
                fill="#3ba525"
              />
              <path
                d="M1181,222.45a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.29.46,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1181,222.45Z"
                fill="#2f6840"
              />
              <path
                d="M1184.48,221.65c-.26,0-.5,0-.73.1a5.2,5.2,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.45,2.45,0,0,1,1.24-.87A2.13,2.13,0,0,1,1184.48,221.65Z"
                fill="#2f6840"
              />
              <path
                d="M1183.11,224.86a2,2,0,0,0-.66-1c-.28-.29-.64-.5-1-.81a2.21,2.21,0,0,1,1.21.55,1.64,1.64,0,0,1,.4.57A.89.89,0,0,1,1183.11,224.86Z"
                fill="#2f6840"
              />
              <path
                d="M1181.15,222.91a6.56,6.56,0,0,0-.7.16,3.45,3.45,0,0,0-.64.22,9.33,9.33,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2,2,0,0,1,1181.15,222.91Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1175.4,217.86c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.37,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1175.4,217.86Z"
                fill="#2f6840"
              />
              <path
                d="M1174.89,217.52c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.91-1.16-2.91-.91,3.34-3,2.55-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,1174.89,217.52Z"
                fill="#3ba525"
              />
              <path
                d="M1175.65,217.49a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.21,2.21,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1175.65,217.49Z"
                fill="#2f6840"
              />
              <path
                d="M1179.12,216.69c-.25,0-.49.05-.72.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.39,2.39,0,0,1,1.23-.86A2.12,2.12,0,0,1,1179.12,216.69Z"
                fill="#2f6840"
              />
              <path
                d="M1177.76,219.9a2,2,0,0,0-.66-1c-.29-.28-.64-.5-1-.81a2.24,2.24,0,0,1,1.21.55,1.64,1.64,0,0,1,.4.57A.94.94,0,0,1,1177.76,219.9Z"
                fill="#2f6840"
              />
              <path
                d="M1175.8,218c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,10,10,0,0,0-1.26.64,2.27,2.27,0,0,1,1.12-1A2,2,0,0,1,1175.8,218Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1167.06,214.49c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1167.06,214.49Z"
                fill="#2f6840"
              />
              <path
                d="M1166.55,214.15c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1166.55,214.15Z"
                fill="#3ba525"
              />
              <path
                d="M1167.3,214.12a2.15,2.15,0,0,0-.79-.94c-.33-.26-.71-.46-1.07-.74a2.27,2.27,0,0,1,1.28.46,1.71,1.71,0,0,1,.47.53A.93.93,0,0,1,1167.3,214.12Z"
                fill="#2f6840"
              />
              <path
                d="M1170.78,213.32c-.25,0-.49.05-.72.1a4,4,0,0,0-.68.18,11.31,11.31,0,0,0-1.35.52,2.54,2.54,0,0,1,1.24-.87A2.12,2.12,0,0,1,1170.78,213.32Z"
                fill="#2f6840"
              />
              <path
                d="M1169.41,216.53a1.9,1.9,0,0,0-.66-1c-.28-.29-.63-.5-1-.81a2.24,2.24,0,0,1,1.22.55,1.78,1.78,0,0,1,.4.57A.94.94,0,0,1,1169.41,216.53Z"
                fill="#2f6840"
              />
              <path
                d="M1167.46,214.58c-.25.06-.48.09-.7.16a3.83,3.83,0,0,0-.65.22,10,10,0,0,0-1.25.65,2.29,2.29,0,0,1,1.12-1A2,2,0,0,1,1167.46,214.58Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1181.76,230c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.92-2.16,3.63,3.56,2.65,3.44-4.69.05-4.69.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.92,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1181.76,230Z"
                fill="#2f6840"
              />
              <path
                d="M1181.26,229.64c4.42-.25-4.33.45-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,1181.26,229.64Z"
                fill="#3ba525"
              />
              <path
                d="M1182,229.61a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.29.46,2,2,0,0,1,.47.53A1,1,0,0,1,1182,229.61Z"
                fill="#2f6840"
              />
              <path
                d="M1185.49,228.81c-.26,0-.5.05-.73.1a5.2,5.2,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.45,2.45,0,0,1,1.24-.87A2.13,2.13,0,0,1,1185.49,228.81Z"
                fill="#2f6840"
              />
              <path
                d="M1184.12,232a2,2,0,0,0-.66-1c-.29-.29-.64-.5-1-.81a2.21,2.21,0,0,1,1.21.55,1.64,1.64,0,0,1,.4.57A.89.89,0,0,1,1184.12,232Z"
                fill="#2f6840"
              />
              <path
                d="M1182.16,230.07a6.56,6.56,0,0,0-.7.16,3.45,3.45,0,0,0-.64.22,9.33,9.33,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2,2,0,0,1,1182.16,230.07Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1168.3,224.41c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.55,14.55,0,0,1,1168.3,224.41Z"
                fill="#2f6840"
              />
              <path
                d="M1167.8,224.07c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1167.8,224.07Z"
                fill="#3ba525"
              />
              <path
                d="M1168.55,224a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.29.46,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1168.55,224Z"
                fill="#2f6840"
              />
              <path
                d="M1172,223.24c-.26,0-.49,0-.72.1a3.57,3.57,0,0,0-.68.18,11.31,11.31,0,0,0-1.35.52,2.5,2.5,0,0,1,1.24-.87A2.12,2.12,0,0,1,1172,223.24Z"
                fill="#2f6840"
              />
              <path
                d="M1170.66,226.45a1.9,1.9,0,0,0-.66-1c-.28-.29-.63-.5-1-.81a2.21,2.21,0,0,1,1.21.55,1.81,1.81,0,0,1,.41.57A.94.94,0,0,1,1170.66,226.45Z"
                fill="#2f6840"
              />
              <path
                d="M1168.7,224.5c-.24.06-.47.09-.69.16a3.83,3.83,0,0,0-.65.22,10,10,0,0,0-1.25.65,2.31,2.31,0,0,1,1.11-1A2,2,0,0,1,1168.7,224.5Z"
                fill="#2f6840"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M1157.64,203.85c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.54-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,1157.64,203.85Z"
                fill="#2f6840"
              />
              <path
                d="M1157.13,203.5c4.43-.25-4.33.46-4.35-.61s4.35-2.62,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1157.13,203.5Z"
                fill="#3ba525"
              />
              <path
                d="M1157.88,203.48a2.06,2.06,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,2,2,0,0,1,.47.53A1,1,0,0,1,1157.88,203.48Z"
                fill="#2f6840"
              />
              <path
                d="M1161.36,202.68c-.26,0-.49,0-.72.1a4,4,0,0,0-.68.17,13.44,13.44,0,0,0-1.35.53,2.44,2.44,0,0,1,1.24-.87A2.07,2.07,0,0,1,1161.36,202.68Z"
                fill="#2f6840"
              />
              <path
                d="M1160,205.89a1.86,1.86,0,0,0-.66-1c-.28-.29-.63-.5-1-.81a2.08,2.08,0,0,1,1.21.55,1.7,1.7,0,0,1,.41.57A.94.94,0,0,1,1160,205.89Z"
                fill="#2f6840"
              />
              <path
                d="M1158,203.93c-.24.06-.47.09-.69.16a5,5,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2,2,0,0,1,1158,203.93Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1155,212.58c4.42-.25-4.33.45-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,1155,212.58Z"
                fill="#2f6840"
              />
              <path
                d="M1154.47,212.23c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1154.47,212.23Z"
                fill="#3ba525"
              />
              <path
                d="M1155.22,212.2a2.08,2.08,0,0,0-.8-.93c-.32-.27-.7-.46-1.06-.74a2.34,2.34,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1155.22,212.2Z"
                fill="#2f6840"
              />
              <path
                d="M1158.7,211.41c-.26,0-.49,0-.72.1a3.22,3.22,0,0,0-.68.17,13.44,13.44,0,0,0-1.35.53,2.44,2.44,0,0,1,1.24-.87A2.07,2.07,0,0,1,1158.7,211.41Z"
                fill="#2f6840"
              />
              <path
                d="M1157.33,214.62a1.86,1.86,0,0,0-.66-1c-.28-.29-.63-.51-1-.81a2.13,2.13,0,0,1,1.22.55,1.74,1.74,0,0,1,.4.56A1,1,0,0,1,1157.33,214.62Z"
                fill="#2f6840"
              />
              <path
                d="M1155.37,212.66c-.24.06-.47.09-.69.16a5,5,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2,2,0,0,1,1155.37,212.66Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1149.62,207.62c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.56,2.64,3.44-4.69,0-4.69,0,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1149.62,207.62Z"
                fill="#2f6840"
              />
              <path
                d="M1149.12,207.27c4.42-.25-4.33.46-4.35-.61s4.34-2.62,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.37A15,15,0,0,1,1149.12,207.27Z"
                fill="#3ba525"
              />
              <path
                d="M1149.87,207.25a2.06,2.06,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,2.16,2.16,0,0,1,.47.53A1,1,0,0,1,1149.87,207.25Z"
                fill="#2f6840"
              />
              <path
                d="M1153.35,206.45c-.26,0-.49.05-.73.1a5.2,5.2,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.45,2.45,0,0,1,1.24-.87A2.12,2.12,0,0,1,1153.35,206.45Z"
                fill="#2f6840"
              />
              <path
                d="M1152,209.66a1.92,1.92,0,0,0-.66-1c-.28-.29-.64-.5-1-.81a2.08,2.08,0,0,1,1.21.55,1.55,1.55,0,0,1,.4.57A.89.89,0,0,1,1152,209.66Z"
                fill="#2f6840"
              />
              <path
                d="M1150,207.71c-.24,0-.47.08-.7.15a4.41,4.41,0,0,0-.64.23,9.33,9.33,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2,2,0,0,1,1150,207.71Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1141.28,204.25c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.23-2.77,2.92-2.15,3.63,3.55,2.65,3.44-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.72-1.17-2.91-1.17-2.91-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1141.28,204.25Z"
                fill="#2f6840"
              />
              <path
                d="M1140.78,203.9c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1140.78,203.9Z"
                fill="#3ba525"
              />
              <path
                d="M1141.53,203.87a2.15,2.15,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.88,1.88,0,0,1,.48.53A1,1,0,0,1,1141.53,203.87Z"
                fill="#2f6840"
              />
              <path
                d="M1145,203.08c-.26,0-.5,0-.73.1a3.22,3.22,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.41,2.41,0,0,1,1.23-.87A2.1,2.1,0,0,1,1145,203.08Z"
                fill="#2f6840"
              />
              <path
                d="M1143.64,206.29a2,2,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.08,2.08,0,0,1,1.21.55,1.6,1.6,0,0,1,.4.56A.92.92,0,0,1,1143.64,206.29Z"
                fill="#2f6840"
              />
              <path
                d="M1141.68,204.33c-.25.06-.48.09-.7.16a4.41,4.41,0,0,0-.64.23,9.33,9.33,0,0,0-1.25.65,2.22,2.22,0,0,1,1.11-1A2,2,0,0,1,1141.68,204.33Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1156,219.74c4.42-.25-4.33.45-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,1156,219.74Z"
                fill="#2f6840"
              />
              <path
                d="M1155.48,219.39c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1155.48,219.39Z"
                fill="#3ba525"
              />
              <path
                d="M1156.23,219.36a2.08,2.08,0,0,0-.8-.93c-.32-.27-.7-.46-1.06-.74a2.34,2.34,0,0,1,1.28.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1156.23,219.36Z"
                fill="#2f6840"
              />
              <path
                d="M1159.71,218.57c-.26,0-.49,0-.72.1a3.22,3.22,0,0,0-.68.17,13.44,13.44,0,0,0-1.35.53,2.44,2.44,0,0,1,1.24-.87A2.07,2.07,0,0,1,1159.71,218.57Z"
                fill="#2f6840"
              />
              <path
                d="M1158.34,221.78a1.86,1.86,0,0,0-.66-1c-.28-.29-.63-.51-1-.81a2.13,2.13,0,0,1,1.22.55,1.74,1.74,0,0,1,.4.56A1,1,0,0,1,1158.34,221.78Z"
                fill="#2f6840"
              />
              <path
                d="M1156.38,219.82c-.24.06-.47.09-.69.16a5,5,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2,2,0,0,1,1156.38,219.82Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1142.53,214.17c4.42-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1142.53,214.17Z"
                fill="#2f6840"
              />
              <path
                d="M1142,213.82c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1142,213.82Z"
                fill="#3ba525"
              />
              <path
                d="M1142.78,213.79a2.15,2.15,0,0,0-.8-.93c-.32-.27-.71-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1142.78,213.79Z"
                fill="#2f6840"
              />
              <path
                d="M1146.25,213c-.25,0-.49,0-.72.1a3.22,3.22,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.41,2.41,0,0,1,1.23-.87A2.07,2.07,0,0,1,1146.25,213Z"
                fill="#2f6840"
              />
              <path
                d="M1144.89,216.21a2,2,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.1,2.1,0,0,1,1.21.55,1.74,1.74,0,0,1,.4.56A1,1,0,0,1,1144.89,216.21Z"
                fill="#2f6840"
              />
              <path
                d="M1142.93,214.25c-.25.06-.48.09-.7.16a4.41,4.41,0,0,0-.64.23,9.43,9.43,0,0,0-1.26.65,2.24,2.24,0,0,1,1.12-1A2,2,0,0,1,1142.93,214.25Z"
                fill="#2f6840"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M1131.9,214.62c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1131.9,214.62Z"
                fill="#2f6840"
              />
              <path
                d="M1131.39,214.27c4.43-.25-4.33.46-4.35-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.23-2.78,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.37A15,15,0,0,1,1131.39,214.27Z"
                fill="#3ba525"
              />
              <path
                d="M1132.14,214.25a2.1,2.1,0,0,0-.79-.94c-.33-.27-.71-.46-1.07-.74a2.34,2.34,0,0,1,1.28.45,2,2,0,0,1,.47.53A1,1,0,0,1,1132.14,214.25Z"
                fill="#2f6840"
              />
              <path
                d="M1135.62,213.45c-.25,0-.49.05-.72.1a5.2,5.2,0,0,0-.68.17,13.44,13.44,0,0,0-1.35.53,2.5,2.5,0,0,1,1.24-.87A2.12,2.12,0,0,1,1135.62,213.45Z"
                fill="#2f6840"
              />
              <path
                d="M1134.25,216.66a1.86,1.86,0,0,0-.66-1c-.28-.29-.63-.5-1-.81a2.17,2.17,0,0,1,1.22.55,1.68,1.68,0,0,1,.4.57A.94.94,0,0,1,1134.25,216.66Z"
                fill="#2f6840"
              />
              <path
                d="M1132.3,214.71a6.61,6.61,0,0,0-.7.15,5,5,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2,2,0,0,1,1132.3,214.71Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1129.24,223.35c4.42-.25-4.33.45-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.72-1.16-2.91-1.16-2.91-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,1129.24,223.35Z"
                fill="#2f6840"
              />
              <path
                d="M1128.73,223c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1128.73,223Z"
                fill="#3ba525"
              />
              <path
                d="M1129.48,223a2.1,2.1,0,0,0-.79-.94c-.33-.27-.71-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.83,1.83,0,0,1,.47.53A1,1,0,0,1,1129.48,223Z"
                fill="#2f6840"
              />
              <path
                d="M1133,222.18c-.25,0-.49,0-.72.1a4,4,0,0,0-.68.17,14.45,14.45,0,0,0-1.35.53,2.48,2.48,0,0,1,1.24-.87A2.07,2.07,0,0,1,1133,222.18Z"
                fill="#2f6840"
              />
              <path
                d="M1131.59,225.39a1.9,1.9,0,0,0-.65-1c-.29-.29-.64-.51-1-.81a2.1,2.1,0,0,1,1.21.55,1.74,1.74,0,0,1,.4.56A1,1,0,0,1,1131.59,225.39Z"
                fill="#2f6840"
              />
              <path
                d="M1129.64,223.43c-.25.06-.48.09-.7.16a5,5,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.24,2.24,0,0,1,1.12-1A2,2,0,0,1,1129.64,223.43Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1123.88,218.39c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.55,14.55,0,0,1,1123.88,218.39Z"
                fill="#2f6840"
              />
              <path
                d="M1123.38,218.05c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1123.38,218.05Z"
                fill="#3ba525"
              />
              <path
                d="M1124.13,218a2.11,2.11,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,2,2,0,0,1,.47.54A1,1,0,0,1,1124.13,218Z"
                fill="#2f6840"
              />
              <path
                d="M1127.61,217.22c-.26,0-.49.05-.72.1a4.51,4.51,0,0,0-.68.17,13.44,13.44,0,0,0-1.35.53,2.5,2.5,0,0,1,1.24-.87A2.12,2.12,0,0,1,1127.61,217.22Z"
                fill="#2f6840"
              />
              <path
                d="M1126.24,220.43a1.86,1.86,0,0,0-.66-1c-.28-.29-.63-.5-1-.81a2.14,2.14,0,0,1,1.21.55,1.7,1.7,0,0,1,.41.57A.94.94,0,0,1,1126.24,220.43Z"
                fill="#2f6840"
              />
              <path
                d="M1124.28,218.48c-.24.06-.47.08-.69.15a4.54,4.54,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.31,2.31,0,0,1,1.11-1A2,2,0,0,1,1124.28,218.48Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1115.54,215c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.64,3.44-4.69,0-4.69,0,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.92,3.33-3,2.54-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,1115.54,215Z"
                fill="#2f6840"
              />
              <path
                d="M1115,214.67c4.42-.25-4.33.46-4.36-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1115,214.67Z"
                fill="#3ba525"
              />
              <path
                d="M1115.79,214.65a2.06,2.06,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,2,2,0,0,1,.47.53A1,1,0,0,1,1115.79,214.65Z"
                fill="#2f6840"
              />
              <path
                d="M1119.27,213.85c-.26,0-.5,0-.73.1a4,4,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.45,2.45,0,0,1,1.24-.87A2.07,2.07,0,0,1,1119.27,213.85Z"
                fill="#2f6840"
              />
              <path
                d="M1117.9,217.06a1.92,1.92,0,0,0-.66-1c-.28-.29-.64-.5-1-.81a2.08,2.08,0,0,1,1.21.55,1.55,1.55,0,0,1,.4.57A.89.89,0,0,1,1117.9,217.06Z"
                fill="#2f6840"
              />
              <path
                d="M1115.94,215.1c-.25.06-.48.09-.7.16a4.41,4.41,0,0,0-.64.23,9.33,9.33,0,0,0-1.25.65,2.22,2.22,0,0,1,1.11-1A2,2,0,0,1,1115.94,215.1Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1130.25,230.51c4.42-.25-4.33.45-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.72-1.16-2.91-1.16-2.91-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,1130.25,230.51Z"
                fill="#2f6840"
              />
              <path
                d="M1129.74,230.16c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1129.74,230.16Z"
                fill="#3ba525"
              />
              <path
                d="M1130.49,230.13a2.13,2.13,0,0,0-.79-.93c-.33-.27-.71-.46-1.07-.74a2.34,2.34,0,0,1,1.28.45,1.83,1.83,0,0,1,.47.53A1,1,0,0,1,1130.49,230.13Z"
                fill="#2f6840"
              />
              <path
                d="M1134,229.34c-.25,0-.49,0-.72.1a4,4,0,0,0-.68.17,13.44,13.44,0,0,0-1.35.53,2.48,2.48,0,0,1,1.24-.87A2.07,2.07,0,0,1,1134,229.34Z"
                fill="#2f6840"
              />
              <path
                d="M1132.6,232.55a1.86,1.86,0,0,0-.66-1c-.28-.29-.63-.51-1-.81a2.1,2.1,0,0,1,1.22.55,1.74,1.74,0,0,1,.4.56A1,1,0,0,1,1132.6,232.55Z"
                fill="#2f6840"
              />
              <path
                d="M1130.65,230.59c-.25.06-.48.09-.7.16a5,5,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.24,2.24,0,0,1,1.12-1A2,2,0,0,1,1130.65,230.59Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1116.79,224.94c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.69.05-4.69.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.17-2.9-1.17-2.9-.91,3.33-3,2.54-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1116.79,224.94Z"
                fill="#2f6840"
              />
              <path
                d="M1116.28,224.59c4.43-.25-4.32.46-4.35-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1116.28,224.59Z"
                fill="#3ba525"
              />
              <path
                d="M1117,224.57a2.12,2.12,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.83,1.83,0,0,1,.47.53A1,1,0,0,1,1117,224.57Z"
                fill="#2f6840"
              />
              <path
                d="M1120.51,223.77c-.25,0-.49,0-.72.1a4,4,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.47,2.47,0,0,1,1.23-.87A2.07,2.07,0,0,1,1120.51,223.77Z"
                fill="#2f6840"
              />
              <path
                d="M1119.15,227a2,2,0,0,0-.66-1c-.29-.29-.64-.5-1-.81a2.1,2.1,0,0,1,1.21.55,1.55,1.55,0,0,1,.4.57A.94.94,0,0,1,1119.15,227Z"
                fill="#2f6840"
              />
              <path
                d="M1117.19,225c-.25.06-.48.09-.7.16a4.41,4.41,0,0,0-.64.23,9.33,9.33,0,0,0-1.25.65,2.18,2.18,0,0,1,1.11-1A2,2,0,0,1,1117.19,225Z"
                fill="#2f6840"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M1105.22,223.22c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1105.22,223.22Z"
                fill="#2f6840"
              />
              <path
                d="M1104.71,222.88c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1104.71,222.88Z"
                fill="#3ba525"
              />
              <path
                d="M1105.46,222.85a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.74a2.35,2.35,0,0,1,1.29.46,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1105.46,222.85Z"
                fill="#2f6840"
              />
              <path
                d="M1108.94,222.05c-.26,0-.49,0-.72.1a4,4,0,0,0-.68.18,11.31,11.31,0,0,0-1.35.52,2.5,2.5,0,0,1,1.24-.87A2.12,2.12,0,0,1,1108.94,222.05Z"
                fill="#2f6840"
              />
              <path
                d="M1107.57,225.26a1.9,1.9,0,0,0-.66-1c-.28-.28-.63-.5-1-.81a2.27,2.27,0,0,1,1.22.55,2,2,0,0,1,.4.57A.94.94,0,0,1,1107.57,225.26Z"
                fill="#2f6840"
              />
              <path
                d="M1105.61,223.31c-.24.06-.47.09-.69.16a3.83,3.83,0,0,0-.65.22,10,10,0,0,0-1.25.65,2.36,2.36,0,0,1,1.11-1A2,2,0,0,1,1105.61,223.31Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1102.56,232c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1102.56,232Z"
                fill="#2f6840"
              />
              <path
                d="M1102.05,231.61c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1102.05,231.61Z"
                fill="#3ba525"
              />
              <path
                d="M1102.8,231.58a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.46-1.06-.74a2.27,2.27,0,0,1,1.28.46,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1102.8,231.58Z"
                fill="#2f6840"
              />
              <path
                d="M1106.28,230.78c-.26,0-.49.05-.72.1a5.2,5.2,0,0,0-.68.17,13.44,13.44,0,0,0-1.35.53,2.5,2.5,0,0,1,1.24-.87A2.12,2.12,0,0,1,1106.28,230.78Z"
                fill="#2f6840"
              />
              <path
                d="M1104.91,234a1.9,1.9,0,0,0-.66-1c-.28-.29-.63-.5-1-.81a2.27,2.27,0,0,1,1.22.55,1.78,1.78,0,0,1,.4.57A.94.94,0,0,1,1104.91,234Z"
                fill="#2f6840"
              />
              <path
                d="M1103,232a7,7,0,0,0-.69.16,3.83,3.83,0,0,0-.65.22,10,10,0,0,0-1.25.65,2.31,2.31,0,0,1,1.11-1A2,2,0,0,1,1103,232Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1097.2,227c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1097.2,227Z"
                fill="#2f6840"
              />
              <path
                d="M1096.7,226.65c4.42-.25-4.33.46-4.35-.61s4.34-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.91-1.16-2.91-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1096.7,226.65Z"
                fill="#3ba525"
              />
              <path
                d="M1097.45,226.62a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.26,2.26,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1097.45,226.62Z"
                fill="#2f6840"
              />
              <path
                d="M1100.93,225.82c-.26,0-.49.05-.73.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.42,2.42,0,0,1,1.24-.86A2.12,2.12,0,0,1,1100.93,225.82Z"
                fill="#2f6840"
              />
              <path
                d="M1099.56,229a2,2,0,0,0-.66-1c-.28-.28-.64-.5-1-.81a2.21,2.21,0,0,1,1.21.55,1.64,1.64,0,0,1,.4.57A.89.89,0,0,1,1099.56,229Z"
                fill="#2f6840"
              />
              <path
                d="M1097.6,227.08c-.24.06-.47.09-.7.16a2.87,2.87,0,0,0-.64.23,9.87,9.87,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,1097.6,227.08Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1088.86,223.62c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.23-2.78,2.92-2.16,3.63,3.56,2.65,3.44-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1088.86,223.62Z"
                fill="#2f6840"
              />
              <path
                d="M1088.36,223.28c4.42-.25-4.33.45-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,1088.36,223.28Z"
                fill="#3ba525"
              />
              <path
                d="M1089.11,223.25a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.46-1.07-.74a2.22,2.22,0,0,1,1.28.46,1.88,1.88,0,0,1,.48.53A1,1,0,0,1,1089.11,223.25Z"
                fill="#2f6840"
              />
              <path
                d="M1092.59,222.45c-.26,0-.5.05-.73.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.45,2.45,0,0,1,1.24-.87A2.13,2.13,0,0,1,1092.59,222.45Z"
                fill="#2f6840"
              />
              <path
                d="M1091.22,225.66a2,2,0,0,0-.66-1c-.29-.29-.64-.5-1-.81a2.21,2.21,0,0,1,1.21.55,1.64,1.64,0,0,1,.4.57A.89.89,0,0,1,1091.22,225.66Z"
                fill="#2f6840"
              />
              <path
                d="M1089.26,223.71c-.25.06-.48.09-.7.16a3.45,3.45,0,0,0-.64.22,9.33,9.33,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2,2,0,0,1,1089.26,223.71Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1103.57,239.11c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1103.57,239.11Z"
                fill="#2f6840"
              />
              <path
                d="M1103.06,238.77c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1103.06,238.77Z"
                fill="#3ba525"
              />
              <path
                d="M1103.81,238.74a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.46-1.06-.74a2.27,2.27,0,0,1,1.28.46,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1103.81,238.74Z"
                fill="#2f6840"
              />
              <path
                d="M1107.29,237.94c-.26,0-.49.05-.72.1a5.2,5.2,0,0,0-.68.17,13.44,13.44,0,0,0-1.35.53,2.5,2.5,0,0,1,1.24-.87A2.12,2.12,0,0,1,1107.29,237.94Z"
                fill="#2f6840"
              />
              <path
                d="M1105.92,241.15a1.9,1.9,0,0,0-.66-1c-.28-.29-.63-.5-1-.81a2.27,2.27,0,0,1,1.22.55,1.78,1.78,0,0,1,.4.57A.94.94,0,0,1,1105.92,241.15Z"
                fill="#2f6840"
              />
              <path
                d="M1104,239.2a7,7,0,0,0-.69.16,3.83,3.83,0,0,0-.65.22,10,10,0,0,0-1.25.65,2.31,2.31,0,0,1,1.11-1A2,2,0,0,1,1104,239.2Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1090.11,233.54c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1090.11,233.54Z"
                fill="#2f6840"
              />
              <path
                d="M1089.6,233.2c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.64,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,1089.6,233.2Z"
                fill="#3ba525"
              />
              <path
                d="M1090.36,233.17a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.46-1.07-.74a2.22,2.22,0,0,1,1.28.46,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1090.36,233.17Z"
                fill="#2f6840"
              />
              <path
                d="M1093.83,232.37c-.25,0-.49,0-.72.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.47,2.47,0,0,1,1.23-.87A2.12,2.12,0,0,1,1093.83,232.37Z"
                fill="#2f6840"
              />
              <path
                d="M1092.47,235.58a2,2,0,0,0-.66-1c-.29-.29-.64-.5-1-.81a2.24,2.24,0,0,1,1.21.55,1.78,1.78,0,0,1,.4.57A.94.94,0,0,1,1092.47,235.58Z"
                fill="#2f6840"
              />
              <path
                d="M1090.51,233.63c-.25.06-.48.09-.7.16a3.45,3.45,0,0,0-.64.22,9.43,9.43,0,0,0-1.26.65,2.29,2.29,0,0,1,1.12-1A2,2,0,0,1,1090.51,233.63Z"
                fill="#2f6840"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M1086.88,206.78c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1086.88,206.78Z"
                fill="#2f6840"
              />
              <path
                d="M1086.37,206.44c4.43-.25-4.32.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.64,3.44-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.72-1.16-2.91-1.16-2.91-.91,3.34-3,2.55-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,1086.37,206.44Z"
                fill="#3ba525"
              />
              <path
                d="M1087.13,206.41a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.21,2.21,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1087.13,206.41Z"
                fill="#2f6840"
              />
              <path
                d="M1090.6,205.61c-.25,0-.49,0-.72.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.47,2.47,0,0,1,1.23-.87A2.12,2.12,0,0,1,1090.6,205.61Z"
                fill="#2f6840"
              />
              <path
                d="M1089.24,208.82a2,2,0,0,0-.66-1c-.29-.28-.64-.5-1-.81a2.24,2.24,0,0,1,1.21.55,1.64,1.64,0,0,1,.4.57A.94.94,0,0,1,1089.24,208.82Z"
                fill="#2f6840"
              />
              <path
                d="M1087.28,206.87c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,8.8,8.8,0,0,0-1.26.64,2.34,2.34,0,0,1,1.12-1A2,2,0,0,1,1087.28,206.87Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1084.22,215.51c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16S1092,216.1,1091,216s-4.69.05-4.69.05,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1084.22,215.51Z"
                fill="#2f6840"
              />
              <path
                d="M1083.71,215.17c4.43-.25-4.32.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,1083.71,215.17Z"
                fill="#3ba525"
              />
              <path
                d="M1084.47,215.14a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.46-1.07-.74a2.22,2.22,0,0,1,1.28.46,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1084.47,215.14Z"
                fill="#2f6840"
              />
              <path
                d="M1087.94,214.34c-.25,0-.49,0-.72.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.47,2.47,0,0,1,1.23-.87A2.12,2.12,0,0,1,1087.94,214.34Z"
                fill="#2f6840"
              />
              <path
                d="M1086.58,217.55a2,2,0,0,0-.66-1c-.29-.29-.64-.5-1-.81a2.24,2.24,0,0,1,1.21.55,1.64,1.64,0,0,1,.4.57A.94.94,0,0,1,1086.58,217.55Z"
                fill="#2f6840"
              />
              <path
                d="M1084.62,215.6a6.56,6.56,0,0,0-.7.16,3.45,3.45,0,0,0-.64.22,9.33,9.33,0,0,0-1.25.65,2.22,2.22,0,0,1,1.11-1A2,2,0,0,1,1084.62,215.6Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1078.87,210.55c4.42-.25-4.33.46-4.35-.61s4.34-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1078.87,210.55Z"
                fill="#2f6840"
              />
              <path
                d="M1078.36,210.21c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.92-2.15,3.63,3.55,2.65,3.44-4.69,0-4.69,0,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.92,3.33-3,2.54-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1078.36,210.21Z"
                fill="#3ba525"
              />
              <path
                d="M1079.11,210.18a2.15,2.15,0,0,0-.79-.94c-.33-.26-.71-.45-1.07-.73a2.21,2.21,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A.93.93,0,0,1,1079.11,210.18Z"
                fill="#2f6840"
              />
              <path
                d="M1082.59,209.38c-.25,0-.49.05-.72.1a4,4,0,0,0-.68.18,12,12,0,0,0-1.35.52,2.46,2.46,0,0,1,1.24-.86A2.12,2.12,0,0,1,1082.59,209.38Z"
                fill="#2f6840"
              />
              <path
                d="M1081.22,212.59a1.94,1.94,0,0,0-.65-1c-.29-.28-.64-.5-1-.8a2.16,2.16,0,0,1,1.21.54,1.78,1.78,0,0,1,.4.57A.94.94,0,0,1,1081.22,212.59Z"
                fill="#2f6840"
              />
              <path
                d="M1079.27,210.64c-.25.06-.48.09-.7.16a3.15,3.15,0,0,0-.65.23,9.87,9.87,0,0,0-1.25.64,2.27,2.27,0,0,1,1.12-1A2,2,0,0,1,1079.27,210.64Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1070.53,207.18c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1070.53,207.18Z"
                fill="#2f6840"
              />
              <path
                d="M1070,206.84c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1070,206.84Z"
                fill="#3ba525"
              />
              <path
                d="M1070.77,206.81a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.29.46,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1070.77,206.81Z"
                fill="#2f6840"
              />
              <path
                d="M1074.25,206c-.26,0-.49.05-.72.1a3.57,3.57,0,0,0-.68.18,11.31,11.31,0,0,0-1.35.52,2.5,2.5,0,0,1,1.24-.87A2.12,2.12,0,0,1,1074.25,206Z"
                fill="#2f6840"
              />
              <path
                d="M1072.88,209.22a1.9,1.9,0,0,0-.66-1c-.28-.29-.63-.5-1-.81a2.21,2.21,0,0,1,1.21.55,1.81,1.81,0,0,1,.41.57A.94.94,0,0,1,1072.88,209.22Z"
                fill="#2f6840"
              />
              <path
                d="M1070.92,207.27c-.24.06-.47.09-.69.16a3.83,3.83,0,0,0-.65.22,10,10,0,0,0-1.25.65,2.36,2.36,0,0,1,1.11-1A2,2,0,0,1,1070.92,207.27Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1085.23,222.67c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.69.05-4.69.05,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1085.23,222.67Z"
                fill="#2f6840"
              />
              <path
                d="M1084.72,222.33c4.43-.25-4.32.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,1084.72,222.33Z"
                fill="#3ba525"
              />
              <path
                d="M1085.48,222.3a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.46-1.07-.74a2.22,2.22,0,0,1,1.28.46,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1085.48,222.3Z"
                fill="#2f6840"
              />
              <path
                d="M1089,221.5c-.25,0-.49.05-.72.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.47,2.47,0,0,1,1.23-.87A2.12,2.12,0,0,1,1089,221.5Z"
                fill="#2f6840"
              />
              <path
                d="M1087.59,224.71a2,2,0,0,0-.66-1c-.29-.29-.64-.5-1-.81a2.24,2.24,0,0,1,1.21.55,1.64,1.64,0,0,1,.4.57A.94.94,0,0,1,1087.59,224.71Z"
                fill="#2f6840"
              />
              <path
                d="M1085.63,222.76a6.56,6.56,0,0,0-.7.16,3.45,3.45,0,0,0-.64.22,9.33,9.33,0,0,0-1.25.65,2.22,2.22,0,0,1,1.11-1A2,2,0,0,1,1085.63,222.76Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1071.77,217.1c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.44-4.69.05-4.69.05,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1071.77,217.1Z"
                fill="#2f6840"
              />
              <path
                d="M1071.27,216.76c4.42-.25-4.33.45-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,1071.27,216.76Z"
                fill="#3ba525"
              />
              <path
                d="M1072,216.73a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.29.46,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1072,216.73Z"
                fill="#2f6840"
              />
              <path
                d="M1075.5,215.93c-.26,0-.49,0-.73.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.45,2.45,0,0,1,1.24-.87A2.12,2.12,0,0,1,1075.5,215.93Z"
                fill="#2f6840"
              />
              <path
                d="M1074.13,219.14a2,2,0,0,0-.66-1c-.28-.29-.64-.5-1-.81a2.21,2.21,0,0,1,1.21.55,1.64,1.64,0,0,1,.4.57A.89.89,0,0,1,1074.13,219.14Z"
                fill="#2f6840"
              />
              <path
                d="M1072.17,217.19c-.24.06-.47.09-.7.16a3.45,3.45,0,0,0-.64.22,9.33,9.33,0,0,0-1.25.65,2.31,2.31,0,0,1,1.11-1A2,2,0,0,1,1072.17,217.19Z"
                fill="#2f6840"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M1076.07,180.73c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.23-2.77,2.92-2.16,3.62,3.56,2.65,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1076.07,180.73Z"
                fill="#2f6840"
              />
              <path
                d="M1075.56,180.38c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1075.56,180.38Z"
                fill="#3ba525"
              />
              <path
                d="M1076.32,180.35a2.15,2.15,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.88,1.88,0,0,1,.48.53A1,1,0,0,1,1076.32,180.35Z"
                fill="#2f6840"
              />
              <path
                d="M1079.8,179.56a5.36,5.36,0,0,0-.73.1,3.22,3.22,0,0,0-.68.17,12,12,0,0,0-1.34.53,2.41,2.41,0,0,1,1.23-.87A2.1,2.1,0,0,1,1079.8,179.56Z"
                fill="#2f6840"
              />
              <path
                d="M1078.43,182.77a2,2,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.16,2.16,0,0,1,1.21.54,1.73,1.73,0,0,1,.4.57A1,1,0,0,1,1078.43,182.77Z"
                fill="#2f6840"
              />
              <path
                d="M1076.47,180.81c-.25.06-.48.09-.7.16a4.41,4.41,0,0,0-.64.23,9.33,9.33,0,0,0-1.25.65,2.18,2.18,0,0,1,1.11-1A2,2,0,0,1,1076.47,180.81Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1073.41,189.46c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.23-2.77,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1073.41,189.46Z"
                fill="#2f6840"
              />
              <path
                d="M1072.91,189.11c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1072.91,189.11Z"
                fill="#3ba525"
              />
              <path
                d="M1073.66,189.08a2.15,2.15,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.88,1.88,0,0,1,.48.53A1,1,0,0,1,1073.66,189.08Z"
                fill="#2f6840"
              />
              <path
                d="M1077.14,188.29a5.36,5.36,0,0,0-.73.1,3.22,3.22,0,0,0-.68.17,10.33,10.33,0,0,0-1.34.53,2.4,2.4,0,0,1,1.24-.87A2.07,2.07,0,0,1,1077.14,188.29Z"
                fill="#2f6840"
              />
              <path
                d="M1075.77,191.5a1.94,1.94,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A.92.92,0,0,1,1075.77,191.5Z"
                fill="#2f6840"
              />
              <path
                d="M1073.81,189.54c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,10.56,10.56,0,0,0-1.25.64,2.24,2.24,0,0,1,1.11-1A2,2,0,0,1,1073.81,189.54Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1068.06,184.5c4.42-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1068.06,184.5Z"
                fill="#2f6840"
              />
              <path
                d="M1067.55,184.15c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1067.55,184.15Z"
                fill="#3ba525"
              />
              <path
                d="M1068.31,184.12a2.21,2.21,0,0,0-.8-.93c-.32-.27-.71-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1068.31,184.12Z"
                fill="#2f6840"
              />
              <path
                d="M1071.78,183.33c-.25,0-.49,0-.72.1a3.22,3.22,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.41,2.41,0,0,1,1.23-.87A2.07,2.07,0,0,1,1071.78,183.33Z"
                fill="#2f6840"
              />
              <path
                d="M1070.42,186.54a2,2,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.1,2.1,0,0,1,1.21.55,1.74,1.74,0,0,1,.4.56A1,1,0,0,1,1070.42,186.54Z"
                fill="#2f6840"
              />
              <path
                d="M1068.46,184.58c-.25.06-.48.09-.7.16a4.41,4.41,0,0,0-.64.23,9.43,9.43,0,0,0-1.26.65,2.24,2.24,0,0,1,1.12-1A2,2,0,0,1,1068.46,184.58Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1059.72,181.13c4.42-.25-4.33.45-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,1059.72,181.13Z"
                fill="#2f6840"
              />
              <path
                d="M1059.21,180.78c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.69.05-4.69.05,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1059.21,180.78Z"
                fill="#3ba525"
              />
              <path
                d="M1060,180.75a2.08,2.08,0,0,0-.8-.93c-.32-.27-.7-.46-1.06-.74a2.34,2.34,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1060,180.75Z"
                fill="#2f6840"
              />
              <path
                d="M1063.44,180a5.21,5.21,0,0,0-.72.1,3.22,3.22,0,0,0-.68.17,9.91,9.91,0,0,0-1.35.53,2.44,2.44,0,0,1,1.24-.87A2.07,2.07,0,0,1,1063.44,180Z"
                fill="#2f6840"
              />
              <path
                d="M1062.07,183.17a1.86,1.86,0,0,0-.66-1c-.28-.29-.63-.51-1-.81a2.18,2.18,0,0,1,1.22.54,1.78,1.78,0,0,1,.4.57A1,1,0,0,1,1062.07,183.17Z"
                fill="#2f6840"
              />
              <path
                d="M1060.11,181.21c-.24.06-.47.09-.69.16a3.87,3.87,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2,2,0,0,1,1060.11,181.21Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1074.42,196.62c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.23-2.78,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1074.42,196.62Z"
                fill="#2f6840"
              />
              <path
                d="M1073.92,196.27c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1073.92,196.27Z"
                fill="#3ba525"
              />
              <path
                d="M1074.67,196.24a2.15,2.15,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.88,1.88,0,0,1,.48.53A1,1,0,0,1,1074.67,196.24Z"
                fill="#2f6840"
              />
              <path
                d="M1078.15,195.45c-.26,0-.5,0-.73.09a4,4,0,0,0-.68.18,10.33,10.33,0,0,0-1.34.53,2.41,2.41,0,0,1,1.23-.87A2.1,2.1,0,0,1,1078.15,195.45Z"
                fill="#2f6840"
              />
              <path
                d="M1076.78,198.66a1.94,1.94,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A.92.92,0,0,1,1076.78,198.66Z"
                fill="#2f6840"
              />
              <path
                d="M1074.82,196.7c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,10.56,10.56,0,0,0-1.25.64,2.24,2.24,0,0,1,1.11-1A2,2,0,0,1,1074.82,196.7Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1061,191.05c4.43-.25-4.32.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,1061,191.05Z"
                fill="#2f6840"
              />
              <path
                d="M1060.46,190.7c4.42-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1060.46,190.7Z"
                fill="#3ba525"
              />
              <path
                d="M1061.21,190.67a2.08,2.08,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1061.21,190.67Z"
                fill="#2f6840"
              />
              <path
                d="M1064.69,189.88a5.58,5.58,0,0,0-.73.1,3,3,0,0,0-.67.17,9.91,9.91,0,0,0-1.35.53,2.44,2.44,0,0,1,1.24-.87A2.07,2.07,0,0,1,1064.69,189.88Z"
                fill="#2f6840"
              />
              <path
                d="M1063.32,193.09a1.92,1.92,0,0,0-.66-1c-.28-.29-.64-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.81,1.81,0,0,1,.41.57A1,1,0,0,1,1063.32,193.09Z"
                fill="#2f6840"
              />
              <path
                d="M1061.36,191.13c-.24.06-.47.09-.7.16a3.48,3.48,0,0,0-.64.23,10,10,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2,2,0,0,1,1061.36,191.13Z"
                fill="#2f6840"
              />
            </g>
          </g>
        </g>
        <g>
          <path
            d="M1153.53,173.6l3,1.85a1,1,0,0,0,.91.06l7.17-3.2a1,1,0,0,0,.24-1.62h0a1,1,0,0,0-.77-.23l-10.15,1.35A1,1,0,0,0,1153.53,173.6Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="1158.83 166.18 1154.79 167.04 1151.23 169.78 1157.19 172.17 1164.5 169.18 1158.83 166.18"
              fill="#ffedc8"
            />
            <polygon
              points="1151.23 169.78 1151.23 172.17 1156.95 174.62 1164.65 171.49 1164.5 169.18 1157.19 172.17 1151.23 169.78"
              fill="#ccae79"
            />
            <polygon
              points="1157.19 172.17 1156.95 174.62 1164.65 171.49 1164.5 169.18 1157.19 172.17"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1152.93,170.46a1.09,1.09,0,0,1,0,1.23c.27-.39.33-1.1.46-1.05Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1155.45,171.47a3.39,3.39,0,0,0,1.5-1.53l-1.08,1.7Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1160.21,170.93a1.11,1.11,0,0,1,.59,1l-.18-1.14Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1162.88,168.32a7.09,7.09,0,0,1-2.37,0,3.41,3.41,0,0,1-1.73.12s1.27-.12,1.73.31A10.46,10.46,0,0,1,1162.88,168.32Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M1076.64,234.37l6.43,4a2.08,2.08,0,0,0,2,.14l15.43-6.9a2.09,2.09,0,0,0,.52-3.49h0a2.11,2.11,0,0,0-1.65-.49l-21.85,2.91A2.09,2.09,0,0,0,1076.64,234.37Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="1088.05 218.42 1079.35 220.26 1071.69 226.15 1084.53 231.3 1100.26 224.86 1088.05 218.42"
              fill="#ffedc8"
            />
            <polygon
              points="1071.69 226.15 1071.69 231.3 1084.01 236.58 1100.6 229.85 1100.26 224.86 1084.53 231.3 1071.69 226.15"
              fill="#ccae79"
            />
            <polygon
              points="1084.53 231.3 1084.01 236.58 1100.6 229.85 1100.26 224.86 1084.53 231.3"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1075.35,227.62a2.31,2.31,0,0,1,0,2.64c.58-.83.72-2.35,1-2.25Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1080.77,229.79a7.34,7.34,0,0,0,3.24-3.29l-2.33,3.66Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1091,228.64a2.37,2.37,0,0,1,1.28,2.08l-.38-2.45Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1096.77,223c-.16-.09-3.25.62-5.1,0a7.35,7.35,0,0,1-3.73.26s2.73-.27,3.73.66A22.15,22.15,0,0,1,1096.77,223Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M1123.67,229.81l2.22,1.38a.72.72,0,0,0,.68.05l5.34-2.39a.72.72,0,0,0,.17-1.2h0a.68.68,0,0,0-.56-.17l-7.56,1A.72.72,0,0,0,1123.67,229.81Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="1127.62 224.29 1124.61 224.93 1121.96 226.97 1126.4 228.75 1131.84 226.52 1127.62 224.29"
              fill="#ffedc8"
            />
            <polygon
              points="1121.96 226.97 1121.96 228.75 1126.22 230.57 1131.95 228.25 1131.84 226.52 1126.4 228.75 1121.96 226.97"
              fill="#ccae79"
            />
            <polygon
              points="1126.4 228.75 1126.22 230.57 1131.95 228.25 1131.84 226.52 1126.4 228.75"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1123.23,227.48a.81.81,0,0,1,0,.91c.2-.29.24-.82.33-.78Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1125.1,228.23a2.55,2.55,0,0,0,1.12-1.14l-.81,1.26Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1128.64,227.83a.82.82,0,0,1,.45.72l-.14-.85Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1130.63,225.88a5.13,5.13,0,0,1-1.76,0,2.43,2.43,0,0,1-1.29.09s.94-.09,1.29.23A7.78,7.78,0,0,1,1130.63,225.88Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M1107.73,234.18l2.22,1.38a.74.74,0,0,0,.68,0l5.34-2.38a.73.73,0,0,0,.18-1.21h0a.79.79,0,0,0-.57-.17l-7.56,1A.72.72,0,0,0,1107.73,234.18Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="1111.68 228.66 1108.67 229.3 1106.02 231.33 1110.46 233.11 1115.9 230.89 1111.68 228.66"
              fill="#ffedc8"
            />
            <polygon
              points="1106.02 231.33 1106.02 233.11 1110.28 234.94 1116.02 232.61 1115.9 230.89 1110.46 233.11 1106.02 231.33"
              fill="#ccae79"
            />
            <polygon
              points="1110.46 233.11 1110.28 234.94 1116.02 232.61 1115.9 230.89 1110.46 233.11"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1107.29,231.84a.83.83,0,0,1,0,.92c.2-.29.24-.82.34-.78Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1109.16,232.59a2.48,2.48,0,0,0,1.12-1.14l-.81,1.27Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1112.71,232.19a.82.82,0,0,1,.44.72l-.13-.84Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1114.69,230.25a5.13,5.13,0,0,1-1.76,0,2.56,2.56,0,0,1-1.29.09s.95-.09,1.29.23A7.78,7.78,0,0,1,1114.69,230.25Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M1123.24,217.81l2.22,1.38a.74.74,0,0,0,.68,0l5.33-2.38a.72.72,0,0,0,.18-1.21h0a.76.76,0,0,0-.57-.17l-7.55,1A.72.72,0,0,0,1123.24,217.81Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="1127.18 212.29 1124.18 212.93 1121.53 214.96 1125.97 216.74 1131.41 214.52 1127.18 212.29"
              fill="#ffedc8"
            />
            <polygon
              points="1121.53 214.96 1121.53 216.74 1125.79 218.57 1131.52 216.24 1131.41 214.52 1125.97 216.74 1121.53 214.96"
              fill="#ccae79"
            />
            <polygon
              points="1125.97 216.74 1125.79 218.57 1131.52 216.24 1131.41 214.52 1125.97 216.74"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1122.79,215.47a.81.81,0,0,1,0,.92c.2-.29.25-.82.34-.78S1122.79,215.47,1122.79,215.47Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1124.67,216.22a2.53,2.53,0,0,0,1.12-1.14l-.81,1.27Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1128.21,215.82a.84.84,0,0,1,.45.72l-.14-.84Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1130.2,213.88a5.14,5.14,0,0,1-1.76,0,2.56,2.56,0,0,1-1.29.09s.94-.09,1.29.23A7.78,7.78,0,0,1,1130.2,213.88Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M1159.22,219.35l4.71,2.93a1.54,1.54,0,0,0,1.43.09l11.3-5.05a1.52,1.52,0,0,0,.38-2.55h0a1.51,1.51,0,0,0-1.2-.36l-16,2.13A1.53,1.53,0,0,0,1159.22,219.35Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="1167.58 207.66 1161.21 209.01 1155.59 213.33 1165 217.1 1176.52 212.38 1167.58 207.66"
              fill="#ffedc8"
            />
            <polygon
              points="1155.59 213.33 1155.59 217.1 1164.62 220.97 1176.77 216.04 1176.52 212.38 1165 217.1 1155.59 213.33"
              fill="#ccae79"
            />
            <polygon
              points="1165 217.1 1164.62 220.97 1176.77 216.04 1176.52 212.38 1165 217.1"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1158.28,214.4a1.72,1.72,0,0,1,0,1.94c.42-.61.52-1.73.72-1.65Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1162.25,216a5.33,5.33,0,0,0,2.37-2.42l-1.71,2.68Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1169.76,215.15a1.74,1.74,0,0,1,.94,1.52l-.29-1.79Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1174,211c-.12-.06-2.38.46-3.74,0a5.38,5.38,0,0,1-2.73.19s2-.19,2.73.49A16.48,16.48,0,0,1,1174,211Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M1182.56,223.45l4.65,2.88a1.5,1.5,0,0,0,1.41.1l11.17-5a1.52,1.52,0,0,0,.38-2.53h0a1.51,1.51,0,0,0-1.19-.35l-15.82,2.1A1.52,1.52,0,0,0,1182.56,223.45Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="1190.82 211.89 1184.52 213.23 1178.97 217.49 1188.27 221.22 1199.65 216.56 1190.82 211.89"
              fill="#ffedc8"
            />
            <polygon
              points="1178.97 217.49 1178.97 221.22 1187.89 225.04 1199.9 220.17 1199.65 216.56 1188.27 221.22 1178.97 217.49"
              fill="#ccae79"
            />
            <polygon
              points="1188.27 221.22 1187.89 225.04 1199.9 220.17 1199.65 216.56 1188.27 221.22"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1181.63,218.56a1.69,1.69,0,0,1,0,1.91c.42-.6.51-1.71.71-1.63Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1185.55,220.13a5.33,5.33,0,0,0,2.34-2.38l-1.68,2.64Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1193,219.29a1.71,1.71,0,0,1,.92,1.51l-.27-1.77Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1197.13,215.22c-.12-.06-2.35.46-3.7,0a5.23,5.23,0,0,1-2.69.19s2-.19,2.69.49A16.16,16.16,0,0,1,1197.13,215.22Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M1204.48,240.72l-4,2.46a1.28,1.28,0,0,1-1.2.09L1189.8,239a1.28,1.28,0,0,1-.32-2.14h0a1.26,1.26,0,0,1,1-.31l13.48,1.79A1.29,1.29,0,0,1,1204.48,240.72Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="1197.44 230.89 1202.81 232.02 1207.53 235.65 1199.61 238.83 1189.92 234.86 1197.44 230.89"
              fill="#ffedc8"
            />
            <polygon
              points="1207.53 235.65 1207.53 238.83 1199.93 242.08 1189.71 237.93 1189.92 234.86 1199.61 238.83 1207.53 235.65"
              fill="#ccae79"
            />
            <polygon
              points="1199.61 238.83 1199.93 242.08 1189.71 237.93 1189.92 234.86 1199.61 238.83"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1205.27,236.56a1.43,1.43,0,0,0,0,1.63c-.36-.51-.44-1.45-.61-1.39Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1201.93,237.9a4.59,4.59,0,0,1-2-2l1.44,2.25Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1195.61,237.19a1.45,1.45,0,0,0-.79,1.28l.24-1.51Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1192.07,233.72a9.14,9.14,0,0,0,3.14,0,4.43,4.43,0,0,0,2.3.16s-1.69-.16-2.3.42A13.47,13.47,0,0,0,1192.07,233.72Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M1194.48,251.45l3,1.88a1,1,0,0,0,.92.06l7.28-3.25a1,1,0,0,0,.24-1.65h0a1,1,0,0,0-.77-.23l-10.31,1.37A1,1,0,0,0,1194.48,251.45Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="1199.86 243.92 1195.76 244.79 1192.14 247.57 1198.2 250 1205.62 246.96 1199.86 243.92"
              fill="#ffedc8"
            />
            <polygon
              points="1192.14 247.57 1192.14 250 1197.96 252.49 1205.78 249.31 1205.62 246.96 1198.2 250 1192.14 247.57"
              fill="#ccae79"
            />
            <polygon
              points="1198.2 250 1197.96 252.49 1205.78 249.31 1205.62 246.96 1198.2 250"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1193.87,248.26a1.1,1.1,0,0,1,0,1.25c.28-.39.34-1.11.47-1.06Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1196.43,249.29a3.46,3.46,0,0,0,1.53-1.56l-1.1,1.73Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1201.26,248.74a1.12,1.12,0,0,1,.61,1l-.18-1.15Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1204,246.09a7,7,0,0,1-2.4,0,3.39,3.39,0,0,1-1.76.12s1.29-.12,1.76.32A10.35,10.35,0,0,1,1204,246.09Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M1179,276l3.82,2.37a1.23,1.23,0,0,0,1.16.08l9.17-4.1a1.24,1.24,0,0,0,.3-2.07h0a1.23,1.23,0,0,0-1-.29l-13,1.72A1.25,1.25,0,0,0,1179,276Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="1185.77 266.49 1180.6 267.58 1176.05 271.08 1183.68 274.14 1193.02 270.31 1185.77 266.49"
              fill="#ffedc8"
            />
            <polygon
              points="1176.05 271.08 1176.05 274.14 1183.37 277.28 1193.22 273.28 1193.02 270.31 1183.68 274.14 1176.05 271.08"
              fill="#ccae79"
            />
            <polygon
              points="1183.68 274.14 1183.37 277.28 1193.22 273.28 1193.02 270.31 1183.68 274.14"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1178.23,272a1.38,1.38,0,0,1,0,1.57c.34-.5.42-1.4.58-1.34Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1181.45,273.25a4.36,4.36,0,0,0,1.92-2l-1.38,2.17Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1187.54,272.56a1.42,1.42,0,0,1,.76,1.24l-.23-1.46Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1191,269.22a9,9,0,0,1-3,0,4.36,4.36,0,0,1-2.21.16s1.62-.16,2.21.39A13.14,13.14,0,0,1,1191,269.22Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M1169.3,271.27l2.25,1.4a.74.74,0,0,0,.69.05l5.42-2.42a.74.74,0,0,0,.18-1.23h0a.76.76,0,0,0-.58-.17l-7.67,1A.73.73,0,0,0,1169.3,271.27Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="1173.3 265.67 1170.25 266.32 1167.56 268.38 1172.07 270.19 1177.59 267.93 1173.3 265.67"
              fill="#ffedc8"
            />
            <polygon
              points="1167.56 268.38 1167.56 270.19 1171.88 272.05 1177.71 269.68 1177.59 267.93 1172.07 270.19 1167.56 268.38"
              fill="#ccae79"
            />
            <polygon
              points="1172.07 270.19 1171.88 272.05 1177.71 269.68 1177.59 267.93 1172.07 270.19"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1168.84,268.9a.8.8,0,0,1,0,.93c.21-.29.26-.83.35-.79Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1170.75,269.66a2.58,2.58,0,0,0,1.13-1.15l-.81,1.28Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1174.35,269.26a.83.83,0,0,1,.45.73l-.14-.86Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1176.37,267.28a5.37,5.37,0,0,1-1.8,0,2.55,2.55,0,0,1-1.3.1s1-.1,1.3.23A7.72,7.72,0,0,1,1176.37,267.28Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M1152.88,301.54l5.23,3.25a1.72,1.72,0,0,0,1.59.1l12.56-5.61a1.7,1.7,0,0,0,.42-2.84h0a1.72,1.72,0,0,0-1.34-.4l-17.79,2.37A1.7,1.7,0,0,0,1152.88,301.54Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="1162.16 288.55 1155.09 290.05 1148.85 294.84 1159.3 299.03 1172.1 293.79 1162.16 288.55"
              fill="#ffedc8"
            />
            <polygon
              points="1148.85 294.84 1148.85 299.03 1158.88 303.33 1172.38 297.85 1172.1 293.79 1159.3 299.03 1148.85 294.84"
              fill="#ccae79"
            />
            <polygon
              points="1159.3 299.03 1158.88 303.33 1172.38 297.85 1172.1 293.79 1159.3 299.03"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1151.83,296a1.88,1.88,0,0,1,0,2.15c.47-.67.58-1.92.8-1.83Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1156.24,297.81a6,6,0,0,0,2.64-2.68l-1.9,3Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1164.59,296.87a1.93,1.93,0,0,1,1,1.69l-.31-2Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1169.26,292.29c-.13-.06-2.64.51-4.15,0a6,6,0,0,1-3,.22s2.22-.22,3,.54A18.06,18.06,0,0,1,1169.26,292.29Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M1204.22,386.63l5,3.08a1.62,1.62,0,0,0,1.51.11l11.91-5.33a1.61,1.61,0,0,0,.4-2.69h0a1.63,1.63,0,0,0-1.27-.38l-16.87,2.24A1.61,1.61,0,0,0,1204.22,386.63Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="1213.03 374.31 1206.31 375.74 1200.39 380.28 1210.31 384.26 1222.45 379.28 1213.03 374.31"
              fill="#ffedc8"
            />
            <polygon
              points="1200.39 380.28 1200.39 384.26 1209.91 388.33 1222.71 383.14 1222.45 379.28 1210.31 384.26 1200.39 380.28"
              fill="#ccae79"
            />
            <polygon
              points="1210.31 384.26 1209.91 388.33 1222.71 383.14 1222.45 379.28 1210.31 384.26"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1203.22,381.42a1.78,1.78,0,0,1,0,2c.45-.64.55-1.82.76-1.74Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1207.41,383.09a5.66,5.66,0,0,0,2.5-2.54l-1.8,2.83Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1215.32,382.2a1.83,1.83,0,0,1,1,1.61l-.29-1.89Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1219.76,377.86c-.13-.06-2.51.49-3.94,0a5.59,5.59,0,0,1-2.87.2s2.1-.2,2.87.52A17.2,17.2,0,0,1,1219.76,377.86Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M1201.42,394.91l2.26,1.4a.73.73,0,0,0,.69.05l5.41-2.42a.74.74,0,0,0,.19-1.23h0a.76.76,0,0,0-.58-.17l-7.68,1A.73.73,0,0,0,1201.42,394.91Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="1205.43 389.31 1202.37 389.96 1199.68 392.02 1204.19 393.83 1209.72 391.57 1205.43 389.31"
              fill="#ffedc8"
            />
            <polygon
              points="1199.68 392.02 1199.68 393.83 1204.01 395.69 1209.84 393.32 1209.72 391.57 1204.19 393.83 1199.68 392.02"
              fill="#ccae79"
            />
            <polygon
              points="1204.19 393.83 1204.01 395.69 1209.84 393.32 1209.72 391.57 1204.19 393.83"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1201,392.54a.82.82,0,0,1,0,.93c.2-.29.25-.83.34-.79Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1202.87,393.3a2.57,2.57,0,0,0,1.14-1.15l-.82,1.28Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1206.47,392.9a.83.83,0,0,1,.45.73l-.13-.86Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1208.49,390.92a5.32,5.32,0,0,1-1.79,0,2.59,2.59,0,0,1-1.31.1s1-.1,1.31.23A7.66,7.66,0,0,1,1208.49,390.92Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M1184.17,404.48l2.25,1.4a.77.77,0,0,0,.69.05l5.42-2.43a.73.73,0,0,0,.18-1.22h0a.72.72,0,0,0-.58-.17l-7.67,1A.73.73,0,0,0,1184.17,404.48Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="1188.17 398.87 1185.12 399.52 1182.43 401.59 1186.94 403.4 1192.46 401.13 1188.17 398.87"
              fill="#ffedc8"
            />
            <polygon
              points="1182.43 401.59 1182.43 403.4 1186.76 405.25 1192.58 402.89 1192.46 401.13 1186.94 403.4 1182.43 401.59"
              fill="#ccae79"
            />
            <polygon
              points="1186.94 403.4 1186.76 405.25 1192.58 402.89 1192.46 401.13 1186.94 403.4"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1183.71,402.1a.81.81,0,0,1,0,.93c.21-.29.26-.82.35-.79Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1185.62,402.87a2.62,2.62,0,0,0,1.14-1.16l-.82,1.29Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1189.22,402.46a.84.84,0,0,1,.45.73l-.14-.86Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1191.24,400.49a5.37,5.37,0,0,1-1.8,0,2.6,2.6,0,0,1-1.3.09s1-.09,1.3.23A8.19,8.19,0,0,1,1191.24,400.49Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M1168.85,406.22l2.26,1.4a.71.71,0,0,0,.68,0l5.42-2.42a.73.73,0,0,0,.18-1.22h0a.75.75,0,0,0-.57-.18l-7.68,1A.73.73,0,0,0,1168.85,406.22Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="1172.86 400.61 1169.8 401.26 1167.11 403.33 1171.62 405.14 1177.14 402.87 1172.86 400.61"
              fill="#ffedc8"
            />
            <polygon
              points="1167.11 403.33 1167.11 405.14 1171.44 406.99 1177.26 404.63 1177.14 402.87 1171.62 405.14 1167.11 403.33"
              fill="#ccae79"
            />
            <polygon
              points="1171.62 405.14 1171.44 406.99 1177.26 404.63 1177.14 402.87 1171.62 405.14"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1168.4,403.84a.83.83,0,0,1,0,.93c.2-.29.25-.83.34-.79Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1170.3,404.61a2.57,2.57,0,0,0,1.14-1.16l-.82,1.28Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1173.9,404.2a.84.84,0,0,1,.45.73l-.13-.86Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1175.92,402.23a5.32,5.32,0,0,1-1.79,0,2.64,2.64,0,0,1-1.31.09s1-.09,1.31.23A8,8,0,0,1,1175.92,402.23Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M1169.09,397.74l5.23,3.25a1.69,1.69,0,0,0,1.59.11l12.55-5.61a1.71,1.71,0,0,0,.42-2.84h0a1.72,1.72,0,0,0-1.34-.4l-17.78,2.37A1.69,1.69,0,0,0,1169.09,397.74Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="1178.37 384.76 1171.29 386.26 1165.06 391.05 1175.51 395.24 1188.3 390 1178.37 384.76"
              fill="#ffedc8"
            />
            <polygon
              points="1165.06 391.05 1165.06 395.24 1175.09 399.54 1188.58 394.06 1188.3 390 1175.51 395.24 1165.06 391.05"
              fill="#ccae79"
            />
            <polygon
              points="1175.51 395.24 1175.09 399.54 1188.58 394.06 1188.3 390 1175.51 395.24"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1168,392.25a1.88,1.88,0,0,1,0,2.15c.47-.68.58-1.92.8-1.83Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1172.45,394a5.92,5.92,0,0,0,2.63-2.68l-1.89,3Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1180.79,393.08a1.93,1.93,0,0,1,1,1.69l-.31-2Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1185.46,388.51c-.13-.07-2.64.51-4.15,0a6,6,0,0,1-3,.21s2.22-.22,3,.54A17.87,17.87,0,0,1,1185.46,388.51Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M1155,406.42l2.26,1.4a.71.71,0,0,0,.68.05l5.42-2.42a.74.74,0,0,0,.18-1.23h0a.72.72,0,0,0-.58-.17l-7.67,1A.73.73,0,0,0,1155,406.42Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="1158.99 400.81 1155.94 401.46 1153.25 403.53 1157.76 405.34 1163.28 403.08 1158.99 400.81"
              fill="#ffedc8"
            />
            <polygon
              points="1153.25 403.53 1153.25 405.34 1157.58 407.19 1163.4 404.83 1163.28 403.08 1157.76 405.34 1153.25 403.53"
              fill="#ccae79"
            />
            <polygon
              points="1157.76 405.34 1157.58 407.19 1163.4 404.83 1163.28 403.08 1157.76 405.34"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1154.54,404.05a.82.82,0,0,1,0,.93c.2-.3.25-.83.34-.79S1154.54,404.05,1154.54,404.05Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1156.44,404.81a2.57,2.57,0,0,0,1.14-1.16l-.82,1.29Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1160,404.4a.85.85,0,0,1,.45.74l-.14-.86Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1162.06,402.43a5.32,5.32,0,0,1-1.79,0,2.51,2.51,0,0,1-1.31.09s1-.09,1.31.24A7.66,7.66,0,0,1,1162.06,402.43Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M1156.84,416.81l-2.26,1.4a.74.74,0,0,1-.69.05l-5.42-2.42a.74.74,0,0,1-.18-1.23h0a.76.76,0,0,1,.58-.17l7.68,1A.73.73,0,0,1,1156.84,416.81Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="1152.83 411.21 1155.88 411.86 1158.58 413.92 1154.07 415.73 1148.54 413.47 1152.83 411.21"
              fill="#ffedc8"
            />
            <polygon
              points="1158.58 413.92 1158.58 415.73 1154.25 417.59 1148.42 415.22 1148.54 413.47 1154.07 415.73 1158.58 413.92"
              fill="#ccae79"
            />
            <polygon
              points="1154.07 415.73 1154.25 417.59 1148.42 415.22 1148.54 413.47 1154.07 415.73"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1157.29,414.44a.82.82,0,0,0,0,.93c-.21-.29-.25-.83-.35-.79Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1155.39,415.2a2.57,2.57,0,0,1-1.14-1.15l.82,1.28Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1151.78,414.8a.82.82,0,0,0-.44.73l.13-.86Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1149.77,412.82a5.31,5.31,0,0,0,1.79,0,2.59,2.59,0,0,0,1.31.1s-1-.1-1.31.23A7.66,7.66,0,0,0,1149.77,412.82Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M1142.34,281.93l2.26,1.4a.71.71,0,0,0,.68.05l5.42-2.42a.74.74,0,0,0,.18-1.23h0a.7.7,0,0,0-.57-.17l-7.68,1A.73.73,0,0,0,1142.34,281.93Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="1146.35 276.32 1143.29 276.97 1140.6 279.04 1145.11 280.85 1150.63 278.59 1146.35 276.32"
              fill="#ffedc8"
            />
            <polygon
              points="1140.6 279.04 1140.6 280.85 1144.93 282.7 1150.75 280.34 1150.63 278.59 1145.11 280.85 1140.6 279.04"
              fill="#ccae79"
            />
            <polygon
              points="1145.11 280.85 1144.93 282.7 1150.75 280.34 1150.63 278.59 1145.11 280.85"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1141.89,279.56a.81.81,0,0,1,0,.92c.2-.29.25-.82.34-.78S1141.89,279.56,1141.89,279.56Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1143.79,280.32a2.57,2.57,0,0,0,1.14-1.16l-.82,1.29Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1147.39,279.91a.85.85,0,0,1,.45.74l-.13-.86Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1149.41,277.94a5.32,5.32,0,0,1-1.79,0,2.51,2.51,0,0,1-1.31.09s1-.09,1.31.24A7.66,7.66,0,0,1,1149.41,277.94Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M1195.35,306.33l6.06,3.76a1.94,1.94,0,0,0,1.84.13l14.55-6.5a2,2,0,0,0,.48-3.29h0a2,2,0,0,0-1.55-.47l-20.6,2.75A2,2,0,0,0,1195.35,306.33Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="1206.1 291.28 1197.9 293.02 1190.67 298.58 1202.78 303.43 1217.61 297.36 1206.1 291.28"
              fill="#ffedc8"
            />
            <polygon
              points="1190.67 298.58 1190.67 303.43 1202.29 308.41 1217.93 302.06 1217.61 297.36 1202.78 303.43 1190.67 298.58"
              fill="#ccae79"
            />
            <polygon
              points="1202.78 303.43 1202.29 308.41 1217.93 302.06 1217.61 297.36 1202.78 303.43"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1194.13,300a2.18,2.18,0,0,1,0,2.49c.55-.78.67-2.22.93-2.12Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1199.24,302a6.89,6.89,0,0,0,3-3.1l-2.19,3.44Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1208.91,300.92a2.24,2.24,0,0,1,1.2,2l-.36-2.3Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1214.33,295.62c-.16-.08-3.07.59-4.82,0a7,7,0,0,1-3.51.25s2.58-.25,3.51.63A20.8,20.8,0,0,1,1214.33,295.62Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M1225.31,324.73l6.06,3.76a2,2,0,0,0,1.84.13l14.55-6.51a2,2,0,0,0,.49-3.28h0a2,2,0,0,0-1.55-.47l-20.61,2.74A2,2,0,0,0,1225.31,324.73Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="1236.07 309.68 1227.86 311.42 1220.63 316.97 1232.74 321.83 1247.58 315.75 1236.07 309.68"
              fill="#ffedc8"
            />
            <polygon
              points="1220.63 316.97 1220.63 321.83 1232.26 326.81 1247.9 320.46 1247.58 315.75 1232.74 321.83 1220.63 316.97"
              fill="#ccae79"
            />
            <polygon
              points="1232.74 321.83 1232.26 326.81 1247.9 320.46 1247.58 315.75 1232.74 321.83"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1224.09,318.36a2.18,2.18,0,0,1,0,2.49c.55-.78.68-2.22.93-2.12Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1229.2,320.41a6.93,6.93,0,0,0,3.06-3.11l-2.2,3.45Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1238.87,319.32a2.24,2.24,0,0,1,1.21,2l-.36-2.31Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1244.29,314c-.15-.08-3.06.59-4.81,0a7,7,0,0,1-3.51.25s2.57-.25,3.51.62A21,21,0,0,1,1244.29,314Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M1237,334.63l3.31,1.59a1.4,1.4,0,0,0,1,0l7.94-2.74c.72-.25.86-1,.26-1.39h0a1.27,1.27,0,0,0-.84-.19l-11.25,1.15C1236.45,333.2,1236.16,334.22,1237,334.63Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="1242.89 328.28 1238.42 329.02 1234.47 331.36 1241.08 333.41 1249.18 330.85 1242.89 328.28"
              fill="#ffedc8"
            />
            <polygon
              points="1234.47 331.36 1234.47 333.41 1240.82 335.51 1249.35 332.83 1249.18 330.85 1241.08 333.41 1234.47 331.36"
              fill="#ccae79"
            />
            <polygon
              points="1241.08 333.41 1240.82 335.51 1249.35 332.83 1249.18 330.85 1241.08 333.41"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1236.36,331.94a.77.77,0,0,1,0,1.06c.3-.33.37-.94.5-.9Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1239.15,332.81a3.62,3.62,0,0,0,1.66-1.31l-1.19,1.45Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1244.42,332.35s.72.29.66.83l-.19-1Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1247.38,330.11a9.8,9.8,0,0,1-2.62,0,4.86,4.86,0,0,1-1.92.11,4.06,4.06,0,0,1,1.92.26A14.21,14.21,0,0,1,1247.38,330.11Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M1228,344.38l3.3,1.59a1.41,1.41,0,0,0,1,0l7.94-2.74c.72-.25.86-1,.27-1.39h0a1.3,1.3,0,0,0-.85-.2l-11.25,1.16C1227.37,343,1227.09,344,1228,344.38Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="1233.82 338.03 1229.34 338.76 1225.4 341.11 1232.01 343.15 1240.1 340.59 1233.82 338.03"
              fill="#ffedc8"
            />
            <polygon
              points="1225.4 341.11 1225.4 343.15 1231.74 345.26 1240.28 342.58 1240.1 340.59 1232.01 343.15 1225.4 341.11"
              fill="#ccae79"
            />
            <polygon
              points="1232.01 343.15 1231.74 345.26 1240.28 342.58 1240.1 340.59 1232.01 343.15"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1227.28,341.69a.75.75,0,0,1,0,1.05c.3-.33.37-.93.51-.89Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1230.07,342.56a3.62,3.62,0,0,0,1.67-1.31l-1.2,1.45Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1235.35,342.1s.72.28.66.82l-.2-1Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1238.31,339.86a9.88,9.88,0,0,1-2.63,0,4.68,4.68,0,0,1-1.91.1,4.07,4.07,0,0,1,1.91.27A14.39,14.39,0,0,1,1238.31,339.86Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M1152.6,286.22l4.68,2.91a1.54,1.54,0,0,0,1.43.09l11.24-5a1.52,1.52,0,0,0,.38-2.54h0a1.51,1.51,0,0,0-1.2-.36l-15.93,2.12A1.52,1.52,0,0,0,1152.6,286.22Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="1160.91 274.59 1154.57 275.93 1148.99 280.23 1158.35 283.98 1169.81 279.28 1160.91 274.59"
              fill="#ffedc8"
            />
            <polygon
              points="1148.99 280.23 1148.99 283.98 1157.97 287.82 1170.06 282.92 1169.81 279.28 1158.35 283.98 1148.99 280.23"
              fill="#ccae79"
            />
            <polygon
              points="1158.35 283.98 1157.97 287.82 1170.06 282.92 1169.81 279.28 1158.35 283.98"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1151.66,281.3a1.68,1.68,0,0,1,0,1.92c.42-.6.52-1.72.72-1.64Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1155.61,282.88a5.36,5.36,0,0,0,2.36-2.4l-1.7,2.66Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1163.08,282a1.73,1.73,0,0,1,.93,1.51l-.28-1.78Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1167.27,277.94c-.12-.06-2.37.46-3.72,0a5.3,5.3,0,0,1-2.71.19s2-.19,2.71.49A16.28,16.28,0,0,1,1167.27,277.94Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M1138.08,211.08l5.72,3.56a1.9,1.9,0,0,0,1.75.12l13.75-6.15a1.87,1.87,0,0,0,.46-3.11h0a1.88,1.88,0,0,0-1.47-.44l-19.48,2.59A1.86,1.86,0,0,0,1138.08,211.08Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="1148.24 196.86 1140.49 198.5 1133.66 203.75 1145.11 208.34 1159.12 202.6 1148.24 196.86"
              fill="#ffedc8"
            />
            <polygon
              points="1133.66 203.75 1133.66 208.34 1144.64 213.05 1159.43 207.05 1159.12 202.6 1145.11 208.34 1133.66 203.75"
              fill="#ccae79"
            />
            <polygon
              points="1145.11 208.34 1144.64 213.05 1159.43 207.05 1159.12 202.6 1145.11 208.34"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1136.93,205.06a2.07,2.07,0,0,1,0,2.36c.51-.74.63-2.1.87-2Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1141.76,207a6.51,6.51,0,0,0,2.88-2.94l-2.07,3.26Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1150.89,206a2.13,2.13,0,0,1,1.15,1.85l-.35-2.18Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1156,201c-.15-.08-2.9.56-4.55,0a6.47,6.47,0,0,1-3.32.23s2.43-.23,3.32.6A19.88,19.88,0,0,1,1156,201Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M1139,174.11l2.23,1.38a.72.72,0,0,0,.67,0l5.34-2.38a.73.73,0,0,0,.18-1.21h0a.75.75,0,0,0-.57-.17l-7.56,1A.72.72,0,0,0,1139,174.11Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="1142.95 168.59 1139.94 169.23 1137.29 171.26 1141.73 173.04 1147.17 170.82 1142.95 168.59"
              fill="#ffedc8"
            />
            <polygon
              points="1137.29 171.26 1137.29 173.04 1141.55 174.87 1147.29 172.54 1147.17 170.82 1141.73 173.04 1137.29 171.26"
              fill="#ccae79"
            />
            <polygon
              points="1141.73 173.04 1141.55 174.87 1147.29 172.54 1147.17 170.82 1141.73 173.04"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1138.56,171.77a.81.81,0,0,1,0,.92c.2-.29.25-.82.34-.78Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1140.43,172.52a2.48,2.48,0,0,0,1.12-1.14l-.8,1.27Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1144,172.12a.82.82,0,0,1,.44.72l-.13-.84Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1146,170.18a5.2,5.2,0,0,1-1.77,0,2.56,2.56,0,0,1-1.29.09s.95-.09,1.29.23A7.83,7.83,0,0,1,1146,170.18Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M1119.24,171.3l3,1.85a1,1,0,0,0,.91.06l7.17-3.2a1,1,0,0,0,.24-1.62h0a1,1,0,0,0-.77-.23l-10.15,1.35A1,1,0,0,0,1119.24,171.3Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="1124.54 163.89 1120.5 164.75 1116.94 167.48 1122.9 169.87 1130.21 166.88 1124.54 163.89"
              fill="#ffedc8"
            />
            <polygon
              points="1116.94 167.48 1116.94 169.87 1122.66 172.32 1130.36 169.2 1130.21 166.88 1122.9 169.87 1116.94 167.48"
              fill="#ccae79"
            />
            <polygon
              points="1122.9 169.87 1122.66 172.32 1130.36 169.2 1130.21 166.88 1122.9 169.87"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1118.64,168.16a1.09,1.09,0,0,1,0,1.23c.27-.39.33-1.09.46-1Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1121.16,169.17a3.39,3.39,0,0,0,1.5-1.53l-1.08,1.7Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1125.92,168.64a1.09,1.09,0,0,1,.59,1l-.18-1.14Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1128.59,166a6.82,6.82,0,0,1-2.37,0,3.36,3.36,0,0,1-1.73.13s1.27-.13,1.73.31A10,10,0,0,1,1128.59,166Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M1091.6,204.23l5.14,3.2a1.71,1.71,0,0,0,1.57.11l12.36-5.53a1.67,1.67,0,0,0,.42-2.79h0a1.69,1.69,0,0,0-1.32-.4l-17.51,2.33A1.67,1.67,0,0,0,1091.6,204.23Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="1100.73 191.45 1093.77 192.93 1087.63 197.64 1097.91 201.77 1110.52 196.61 1100.73 191.45"
              fill="#ffedc8"
            />
            <polygon
              points="1087.63 197.64 1087.63 201.77 1097.5 206 1110.79 200.61 1110.52 196.61 1097.91 201.77 1087.63 197.64"
              fill="#ccae79"
            />
            <polygon
              points="1097.91 201.77 1097.5 206 1110.79 200.61 1110.52 196.61 1097.91 201.77"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1090.56,198.82a1.86,1.86,0,0,1,0,2.12c.47-.66.58-1.89.79-1.8Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1094.9,200.56a5.85,5.85,0,0,0,2.6-2.64l-1.87,2.93Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1103.12,199.64a1.9,1.9,0,0,1,1,1.66l-.3-2Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1107.72,195.13c-.13-.06-2.6.51-4.09,0a5.83,5.83,0,0,1-3,.21s2.19-.21,3,.54A17.93,17.93,0,0,1,1107.72,195.13Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M1070.71,190.89l5.29,3.28a1.71,1.71,0,0,0,1.6.11l12.69-5.68a1.71,1.71,0,0,0,.43-2.86h0a1.71,1.71,0,0,0-1.35-.41l-18,2.39A1.72,1.72,0,0,0,1070.71,190.89Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="1080.09 177.76 1072.94 179.28 1066.64 184.12 1077.2 188.35 1090.13 183.06 1080.09 177.76"
              fill="#ffedc8"
            />
            <polygon
              points="1066.64 184.12 1066.64 188.35 1076.77 192.7 1090.41 187.16 1090.13 183.06 1077.2 188.35 1066.64 184.12"
              fill="#ccae79"
            />
            <polygon
              points="1077.2 188.35 1076.77 192.7 1090.41 187.16 1090.13 183.06 1077.2 188.35"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1069.65,185.33a1.91,1.91,0,0,1,0,2.17c.48-.68.59-1.93.81-1.85Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1074.11,187.12a6,6,0,0,0,2.66-2.71l-1.91,3Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1082.54,186.17a2,2,0,0,1,1,1.71l-.31-2Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1087.27,181.54c-.14-.07-2.67.52-4.2,0a6.07,6.07,0,0,1-3.06.22s2.24-.22,3.06.55A18.06,18.06,0,0,1,1087.27,181.54Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M1101.54,176.74l2.87,1.78a1,1,0,0,0,.87.06l6.87-3.08a.92.92,0,0,0,.23-1.55h0a.88.88,0,0,0-.73-.22l-9.74,1.29A.94.94,0,0,0,1101.54,176.74Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="1106.63 169.63 1102.75 170.45 1099.33 173.07 1105.06 175.37 1112.07 172.5 1106.63 169.63"
              fill="#ffedc8"
            />
            <polygon
              points="1099.33 173.07 1099.33 175.37 1104.83 177.72 1112.22 174.72 1112.07 172.5 1105.06 175.37 1099.33 173.07"
              fill="#ccae79"
            />
            <polygon
              points="1105.06 175.37 1104.83 177.72 1112.22 174.72 1112.07 172.5 1105.06 175.37"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1101,173.73a1,1,0,0,1,0,1.18c.25-.37.31-1,.43-1Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1103.38,174.7a3.3,3.3,0,0,0,1.45-1.47l-1,1.63Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1108,174.18a1.05,1.05,0,0,1,.57.93l-.17-1.09Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1110.51,171.68a6.76,6.76,0,0,1-2.27,0,3.33,3.33,0,0,1-1.66.11s1.22-.12,1.66.3A9.82,9.82,0,0,1,1110.51,171.68Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M1142.36,163.12l6,3.73a2,2,0,0,0,1.83.12l14.41-6.44a2,2,0,0,0,.48-3.25h0a1.9,1.9,0,0,0-1.53-.46l-20.41,2.71A2,2,0,0,0,1142.36,163.12Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="1153.02 148.22 1144.89 149.94 1137.73 155.44 1149.73 160.25 1164.42 154.24 1153.02 148.22"
              fill="#ffedc8"
            />
            <polygon
              points="1137.73 155.44 1137.73 160.25 1149.24 165.18 1164.73 158.9 1164.42 154.24 1149.73 160.25 1137.73 155.44"
              fill="#ccae79"
            />
            <polygon
              points="1149.73 160.25 1149.24 165.18 1164.73 158.9 1164.42 154.24 1149.73 160.25"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1141.16,156.82a2.15,2.15,0,0,1,0,2.46c.54-.77.67-2.2.92-2.1Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1146.22,158.84a6.82,6.82,0,0,0,3-3.07l-2.17,3.41Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1155.79,157.77a2.22,2.22,0,0,1,1.2,1.94l-.36-2.29Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1161.16,152.52c-.15-.08-3,.58-4.77,0a6.86,6.86,0,0,1-3.47.24s2.55-.25,3.47.62A20.61,20.61,0,0,1,1161.16,152.52Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M1162.27,160.79s1,2.07,2.49,2.42,3.64-1.09,3.31.1,2.73,1.73,4,1.41,4.21-3.15,4.19-4S1162.27,160.79,1162.27,160.79Z"
            fill="#131b8c"
            opacity="0.63"
          />
          <g>
            <path
              d="M1162.22,159.09l0,1.7,2.5,1.74,3.24-.08.76,1.24s2.24,1,3.73-.1a12.05,12.05,0,0,0,2.62-3.14l0-1.7Z"
              fill="#ccae79"
            />
            <path
              d="M1164.82,157.92l-2.6,1.17,2.68,1.74,3.1-.09,1,1.28s3,.82,3.42-.1a18.64,18.64,0,0,1,2.62-3.17l-2.43-1Z"
              fill="#ffedc8"
            />
            <polygon
              points="1164.9 160.82 1164.77 162.53 1168.01 162.44 1168 160.74 1164.9 160.82"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1171.68,162.33s.53,1.55,0,1.66a7.49,7.49,0,0,0,3.4-3.54l0-1.7S1172.39,162.32,1171.68,162.33Z"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1169.59,162.15l.61.11s-.38-.1-.29.61A1.61,1.61,0,0,0,1169.59,162.15Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1171,162.36a3.62,3.62,0,0,0,.68-.57,3.56,3.56,0,0,0,.75-1.17s-1.31,1.52-1,1.73Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1163.79,160.11a10.65,10.65,0,0,1,0,1.23s-.07-.93.19-1.09Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1168.55,157.82l1.23,0c.09,0-1,0-1.22.58v-.55"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1163.53,158.5l.65-.29s-.37.24-.22.28.72.28,1,.16a1,1,0,0,1,.62,0Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M1096.31,220.37s2,4,4.77,4.63,7-2.09,6.32.19,5.23,3.3,7.75,2.68,8-6,8-7.72S1096.31,220.37,1096.31,220.37Z"
            fill="#131b8c"
            opacity="0.63"
          />
          <g>
            <path
              d="M1096.23,217.12l.08,3.25,4.78,3.33,6.2-.17,1.47,2.38s4.27,2,7.12-.19a23.25,23.25,0,0,0,5-6l-.09-3.24Z"
              fill="#ccae79"
            />
            <path
              d="M1101.2,214.88l-5,2.24,5.12,3.31,5.92-.16,2,2.44s5.82,1.57,6.53-.18,5-6.07,5-6.07l-4.65-2Z"
              fill="#ffedc8"
            />
            <polygon
              points="1101.35 220.43 1101.09 223.7 1107.29 223.53 1107.27 220.27 1101.35 220.43"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1114.31,223.32s1,3,.09,3.16a14.25,14.25,0,0,0,6.48-6.78l-.09-3.24S1115.67,223.3,1114.31,223.32Z"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1110.31,223l1.18.21s-.73-.19-.55,1.18A3.32,3.32,0,0,0,1110.31,223Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1113,223.37c-.13,0,.23,0,1.28-1.09a6.84,6.84,0,0,0,1.44-2.24s-2.51,2.91-1.89,3.31Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1099.22,219.06a18.47,18.47,0,0,1,.07,2.35s-.14-1.77.35-2.08Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1108.32,214.69l2.35-.07c.18,0-1.84,0-2.32,1.11l0-1"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1098.73,216l1.24-.56s-.7.45-.42.54,1.38.54,1.82.3a1.83,1.83,0,0,1,1.18,0Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M1130.86,220.48s1.56,3.11,3.74,3.64,5.47-1.64,5,.15,4.11,2.59,6.09,2.1,6.32-4.72,6.29-6.06S1130.86,220.48,1130.86,220.48Z"
            fill="#131b8c"
            opacity="0.63"
          />
          <g>
            <path
              d="M1130.79,217.93l.07,2.55,3.75,2.62,4.86-.14,1.16,1.87s3.35,1.57,5.59-.15a18.17,18.17,0,0,0,3.93-4.72l-.07-2.55Z"
              fill="#ccae79"
            />
            <path
              d="M1134.7,216.17l-3.91,1.76,4,2.6,4.64-.12,1.56,1.91s4.57,1.23,5.13-.14,3.93-4.77,3.93-4.77l-3.66-1.56Z"
              fill="#ffedc8"
            />
            <polygon
              points="1134.82 220.53 1134.61 223.09 1139.47 222.96 1139.46 220.41 1134.82 220.53"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1145,222.8s.8,2.32.07,2.48a11.2,11.2,0,0,0,5.09-5.32l-.07-2.55S1146.06,222.78,1145,222.8Z"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1141.85,222.51l.92.17s-.57-.15-.43.93A2.67,2.67,0,0,0,1141.85,222.51Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1144,222.84c-.1,0,.18,0,1-.86a5.53,5.53,0,0,0,1.13-1.75s-2,2.28-1.49,2.6Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1133.14,219.45a14.48,14.48,0,0,1,0,1.85s-.1-1.39.28-1.63Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1140.29,216l1.84-.05c.14,0-1.45,0-1.82.87l0-.82"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1132.76,217.05l1-.44s-.55.35-.33.42,1.08.42,1.43.24a1.39,1.39,0,0,1,.93,0Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M1194,270.63s1.84,3.65,4.4,4.27,6.41-1.93,5.81.17,4.82,3,7.13,2.47,7.42-5.53,7.39-7.1S1194,270.63,1194,270.63Z"
            fill="#131b8c"
            opacity="0.63"
          />
          <g>
            <path
              d="M1193.89,267.64l.08,3,4.4,3.07,5.71-.16,1.35,2.2s3.94,1.83,6.56-.18a21.14,21.14,0,0,0,4.6-5.54l-.08-3Z"
              fill="#ccae79"
            />
            <path
              d="M1198.48,265.58l-4.59,2.06,4.72,3.05,5.45-.14,1.83,2.24s5.36,1.44,6-.16,4.61-5.6,4.61-5.6l-4.28-1.82Z"
              fill="#ffedc8"
            />
            <polygon
              points="1198.61 270.69 1198.38 273.7 1204.08 273.55 1204.06 270.55 1198.61 270.69"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1210.55,273.35s.93,2.72.07,2.91a13.05,13.05,0,0,0,6-6.24l-.08-3S1211.8,273.33,1210.55,273.35Z"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1206.86,273l1.09.2s-.68-.18-.51,1.08A3,3,0,0,0,1206.86,273Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1209.34,273.4c-.12,0,.21,0,1.18-1a6.23,6.23,0,0,0,1.32-2.05s-2.31,2.67-1.74,3Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1196.65,269.43a18.65,18.65,0,0,1,.06,2.16s-.12-1.63.33-1.91Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1205,265.4l2.17-.06c.15,0-1.71,0-2.15,1l0-1"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1196.2,266.6l1.14-.51s-.64.41-.38.49,1.27.5,1.67.28a1.63,1.63,0,0,1,1.09,0Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M1185.43,229.67s-1.26,2.5-3,2.92-4.4-1.32-4,.12-3.3,2.09-4.89,1.7-5.09-3.8-5.06-4.88S1185.43,229.67,1185.43,229.67Z"
            fill="#131b8c"
            opacity="0.63"
          />
          <g>
            <path
              d="M1185.48,227.62l0,2-3,2.1-3.91-.1-.93,1.5s-2.7,1.26-4.5-.12a14.52,14.52,0,0,1-3.16-3.8l0-2.05Z"
              fill="#ccae79"
            />
            <path
              d="M1182.34,226.2l3.14,1.42-3.24,2.09-3.73-.1-1.26,1.54s-3.67,1-4.12-.11-3.17-3.84-3.17-3.84l2.94-1.25Z"
              fill="#ffedc8"
            />
            <polygon
              points="1182.24 229.71 1182.41 231.77 1178.5 231.67 1178.51 229.61 1182.24 229.71"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1174.06,231.53s-.65,1.87-.06,2a9,9,0,0,1-4.09-4.28l0-2.05S1173.2,231.52,1174.06,231.53Z"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1176.58,231.31l-.74.13s.46-.12.35.75A2.06,2.06,0,0,1,1176.58,231.31Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1174.89,231.57c.08,0-.15,0-.81-.69a4.33,4.33,0,0,1-.91-1.42s1.58,1.84,1.19,2.1Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1183.59,228.84a11.73,11.73,0,0,0,0,1.49s.09-1.12-.23-1.32Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1177.84,226.08l-1.48,0c-.11,0,1.16,0,1.47.7v-.66"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1183.9,226.9l-.78-.35s.44.29.26.34-.87.34-1.15.19a1.1,1.1,0,0,0-.74,0Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M1162.43,269.71s-1,2.08-2.5,2.43-3.66-1.1-3.32.1-2.74,1.73-4.06,1.4-4.22-3.15-4.2-4S1162.43,269.71,1162.43,269.71Z"
            fill="#131b8c"
            opacity="0.63"
          />
          <g>
            <path
              d="M1162.47,268l0,1.7-2.51,1.75-3.25-.09-.77,1.25s-2.24,1-3.73-.11a12,12,0,0,1-2.62-3.15l0-1.7Z"
              fill="#ccae79"
            />
            <path
              d="M1159.86,266.83l2.61,1.18-2.69,1.73-3.1-.08-1,1.28s-3.05.82-3.42-.09a18.51,18.51,0,0,0-2.63-3.19l2.44-1Z"
              fill="#ffedc8"
            />
            <polygon
              points="1159.78 269.74 1159.92 271.46 1156.67 271.37 1156.68 269.66 1159.78 269.74"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1153,271.26s-.53,1.55,0,1.65a7.44,7.44,0,0,1-3.4-3.55l0-1.7S1152.28,271.25,1153,271.26Z"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1155.09,271.07l-.62.11s.38-.1.29.62A1.77,1.77,0,0,1,1155.09,271.07Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1153.68,271.29c.07,0-.12,0-.67-.58a3.5,3.5,0,0,1-.76-1.17s1.32,1.52,1,1.73Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1160.9,269a10.87,10.87,0,0,0,0,1.24s.07-.93-.19-1.09Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1156.13,266.73l-1.23,0c-.09,0,1,0,1.22.58v-.55"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1161.16,267.42l-.65-.3s.36.24.22.28-.72.29-1,.16a1,1,0,0,0-.62,0Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M1200.28,387.32s-1,2.08-2.5,2.43-3.65-1.1-3.32.1-2.74,1.73-4.06,1.4-4.22-3.15-4.2-4S1200.28,387.32,1200.28,387.32Z"
            fill="#131b8c"
            opacity="0.63"
          />
          <g>
            <path
              d="M1200.32,385.62l0,1.7-2.51,1.74-3.25-.08-.77,1.24s-2.24,1-3.73-.1a12,12,0,0,1-2.62-3.15l0-1.7Z"
              fill="#ccae79"
            />
            <path
              d="M1197.71,384.44l2.61,1.18-2.69,1.73-3.1-.08-1,1.28s-3,.82-3.42-.1a18.8,18.8,0,0,0-2.62-3.18l2.43-1Z"
              fill="#ffedc8"
            />
            <polygon
              points="1197.63 387.35 1197.77 389.06 1194.53 388.98 1194.53 387.27 1197.63 387.35"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1190.84,388.86s-.53,1.56,0,1.66a7.44,7.44,0,0,1-3.4-3.55l0-1.7S1190.13,388.85,1190.84,388.86Z"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1192.94,388.68l-.62.11s.38-.1.29.62A1.69,1.69,0,0,1,1192.94,388.68Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1191.53,388.9c.07,0-.12,0-.67-.58a3.71,3.71,0,0,1-.76-1.17s1.32,1.52,1,1.73Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1198.75,386.63a10.65,10.65,0,0,0,0,1.23s.07-.92-.19-1.09Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1194,384.34l-1.23,0c-.09,0,1,0,1.22.58v-.55"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1199,385l-.65-.29s.36.24.22.28-.72.29-1,.16a1,1,0,0,0-.62,0Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M1190.54,419.88s-1.8,3.57-4.29,4.17-6.27-1.88-5.69.17-4.7,3-7,2.41-7.24-5.41-7.21-6.94S1190.54,419.88,1190.54,419.88Z"
            fill="#131b8c"
            opacity="0.63"
          />
          <g>
            <path
              d="M1190.62,417l-.08,2.92-4.3,3-5.58-.15-1.32,2.14s-3.85,1.79-6.41-.17a20.81,20.81,0,0,1-4.5-5.42l.08-2.92Z"
              fill="#ccae79"
            />
            <path
              d="M1186.14,414.94l4.48,2-4.62,3-5.32-.15-1.79,2.2s-5.24,1.41-5.87-.16-4.51-5.47-4.51-5.47l4.19-1.78Z"
              fill="#ffedc8"
            />
            <polygon
              points="1186 419.94 1186.24 422.88 1180.66 422.73 1180.68 419.79 1186 419.94"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1174.34,422.53s-.92,2.67-.08,2.85a12.79,12.79,0,0,1-5.83-6.1l.08-2.92S1173.12,422.52,1174.34,422.53Z"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1177.94,422.21l-1.06.19s.66-.17.5,1.06A3,3,0,0,1,1177.94,422.21Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1175.52,422.59c.12,0-.21,0-1.15-1a6.22,6.22,0,0,1-1.3-2s2.26,2.61,1.7,3Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1187.92,418.7a17.89,17.89,0,0,0-.06,2.12s.12-1.6-.32-1.87Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1179.73,414.77l-2.11-.06c-.16,0,1.66,0,2.09,1l0-.94"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1188.36,415.94l-1.11-.5s.62.4.37.48-1.24.49-1.63.27a1.64,1.64,0,0,0-1.07,0Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
      </g>
      <g>
        <g>
          <g>
            <g>
              <path
                d="M226.22,230.66c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,226.22,230.66Z"
                fill="#2f6840"
              />
              <path
                d="M225.72,230.32c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.91-1.16-2.91-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,225.72,230.32Z"
                fill="#3ba525"
              />
              <path
                d="M226.47,230.29a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.26,2.26,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,226.47,230.29Z"
                fill="#2f6840"
              />
              <path
                d="M230,229.49c-.26,0-.49,0-.73.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.38,2.38,0,0,1,1.24-.86A2.12,2.12,0,0,1,230,229.49Z"
                fill="#2f6840"
              />
              <path
                d="M228.58,232.7a2,2,0,0,0-.66-1c-.28-.28-.64-.5-1-.81a2.21,2.21,0,0,1,1.21.55,1.64,1.64,0,0,1,.4.57A.89.89,0,0,1,228.58,232.7Z"
                fill="#2f6840"
              />
              <path
                d="M226.62,230.75c-.24.06-.47.09-.7.16a2.87,2.87,0,0,0-.64.23,9.24,9.24,0,0,0-1.25.64,2.24,2.24,0,0,1,1.11-1A2,2,0,0,1,226.62,230.75Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M223.56,239.39c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.44-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,223.56,239.39Z"
                fill="#2f6840"
              />
              <path
                d="M223.06,239.05c4.42-.25-4.33.45-4.35-.61s4.34-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,223.06,239.05Z"
                fill="#3ba525"
              />
              <path
                d="M223.81,239a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.74a2.35,2.35,0,0,1,1.29.46,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,223.81,239Z"
                fill="#2f6840"
              />
              <path
                d="M227.29,238.22c-.26,0-.49.05-.73.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.45,2.45,0,0,1,1.24-.87A2.12,2.12,0,0,1,227.29,238.22Z"
                fill="#2f6840"
              />
              <path
                d="M225.92,241.43a2,2,0,0,0-.66-1c-.28-.28-.64-.5-1-.81a2.21,2.21,0,0,1,1.21.55,1.64,1.64,0,0,1,.4.57A.89.89,0,0,1,225.92,241.43Z"
                fill="#2f6840"
              />
              <path
                d="M224,239.48c-.24.06-.47.09-.7.16a3.45,3.45,0,0,0-.64.22,9.33,9.33,0,0,0-1.25.65,2.31,2.31,0,0,1,1.11-1A2,2,0,0,1,224,239.48Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M218.21,234.43c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.23-2.78,2.92-2.16S226,235,225,234.91s-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,218.21,234.43Z"
                fill="#2f6840"
              />
              <path
                d="M217.71,234.09c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,217.71,234.09Z"
                fill="#3ba525"
              />
              <path
                d="M218.46,234.06a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.28,2.28,0,0,1,1.28.45,1.88,1.88,0,0,1,.48.53A1,1,0,0,1,218.46,234.06Z"
                fill="#2f6840"
              />
              <path
                d="M221.94,233.27c-.26,0-.5,0-.73.09a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.39,2.39,0,0,1,1.23-.86A2.1,2.1,0,0,1,221.94,233.27Z"
                fill="#2f6840"
              />
              <path
                d="M220.57,236.48a2,2,0,0,0-.66-1c-.29-.28-.64-.5-1-.8a2.13,2.13,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A.92.92,0,0,1,220.57,236.48Z"
                fill="#2f6840"
              />
              <path
                d="M218.61,234.52c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,9.24,9.24,0,0,0-1.25.64,2.24,2.24,0,0,1,1.11-1A2,2,0,0,1,218.61,234.52Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M209.87,231.06c4.42-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,209.87,231.06Z"
                fill="#2f6840"
              />
              <path
                d="M209.36,230.72c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.64,3.44-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.92,3.34-3,2.55-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,209.36,230.72Z"
                fill="#3ba525"
              />
              <path
                d="M210.12,230.69a2.24,2.24,0,0,0-.8-.94c-.32-.26-.71-.45-1.07-.73a2.21,2.21,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,210.12,230.69Z"
                fill="#2f6840"
              />
              <path
                d="M213.59,229.89c-.25,0-.49.05-.72.1a4,4,0,0,0-.68.18,12.79,12.79,0,0,0-1.35.52,2.54,2.54,0,0,1,1.24-.87A2.12,2.12,0,0,1,213.59,229.89Z"
                fill="#2f6840"
              />
              <path
                d="M212.22,233.1a1.94,1.94,0,0,0-.65-1c-.29-.28-.64-.5-1-.81a2.24,2.24,0,0,1,1.21.55,1.78,1.78,0,0,1,.4.57A.94.94,0,0,1,212.22,233.1Z"
                fill="#2f6840"
              />
              <path
                d="M210.27,231.15c-.25.06-.48.09-.7.16a3.83,3.83,0,0,0-.65.22,10,10,0,0,0-1.25.65,2.34,2.34,0,0,1,1.12-1A2,2,0,0,1,210.27,231.15Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M224.57,246.55c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.44-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,224.57,246.55Z"
                fill="#2f6840"
              />
              <path
                d="M224.07,246.21c4.42-.25-4.33.45-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,224.07,246.21Z"
                fill="#3ba525"
              />
              <path
                d="M224.82,246.18a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.29.46,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,224.82,246.18Z"
                fill="#2f6840"
              />
              <path
                d="M228.3,245.38c-.26,0-.49.05-.73.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.45,2.45,0,0,1,1.24-.87A2.12,2.12,0,0,1,228.3,245.38Z"
                fill="#2f6840"
              />
              <path
                d="M226.93,248.59a2,2,0,0,0-.66-1c-.28-.29-.64-.5-1-.81a2.21,2.21,0,0,1,1.21.55,1.64,1.64,0,0,1,.4.57A.89.89,0,0,1,226.93,248.59Z"
                fill="#2f6840"
              />
              <path
                d="M225,246.64c-.24.06-.47.09-.7.16a3.45,3.45,0,0,0-.64.22,9.33,9.33,0,0,0-1.25.65,2.31,2.31,0,0,1,1.11-1A2,2,0,0,1,225,246.64Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M211.12,241c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,211.12,241Z"
                fill="#2f6840"
              />
              <path
                d="M210.61,240.64c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,210.61,240.64Z"
                fill="#3ba525"
              />
              <path
                d="M211.36,240.61a2.15,2.15,0,0,0-.79-.94c-.33-.26-.71-.45-1.07-.73a2.26,2.26,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,211.36,240.61Z"
                fill="#2f6840"
              />
              <path
                d="M214.84,239.81c-.25,0-.49.05-.72.1a4,4,0,0,0-.68.18,11.31,11.31,0,0,0-1.35.52,2.5,2.5,0,0,1,1.24-.87A2.12,2.12,0,0,1,214.84,239.81Z"
                fill="#2f6840"
              />
              <path
                d="M213.47,243a1.9,1.9,0,0,0-.66-1c-.28-.28-.63-.5-1-.81a2.24,2.24,0,0,1,1.22.55,1.78,1.78,0,0,1,.4.57A.94.94,0,0,1,213.47,243Z"
                fill="#2f6840"
              />
              <path
                d="M211.51,241.07c-.24.06-.47.09-.69.16a3.83,3.83,0,0,0-.65.22,10,10,0,0,0-1.25.65,2.36,2.36,0,0,1,1.11-1A2,2,0,0,1,211.51,241.07Z"
                fill="#2f6840"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M253.56,236.22c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.23-2.77,2.92-2.15,3.62,3.56,2.65,3.44-4.69.05-4.69.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.17-2.9-1.17-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,253.56,236.22Z"
                fill="#2f6840"
              />
              <path
                d="M253.05,235.88c4.43-.26-4.32.45-4.35-.62s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.37A14.67,14.67,0,0,1,253.05,235.88Z"
                fill="#3ba525"
              />
              <path
                d="M253.81,235.85a2.17,2.17,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,2.2,2.2,0,0,1,.48.53A1,1,0,0,1,253.81,235.85Z"
                fill="#2f6840"
              />
              <path
                d="M257.29,235.05c-.26,0-.5,0-.73.1a5.2,5.2,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.47,2.47,0,0,1,1.23-.87A2.15,2.15,0,0,1,257.29,235.05Z"
                fill="#2f6840"
              />
              <path
                d="M255.92,238.26a2,2,0,0,0-.66-1c-.29-.29-.64-.5-1-.81a2.17,2.17,0,0,1,1.21.55,1.55,1.55,0,0,1,.4.57A.94.94,0,0,1,255.92,238.26Z"
                fill="#2f6840"
              />
              <path
                d="M254,236.31a6.61,6.61,0,0,0-.7.15,4.41,4.41,0,0,0-.64.23,9.33,9.33,0,0,0-1.25.65,2.18,2.18,0,0,1,1.11-1A2,2,0,0,1,254,236.31Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M250.9,245c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.92-2.15,3.63,3.55,2.65,3.44-4.69.05-4.69.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.17-2.91-1.17-2.91-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,250.9,245Z"
                fill="#2f6840"
              />
              <path
                d="M250.4,244.6c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,250.4,244.6Z"
                fill="#3ba525"
              />
              <path
                d="M251.15,244.58a2.12,2.12,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,2,2,0,0,1,.48.53A1,1,0,0,1,251.15,244.58Z"
                fill="#2f6840"
              />
              <path
                d="M254.63,243.78c-.26,0-.5,0-.73.1a4,4,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.4,2.4,0,0,1,1.24-.87A2.07,2.07,0,0,1,254.63,243.78Z"
                fill="#2f6840"
              />
              <path
                d="M253.26,247a2,2,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.08,2.08,0,0,1,1.21.55,1.6,1.6,0,0,1,.4.56A.92.92,0,0,1,253.26,247Z"
                fill="#2f6840"
              />
              <path
                d="M251.3,245c-.25.06-.48.09-.7.16a4.41,4.41,0,0,0-.64.23,9.33,9.33,0,0,0-1.25.65,2.22,2.22,0,0,1,1.11-1A2,2,0,0,1,251.3,245Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M245.55,240c4.42-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,245.55,240Z"
                fill="#2f6840"
              />
              <path
                d="M245,239.65c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.64,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,245,239.65Z"
                fill="#3ba525"
              />
              <path
                d="M245.8,239.62a2.17,2.17,0,0,0-.8-.94c-.32-.27-.71-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.87,1.87,0,0,1,.47.54A1,1,0,0,1,245.8,239.62Z"
                fill="#2f6840"
              />
              <path
                d="M249.27,238.82c-.25,0-.49.05-.72.1a5.2,5.2,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.47,2.47,0,0,1,1.23-.87A2.12,2.12,0,0,1,249.27,238.82Z"
                fill="#2f6840"
              />
              <path
                d="M247.91,242a2,2,0,0,0-.66-1c-.29-.29-.64-.5-1-.81a2.17,2.17,0,0,1,1.21.55,1.68,1.68,0,0,1,.4.57A.94.94,0,0,1,247.91,242Z"
                fill="#2f6840"
              />
              <path
                d="M246,240.08a6.56,6.56,0,0,0-.7.16,3.45,3.45,0,0,0-.64.22,9.43,9.43,0,0,0-1.26.65,2.29,2.29,0,0,1,1.12-1A2,2,0,0,1,246,240.08Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M237.21,236.62c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,237.21,236.62Z"
                fill="#2f6840"
              />
              <path
                d="M236.7,236.27c4.43-.25-4.33.46-4.35-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.23-2.78,2.92-2.16,3.62,3.56,2.65,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A15,15,0,0,1,236.7,236.27Z"
                fill="#3ba525"
              />
              <path
                d="M237.45,236.25a2.1,2.1,0,0,0-.79-.94c-.33-.27-.71-.46-1.07-.74a2.34,2.34,0,0,1,1.28.45,1.83,1.83,0,0,1,.47.53A1,1,0,0,1,237.45,236.25Z"
                fill="#2f6840"
              />
              <path
                d="M240.93,235.45c-.25,0-.49,0-.72.1a5.2,5.2,0,0,0-.68.17,13.44,13.44,0,0,0-1.35.53,2.5,2.5,0,0,1,1.24-.87A2.07,2.07,0,0,1,240.93,235.45Z"
                fill="#2f6840"
              />
              <path
                d="M239.56,238.66a1.86,1.86,0,0,0-.66-1c-.28-.29-.63-.5-1-.81a2.1,2.1,0,0,1,1.22.55,1.68,1.68,0,0,1,.4.57A.94.94,0,0,1,239.56,238.66Z"
                fill="#2f6840"
              />
              <path
                d="M237.61,236.71a6.61,6.61,0,0,0-.7.15,5,5,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2,2,0,0,1,237.61,236.71Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M251.91,252.11c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.23-2.77,2.92-2.15,3.63,3.55,2.65,3.44-4.69,0-4.69,0,6,.86,4,1.54-3.31,2-4.36,1.72-1.17-2.91-1.17-2.91-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,251.91,252.11Z"
                fill="#2f6840"
              />
              <path
                d="M251.41,251.76c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,251.41,251.76Z"
                fill="#3ba525"
              />
              <path
                d="M252.16,251.74a2.12,2.12,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,2,2,0,0,1,.48.53A1,1,0,0,1,252.16,251.74Z"
                fill="#2f6840"
              />
              <path
                d="M255.64,250.94c-.26,0-.5,0-.73.1a4,4,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.4,2.4,0,0,1,1.24-.87A2.07,2.07,0,0,1,255.64,250.94Z"
                fill="#2f6840"
              />
              <path
                d="M254.27,254.15a2,2,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.08,2.08,0,0,1,1.21.55,1.6,1.6,0,0,1,.4.56A.92.92,0,0,1,254.27,254.15Z"
                fill="#2f6840"
              />
              <path
                d="M252.31,252.19c-.25.06-.48.09-.7.16a4.41,4.41,0,0,0-.64.23,9.33,9.33,0,0,0-1.25.65,2.22,2.22,0,0,1,1.11-1A2,2,0,0,1,252.31,252.19Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M238.45,246.54c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,238.45,246.54Z"
                fill="#2f6840"
              />
              <path
                d="M238,246.19c4.42-.25-4.33.46-4.35-.61s4.35-2.62,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A15,15,0,0,1,238,246.19Z"
                fill="#3ba525"
              />
              <path
                d="M238.7,246.17a2.06,2.06,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,2,2,0,0,1,.47.53A1,1,0,0,1,238.7,246.17Z"
                fill="#2f6840"
              />
              <path
                d="M242.18,245.37c-.26,0-.49,0-.73.1a4.69,4.69,0,0,0-.67.17,13.44,13.44,0,0,0-1.35.53,2.5,2.5,0,0,1,1.24-.87A2.07,2.07,0,0,1,242.18,245.37Z"
                fill="#2f6840"
              />
              <path
                d="M240.81,248.58a1.86,1.86,0,0,0-.66-1c-.28-.29-.64-.5-1-.81a2.08,2.08,0,0,1,1.21.55,1.7,1.7,0,0,1,.41.57A.94.94,0,0,1,240.81,248.58Z"
                fill="#2f6840"
              />
              <path
                d="M238.85,246.63c-.24.05-.47.08-.7.15a4.41,4.41,0,0,0-.64.23,10,10,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2,2,0,0,1,238.85,246.63Z"
                fill="#2f6840"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M275.89,253.23c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,275.89,253.23Z"
                fill="#2f6840"
              />
              <path
                d="M275.38,252.89c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,275.38,252.89Z"
                fill="#3ba525"
              />
              <path
                d="M276.13,252.86a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,276.13,252.86Z"
                fill="#2f6840"
              />
              <path
                d="M279.61,252.07c-.26,0-.49,0-.72.09a3.57,3.57,0,0,0-.68.18,11.31,11.31,0,0,0-1.35.52,2.42,2.42,0,0,1,1.24-.86A2.07,2.07,0,0,1,279.61,252.07Z"
                fill="#2f6840"
              />
              <path
                d="M278.24,255.28a1.82,1.82,0,0,0-.66-1c-.28-.29-.63-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.81,1.81,0,0,1,.41.57A1,1,0,0,1,278.24,255.28Z"
                fill="#2f6840"
              />
              <path
                d="M276.28,253.32c-.24.06-.47.09-.69.16a3.15,3.15,0,0,0-.65.23,9.87,9.87,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,276.28,253.32Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M273.23,262c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,273.23,262Z"
                fill="#2f6840"
              />
              <path
                d="M272.72,261.62c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.69.05-4.69.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.17-2.91-1.17-2.91-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,272.72,261.62Z"
                fill="#3ba525"
              />
              <path
                d="M273.47,261.59a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.06-.73a2.26,2.26,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,273.47,261.59Z"
                fill="#2f6840"
              />
              <path
                d="M277,260.79c-.26,0-.49,0-.72.1a4,4,0,0,0-.68.18,11.31,11.31,0,0,0-1.35.52,2.42,2.42,0,0,1,1.24-.86A2.12,2.12,0,0,1,277,260.79Z"
                fill="#2f6840"
              />
              <path
                d="M275.58,264a1.9,1.9,0,0,0-.66-1c-.28-.28-.63-.5-1-.81a2.27,2.27,0,0,1,1.22.55,1.78,1.78,0,0,1,.4.57A.94.94,0,0,1,275.58,264Z"
                fill="#2f6840"
              />
              <path
                d="M273.62,262.05c-.24.06-.47.09-.69.16a3.15,3.15,0,0,0-.65.23,9.87,9.87,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,273.62,262.05Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M267.87,257c4.43-.25-4.33.46-4.35-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.28-2.07-2.37A14.86,14.86,0,0,1,267.87,257Z"
                fill="#2f6840"
              />
              <path
                d="M267.37,256.66c4.42-.25-4.33.46-4.35-.61s4.34-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,267.37,256.66Z"
                fill="#3ba525"
              />
              <path
                d="M268.12,256.63a2,2,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,268.12,256.63Z"
                fill="#2f6840"
              />
              <path
                d="M271.6,255.84c-.26,0-.49,0-.73.09a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.38,2.38,0,0,1,1.24-.86A2.07,2.07,0,0,1,271.6,255.84Z"
                fill="#2f6840"
              />
              <path
                d="M270.23,259.05a1.88,1.88,0,0,0-.66-1c-.28-.29-.64-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A.92.92,0,0,1,270.23,259.05Z"
                fill="#2f6840"
              />
              <path
                d="M268.27,257.09c-.24.06-.47.09-.7.16a2.87,2.87,0,0,0-.64.23,9.24,9.24,0,0,0-1.25.64,2.24,2.24,0,0,1,1.11-1A2,2,0,0,1,268.27,257.09Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M259.53,253.63c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.23-2.78,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,259.53,253.63Z"
                fill="#2f6840"
              />
              <path
                d="M259,253.29c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.54-2.26-2.27-2.08-2.36A14.55,14.55,0,0,1,259,253.29Z"
                fill="#3ba525"
              />
              <path
                d="M259.78,253.26a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.21,2.21,0,0,1,1.28.45,1.88,1.88,0,0,1,.48.53A1,1,0,0,1,259.78,253.26Z"
                fill="#2f6840"
              />
              <path
                d="M263.26,252.46c-.26,0-.5,0-.73.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.39,2.39,0,0,1,1.23-.86A2.15,2.15,0,0,1,263.26,252.46Z"
                fill="#2f6840"
              />
              <path
                d="M261.89,255.67a2,2,0,0,0-.66-1c-.29-.28-.64-.5-1-.8a2.16,2.16,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A.89.89,0,0,1,261.89,255.67Z"
                fill="#2f6840"
              />
              <path
                d="M259.93,253.72c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,9.24,9.24,0,0,0-1.25.64,2.2,2.2,0,0,1,1.11-1A2,2,0,0,1,259.93,253.72Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M274.24,269.12c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,274.24,269.12Z"
                fill="#2f6840"
              />
              <path
                d="M273.73,268.78c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.37,1.72-1.16-2.91-1.16-2.91-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,273.73,268.78Z"
                fill="#3ba525"
              />
              <path
                d="M274.48,268.75a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.06-.73a2.26,2.26,0,0,1,1.28.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,274.48,268.75Z"
                fill="#2f6840"
              />
              <path
                d="M278,268c-.26,0-.49.05-.72.1a4,4,0,0,0-.68.18,11.31,11.31,0,0,0-1.35.52,2.42,2.42,0,0,1,1.24-.86A2.12,2.12,0,0,1,278,268Z"
                fill="#2f6840"
              />
              <path
                d="M276.59,271.16a1.9,1.9,0,0,0-.66-1c-.28-.28-.63-.5-1-.81a2.27,2.27,0,0,1,1.22.55,1.78,1.78,0,0,1,.4.57A.94.94,0,0,1,276.59,271.16Z"
                fill="#2f6840"
              />
              <path
                d="M274.63,269.21c-.24.06-.47.09-.69.16a3.15,3.15,0,0,0-.65.23,8.71,8.71,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,274.63,269.21Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M260.78,263.55c4.42-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,260.78,263.55Z"
                fill="#2f6840"
              />
              <path
                d="M260.27,263.21c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.64,3.44-4.69.05-4.69.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.54-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,260.27,263.21Z"
                fill="#3ba525"
              />
              <path
                d="M261,263.18a2.24,2.24,0,0,0-.8-.94c-.32-.26-.71-.45-1.07-.73a2.21,2.21,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,261,263.18Z"
                fill="#2f6840"
              />
              <path
                d="M264.5,262.38c-.25,0-.49.05-.72.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.39,2.39,0,0,1,1.23-.86A2.12,2.12,0,0,1,264.5,262.38Z"
                fill="#2f6840"
              />
              <path
                d="M263.14,265.59a2,2,0,0,0-.66-1c-.29-.28-.64-.5-1-.8a2.16,2.16,0,0,1,1.21.54,1.78,1.78,0,0,1,.4.57A1,1,0,0,1,263.14,265.59Z"
                fill="#2f6840"
              />
              <path
                d="M261.18,263.64c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,9.34,9.34,0,0,0-1.26.64,2.27,2.27,0,0,1,1.12-1A2,2,0,0,1,261.18,263.64Z"
                fill="#2f6840"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M292,276.58c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.92-2.16,3.63,3.56,2.65,3.44-4.69.05-4.69.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.92,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,292,276.58Z"
                fill="#2f6840"
              />
              <path
                d="M291.49,276.24c4.42-.25-4.33.45-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,291.49,276.24Z"
                fill="#3ba525"
              />
              <path
                d="M292.24,276.21a2.17,2.17,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,2.23,2.23,0,0,1,.47.54A1,1,0,0,1,292.24,276.21Z"
                fill="#2f6840"
              />
              <path
                d="M295.72,275.41c-.26,0-.5,0-.73.1a5.2,5.2,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.45,2.45,0,0,1,1.24-.87A2.13,2.13,0,0,1,295.72,275.41Z"
                fill="#2f6840"
              />
              <path
                d="M294.35,278.62a2,2,0,0,0-.66-1c-.29-.29-.64-.5-1-.81a2.14,2.14,0,0,1,1.21.55,1.55,1.55,0,0,1,.4.57A.89.89,0,0,1,294.35,278.62Z"
                fill="#2f6840"
              />
              <path
                d="M292.39,276.67a6.56,6.56,0,0,0-.7.16,3.45,3.45,0,0,0-.64.22,9.33,9.33,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2,2,0,0,1,292.39,276.67Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M289.33,285.31c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.56,2.64,3.44-4.69.05-4.69.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.92,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,289.33,285.31Z"
                fill="#2f6840"
              />
              <path
                d="M288.83,285c4.42-.25-4.33.46-4.36-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.37A14.87,14.87,0,0,1,288.83,285Z"
                fill="#3ba525"
              />
              <path
                d="M289.58,284.94a2.06,2.06,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,2.16,2.16,0,0,1,.47.53A1,1,0,0,1,289.58,284.94Z"
                fill="#2f6840"
              />
              <path
                d="M293.06,284.14c-.26,0-.5.05-.73.1a5.2,5.2,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.45,2.45,0,0,1,1.24-.87A2.13,2.13,0,0,1,293.06,284.14Z"
                fill="#2f6840"
              />
              <path
                d="M291.69,287.35a1.92,1.92,0,0,0-.66-1c-.28-.29-.64-.5-1-.81a2.14,2.14,0,0,1,1.21.55,1.55,1.55,0,0,1,.4.57A.89.89,0,0,1,291.69,287.35Z"
                fill="#2f6840"
              />
              <path
                d="M289.73,285.4a6.61,6.61,0,0,0-.7.15,4.41,4.41,0,0,0-.64.23,9.33,9.33,0,0,0-1.25.65,2.22,2.22,0,0,1,1.11-1A2,2,0,0,1,289.73,285.4Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M284,280.35c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.69.05-4.69.05,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,284,280.35Z"
                fill="#2f6840"
              />
              <path
                d="M283.47,280c4.43-.25-4.32.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,283.47,280Z"
                fill="#3ba525"
              />
              <path
                d="M284.23,280a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.46-1.07-.74a2.22,2.22,0,0,1,1.28.46,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,284.23,280Z"
                fill="#2f6840"
              />
              <path
                d="M287.7,279.18c-.25,0-.49.05-.72.1a4,4,0,0,0-.68.18A11.87,11.87,0,0,0,285,280a2.47,2.47,0,0,1,1.23-.87A2.12,2.12,0,0,1,287.7,279.18Z"
                fill="#2f6840"
              />
              <path
                d="M286.34,282.39a2,2,0,0,0-.66-1c-.29-.29-.64-.5-1-.81a2.24,2.24,0,0,1,1.21.55,1.64,1.64,0,0,1,.4.57A.94.94,0,0,1,286.34,282.39Z"
                fill="#2f6840"
              />
              <path
                d="M284.38,280.44a6.56,6.56,0,0,0-.7.16,3.45,3.45,0,0,0-.64.22,9.33,9.33,0,0,0-1.25.65,2.22,2.22,0,0,1,1.11-1A2,2,0,0,1,284.38,280.44Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M275.64,277c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.24.27,2.24,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,275.64,277Z"
                fill="#2f6840"
              />
              <path
                d="M275.13,276.64c4.43-.26-4.33.45-4.35-.62s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.34,14.34,0,0,1,275.13,276.64Z"
                fill="#3ba525"
              />
              <path
                d="M275.88,276.61a2.15,2.15,0,0,0-.79-.94c-.33-.27-.71-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,2,2,0,0,1,.47.53A1,1,0,0,1,275.88,276.61Z"
                fill="#2f6840"
              />
              <path
                d="M279.36,275.81c-.25,0-.49.05-.72.1a5.2,5.2,0,0,0-.68.17,14.45,14.45,0,0,0-1.35.53,2.54,2.54,0,0,1,1.24-.87A2.12,2.12,0,0,1,279.36,275.81Z"
                fill="#2f6840"
              />
              <path
                d="M278,279a1.9,1.9,0,0,0-.65-1c-.29-.29-.64-.5-1-.81a2.17,2.17,0,0,1,1.21.55,1.68,1.68,0,0,1,.4.57A.94.94,0,0,1,278,279Z"
                fill="#2f6840"
              />
              <path
                d="M276,277.07a6.61,6.61,0,0,0-.7.15,5,5,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.24,2.24,0,0,1,1.12-1A2,2,0,0,1,276,277.07Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M290.34,292.47c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.92-2.15,3.63,3.56,2.65,3.44-4.69.05-4.69.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.92,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,290.34,292.47Z"
                fill="#2f6840"
              />
              <path
                d="M289.84,292.12c4.42-.25-4.33.46-4.36-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.37A14.87,14.87,0,0,1,289.84,292.12Z"
                fill="#3ba525"
              />
              <path
                d="M290.59,292.1a2.12,2.12,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,2.16,2.16,0,0,1,.47.53A1,1,0,0,1,290.59,292.1Z"
                fill="#2f6840"
              />
              <path
                d="M294.07,291.3c-.26,0-.5.05-.73.1a5.2,5.2,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.45,2.45,0,0,1,1.24-.87A2.13,2.13,0,0,1,294.07,291.3Z"
                fill="#2f6840"
              />
              <path
                d="M292.7,294.51a2,2,0,0,0-.66-1c-.28-.29-.64-.5-1-.81a2.08,2.08,0,0,1,1.21.55,1.55,1.55,0,0,1,.4.57A.89.89,0,0,1,292.7,294.51Z"
                fill="#2f6840"
              />
              <path
                d="M290.74,292.56a6.61,6.61,0,0,0-.7.15,4.41,4.41,0,0,0-.64.23,9.33,9.33,0,0,0-1.25.65,2.22,2.22,0,0,1,1.11-1A2,2,0,0,1,290.74,292.56Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M276.89,286.9c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.24.27,2.24,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,276.89,286.9Z"
                fill="#2f6840"
              />
              <path
                d="M276.38,286.56c4.43-.26-4.33.45-4.35-.62s4.35-2.62,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.34,14.34,0,0,1,276.38,286.56Z"
                fill="#3ba525"
              />
              <path
                d="M277.13,286.53a2.11,2.11,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,2.16,2.16,0,0,1,.47.53A1,1,0,0,1,277.13,286.53Z"
                fill="#2f6840"
              />
              <path
                d="M280.61,285.73c-.26,0-.49,0-.72.1a4.83,4.83,0,0,0-.68.17,13.44,13.44,0,0,0-1.35.53,2.5,2.5,0,0,1,1.24-.87A2.12,2.12,0,0,1,280.61,285.73Z"
                fill="#2f6840"
              />
              <path
                d="M279.24,288.94a1.86,1.86,0,0,0-.66-1c-.28-.29-.63-.5-1-.81a2.14,2.14,0,0,1,1.21.55,1.7,1.7,0,0,1,.41.57A.94.94,0,0,1,279.24,288.94Z"
                fill="#2f6840"
              />
              <path
                d="M277.28,287a7,7,0,0,0-.69.15,5,5,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2,2,0,0,1,277.28,287Z"
                fill="#2f6840"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M313.05,295c4.42-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,313.05,295Z"
                fill="#2f6840"
              />
              <path
                d="M312.54,294.65c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.92,3.34-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,312.54,294.65Z"
                fill="#3ba525"
              />
              <path
                d="M313.3,294.62a2.21,2.21,0,0,0-.8-.93c-.32-.27-.71-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,313.3,294.62Z"
                fill="#2f6840"
              />
              <path
                d="M316.77,293.83a5.43,5.43,0,0,0-.72.1,3.22,3.22,0,0,0-.68.17,12.94,12.94,0,0,0-1.35.53,2.48,2.48,0,0,1,1.24-.87A2.07,2.07,0,0,1,316.77,293.83Z"
                fill="#2f6840"
              />
              <path
                d="M315.4,297a1.9,1.9,0,0,0-.65-1c-.29-.29-.64-.51-1-.81a2.16,2.16,0,0,1,1.21.54,1.9,1.9,0,0,1,.4.57A1,1,0,0,1,315.4,297Z"
                fill="#2f6840"
              />
              <path
                d="M313.45,295.08c-.25.06-.48.09-.7.16a5,5,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.24,2.24,0,0,1,1.12-1A2,2,0,0,1,313.45,295.08Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M310.39,303.73c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,310.39,303.73Z"
                fill="#2f6840"
              />
              <path
                d="M309.88,303.38c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.44-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,309.88,303.38Z"
                fill="#3ba525"
              />
              <path
                d="M310.64,303.35a2.15,2.15,0,0,0-.8-.93c-.32-.27-.71-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,310.64,303.35Z"
                fill="#2f6840"
              />
              <path
                d="M314.11,302.56a5.43,5.43,0,0,0-.72.1,3.22,3.22,0,0,0-.68.17,10.33,10.33,0,0,0-1.34.53,2.41,2.41,0,0,1,1.23-.87A2.07,2.07,0,0,1,314.11,302.56Z"
                fill="#2f6840"
              />
              <path
                d="M312.75,305.77a1.94,1.94,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.16,2.16,0,0,1,1.21.54,1.78,1.78,0,0,1,.4.57A1,1,0,0,1,312.75,305.77Z"
                fill="#2f6840"
              />
              <path
                d="M310.79,303.81c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,10.68,10.68,0,0,0-1.26.64,2.27,2.27,0,0,1,1.12-1A2,2,0,0,1,310.79,303.81Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M305,298.77c4.42-.25-4.33.45-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,305,298.77Z"
                fill="#2f6840"
              />
              <path
                d="M304.53,298.42c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.23-2.78,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,304.53,298.42Z"
                fill="#3ba525"
              />
              <path
                d="M305.28,298.39a2.13,2.13,0,0,0-.79-.93c-.33-.27-.71-.46-1.07-.74a2.34,2.34,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,305.28,298.39Z"
                fill="#2f6840"
              />
              <path
                d="M308.76,297.6c-.25,0-.49,0-.72.1a3.22,3.22,0,0,0-.68.17,13.44,13.44,0,0,0-1.35.53,2.44,2.44,0,0,1,1.24-.87A2.07,2.07,0,0,1,308.76,297.6Z"
                fill="#2f6840"
              />
              <path
                d="M307.39,300.81a1.86,1.86,0,0,0-.66-1c-.28-.29-.63-.51-1-.81a2.1,2.1,0,0,1,1.22.55,1.74,1.74,0,0,1,.4.56A1,1,0,0,1,307.39,300.81Z"
                fill="#2f6840"
              />
              <path
                d="M305.44,298.85c-.25.06-.48.09-.7.16a5,5,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2.07,2.07,0,0,1,305.44,298.85Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M296.69,295.4c4.43-.25-4.32.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,296.69,295.4Z"
                fill="#2f6840"
              />
              <path
                d="M296.19,295.05c4.42-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,296.19,295.05Z"
                fill="#3ba525"
              />
              <path
                d="M296.94,295a2.08,2.08,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,296.94,295Z"
                fill="#2f6840"
              />
              <path
                d="M300.42,294.23a5.58,5.58,0,0,0-.73.1,3,3,0,0,0-.67.17,9.91,9.91,0,0,0-1.35.53,2.44,2.44,0,0,1,1.24-.87A2.07,2.07,0,0,1,300.42,294.23Z"
                fill="#2f6840"
              />
              <path
                d="M299.05,297.44a1.92,1.92,0,0,0-.66-1c-.28-.29-.64-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.81,1.81,0,0,1,.41.57A1,1,0,0,1,299.05,297.44Z"
                fill="#2f6840"
              />
              <path
                d="M297.09,295.48c-.24.06-.47.09-.7.16a3.48,3.48,0,0,0-.64.23,10,10,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2,2,0,0,1,297.09,295.48Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M311.4,310.89c4.42-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,311.4,310.89Z"
                fill="#2f6840"
              />
              <path
                d="M310.89,310.54c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.44-4.69.05-4.69.05,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,310.89,310.54Z"
                fill="#3ba525"
              />
              <path
                d="M311.65,310.51a2.15,2.15,0,0,0-.8-.93c-.32-.27-.71-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,311.65,310.51Z"
                fill="#2f6840"
              />
              <path
                d="M315.12,309.72c-.25,0-.49,0-.72.09a4,4,0,0,0-.68.18,10.33,10.33,0,0,0-1.34.53,2.41,2.41,0,0,1,1.23-.87A2.07,2.07,0,0,1,315.12,309.72Z"
                fill="#2f6840"
              />
              <path
                d="M313.76,312.93a1.94,1.94,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.16,2.16,0,0,1,1.21.54,1.78,1.78,0,0,1,.4.57A1,1,0,0,1,313.76,312.93Z"
                fill="#2f6840"
              />
              <path
                d="M311.8,311c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,10.68,10.68,0,0,0-1.26.64,2.27,2.27,0,0,1,1.12-1A2,2,0,0,1,311.8,311Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M297.94,305.32c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.92,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,297.94,305.32Z"
                fill="#2f6840"
              />
              <path
                d="M297.44,305c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,297.44,305Z"
                fill="#3ba525"
              />
              <path
                d="M298.19,304.94a2.15,2.15,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,2,2,0,0,1,.47.53A1,1,0,0,1,298.19,304.94Z"
                fill="#2f6840"
              />
              <path
                d="M301.67,304.15a5.36,5.36,0,0,0-.73.1,3.22,3.22,0,0,0-.68.17,10.33,10.33,0,0,0-1.34.53,2.4,2.4,0,0,1,1.24-.87A2.07,2.07,0,0,1,301.67,304.15Z"
                fill="#2f6840"
              />
              <path
                d="M300.3,307.36a2,2,0,0,0-.66-1c-.28-.29-.64-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A.92.92,0,0,1,300.3,307.36Z"
                fill="#2f6840"
              />
              <path
                d="M298.34,305.4c-.25.06-.48.09-.7.16a3.48,3.48,0,0,0-.64.23,9.33,9.33,0,0,0-1.25.65,2.22,2.22,0,0,1,1.11-1A2,2,0,0,1,298.34,305.4Z"
                fill="#2f6840"
              />
            </g>
          </g>
        </g>
        <g>
          <g>
            <g>
              <path
                d="M34.54,160.21c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,34.54,160.21Z"
                fill="#2f6840"
              />
              <path
                d="M34,159.86c4.42-.25-4.33.46-4.35-.61S34,156.63,35,156.8s.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.37A15,15,0,0,1,34,159.86Z"
                fill="#3ba525"
              />
              <path
                d="M34.79,159.84a2.06,2.06,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,2.16,2.16,0,0,1,.47.53A1,1,0,0,1,34.79,159.84Z"
                fill="#2f6840"
              />
              <path
                d="M38.27,159c-.26,0-.49.05-.73.1a4.69,4.69,0,0,0-.67.17,13.44,13.44,0,0,0-1.35.53,2.5,2.5,0,0,1,1.24-.87A2.12,2.12,0,0,1,38.27,159Z"
                fill="#2f6840"
              />
              <path
                d="M36.9,162.25a1.92,1.92,0,0,0-.66-1c-.28-.29-.64-.5-1-.81a2.14,2.14,0,0,1,1.21.55,1.7,1.7,0,0,1,.41.57A.94.94,0,0,1,36.9,162.25Z"
                fill="#2f6840"
              />
              <path
                d="M34.94,160.3c-.24,0-.47.08-.7.15a4.41,4.41,0,0,0-.64.23,10,10,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2,2,0,0,1,34.94,160.3Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M31.88,168.94c4.43-.25-4.32.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25S34.32,165.35,36,166s3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.36,1.72-1.16-2.91-1.16-2.91-.91,3.34-3,2.55-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,31.88,168.94Z"
                fill="#2f6840"
              />
              <path
                d="M31.38,168.59c4.42-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,31.38,168.59Z"
                fill="#3ba525"
              />
              <path
                d="M32.13,168.57a2.06,2.06,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,2,2,0,0,1,.47.53A1,1,0,0,1,32.13,168.57Z"
                fill="#2f6840"
              />
              <path
                d="M35.61,167.77c-.26,0-.49,0-.73.1a3.65,3.65,0,0,0-.67.17,13.44,13.44,0,0,0-1.35.53,2.44,2.44,0,0,1,1.24-.87A2.07,2.07,0,0,1,35.61,167.77Z"
                fill="#2f6840"
              />
              <path
                d="M34.24,171a1.86,1.86,0,0,0-.66-1c-.28-.29-.64-.51-1-.81a2.08,2.08,0,0,1,1.21.55,1.76,1.76,0,0,1,.41.56A1,1,0,0,1,34.24,171Z"
                fill="#2f6840"
              />
              <path
                d="M32.28,169c-.24.06-.47.09-.69.16a4.14,4.14,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2,2,0,0,1,32.28,169Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M26.53,164c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25S29,160.39,30.65,161s3.63,3.56,2.65,3.44-4.69.05-4.69.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.92,3.33-3,2.55S21.8,165.13,22,165A14.65,14.65,0,0,1,26.53,164Z"
                fill="#2f6840"
              />
              <path
                d="M26,163.64c4.42-.25-4.33.45-4.36-.61S26,160.4,27,160.57s.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,26,163.64Z"
                fill="#3ba525"
              />
              <path
                d="M26.78,163.61a2.17,2.17,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,2.23,2.23,0,0,1,.47.54A1,1,0,0,1,26.78,163.61Z"
                fill="#2f6840"
              />
              <path
                d="M30.26,162.81c-.26,0-.5.05-.73.1a5.2,5.2,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.45,2.45,0,0,1,1.24-.87A2.13,2.13,0,0,1,30.26,162.81Z"
                fill="#2f6840"
              />
              <path
                d="M28.89,166a2,2,0,0,0-.66-1c-.28-.29-.64-.5-1-.81a2.14,2.14,0,0,1,1.21.55,1.55,1.55,0,0,1,.4.57A.89.89,0,0,1,28.89,166Z"
                fill="#2f6840"
              />
              <path
                d="M26.93,164.07c-.25.06-.48.08-.7.15a4.41,4.41,0,0,0-.64.23,9.33,9.33,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2,2,0,0,1,26.93,164.07Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M18.19,160.61c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.54-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,18.19,160.61Z"
                fill="#2f6840"
              />
              <path
                d="M17.68,160.26c4.43-.25-4.32.46-4.35-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,17.68,160.26Z"
                fill="#3ba525"
              />
              <path
                d="M18.44,160.24a2.12,2.12,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.83,1.83,0,0,1,.47.53A1,1,0,0,1,18.44,160.24Z"
                fill="#2f6840"
              />
              <path
                d="M21.91,159.44c-.25,0-.49,0-.72.1a4,4,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.47,2.47,0,0,1,1.23-.87A2.07,2.07,0,0,1,21.91,159.44Z"
                fill="#2f6840"
              />
              <path
                d="M20.55,162.65a2,2,0,0,0-.66-1c-.29-.29-.64-.5-1-.81a2.1,2.1,0,0,1,1.21.55,1.55,1.55,0,0,1,.4.57A.94.94,0,0,1,20.55,162.65Z"
                fill="#2f6840"
              />
              <path
                d="M18.59,160.7a6.61,6.61,0,0,0-.7.15,4.41,4.41,0,0,0-.64.23,10.08,10.08,0,0,0-1.26.65,2.24,2.24,0,0,1,1.12-1A2,2,0,0,1,18.59,160.7Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M32.89,176.1c4.43-.25-4.32.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.36,1.72S33.43,177,33.43,177s-.91,3.34-3,2.55-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,32.89,176.1Z"
                fill="#2f6840"
              />
              <path
                d="M32.39,175.75c4.42-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,32.39,175.75Z"
                fill="#3ba525"
              />
              <path
                d="M33.14,175.73a2.06,2.06,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45A2,2,0,0,1,33,175,1,1,0,0,1,33.14,175.73Z"
                fill="#2f6840"
              />
              <path
                d="M36.62,174.93c-.26,0-.49,0-.73.1a3.65,3.65,0,0,0-.67.17,13.44,13.44,0,0,0-1.35.53,2.44,2.44,0,0,1,1.24-.87A2.07,2.07,0,0,1,36.62,174.93Z"
                fill="#2f6840"
              />
              <path
                d="M35.25,178.14a1.92,1.92,0,0,0-.66-1c-.28-.29-.64-.51-1-.81a2.08,2.08,0,0,1,1.21.55,1.76,1.76,0,0,1,.41.56A1,1,0,0,1,35.25,178.14Z"
                fill="#2f6840"
              />
              <path
                d="M33.29,176.18c-.24.06-.47.09-.7.16a4.41,4.41,0,0,0-.64.23,10,10,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2,2,0,0,1,33.29,176.18Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M19.44,170.53c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.54-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,19.44,170.53Z"
                fill="#2f6840"
              />
              <path
                d="M18.93,170.18c4.43-.25-4.33.46-4.35-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,18.93,170.18Z"
                fill="#3ba525"
              />
              <path
                d="M19.68,170.16a2.1,2.1,0,0,0-.79-.94c-.33-.27-.71-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.83,1.83,0,0,1,.47.53A1,1,0,0,1,19.68,170.16Z"
                fill="#2f6840"
              />
              <path
                d="M23.16,169.36c-.25,0-.49,0-.72.1a4,4,0,0,0-.68.17,14.45,14.45,0,0,0-1.35.53,2.54,2.54,0,0,1,1.24-.87A2.07,2.07,0,0,1,23.16,169.36Z"
                fill="#2f6840"
              />
              <path
                d="M21.79,172.57a1.9,1.9,0,0,0-.65-1c-.29-.29-.64-.5-1-.81a2.1,2.1,0,0,1,1.21.55,1.68,1.68,0,0,1,.4.57A.94.94,0,0,1,21.79,172.57Z"
                fill="#2f6840"
              />
              <path
                d="M19.84,170.62a6.61,6.61,0,0,0-.7.15,5,5,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.24,2.24,0,0,1,1.12-1A2,2,0,0,1,19.84,170.62Z"
                fill="#2f6840"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M25.36,180.8c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.23-2.78,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,25.36,180.8Z"
                fill="#2f6840"
              />
              <path
                d="M24.86,180.46c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,24.86,180.46Z"
                fill="#3ba525"
              />
              <path
                d="M25.61,180.43a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.21,2.21,0,0,1,1.28.45,1.88,1.88,0,0,1,.48.53A1,1,0,0,1,25.61,180.43Z"
                fill="#2f6840"
              />
              <path
                d="M29.09,179.63c-.26,0-.5.05-.73.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.39,2.39,0,0,1,1.23-.86A2.15,2.15,0,0,1,29.09,179.63Z"
                fill="#2f6840"
              />
              <path
                d="M27.72,182.84a2,2,0,0,0-.66-1c-.29-.28-.64-.5-1-.8a2.13,2.13,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A.89.89,0,0,1,27.72,182.84Z"
                fill="#2f6840"
              />
              <path
                d="M25.76,180.89c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,9.24,9.24,0,0,0-1.25.64,2.24,2.24,0,0,1,1.11-1A2,2,0,0,1,25.76,180.89Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M22.7,189.53c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.92-2.16,3.63,3.56,2.65,3.44-4.69.05-4.69.05,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,22.7,189.53Z"
                fill="#2f6840"
              />
              <path
                d="M22.2,189.19c4.42-.25-4.33.45-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,22.2,189.19Z"
                fill="#3ba525"
              />
              <path
                d="M23,189.16a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.21,2.21,0,0,1,1.28.45,1.88,1.88,0,0,1,.48.53A1,1,0,0,1,23,189.16Z"
                fill="#2f6840"
              />
              <path
                d="M26.43,188.36c-.26,0-.5,0-.73.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.45,2.45,0,0,1,1.24-.87A2.13,2.13,0,0,1,26.43,188.36Z"
                fill="#2f6840"
              />
              <path
                d="M25.06,191.57a2,2,0,0,0-.66-1c-.29-.28-.64-.5-1-.81a2.21,2.21,0,0,1,1.21.55,1.64,1.64,0,0,1,.4.57A.89.89,0,0,1,25.06,191.57Z"
                fill="#2f6840"
              />
              <path
                d="M23.1,189.62c-.25.06-.48.09-.7.16a3.45,3.45,0,0,0-.64.22,9.33,9.33,0,0,0-1.25.65,2.31,2.31,0,0,1,1.11-1A2,2,0,0,1,23.1,189.62Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M17.35,184.57c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,17.35,184.57Z"
                fill="#2f6840"
              />
              <path
                d="M16.84,184.23c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.56,2.64,3.44-4.69.05-4.69.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,16.84,184.23Z"
                fill="#3ba525"
              />
              <path
                d="M17.6,184.2a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73A2.28,2.28,0,0,1,17,183a1.71,1.71,0,0,1,.47.53A1,1,0,0,1,17.6,184.2Z"
                fill="#2f6840"
              />
              <path
                d="M21.07,183.41c-.25,0-.49,0-.72.09a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.39,2.39,0,0,1,1.23-.86A2.07,2.07,0,0,1,21.07,183.41Z"
                fill="#2f6840"
              />
              <path
                d="M19.71,186.62a1.94,1.94,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.16,2.16,0,0,1,1.21.54,1.78,1.78,0,0,1,.4.57A1,1,0,0,1,19.71,186.62Z"
                fill="#2f6840"
              />
              <path
                d="M17.75,184.66c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,10,10,0,0,0-1.26.64,2.27,2.27,0,0,1,1.12-1A2,2,0,0,1,17.75,184.66Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M9,181.2c4.42-.25-4.33.46-4.36-.61S9,178,9.93,178.14s.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,9,181.2Z"
                fill="#2f6840"
              />
              <path
                d="M8.5,180.86c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46S9.7,180,9.7,180s1.23-2.77,2.92-2.15,3.62,3.55,2.65,3.44-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.72S9,181.73,9,181.73s-.91,3.34-3,2.55S3.77,182,4,181.92A14.65,14.65,0,0,1,8.5,180.86Z"
                fill="#3ba525"
              />
              <path
                d="M9.25,180.83a2.15,2.15,0,0,0-.79-.94c-.33-.26-.71-.45-1.07-.73a2.26,2.26,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,9.25,180.83Z"
                fill="#2f6840"
              />
              <path
                d="M12.73,180c-.25,0-.49.05-.72.1a4,4,0,0,0-.68.18,11.31,11.31,0,0,0-1.35.52,2.5,2.5,0,0,1,1.24-.87A2.12,2.12,0,0,1,12.73,180Z"
                fill="#2f6840"
              />
              <path
                d="M11.36,183.24a1.9,1.9,0,0,0-.66-1c-.28-.28-.63-.5-1-.81A2.24,2.24,0,0,1,11,182a1.78,1.78,0,0,1,.4.57A.94.94,0,0,1,11.36,183.24Z"
                fill="#2f6840"
              />
              <path
                d="M9.41,181.29c-.25.06-.48.09-.7.16a3.15,3.15,0,0,0-.65.23,8.71,8.71,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,9.41,181.29Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M23.71,196.69c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.92-2.16,3.63,3.56,2.65,3.44-4.69.05-4.69.05,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,23.71,196.69Z"
                fill="#2f6840"
              />
              <path
                d="M23.21,196.35c4.42-.25-4.33.45-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15S31,196.93,30,196.82s-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,23.21,196.35Z"
                fill="#3ba525"
              />
              <path
                d="M24,196.32a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.74a2.29,2.29,0,0,1,1.28.46,1.88,1.88,0,0,1,.48.53A1,1,0,0,1,24,196.32Z"
                fill="#2f6840"
              />
              <path
                d="M27.44,195.52c-.26,0-.5,0-.73.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.45,2.45,0,0,1,1.24-.87A2.13,2.13,0,0,1,27.44,195.52Z"
                fill="#2f6840"
              />
              <path
                d="M26.07,198.73a2,2,0,0,0-.66-1c-.29-.28-.64-.5-1-.81a2.21,2.21,0,0,1,1.21.55,1.64,1.64,0,0,1,.4.57A.89.89,0,0,1,26.07,198.73Z"
                fill="#2f6840"
              />
              <path
                d="M24.11,196.78c-.25.06-.48.09-.7.16a3.45,3.45,0,0,0-.64.22,9.33,9.33,0,0,0-1.25.65,2.31,2.31,0,0,1,1.11-1A2,2,0,0,1,24.11,196.78Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M10.25,191.12c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16S18,191.71,17,191.6s-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,10.25,191.12Z"
                fill="#2f6840"
              />
              <path
                d="M9.75,190.78c4.42-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.72-1.16-2.91-1.16-2.91-.91,3.34-3,2.55S5,191.93,5.2,191.84A14.65,14.65,0,0,1,9.75,190.78Z"
                fill="#3ba525"
              />
              <path
                d="M10.5,190.75a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.26,2.26,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,10.5,190.75Z"
                fill="#2f6840"
              />
              <path
                d="M14,190c-.26,0-.49.05-.73.1a3.67,3.67,0,0,0-.67.18,11.31,11.31,0,0,0-1.35.52,2.5,2.5,0,0,1,1.24-.87A2.12,2.12,0,0,1,14,190Z"
                fill="#2f6840"
              />
              <path
                d="M12.61,193.16a1.9,1.9,0,0,0-.66-1c-.28-.28-.64-.5-1-.81a2.21,2.21,0,0,1,1.21.55,1.81,1.81,0,0,1,.41.57A.94.94,0,0,1,12.61,193.16Z"
                fill="#2f6840"
              />
              <path
                d="M10.65,191.21c-.24.06-.47.09-.69.16a2.78,2.78,0,0,0-.65.23,8.71,8.71,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,10.65,191.21Z"
                fill="#2f6840"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M48.07,197.17c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,48.07,197.17Z"
                fill="#2f6840"
              />
              <path
                d="M47.56,196.83c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.72-1.17-2.91-1.17-2.91-.91,3.34-3,2.55S42.83,198,43,197.89A14.65,14.65,0,0,1,47.56,196.83Z"
                fill="#3ba525"
              />
              <path
                d="M48.31,196.8a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.06-.73a2.26,2.26,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,48.31,196.8Z"
                fill="#2f6840"
              />
              <path
                d="M51.79,196c-.26,0-.49.05-.72.1a4,4,0,0,0-.68.18,11.31,11.31,0,0,0-1.35.52,2.42,2.42,0,0,1,1.24-.86A2.07,2.07,0,0,1,51.79,196Z"
                fill="#2f6840"
              />
              <path
                d="M50.42,199.21a1.9,1.9,0,0,0-.66-1c-.28-.28-.63-.5-1-.81A2.27,2.27,0,0,1,50,198a1.78,1.78,0,0,1,.4.57A.94.94,0,0,1,50.42,199.21Z"
                fill="#2f6840"
              />
              <path
                d="M48.46,197.26c-.24.06-.47.09-.69.16a3.15,3.15,0,0,0-.65.23,8.71,8.71,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,48.46,197.26Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M45.41,205.9c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,45.41,205.9Z"
                fill="#2f6840"
              />
              <path
                d="M44.9,205.56c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25S47.33,202,49,202.58s3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,44.9,205.56Z"
                fill="#3ba525"
              />
              <path
                d="M45.65,205.53a2.15,2.15,0,0,0-.79-.94c-.33-.26-.71-.46-1.07-.74a2.27,2.27,0,0,1,1.28.46,1.71,1.71,0,0,1,.47.53A.93.93,0,0,1,45.65,205.53Z"
                fill="#2f6840"
              />
              <path
                d="M49.13,204.73c-.25,0-.49.05-.72.1a4,4,0,0,0-.68.18,11.31,11.31,0,0,0-1.35.52,2.5,2.5,0,0,1,1.24-.87A2.12,2.12,0,0,1,49.13,204.73Z"
                fill="#2f6840"
              />
              <path
                d="M47.76,207.94a1.9,1.9,0,0,0-.66-1c-.28-.29-.63-.5-1-.81a2.24,2.24,0,0,1,1.22.55,1.78,1.78,0,0,1,.4.57A.94.94,0,0,1,47.76,207.94Z"
                fill="#2f6840"
              />
              <path
                d="M45.81,206c-.25.06-.48.09-.7.16a3.83,3.83,0,0,0-.65.22,10,10,0,0,0-1.25.65,2.36,2.36,0,0,1,1.11-1A2.07,2.07,0,0,1,45.81,206Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M40.05,200.94c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,40.05,200.94Z"
                fill="#2f6840"
              />
              <path
                d="M39.55,200.6c4.42-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25S42,197,43.67,197.63s3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,39.55,200.6Z"
                fill="#3ba525"
              />
              <path
                d="M40.3,200.57a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.26,2.26,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,40.3,200.57Z"
                fill="#2f6840"
              />
              <path
                d="M43.78,199.78c-.26,0-.49,0-.73.09a3.67,3.67,0,0,0-.67.18,11.31,11.31,0,0,0-1.35.52,2.42,2.42,0,0,1,1.24-.86A2.07,2.07,0,0,1,43.78,199.78Z"
                fill="#2f6840"
              />
              <path
                d="M42.41,203a1.88,1.88,0,0,0-.66-1c-.28-.28-.64-.5-1-.8a2.13,2.13,0,0,1,1.21.54,1.81,1.81,0,0,1,.41.57A1,1,0,0,1,42.41,203Z"
                fill="#2f6840"
              />
              <path
                d="M40.45,201c-.24.06-.47.09-.69.16a2.78,2.78,0,0,0-.65.23,9.87,9.87,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,40.45,201Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M31.71,197.57c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.92-2.16,3.63,3.56,2.65,3.44-4.69.05-4.69.05,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.92,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,31.71,197.57Z"
                fill="#2f6840"
              />
              <path
                d="M31.21,197.23c4.42-.25-4.33.45-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15S39,197.81,38,197.7s-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,31.21,197.23Z"
                fill="#3ba525"
              />
              <path
                d="M32,197.2a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.74a2.35,2.35,0,0,1,1.29.46,2,2,0,0,1,.47.53A1,1,0,0,1,32,197.2Z"
                fill="#2f6840"
              />
              <path
                d="M35.44,196.4c-.26,0-.5,0-.73.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.45,2.45,0,0,1,1.24-.87A2.13,2.13,0,0,1,35.44,196.4Z"
                fill="#2f6840"
              />
              <path
                d="M34.07,199.61a2,2,0,0,0-.66-1c-.29-.28-.64-.5-1-.81a2.21,2.21,0,0,1,1.21.55,1.64,1.64,0,0,1,.4.57A.89.89,0,0,1,34.07,199.61Z"
                fill="#2f6840"
              />
              <path
                d="M32.11,197.66c-.25.06-.48.09-.7.16a3.45,3.45,0,0,0-.64.22,9.33,9.33,0,0,0-1.25.65,2.31,2.31,0,0,1,1.11-1A2,2,0,0,1,32.11,197.66Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M46.42,213.06c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,46.42,213.06Z"
                fill="#2f6840"
              />
              <path
                d="M45.91,212.72c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.23-2.77,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,45.91,212.72Z"
                fill="#3ba525"
              />
              <path
                d="M46.66,212.69a2.15,2.15,0,0,0-.79-.94c-.33-.26-.71-.46-1.07-.74a2.27,2.27,0,0,1,1.28.46,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,46.66,212.69Z"
                fill="#2f6840"
              />
              <path
                d="M50.14,211.89c-.25,0-.49.05-.72.1a4,4,0,0,0-.68.18,11.31,11.31,0,0,0-1.35.52,2.5,2.5,0,0,1,1.24-.87A2.12,2.12,0,0,1,50.14,211.89Z"
                fill="#2f6840"
              />
              <path
                d="M48.77,215.1a1.9,1.9,0,0,0-.66-1c-.28-.29-.63-.5-1-.81a2.24,2.24,0,0,1,1.22.55,1.78,1.78,0,0,1,.4.57A.94.94,0,0,1,48.77,215.1Z"
                fill="#2f6840"
              />
              <path
                d="M46.82,213.15c-.25.06-.48.09-.7.16a3.83,3.83,0,0,0-.65.22,10,10,0,0,0-1.25.65,2.31,2.31,0,0,1,1.11-1A2.07,2.07,0,0,1,46.82,213.15Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M33,207.49c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.37,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,33,207.49Z"
                fill="#2f6840"
              />
              <path
                d="M32.45,207.15c4.43-.25-4.32.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.36,1.71S33,208,33,208s-.91,3.34-3,2.55-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,32.45,207.15Z"
                fill="#3ba525"
              />
              <path
                d="M33.21,207.12a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.74a2.29,2.29,0,0,1,1.28.46,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,33.21,207.12Z"
                fill="#2f6840"
              />
              <path
                d="M36.68,206.32c-.25,0-.49.05-.72.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.47,2.47,0,0,1,1.23-.87A2.12,2.12,0,0,1,36.68,206.32Z"
                fill="#2f6840"
              />
              <path
                d="M35.32,209.53a2,2,0,0,0-.66-1c-.29-.28-.64-.5-1-.81a2.24,2.24,0,0,1,1.21.55,1.64,1.64,0,0,1,.4.57A.94.94,0,0,1,35.32,209.53Z"
                fill="#2f6840"
              />
              <path
                d="M33.36,207.58c-.25.06-.48.09-.7.16A3.45,3.45,0,0,0,32,208a10.08,10.08,0,0,0-1.26.65,2.34,2.34,0,0,1,1.12-1A2,2,0,0,1,33.36,207.58Z"
                fill="#2f6840"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M75.55,204.5c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.69.05-4.69.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.17-2.9-1.17-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,75.55,204.5Z"
                fill="#2f6840"
              />
              <path
                d="M75,204.16c4.43-.25-4.32.45-4.35-.61S75,200.92,76,201.09s.27,2.25.27,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,75,204.16Z"
                fill="#3ba525"
              />
              <path
                d="M75.8,204.13a2.17,2.17,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.87,1.87,0,0,1,.47.54A1,1,0,0,1,75.8,204.13Z"
                fill="#2f6840"
              />
              <path
                d="M79.27,203.33c-.25,0-.49,0-.72.1a5.2,5.2,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.47,2.47,0,0,1,1.23-.87A2.12,2.12,0,0,1,79.27,203.33Z"
                fill="#2f6840"
              />
              <path
                d="M77.91,206.54a2,2,0,0,0-.66-1c-.29-.29-.64-.5-1-.81a2.24,2.24,0,0,1,1.21.55,1.55,1.55,0,0,1,.4.57A.94.94,0,0,1,77.91,206.54Z"
                fill="#2f6840"
              />
              <path
                d="M76,204.59a6.56,6.56,0,0,0-.7.16,3.45,3.45,0,0,0-.64.22,9.33,9.33,0,0,0-1.25.65,2.22,2.22,0,0,1,1.11-1A2,2,0,0,1,76,204.59Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M72.89,213.23c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.23-2.77,2.92-2.15,3.62,3.56,2.65,3.44-4.69.05-4.69.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.17-2.9-1.17-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,72.89,213.23Z"
                fill="#2f6840"
              />
              <path
                d="M72.38,212.89c4.43-.26-4.32.45-4.35-.62s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.37A14.67,14.67,0,0,1,72.38,212.89Z"
                fill="#3ba525"
              />
              <path
                d="M73.14,212.86a2.17,2.17,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,2.2,2.2,0,0,1,.48.53A1,1,0,0,1,73.14,212.86Z"
                fill="#2f6840"
              />
              <path
                d="M76.62,212.06c-.26,0-.5.05-.73.1a5.2,5.2,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53A2.47,2.47,0,0,1,75.1,212,2.15,2.15,0,0,1,76.62,212.06Z"
                fill="#2f6840"
              />
              <path
                d="M75.25,215.27a2,2,0,0,0-.66-1c-.29-.29-.64-.5-1-.81a2.17,2.17,0,0,1,1.21.55,1.55,1.55,0,0,1,.4.57A.94.94,0,0,1,75.25,215.27Z"
                fill="#2f6840"
              />
              <path
                d="M73.29,213.32a6.61,6.61,0,0,0-.7.15,4.41,4.41,0,0,0-.64.23,9.33,9.33,0,0,0-1.25.65,2.18,2.18,0,0,1,1.11-1A2,2,0,0,1,73.29,213.32Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M67.54,208.27c4.42-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,67.54,208.27Z"
                fill="#2f6840"
              />
              <path
                d="M67,207.93c4.43-.25-4.33.45-4.35-.61S67,204.69,68,204.86s.27,2.25.27,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.64,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.92,3.34-3,2.55-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,67,207.93Z"
                fill="#3ba525"
              />
              <path
                d="M67.79,207.9A2.24,2.24,0,0,0,67,207c-.33-.26-.71-.46-1.07-.74a2.22,2.22,0,0,1,1.28.46,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,67.79,207.9Z"
                fill="#2f6840"
              />
              <path
                d="M71.26,207.1c-.25,0-.49.05-.72.1a4,4,0,0,0-.68.18,12.79,12.79,0,0,0-1.35.52,2.54,2.54,0,0,1,1.24-.87A2.12,2.12,0,0,1,71.26,207.1Z"
                fill="#2f6840"
              />
              <path
                d="M69.89,210.31a1.94,1.94,0,0,0-.65-1c-.29-.29-.64-.5-1-.81a2.24,2.24,0,0,1,1.21.55,1.78,1.78,0,0,1,.4.57A.94.94,0,0,1,69.89,210.31Z"
                fill="#2f6840"
              />
              <path
                d="M67.94,208.36c-.25.06-.48.09-.7.16a3.83,3.83,0,0,0-.65.22,10,10,0,0,0-1.25.65,2.29,2.29,0,0,1,1.12-1A2,2,0,0,1,67.94,208.36Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M59.2,204.9c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,59.2,204.9Z"
                fill="#2f6840"
              />
              <path
                d="M58.69,204.56c4.43-.26-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.34,14.34,0,0,1,58.69,204.56Z"
                fill="#3ba525"
              />
              <path
                d="M59.44,204.53a2.11,2.11,0,0,0-.8-.94c-.32-.27-.7-.46-1.06-.74a2.34,2.34,0,0,1,1.28.45,2,2,0,0,1,.47.54A1,1,0,0,1,59.44,204.53Z"
                fill="#2f6840"
              />
              <path
                d="M62.92,203.73c-.26,0-.49.05-.72.1a5.2,5.2,0,0,0-.68.17,13.44,13.44,0,0,0-1.35.53,2.5,2.5,0,0,1,1.24-.87A2.12,2.12,0,0,1,62.92,203.73Z"
                fill="#2f6840"
              />
              <path
                d="M61.55,206.94a1.86,1.86,0,0,0-.66-1c-.28-.29-.63-.5-1-.81a2.2,2.2,0,0,1,1.22.55,1.68,1.68,0,0,1,.4.57A.94.94,0,0,1,61.55,206.94Z"
                fill="#2f6840"
              />
              <path
                d="M59.59,205a7,7,0,0,0-.69.15,5,5,0,0,0-.65.23A10,10,0,0,0,57,206a2.31,2.31,0,0,1,1.11-1A2,2,0,0,1,59.59,205Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M73.9,220.39c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.69,0-4.69,0,6,.86,4,1.54-3.31,2-4.36,1.72-1.17-2.9-1.17-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,73.9,220.39Z"
                fill="#2f6840"
              />
              <path
                d="M73.39,220c4.43-.25-4.32.46-4.35-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.27-2.07-2.37A14.86,14.86,0,0,1,73.39,220Z"
                fill="#3ba525"
              />
              <path
                d="M74.15,220a2.12,2.12,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,2.2,2.2,0,0,1,.48.53A1,1,0,0,1,74.15,220Z"
                fill="#2f6840"
              />
              <path
                d="M77.63,219.22c-.26,0-.5.05-.73.1a5.2,5.2,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.47,2.47,0,0,1,1.23-.87A2.15,2.15,0,0,1,77.63,219.22Z"
                fill="#2f6840"
              />
              <path
                d="M76.26,222.43a2,2,0,0,0-.66-1c-.29-.29-.64-.5-1-.81a2.17,2.17,0,0,1,1.21.55,1.55,1.55,0,0,1,.4.57A.94.94,0,0,1,76.26,222.43Z"
                fill="#2f6840"
              />
              <path
                d="M74.3,220.48a6.61,6.61,0,0,0-.7.15,4.41,4.41,0,0,0-.64.23,9.33,9.33,0,0,0-1.25.65,2.18,2.18,0,0,1,1.11-1A2,2,0,0,1,74.3,220.48Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M60.44,214.82c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.44-4.69.05-4.69.05,6,.86,4,1.54-3.31,2-4.36,1.72S61,215.7,61,215.7s-.91,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,60.44,214.82Z"
                fill="#2f6840"
              />
              <path
                d="M59.94,214.48c4.42-.26-4.33.45-4.35-.61s4.34-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.34,14.34,0,0,1,59.94,214.48Z"
                fill="#3ba525"
              />
              <path
                d="M60.69,214.45a2.11,2.11,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,2,2,0,0,1,.47.54A1,1,0,0,1,60.69,214.45Z"
                fill="#2f6840"
              />
              <path
                d="M64.17,213.65c-.26,0-.49,0-.73.1a5.2,5.2,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.45,2.45,0,0,1,1.24-.87A2.12,2.12,0,0,1,64.17,213.65Z"
                fill="#2f6840"
              />
              <path
                d="M62.8,216.86a1.92,1.92,0,0,0-.66-1c-.28-.29-.64-.5-1-.81a2.14,2.14,0,0,1,1.21.55,1.55,1.55,0,0,1,.4.57A.89.89,0,0,1,62.8,216.86Z"
                fill="#2f6840"
              />
              <path
                d="M60.84,214.91c-.24.05-.47.08-.7.15a4.41,4.41,0,0,0-.64.23,10,10,0,0,0-1.25.65,2.31,2.31,0,0,1,1.11-1A2,2,0,0,1,60.84,214.91Z"
                fill="#2f6840"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M102.46,213.76c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.44-4.69.05-4.69.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,102.46,213.76Z"
                fill="#2f6840"
              />
              <path
                d="M102,213.42c4.42-.25-4.33.45-4.35-.61s4.34-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,102,213.42Z"
                fill="#3ba525"
              />
              <path
                d="M102.71,213.39a2.11,2.11,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,2,2,0,0,1,.47.54A1,1,0,0,1,102.71,213.39Z"
                fill="#2f6840"
              />
              <path
                d="M106.19,212.59c-.26,0-.49,0-.73.1a5.2,5.2,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.45,2.45,0,0,1,1.24-.87A2.12,2.12,0,0,1,106.19,212.59Z"
                fill="#2f6840"
              />
              <path
                d="M104.82,215.8a1.92,1.92,0,0,0-.66-1c-.28-.29-.64-.5-1-.81a2.14,2.14,0,0,1,1.21.55,1.55,1.55,0,0,1,.4.57A.89.89,0,0,1,104.82,215.8Z"
                fill="#2f6840"
              />
              <path
                d="M102.86,213.85c-.24.06-.47.08-.7.16a3.45,3.45,0,0,0-.64.22,10,10,0,0,0-1.25.65,2.31,2.31,0,0,1,1.11-1A2,2,0,0,1,102.86,213.85Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M99.8,222.49c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,99.8,222.49Z"
                fill="#2f6840"
              />
              <path
                d="M99.3,222.14c4.42-.25-4.33.46-4.35-.61s4.35-2.62,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.37A15,15,0,0,1,99.3,222.14Z"
                fill="#3ba525"
              />
              <path
                d="M100.05,222.12a2.06,2.06,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,2.16,2.16,0,0,1,.47.53A1,1,0,0,1,100.05,222.12Z"
                fill="#2f6840"
              />
              <path
                d="M103.53,221.32c-.26,0-.49.05-.73.1a4.69,4.69,0,0,0-.67.17,13.44,13.44,0,0,0-1.35.53,2.5,2.5,0,0,1,1.24-.87A2.12,2.12,0,0,1,103.53,221.32Z"
                fill="#2f6840"
              />
              <path
                d="M102.16,224.53a1.86,1.86,0,0,0-.66-1c-.28-.29-.64-.5-1-.81a2.14,2.14,0,0,1,1.21.55,1.7,1.7,0,0,1,.41.57A.94.94,0,0,1,102.16,224.53Z"
                fill="#2f6840"
              />
              <path
                d="M100.2,222.58c-.24,0-.47.08-.7.15a4.41,4.41,0,0,0-.64.23,10,10,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2,2,0,0,1,100.2,222.58Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M94.45,217.53c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.92-2.16,3.63,3.56,2.65,3.44-4.69.05-4.69.05,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.92,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,94.45,217.53Z"
                fill="#2f6840"
              />
              <path
                d="M94,217.19c4.42-.25-4.33.45-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,94,217.19Z"
                fill="#3ba525"
              />
              <path
                d="M94.7,217.16a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.29.46,2,2,0,0,1,.47.53A1,1,0,0,1,94.7,217.16Z"
                fill="#2f6840"
              />
              <path
                d="M98.18,216.36c-.26,0-.5,0-.73.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.45,2.45,0,0,1,1.24-.87A2.13,2.13,0,0,1,98.18,216.36Z"
                fill="#2f6840"
              />
              <path
                d="M96.81,219.57a2,2,0,0,0-.66-1c-.28-.29-.64-.5-1-.81a2.21,2.21,0,0,1,1.21.55,1.64,1.64,0,0,1,.4.57A.89.89,0,0,1,96.81,219.57Z"
                fill="#2f6840"
              />
              <path
                d="M94.85,217.62c-.25.06-.48.09-.7.16a3.45,3.45,0,0,0-.64.22,9.33,9.33,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2,2,0,0,1,94.85,217.62Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M86.11,214.16c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,86.11,214.16Z"
                fill="#2f6840"
              />
              <path
                d="M85.6,213.82c4.43-.26-4.33.45-4.35-.62s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.27-2.07-2.36A14.24,14.24,0,0,1,85.6,213.82Z"
                fill="#3ba525"
              />
              <path
                d="M86.36,213.79a2.17,2.17,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,2,2,0,0,1,.47.53A1,1,0,0,1,86.36,213.79Z"
                fill="#2f6840"
              />
              <path
                d="M89.83,213c-.25,0-.49,0-.72.1a5.2,5.2,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.47,2.47,0,0,1,1.23-.87A2.12,2.12,0,0,1,89.83,213Z"
                fill="#2f6840"
              />
              <path
                d="M88.47,216.2a2,2,0,0,0-.66-1c-.29-.29-.64-.5-1-.81a2.17,2.17,0,0,1,1.21.55,1.68,1.68,0,0,1,.4.57A.94.94,0,0,1,88.47,216.2Z"
                fill="#2f6840"
              />
              <path
                d="M86.51,214.25a6.61,6.61,0,0,0-.7.15,4.41,4.41,0,0,0-.64.23,10.08,10.08,0,0,0-1.26.65,2.29,2.29,0,0,1,1.12-1A2,2,0,0,1,86.51,214.25Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M100.81,229.65c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,100.81,229.65Z"
                fill="#2f6840"
              />
              <path
                d="M100.31,229.3c4.42-.25-4.33.46-4.35-.61s4.35-2.62,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.37A15,15,0,0,1,100.31,229.3Z"
                fill="#3ba525"
              />
              <path
                d="M101.06,229.28a2.06,2.06,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,2.16,2.16,0,0,1,.47.53A1,1,0,0,1,101.06,229.28Z"
                fill="#2f6840"
              />
              <path
                d="M104.54,228.48c-.26,0-.49.05-.73.1a4.69,4.69,0,0,0-.67.17,13.44,13.44,0,0,0-1.35.53,2.5,2.5,0,0,1,1.24-.87A2.12,2.12,0,0,1,104.54,228.48Z"
                fill="#2f6840"
              />
              <path
                d="M103.17,231.69a1.92,1.92,0,0,0-.66-1c-.28-.29-.64-.5-1-.81a2.14,2.14,0,0,1,1.21.55,1.7,1.7,0,0,1,.41.57A.94.94,0,0,1,103.17,231.69Z"
                fill="#2f6840"
              />
              <path
                d="M101.21,229.74c-.24,0-.47.08-.7.15a4.41,4.41,0,0,0-.64.23,10,10,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2,2,0,0,1,101.21,229.74Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M87.36,224.08c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,87.36,224.08Z"
                fill="#2f6840"
              />
              <path
                d="M86.85,223.74c4.43-.26-4.33.45-4.35-.62s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.34,14.34,0,0,1,86.85,223.74Z"
                fill="#3ba525"
              />
              <path
                d="M87.6,223.71a2.15,2.15,0,0,0-.79-.94c-.33-.27-.71-.46-1.07-.74a2.31,2.31,0,0,1,1.28.45,2,2,0,0,1,.47.53A1,1,0,0,1,87.6,223.71Z"
                fill="#2f6840"
              />
              <path
                d="M91.08,222.91c-.25,0-.49.05-.72.1a5.2,5.2,0,0,0-.68.17,14.45,14.45,0,0,0-1.35.53,2.54,2.54,0,0,1,1.24-.87A2.12,2.12,0,0,1,91.08,222.91Z"
                fill="#2f6840"
              />
              <path
                d="M89.71,226.12a1.86,1.86,0,0,0-.66-1c-.28-.29-.63-.5-1-.81a2.17,2.17,0,0,1,1.21.55,1.68,1.68,0,0,1,.4.57A.94.94,0,0,1,89.71,226.12Z"
                fill="#2f6840"
              />
              <path
                d="M87.76,224.17a6.61,6.61,0,0,0-.7.15,5,5,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.29,2.29,0,0,1,1.12-1A2,2,0,0,1,87.76,224.17Z"
                fill="#2f6840"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M127.68,227c4.42-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,127.68,227Z"
                fill="#2f6840"
              />
              <path
                d="M127.17,226.65c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.24.27,2.24,1.24-2.77,2.93-2.15,3.62,3.56,2.64,3.44-4.69,0-4.69,0,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,127.17,226.65Z"
                fill="#3ba525"
              />
              <path
                d="M127.93,226.62a2.17,2.17,0,0,0-.8-.94c-.32-.26-.71-.45-1.07-.73a2.28,2.28,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,127.93,226.62Z"
                fill="#2f6840"
              />
              <path
                d="M131.4,225.83c-.25,0-.49,0-.72.09a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.39,2.39,0,0,1,1.23-.86A2.07,2.07,0,0,1,131.4,225.83Z"
                fill="#2f6840"
              />
              <path
                d="M130,229a1.94,1.94,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.16,2.16,0,0,1,1.21.54,1.78,1.78,0,0,1,.4.57A1,1,0,0,1,130,229Z"
                fill="#2f6840"
              />
              <path
                d="M128.08,227.08c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,9.34,9.34,0,0,0-1.26.64,2.27,2.27,0,0,1,1.12-1A2,2,0,0,1,128.08,227.08Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M125,235.72c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,125,235.72Z"
                fill="#2f6840"
              />
              <path
                d="M124.51,235.38c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.64,3.44-4.69.05-4.69.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.54-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,124.51,235.38Z"
                fill="#3ba525"
              />
              <path
                d="M125.27,235.35a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.21,2.21,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,125.27,235.35Z"
                fill="#2f6840"
              />
              <path
                d="M128.74,234.55c-.25,0-.49,0-.72.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.39,2.39,0,0,1,1.23-.86A2.12,2.12,0,0,1,128.74,234.55Z"
                fill="#2f6840"
              />
              <path
                d="M127.38,237.76a2,2,0,0,0-.66-1c-.29-.28-.64-.5-1-.8a2.16,2.16,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A.94.94,0,0,1,127.38,237.76Z"
                fill="#2f6840"
              />
              <path
                d="M125.42,235.81c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,10,10,0,0,0-1.26.64,2.27,2.27,0,0,1,1.12-1A2,2,0,0,1,125.42,235.81Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M119.67,230.76c4.42-.25-4.33.46-4.36-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.37A14.87,14.87,0,0,1,119.67,230.76Z"
                fill="#2f6840"
              />
              <path
                d="M119.16,230.42c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.92-2.16,3.63,3.56,2.65,3.44-4.69.05-4.69.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.17-2.9-1.17-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,119.16,230.42Z"
                fill="#3ba525"
              />
              <path
                d="M119.91,230.39a2.07,2.07,0,0,0-.79-.93c-.33-.27-.71-.46-1.07-.74a2.31,2.31,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A.93.93,0,0,1,119.91,230.39Z"
                fill="#2f6840"
              />
              <path
                d="M123.39,229.6c-.25,0-.49,0-.72.09a4,4,0,0,0-.68.18,11.31,11.31,0,0,0-1.35.52,2.46,2.46,0,0,1,1.24-.86A2.07,2.07,0,0,1,123.39,229.6Z"
                fill="#2f6840"
              />
              <path
                d="M122,232.81a1.82,1.82,0,0,0-.66-1c-.28-.29-.63-.51-1-.81a2.15,2.15,0,0,1,1.22.54,1.78,1.78,0,0,1,.4.57A1,1,0,0,1,122,232.81Z"
                fill="#2f6840"
              />
              <path
                d="M120.07,230.85c-.25.06-.48.09-.7.16a3.15,3.15,0,0,0-.65.23,9.87,9.87,0,0,0-1.25.64,2.27,2.27,0,0,1,1.12-1A2,2,0,0,1,120.07,230.85Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M111.32,227.39c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,111.32,227.39Z"
                fill="#2f6840"
              />
              <path
                d="M110.82,227.05c4.42-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,110.82,227.05Z"
                fill="#3ba525"
              />
              <path
                d="M111.57,227a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.26,2.26,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,111.57,227Z"
                fill="#2f6840"
              />
              <path
                d="M115.05,226.23c-.26,0-.49,0-.73.09a3.67,3.67,0,0,0-.67.18,11.31,11.31,0,0,0-1.35.52,2.42,2.42,0,0,1,1.24-.86A2.07,2.07,0,0,1,115.05,226.23Z"
                fill="#2f6840"
              />
              <path
                d="M113.68,229.44a1.88,1.88,0,0,0-.66-1c-.28-.28-.64-.5-1-.8a2.13,2.13,0,0,1,1.21.54,1.81,1.81,0,0,1,.41.57A1,1,0,0,1,113.68,229.44Z"
                fill="#2f6840"
              />
              <path
                d="M111.72,227.48c-.24.06-.47.09-.69.16a2.78,2.78,0,0,0-.65.23,9.87,9.87,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,111.72,227.48Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M126,242.88c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,126,242.88Z"
                fill="#2f6840"
              />
              <path
                d="M125.52,242.54c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.64,3.44-4.69.05-4.69.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.54-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,125.52,242.54Z"
                fill="#3ba525"
              />
              <path
                d="M126.28,242.51a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.21,2.21,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,126.28,242.51Z"
                fill="#2f6840"
              />
              <path
                d="M129.75,241.71c-.25,0-.49,0-.72.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.39,2.39,0,0,1,1.23-.86A2.12,2.12,0,0,1,129.75,241.71Z"
                fill="#2f6840"
              />
              <path
                d="M128.39,244.92a2,2,0,0,0-.66-1c-.29-.28-.64-.5-1-.8a2.16,2.16,0,0,1,1.21.54,1.78,1.78,0,0,1,.4.57A.94.94,0,0,1,128.39,244.92Z"
                fill="#2f6840"
              />
              <path
                d="M126.43,243c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,10,10,0,0,0-1.26.64,2.27,2.27,0,0,1,1.12-1A2,2,0,0,1,126.43,243Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M112.57,237.31c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.92,3.34-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,112.57,237.31Z"
                fill="#2f6840"
              />
              <path
                d="M112.07,237c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,112.07,237Z"
                fill="#3ba525"
              />
              <path
                d="M112.82,236.94a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.26,2.26,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,112.82,236.94Z"
                fill="#2f6840"
              />
              <path
                d="M116.3,236.15c-.26,0-.5,0-.73.09a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.38,2.38,0,0,1,1.24-.86A2.07,2.07,0,0,1,116.3,236.15Z"
                fill="#2f6840"
              />
              <path
                d="M114.93,239.36a1.94,1.94,0,0,0-.66-1c-.28-.28-.64-.5-1-.8a2.13,2.13,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A.92.92,0,0,1,114.93,239.36Z"
                fill="#2f6840"
              />
              <path
                d="M113,237.4c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,9.24,9.24,0,0,0-1.25.64,2.24,2.24,0,0,1,1.11-1A2,2,0,0,1,113,237.4Z"
                fill="#2f6840"
              />
            </g>
          </g>
        </g>
        <g>
          <path
            d="M95.35,207.41s-1.38,4.1-4,5.12-7-1.06-6.07,1.05-4.59,3.91-7.11,3.66-8.59-4.69-8.79-6.35S95.35,207.41,95.35,207.41Z"
            fill="#131b8c"
            opacity="0.63"
          />
          <g>
            <path
              d="M95,204.26l.36,3.15-4.15,3.87-6,.69-1.09,2.5s-3.85,2.51-6.9.79a22.66,22.66,0,0,1-5.65-5.11L71.2,207Z"
              fill="#ccae79"
            />
            <path
              d="M89.88,202.78,95,204.26l-4.49,3.9-5.73.66-1.58,2.63s-5.4,2.31-6.32.73S71.2,207,71.2,207l4.21-2.55Z"
              fill="#ffedc8"
            />
            <polygon
              points="90.5 208.16 91.2 211.28 85.2 211.97 84.77 208.82 90.5 208.16"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M78.39,212.73s-.58,3,.35,3.06a13.87,13.87,0,0,1-7.18-5.64L71.2,207S77.08,212.9,78.39,212.73Z"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M82.2,211.83l-1.11.37s.68-.28.7,1.06A3.25,3.25,0,0,1,82.2,211.83Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M79.67,212.61a8.22,8.22,0,0,1-1.39-.89,6.82,6.82,0,0,1-1.7-1.95s2.82,2.45,2.28,2.93Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M92.36,206.54a18.22,18.22,0,0,0,.27,2.28s-.12-1.73-.63-2Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M83,203.58l-2.28.26c-.17,0,1.78-.21,2.39.75l-.12-1"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M92.42,203.52l-1.27-.37s.73.34.47.46-1.25.71-1.71.54a1.81,1.81,0,0,0-1.14.19Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M36.16,202.62s1.85,3.54,4.37,4.1,6.25-2,5.7.08,4.76,2.9,7,2.3,7.18-5.54,7.12-7.08S36.16,202.62,36.16,202.62Z"
            fill="#131b8c"
            opacity="0.63"
          />
          <g>
            <path
              d="M36,199.69l.13,2.93,4.36,2.93,5.58-.24,1.36,2.12s3.89,1.73,6.42-.28a20.83,20.83,0,0,0,4.42-5.5l-.13-2.93Z"
              fill="#ccae79"
            />
            <path
              d="M40.48,197.59,36,199.69l4.67,2.91,5.33-.23,1.83,2.17s5.28,1.32,5.89-.26,4.42-5.56,4.42-5.56L54,197Z"
              fill="#ffedc8"
            />
            <polygon
              points="40.7 202.6 40.52 205.55 46.1 205.31 46.03 202.37 40.7 202.6"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M52.43,205s1,2.65.13,2.85a12.84,12.84,0,0,0,5.74-6.21l-.13-2.93S53.66,205,52.43,205Z"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M48.82,204.74l1.07.18s-.67-.16-.49,1.07A2.89,2.89,0,0,0,48.82,204.74Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M51.25,205.08c-.12,0,.21,0,1.14-1a6.37,6.37,0,0,0,1.27-2s-2.22,2.66-1.66,3Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M38.76,201.39a17.43,17.43,0,0,1,.09,2.12s-.15-1.59.29-1.88Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M46.9,197.31l2.12-.09c.16,0-1.67.07-2.08,1l0-.95"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M38.27,198.64l1.11-.52s-.62.41-.37.48,1.25.47,1.65.25a1.62,1.62,0,0,1,1.06,0Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M13.8,181.33,19.74,185a2,2,0,0,0,1.81.12l14.25-6.37a1.94,1.94,0,0,0,.48-3.23h0a2,2,0,0,0-1.52-.45l-20.19,2.68A1.93,1.93,0,0,0,13.8,181.33Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="24.34 166.58 16.3 168.29 9.22 173.73 21.09 178.49 35.62 172.53 24.34 166.58"
              fill="#ffedc8"
            />
            <polygon
              points="9.22 173.73 9.22 178.49 20.61 183.37 35.94 177.15 35.62 172.53 21.09 178.49 9.22 173.73"
              fill="#ccae79"
            />
            <polygon
              points="21.09 178.49 20.61 183.37 35.94 177.15 35.62 172.53 21.09 178.49"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M12.61,175.09a2.14,2.14,0,0,1,0,2.44c.54-.77.66-2.18.91-2.08Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M17.62,177.09a6.74,6.74,0,0,0,3-3l-2.15,3.38Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M27.09,176A2.18,2.18,0,0,1,28.27,178l-.35-2.26Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M32.4,170.83c-.15-.07-3,.58-4.72,0a6.79,6.79,0,0,1-3.43.25s2.52-.25,3.43.61A20.73,20.73,0,0,1,32.4,170.83Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M3.74,199.61l4.86,3a1.59,1.59,0,0,0,1.47.1l11.65-5.21a1.58,1.58,0,0,0,.39-2.64h0a1.59,1.59,0,0,0-1.24-.37l-16.5,2.2A1.57,1.57,0,0,0,3.74,199.61Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="12.36 187.56 5.79 188.95 0 193.4 9.7 197.29 21.58 192.43 12.36 187.56"
              fill="#ffedc8"
            />
            <polygon
              points="0 193.4 0 197.29 9.31 201.28 21.83 196.19 21.58 192.43 9.7 197.29 0 193.4"
              fill="#ccae79"
            />
            <polygon
              points="9.7 197.29 9.31 201.28 21.83 196.19 21.58 192.43 9.7 197.29"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M2.77,194.51a1.77,1.77,0,0,1,0,2c.44-.63.54-1.78.74-1.7Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M6.86,196.15a5.57,5.57,0,0,0,2.45-2.48l-1.76,2.76Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M14.6,195.28a1.81,1.81,0,0,1,1,1.57L15.28,195Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M18.94,191c-.12-.07-2.45.47-3.85,0a5.55,5.55,0,0,1-2.81.19s2.06-.2,2.81.51A16.61,16.61,0,0,1,18.94,191Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M20,213.7l4.85,3a1.57,1.57,0,0,0,1.47.1L38,211.6a1.58,1.58,0,0,0,.39-2.63h0a1.59,1.59,0,0,0-1.25-.37l-16.5,2.19A1.58,1.58,0,0,0,20,213.7Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="28.58 201.65 22.01 203.04 16.22 207.49 25.92 211.37 37.8 206.51 28.58 201.65"
              fill="#ffedc8"
            />
            <polygon
              points="16.22 207.49 16.22 211.37 25.53 215.36 38.06 210.28 37.8 206.51 25.92 211.37 16.22 207.49"
              fill="#ccae79"
            />
            <polygon
              points="25.92 211.37 25.53 215.36 38.06 210.28 37.8 206.51 25.92 211.37"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M19,208.6a1.73,1.73,0,0,1,0,2c.44-.62.54-1.78.74-1.7Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M23.08,210.24a5.56,5.56,0,0,0,2.45-2.49l-1.76,2.76Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M30.83,209.36a1.79,1.79,0,0,1,1,1.58l-.29-1.85Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M35.17,205.12c-.13-.06-2.46.47-3.86,0a5.64,5.64,0,0,1-2.81.2s2.06-.2,2.81.5A16.75,16.75,0,0,1,35.17,205.12Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M36.94,218.81l2.7,1.68a.86.86,0,0,0,.82.06l6.49-2.9a.88.88,0,0,0,.22-1.47h0a.91.91,0,0,0-.69-.21l-9.19,1.23A.87.87,0,0,0,36.94,218.81Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="41.73 212.1 38.08 212.88 34.85 215.36 40.26 217.52 46.87 214.81 41.73 212.1"
              fill="#ffedc8"
            />
            <polygon
              points="34.85 215.36 34.85 217.52 40.04 219.74 47.01 216.91 46.87 214.81 40.26 217.52 34.85 215.36"
              fill="#ccae79"
            />
            <polygon
              points="40.26 217.52 40.04 219.74 47.01 216.91 46.87 214.81 40.26 217.52"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M36.4,216a1,1,0,0,1,0,1.12c.24-.35.3-1,.41-1Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M38.67,216.89A3.08,3.08,0,0,0,40,215.5l-1,1.54Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M43,216.4a1,1,0,0,1,.53.88l-.16-1Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M45.4,214a6.56,6.56,0,0,1-2.14,0,3.12,3.12,0,0,1-1.57.11s1.15-.11,1.57.28A8.93,8.93,0,0,1,45.4,214Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M116.94,236.34l2.7,1.68a.88.88,0,0,0,.82,0l6.49-2.9a.87.87,0,0,0,.22-1.46h0a.87.87,0,0,0-.69-.21l-9.19,1.22A.88.88,0,0,0,116.94,236.34Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="121.73 229.63 118.08 230.4 114.85 232.88 120.25 235.04 126.87 232.34 121.73 229.63"
              fill="#ffedc8"
            />
            <polygon
              points="114.85 232.88 114.85 235.04 120.04 237.27 127.01 234.44 126.87 232.34 120.25 235.04 114.85 232.88"
              fill="#ccae79"
            />
            <polygon
              points="120.25 235.04 120.04 237.27 127.01 234.44 126.87 232.34 120.25 235.04"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M116.4,233.5a1,1,0,0,1,0,1.11c.24-.35.3-1,.41-1Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M118.67,234.41A3.08,3.08,0,0,0,120,233l-1,1.53Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M123,233.93a1,1,0,0,1,.53.87l-.16-1Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M125.4,231.56a6,6,0,0,1-2.14,0,3.12,3.12,0,0,1-1.57.11s1.15-.11,1.57.28A9.49,9.49,0,0,1,125.4,231.56Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M121.63,227l2.71,1.67a.85.85,0,0,0,.82.06l6.49-2.9a.88.88,0,0,0,.21-1.47h0a.86.86,0,0,0-.69-.2L122,225.41A.88.88,0,0,0,121.63,227Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="126.43 220.31 122.77 221.09 119.55 223.57 124.95 225.73 131.56 223.02 126.43 220.31"
              fill="#ffedc8"
            />
            <polygon
              points="119.55 223.57 119.55 225.73 124.73 227.95 131.71 225.12 131.56 223.02 124.95 225.73 119.55 223.57"
              fill="#ccae79"
            />
            <polygon
              points="124.95 225.73 124.73 227.95 131.71 225.12 131.56 223.02 124.95 225.73"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M121.09,224.18a1,1,0,0,1,0,1.12c.25-.35.3-1,.42-1Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M123.37,225.1a3,3,0,0,0,1.36-1.39l-1,1.54Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M127.68,224.61a1,1,0,0,1,.54.88l-.16-1Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M130.1,222.25a6.62,6.62,0,0,1-2.15,0,3.09,3.09,0,0,1-1.56.11s1.15-.11,1.56.28A9.54,9.54,0,0,1,130.1,222.25Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M219.37,238l3.75,2.33a1.21,1.21,0,0,0,1.14.07l9-4a1.22,1.22,0,0,0,.31-2h0a1.25,1.25,0,0,0-1-.29l-12.77,1.7A1.22,1.22,0,0,0,219.37,238Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="226.03 228.65 220.95 229.73 216.48 233.16 223.98 236.17 233.16 232.41 226.03 228.65"
              fill="#ffedc8"
            />
            <polygon
              points="216.48 233.16 216.48 236.17 223.67 239.25 233.36 235.32 233.16 232.41 223.98 236.17 216.48 233.16"
              fill="#ccae79"
            />
            <polygon
              points="223.98 236.17 223.67 239.25 233.36 235.32 233.16 232.41 223.98 236.17"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M218.62,234a1.36,1.36,0,0,1,0,1.55c.34-.49.41-1.38.57-1.32Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M221.78,235.29a4.24,4.24,0,0,0,1.89-1.92l-1.36,2.13Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M227.77,234.62a1.39,1.39,0,0,1,.75,1.21l-.23-1.43Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M231.12,231.34a9,9,0,0,1-3,0,4.26,4.26,0,0,1-2.17.15s1.6-.16,2.17.39A12.59,12.59,0,0,1,231.12,231.34Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M243.52,242.68l4.24,2.63a1.37,1.37,0,0,0,1.3.09l10.2-4.56a1.38,1.38,0,0,0,.34-2.3h0a1.4,1.4,0,0,0-1.09-.33l-14.45,1.92A1.39,1.39,0,0,0,243.52,242.68Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="251.06 232.13 245.31 233.35 240.24 237.24 248.73 240.64 259.13 236.39 251.06 232.13"
              fill="#ffedc8"
            />
            <polygon
              points="240.24 237.24 240.24 240.64 248.39 244.13 259.35 239.69 259.13 236.39 248.73 240.64 240.24 237.24"
              fill="#ccae79"
            />
            <polygon
              points="248.73 240.64 248.39 244.13 259.35 239.69 259.13 236.39 248.73 240.64"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M242.66,238.21a1.53,1.53,0,0,1,0,1.75c.39-.55.48-1.56.65-1.49Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M246.25,239.65a4.88,4.88,0,0,0,2.14-2.18l-1.54,2.42Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M253,238.88a1.58,1.58,0,0,1,.85,1.38l-.25-1.62Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M256.82,235.17a10.22,10.22,0,0,1-3.37,0,4.86,4.86,0,0,1-2.46.17s1.8-.17,2.46.44A14.83,14.83,0,0,1,256.82,235.17Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M271.83,273.37l3.95,2.45a1.28,1.28,0,0,0,1.2.09l9.48-4.24a1.29,1.29,0,0,0,.32-2.14h0a1.26,1.26,0,0,0-1-.31L272.34,271A1.28,1.28,0,0,0,271.83,273.37Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="278.84 263.57 273.49 264.7 268.78 268.32 276.67 271.48 286.34 267.52 278.84 263.57"
              fill="#ffedc8"
            />
            <polygon
              points="268.78 268.32 268.78 271.48 276.36 274.73 286.55 270.59 286.34 267.52 276.67 271.48 268.78 268.32"
              fill="#ccae79"
            />
            <polygon
              points="276.67 271.48 276.36 274.73 286.55 270.59 286.34 267.52 276.67 271.48"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M271,269.22a1.43,1.43,0,0,1,0,1.63c.35-.51.44-1.45.6-1.39Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M274.37,270.56a4.54,4.54,0,0,0,2-2l-1.44,2.25Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M280.66,269.85a1.45,1.45,0,0,1,.79,1.28l-.23-1.51Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M284.2,266.39a9.14,9.14,0,0,1-3.14,0,4.53,4.53,0,0,1-2.29.16s1.68-.16,2.29.41A13.85,13.85,0,0,1,284.2,266.39Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M276.3,289.92l4.52,2.81a1.47,1.47,0,0,0,1.38.09L293.05,288a1.47,1.47,0,0,0,.36-2.45h0a1.48,1.48,0,0,0-1.16-.35l-15.37,2.05A1.47,1.47,0,0,0,276.3,289.92Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="284.32 278.7 278.21 280 272.82 284.14 281.85 287.76 292.91 283.23 284.32 278.7"
              fill="#ffedc8"
            />
            <polygon
              points="272.82 284.14 272.82 287.76 281.48 291.47 293.15 286.74 292.91 283.23 281.85 287.76 272.82 284.14"
              fill="#ccae79"
            />
            <polygon
              points="281.85 287.76 281.48 291.47 293.15 286.74 292.91 283.23 281.85 287.76"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M275.39,285.17a1.62,1.62,0,0,1,0,1.86c.41-.58.51-1.66.7-1.58Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M279.21,286.7a5.14,5.14,0,0,0,2.27-2.32L279.85,287Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M286.42,285.89a1.67,1.67,0,0,1,.9,1.46l-.27-1.72Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M290.46,281.93c-.12-.06-2.29.44-3.59,0a5.23,5.23,0,0,1-2.62.19s1.92-.19,2.62.47A15.38,15.38,0,0,1,290.46,281.93Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M296.27,296.43l4.41,2.74a1.44,1.44,0,0,0,1.35.09l10.61-4.74a1.44,1.44,0,0,0,.35-2.4h0a1.45,1.45,0,0,0-1.13-.34l-15,2A1.44,1.44,0,0,0,296.27,296.43Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="304.11 285.45 298.13 286.72 292.86 290.77 301.69 294.31 312.5 289.88 304.11 285.45"
              fill="#ffedc8"
            />
            <polygon
              points="292.86 290.77 292.86 294.31 301.33 297.94 312.74 293.31 312.5 289.88 301.69 294.31 292.86 290.77"
              fill="#ccae79"
            />
            <polygon
              points="301.69 294.31 301.33 297.94 312.74 293.31 312.5 289.88 301.69 294.31"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M295.38,291.78a1.6,1.6,0,0,1,0,1.82c.4-.57.49-1.62.67-1.55Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M299.1,293.28a5,5,0,0,0,2.23-2.27l-1.6,2.52Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M306.15,292.48a1.63,1.63,0,0,1,.88,1.43l-.26-1.68Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M310.1,288.62c-.11-.06-2.23.43-3.5,0a5,5,0,0,1-2.56.18s1.87-.18,2.56.46A14.8,14.8,0,0,1,310.1,288.62Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M308.93,304.22l2.7,1.68a.86.86,0,0,0,.82.06l6.49-2.9a.88.88,0,0,0,.22-1.47h0a.93.93,0,0,0-.7-.21l-9.19,1.23A.87.87,0,0,0,308.93,304.22Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="313.72 297.51 310.06 298.29 306.84 300.76 312.24 302.93 318.86 300.22 313.72 297.51"
              fill="#ffedc8"
            />
            <polygon
              points="306.84 300.76 306.84 302.93 312.02 305.15 319 302.32 318.86 300.22 312.24 302.93 306.84 300.76"
              fill="#ccae79"
            />
            <polygon
              points="312.24 302.93 312.02 305.15 319 302.32 318.86 300.22 312.24 302.93"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M308.38,301.38a1,1,0,0,1,0,1.12c.25-.35.3-1,.42-.95Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M310.66,302.3a3,3,0,0,0,1.36-1.39l-1,1.54Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M315,301.81a1,1,0,0,1,.54.88l-.16-1Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M317.39,299.45a6.61,6.61,0,0,1-2.15,0,3.09,3.09,0,0,1-1.56.11s1.15-.11,1.56.28A9,9,0,0,1,317.39,299.45Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M102.5,231.29l2.7,1.67a.86.86,0,0,0,.82.06l6.49-2.9a.88.88,0,0,0,.22-1.47h0a.86.86,0,0,0-.69-.2l-9.19,1.22A.88.88,0,0,0,102.5,231.29Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="107.29 224.57 103.64 225.35 100.41 227.83 105.81 229.99 112.43 227.28 107.29 224.57"
              fill="#ffedc8"
            />
            <polygon
              points="100.41 227.83 100.41 229.99 105.6 232.21 112.57 229.38 112.43 227.28 105.81 229.99 100.41 227.83"
              fill="#ccae79"
            />
            <polygon
              points="105.81 229.99 105.6 232.21 112.57 229.38 112.43 227.28 105.81 229.99"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M102,228.45a1,1,0,0,1,0,1.11c.24-.35.3-1,.41-.95Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M104.23,229.36A3.08,3.08,0,0,0,105.6,228l-1,1.54Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M108.55,228.87a1,1,0,0,1,.53.88l-.16-1Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M111,226.51a6.56,6.56,0,0,1-2.14,0,3.12,3.12,0,0,1-1.57.11s1.15-.11,1.57.28A9.49,9.49,0,0,1,111,226.51Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M55.91,217.91l4,2.49a1.27,1.27,0,0,0,1.21.08l9.61-4.3a1.3,1.3,0,0,0,.33-2.17h0a1.33,1.33,0,0,0-1-.3l-13.61,1.81A1.3,1.3,0,0,0,55.91,217.91Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="63.02 207.97 57.6 209.12 52.83 212.79 60.83 216 70.62 211.98 63.02 207.97"
              fill="#ffedc8"
            />
            <polygon
              points="52.83 212.79 52.83 216 60.5 219.29 70.83 215.09 70.62 211.98 60.83 216 52.83 212.79"
              fill="#ccae79"
            />
            <polygon
              points="60.83 216 60.5 219.29 70.83 215.09 70.62 211.98 60.83 216"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M55.11,213.7a1.45,1.45,0,0,1,0,1.65c.36-.52.44-1.47.61-1.4Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M58.48,215.06a4.56,4.56,0,0,0,2-2.05l-1.45,2.27Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M64.87,214.34a1.48,1.48,0,0,1,.8,1.3l-.24-1.53Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M68.45,210.84a9.65,9.65,0,0,1-3.18,0A4.65,4.65,0,0,1,63,211s1.7-.16,2.32.42A13.87,13.87,0,0,1,68.45,210.84Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
      </g>
      <g>
        <g>
          <g>
            <g>
              <path
                d="M281.43,132.13c4.43-.25-4.33.46-4.35-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71S282,133,282,133s-.92,3.34-3,2.55-2.25-2.28-2.08-2.37A14.65,14.65,0,0,1,281.43,132.13Z"
                fill="#2f6840"
              />
              <path
                d="M280.93,131.79c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.24.27,2.24,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,280.93,131.79Z"
                fill="#3ba525"
              />
              <path
                d="M281.68,131.76a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,281.68,131.76Z"
                fill="#2f6840"
              />
              <path
                d="M285.16,131c-.26,0-.5,0-.73.09a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.38,2.38,0,0,1,1.24-.86A2.07,2.07,0,0,1,285.16,131Z"
                fill="#2f6840"
              />
              <path
                d="M283.79,134.18a1.94,1.94,0,0,0-.66-1c-.28-.29-.64-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A.92.92,0,0,1,283.79,134.18Z"
                fill="#2f6840"
              />
              <path
                d="M281.83,132.22c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,9.24,9.24,0,0,0-1.25.64,2.24,2.24,0,0,1,1.11-1A2,2,0,0,1,281.83,132.22Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M278.77,140.86c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,278.77,140.86Z"
                fill="#2f6840"
              />
              <path
                d="M278.27,140.52c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15S286,141.1,285,141s-4.7,0-4.7,0,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.54-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,278.27,140.52Z"
                fill="#3ba525"
              />
              <path
                d="M279,140.49a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.26,2.26,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,279,140.49Z"
                fill="#2f6840"
              />
              <path
                d="M282.5,139.69c-.26,0-.49.05-.73.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.38,2.38,0,0,1,1.24-.86A2.12,2.12,0,0,1,282.5,139.69Z"
                fill="#2f6840"
              />
              <path
                d="M281.13,142.9a2,2,0,0,0-.66-1c-.28-.28-.64-.5-1-.8a2.13,2.13,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A.89.89,0,0,1,281.13,142.9Z"
                fill="#2f6840"
              />
              <path
                d="M279.17,141c-.24.06-.47.09-.7.16a2.87,2.87,0,0,0-.64.23,9.24,9.24,0,0,0-1.25.64,2.24,2.24,0,0,1,1.11-1A2,2,0,0,1,279.17,141Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M273.42,135.9c4.43-.25-4.33.46-4.35-.61s4.35-2.62,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.37A15,15,0,0,1,273.42,135.9Z"
                fill="#2f6840"
              />
              <path
                d="M272.91,135.56c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,272.91,135.56Z"
                fill="#3ba525"
              />
              <path
                d="M273.67,135.53a2.09,2.09,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.88,1.88,0,0,1,.48.53A1,1,0,0,1,273.67,135.53Z"
                fill="#2f6840"
              />
              <path
                d="M277.14,134.74c-.25,0-.49,0-.72.09a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.39,2.39,0,0,1,1.23-.86A2.07,2.07,0,0,1,277.14,134.74Z"
                fill="#2f6840"
              />
              <path
                d="M275.78,138a1.94,1.94,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.16,2.16,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A1,1,0,0,1,275.78,138Z"
                fill="#2f6840"
              />
              <path
                d="M273.82,136c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,9.24,9.24,0,0,0-1.25.64,2.2,2.2,0,0,1,1.11-1A2,2,0,0,1,273.82,136Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M265.08,132.53c4.42-.25-4.33.46-4.35-.61s4.34-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,265.08,132.53Z"
                fill="#2f6840"
              />
              <path
                d="M264.57,132.19c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.92-2.15,3.63,3.56,2.65,3.44-4.69.05-4.69.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.92,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,264.57,132.19Z"
                fill="#3ba525"
              />
              <path
                d="M265.32,132.16a2.15,2.15,0,0,0-.79-.94c-.33-.26-.71-.45-1.07-.73a2.21,2.21,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A.93.93,0,0,1,265.32,132.16Z"
                fill="#2f6840"
              />
              <path
                d="M268.8,131.37c-.25,0-.49,0-.72.09a4,4,0,0,0-.68.18,12,12,0,0,0-1.35.52,2.46,2.46,0,0,1,1.24-.86A2.07,2.07,0,0,1,268.8,131.37Z"
                fill="#2f6840"
              />
              <path
                d="M267.43,134.58a1.93,1.93,0,0,0-.65-1c-.29-.28-.64-.5-1-.8a2.16,2.16,0,0,1,1.21.54,1.78,1.78,0,0,1,.4.57A1,1,0,0,1,267.43,134.58Z"
                fill="#2f6840"
              />
              <path
                d="M265.48,132.62c-.25.06-.48.09-.7.16a3.15,3.15,0,0,0-.65.23,9.87,9.87,0,0,0-1.25.64,2.27,2.27,0,0,1,1.12-1A2,2,0,0,1,265.48,132.62Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M279.78,148c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.92,3.34-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,279.78,148Z"
                fill="#2f6840"
              />
              <path
                d="M279.28,147.68c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.54-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,279.28,147.68Z"
                fill="#3ba525"
              />
              <path
                d="M280,147.65a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.26,2.26,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,280,147.65Z"
                fill="#2f6840"
              />
              <path
                d="M283.51,146.85c-.26,0-.5.05-.73.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.38,2.38,0,0,1,1.24-.86A2.12,2.12,0,0,1,283.51,146.85Z"
                fill="#2f6840"
              />
              <path
                d="M282.14,150.06a2,2,0,0,0-.66-1c-.28-.28-.64-.5-1-.8a2.13,2.13,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A.89.89,0,0,1,282.14,150.06Z"
                fill="#2f6840"
              />
              <path
                d="M280.18,148.11c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,9.24,9.24,0,0,0-1.25.64,2.24,2.24,0,0,1,1.11-1A2,2,0,0,1,280.18,148.11Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M266.33,142.45c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,266.33,142.45Z"
                fill="#2f6840"
              />
              <path
                d="M265.82,142.11c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.69,0-4.69,0,6,.86,4,1.54-3.31,2-4.36,1.72-1.17-2.9-1.17-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,265.82,142.11Z"
                fill="#3ba525"
              />
              <path
                d="M266.57,142.08a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.06-.73a2.34,2.34,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,266.57,142.08Z"
                fill="#2f6840"
              />
              <path
                d="M270.05,141.29c-.26,0-.49,0-.72.09a4,4,0,0,0-.68.18,11.31,11.31,0,0,0-1.35.52,2.42,2.42,0,0,1,1.24-.86A2.07,2.07,0,0,1,270.05,141.29Z"
                fill="#2f6840"
              />
              <path
                d="M268.68,144.5a1.88,1.88,0,0,0-.66-1c-.28-.28-.63-.5-1-.8a2.18,2.18,0,0,1,1.22.54,1.78,1.78,0,0,1,.4.57A1,1,0,0,1,268.68,144.5Z"
                fill="#2f6840"
              />
              <path
                d="M266.72,142.54c-.24.06-.47.09-.69.16a3.15,3.15,0,0,0-.65.23,9.87,9.87,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,266.72,142.54Z"
                fill="#2f6840"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M253.06,129.68c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.24.27,2.24,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,253.06,129.68Z"
                fill="#2f6840"
              />
              <path
                d="M252.55,129.34c4.43-.26-4.33.45-4.35-.62s4.35-2.62,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.34,14.34,0,0,1,252.55,129.34Z"
                fill="#3ba525"
              />
              <path
                d="M253.3,129.31a2.11,2.11,0,0,0-.8-.94c-.32-.27-.7-.46-1.06-.74a2.34,2.34,0,0,1,1.28.45,2,2,0,0,1,.47.53A1,1,0,0,1,253.3,129.31Z"
                fill="#2f6840"
              />
              <path
                d="M256.78,128.51c-.26,0-.49.05-.72.1a5.2,5.2,0,0,0-.68.17,13.44,13.44,0,0,0-1.35.53,2.5,2.5,0,0,1,1.24-.87A2.12,2.12,0,0,1,256.78,128.51Z"
                fill="#2f6840"
              />
              <path
                d="M255.41,131.72a1.86,1.86,0,0,0-.66-1c-.28-.29-.63-.5-1-.81a2.2,2.2,0,0,1,1.22.55,1.68,1.68,0,0,1,.4.57A.94.94,0,0,1,255.41,131.72Z"
                fill="#2f6840"
              />
              <path
                d="M253.45,129.77a7,7,0,0,0-.69.15,5,5,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.31,2.31,0,0,1,1.11-1A2,2,0,0,1,253.45,129.77Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M250.4,138.41c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.54-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,250.4,138.41Z"
                fill="#2f6840"
              />
              <path
                d="M249.89,138.06c4.43-.25-4.33.46-4.35-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.23-2.78,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A15,15,0,0,1,249.89,138.06Z"
                fill="#3ba525"
              />
              <path
                d="M250.64,138a2.1,2.1,0,0,0-.79-.94c-.33-.27-.71-.46-1.07-.74a2.34,2.34,0,0,1,1.28.45,1.83,1.83,0,0,1,.47.53A1,1,0,0,1,250.64,138Z"
                fill="#2f6840"
              />
              <path
                d="M254.12,137.24c-.25,0-.49,0-.72.1a4,4,0,0,0-.68.17,13.44,13.44,0,0,0-1.35.53,2.5,2.5,0,0,1,1.24-.87A2.07,2.07,0,0,1,254.12,137.24Z"
                fill="#2f6840"
              />
              <path
                d="M252.75,140.45a1.86,1.86,0,0,0-.66-1c-.28-.29-.63-.5-1-.81a2.1,2.1,0,0,1,1.22.55,1.68,1.68,0,0,1,.4.57A.94.94,0,0,1,252.75,140.45Z"
                fill="#2f6840"
              />
              <path
                d="M250.8,138.5a6.61,6.61,0,0,0-.7.15,5,5,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2,2,0,0,1,250.8,138.5Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M245,133.45c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,245,133.45Z"
                fill="#2f6840"
              />
              <path
                d="M244.54,133.11c4.42-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,244.54,133.11Z"
                fill="#3ba525"
              />
              <path
                d="M245.29,133.08a2.11,2.11,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,2,2,0,0,1,.47.54A1,1,0,0,1,245.29,133.08Z"
                fill="#2f6840"
              />
              <path
                d="M248.77,132.28c-.26,0-.49.05-.73.1a4.69,4.69,0,0,0-.67.17,13.44,13.44,0,0,0-1.35.53,2.5,2.5,0,0,1,1.24-.87A2.12,2.12,0,0,1,248.77,132.28Z"
                fill="#2f6840"
              />
              <path
                d="M247.4,135.49a1.92,1.92,0,0,0-.66-1c-.28-.29-.64-.5-1-.81a2.14,2.14,0,0,1,1.21.55,1.7,1.7,0,0,1,.41.57A.94.94,0,0,1,247.4,135.49Z"
                fill="#2f6840"
              />
              <path
                d="M245.44,133.54c-.24.06-.47.08-.7.16a3.45,3.45,0,0,0-.64.22,10,10,0,0,0-1.25.65,2.31,2.31,0,0,1,1.11-1A2,2,0,0,1,245.44,133.54Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M236.7,130.08c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.92-2.15,3.63,3.56,2.65,3.44-4.69,0-4.69,0,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.92,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,236.7,130.08Z"
                fill="#2f6840"
              />
              <path
                d="M236.2,129.73c4.42-.25-4.33.46-4.36-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.87,14.87,0,0,1,236.2,129.73Z"
                fill="#3ba525"
              />
              <path
                d="M237,129.71a2.12,2.12,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,2.38,2.38,0,0,1,.47.53A1,1,0,0,1,237,129.71Z"
                fill="#2f6840"
              />
              <path
                d="M240.43,128.91c-.26,0-.5,0-.73.1a5.2,5.2,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.45,2.45,0,0,1,1.24-.87A2.07,2.07,0,0,1,240.43,128.91Z"
                fill="#2f6840"
              />
              <path
                d="M239.06,132.12a2,2,0,0,0-.66-1c-.29-.29-.64-.5-1-.81a2.08,2.08,0,0,1,1.21.55,1.55,1.55,0,0,1,.4.57A.89.89,0,0,1,239.06,132.12Z"
                fill="#2f6840"
              />
              <path
                d="M237.1,130.17a6.61,6.61,0,0,0-.7.15,4.41,4.41,0,0,0-.64.23,9.33,9.33,0,0,0-1.25.65,2.22,2.22,0,0,1,1.11-1A2,2,0,0,1,237.1,130.17Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M251.41,145.57c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.54-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,251.41,145.57Z"
                fill="#2f6840"
              />
              <path
                d="M250.9,145.22c4.43-.25-4.33.46-4.35-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.23-2.78,2.92-2.16,3.62,3.56,2.65,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,250.9,145.22Z"
                fill="#3ba525"
              />
              <path
                d="M251.65,145.2a2.1,2.1,0,0,0-.79-.94c-.33-.27-.71-.46-1.07-.74a2.34,2.34,0,0,1,1.28.45,1.83,1.83,0,0,1,.47.53A1,1,0,0,1,251.65,145.2Z"
                fill="#2f6840"
              />
              <path
                d="M255.13,144.4c-.25,0-.49,0-.72.1a4,4,0,0,0-.68.17,13.44,13.44,0,0,0-1.35.53,2.5,2.5,0,0,1,1.24-.87A2.07,2.07,0,0,1,255.13,144.4Z"
                fill="#2f6840"
              />
              <path
                d="M253.76,147.61a1.86,1.86,0,0,0-.66-1c-.28-.29-.63-.5-1-.81a2.1,2.1,0,0,1,1.22.55,1.68,1.68,0,0,1,.4.57A.94.94,0,0,1,253.76,147.61Z"
                fill="#2f6840"
              />
              <path
                d="M251.81,145.65c-.25.06-.48.09-.7.16a5,5,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2.07,2.07,0,0,1,251.81,145.65Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M238,140c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,238,140Z"
                fill="#2f6840"
              />
              <path
                d="M237.44,139.65c4.43-.25-4.32.46-4.35-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.28-2.07-2.37A14.86,14.86,0,0,1,237.44,139.65Z"
                fill="#3ba525"
              />
              <path
                d="M238.2,139.63a2.12,2.12,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,2,2,0,0,1,.47.53A1,1,0,0,1,238.2,139.63Z"
                fill="#2f6840"
              />
              <path
                d="M241.67,138.83c-.25,0-.49,0-.72.1a5.2,5.2,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.47,2.47,0,0,1,1.23-.87A2.07,2.07,0,0,1,241.67,138.83Z"
                fill="#2f6840"
              />
              <path
                d="M240.31,142a2,2,0,0,0-.66-1c-.29-.29-.64-.5-1-.81a2.1,2.1,0,0,1,1.21.55,1.55,1.55,0,0,1,.4.57A.94.94,0,0,1,240.31,142Z"
                fill="#2f6840"
              />
              <path
                d="M238.35,140.09a6.61,6.61,0,0,0-.7.15,4.41,4.41,0,0,0-.64.23,10.08,10.08,0,0,0-1.26.65,2.24,2.24,0,0,1,1.12-1A2,2,0,0,1,238.35,140.09Z"
                fill="#2f6840"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M224.58,128.59c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.92-2.16,3.63,3.56,2.65,3.44-4.69.05-4.69.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.92,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,224.58,128.59Z"
                fill="#2f6840"
              />
              <path
                d="M224.08,128.25c4.42-.25-4.33.45-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,224.08,128.25Z"
                fill="#3ba525"
              />
              <path
                d="M224.83,128.22a2.17,2.17,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,2,2,0,0,1,.47.54A1,1,0,0,1,224.83,128.22Z"
                fill="#2f6840"
              />
              <path
                d="M228.31,127.42c-.26,0-.5,0-.73.1a5.2,5.2,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.45,2.45,0,0,1,1.24-.87A2.13,2.13,0,0,1,228.31,127.42Z"
                fill="#2f6840"
              />
              <path
                d="M226.94,130.63a2,2,0,0,0-.66-1c-.28-.29-.64-.5-1-.81a2.14,2.14,0,0,1,1.21.55,1.55,1.55,0,0,1,.4.57A.89.89,0,0,1,226.94,130.63Z"
                fill="#2f6840"
              />
              <path
                d="M225,128.68c-.25.06-.48.08-.7.15a4.41,4.41,0,0,0-.64.23,9.33,9.33,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2,2,0,0,1,225,128.68Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M221.92,137.32c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.56,2.64,3.44-4.69.05-4.69.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,221.92,137.32Z"
                fill="#2f6840"
              />
              <path
                d="M221.42,137c4.42-.25-4.33.46-4.36-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.87,14.87,0,0,1,221.42,137Z"
                fill="#3ba525"
              />
              <path
                d="M222.17,137a2.06,2.06,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,2.16,2.16,0,0,1,.47.53A1,1,0,0,1,222.17,137Z"
                fill="#2f6840"
              />
              <path
                d="M225.65,136.15c-.26,0-.49,0-.73.1a5.2,5.2,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.45,2.45,0,0,1,1.24-.87A2.07,2.07,0,0,1,225.65,136.15Z"
                fill="#2f6840"
              />
              <path
                d="M224.28,139.36a1.92,1.92,0,0,0-.66-1c-.28-.29-.64-.5-1-.81a2.08,2.08,0,0,1,1.21.55,1.55,1.55,0,0,1,.4.57A.89.89,0,0,1,224.28,139.36Z"
                fill="#2f6840"
              />
              <path
                d="M222.32,137.41c-.24.05-.47.08-.7.15a4.41,4.41,0,0,0-.64.23,9.33,9.33,0,0,0-1.25.65,2.22,2.22,0,0,1,1.11-1A2,2,0,0,1,222.32,137.41Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M216.57,132.36c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.69,0-4.69,0,6,.86,4,1.54-3.31,2-4.36,1.72-1.17-2.9-1.17-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,216.57,132.36Z"
                fill="#2f6840"
              />
              <path
                d="M216.06,132c4.43-.25-4.32.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,216.06,132Z"
                fill="#3ba525"
              />
              <path
                d="M216.82,132a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.46-1.07-.74a2.22,2.22,0,0,1,1.28.46,1.88,1.88,0,0,1,.48.53A1,1,0,0,1,216.82,132Z"
                fill="#2f6840"
              />
              <path
                d="M220.29,131.19c-.25,0-.49.05-.72.1a5.2,5.2,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.47,2.47,0,0,1,1.23-.87A2.12,2.12,0,0,1,220.29,131.19Z"
                fill="#2f6840"
              />
              <path
                d="M218.93,134.4a2,2,0,0,0-.66-1c-.29-.29-.64-.5-1-.81a2.24,2.24,0,0,1,1.21.55,1.64,1.64,0,0,1,.4.57A.94.94,0,0,1,218.93,134.4Z"
                fill="#2f6840"
              />
              <path
                d="M217,132.45a6.56,6.56,0,0,0-.7.16,3.45,3.45,0,0,0-.64.22,9.33,9.33,0,0,0-1.25.65,2.22,2.22,0,0,1,1.11-1A2,2,0,0,1,217,132.45Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M208.23,129c4.42-.25-4.33.46-4.35-.61s4.34-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,208.23,129Z"
                fill="#2f6840"
              />
              <path
                d="M207.72,128.64c4.43-.25-4.33.46-4.35-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.92,3.34-3,2.55-2.26-2.27-2.08-2.37A15,15,0,0,1,207.72,128.64Z"
                fill="#3ba525"
              />
              <path
                d="M208.47,128.62a2.1,2.1,0,0,0-.79-.94c-.33-.27-.71-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,2,2,0,0,1,.47.53A1,1,0,0,1,208.47,128.62Z"
                fill="#2f6840"
              />
              <path
                d="M212,127.82c-.25,0-.49.05-.72.1a5.2,5.2,0,0,0-.68.17,14.45,14.45,0,0,0-1.35.53,2.54,2.54,0,0,1,1.24-.87A2.12,2.12,0,0,1,212,127.82Z"
                fill="#2f6840"
              />
              <path
                d="M210.58,131a1.9,1.9,0,0,0-.65-1c-.29-.29-.64-.5-1-.81a2.17,2.17,0,0,1,1.21.55,1.68,1.68,0,0,1,.4.57A.94.94,0,0,1,210.58,131Z"
                fill="#2f6840"
              />
              <path
                d="M208.63,129.08a6.61,6.61,0,0,0-.7.15,5,5,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.24,2.24,0,0,1,1.12-1A2,2,0,0,1,208.63,129.08Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M222.93,144.48c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.56,2.64,3.44S225,145,225,145s6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.92,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,222.93,144.48Z"
                fill="#2f6840"
              />
              <path
                d="M222.43,144.13c4.42-.25-4.33.46-4.36-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71S223,145,223,145s-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.87,14.87,0,0,1,222.43,144.13Z"
                fill="#3ba525"
              />
              <path
                d="M223.18,144.11a2.06,2.06,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,2.16,2.16,0,0,1,.47.53A1,1,0,0,1,223.18,144.11Z"
                fill="#2f6840"
              />
              <path
                d="M226.66,143.31c-.26,0-.5,0-.73.1a5.2,5.2,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.45,2.45,0,0,1,1.24-.87A2.07,2.07,0,0,1,226.66,143.31Z"
                fill="#2f6840"
              />
              <path
                d="M225.29,146.52a1.92,1.92,0,0,0-.66-1c-.28-.29-.64-.5-1-.81a2.08,2.08,0,0,1,1.21.55,1.55,1.55,0,0,1,.4.57A.89.89,0,0,1,225.29,146.52Z"
                fill="#2f6840"
              />
              <path
                d="M223.33,144.57a6.61,6.61,0,0,0-.7.15,4.41,4.41,0,0,0-.64.23,9.33,9.33,0,0,0-1.25.65,2.22,2.22,0,0,1,1.11-1A2,2,0,0,1,223.33,144.57Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M209.48,138.91c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,209.48,138.91Z"
                fill="#2f6840"
              />
              <path
                d="M209,138.56c4.43-.25-4.33.46-4.35-.61s4.35-2.62,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.37A15,15,0,0,1,209,138.56Z"
                fill="#3ba525"
              />
              <path
                d="M209.72,138.54a2.06,2.06,0,0,0-.8-.94c-.32-.27-.7-.46-1.06-.74a2.34,2.34,0,0,1,1.28.45,2.16,2.16,0,0,1,.47.53A1,1,0,0,1,209.72,138.54Z"
                fill="#2f6840"
              />
              <path
                d="M213.2,137.74c-.26,0-.49,0-.72.1a5.2,5.2,0,0,0-.68.17,13.44,13.44,0,0,0-1.35.53,2.5,2.5,0,0,1,1.24-.87A2.12,2.12,0,0,1,213.2,137.74Z"
                fill="#2f6840"
              />
              <path
                d="M211.83,141a1.86,1.86,0,0,0-.66-1c-.28-.29-.63-.5-1-.81a2.2,2.2,0,0,1,1.22.55,1.68,1.68,0,0,1,.4.57A.94.94,0,0,1,211.83,141Z"
                fill="#2f6840"
              />
              <path
                d="M209.87,139a7,7,0,0,0-.69.15,5,5,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2,2,0,0,1,209.87,139Z"
                fill="#2f6840"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M196.18,130.39c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.23-2.78,2.92-2.16,3.62,3.56,2.65,3.44-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,196.18,130.39Z"
                fill="#2f6840"
              />
              <path
                d="M195.67,130.05c4.43-.25-4.32.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.36,1.72-1.16-2.91-1.16-2.91-.91,3.34-3,2.55-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,195.67,130.05Z"
                fill="#3ba525"
              />
              <path
                d="M196.43,130a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.21,2.21,0,0,1,1.28.45,1.88,1.88,0,0,1,.48.53A1,1,0,0,1,196.43,130Z"
                fill="#2f6840"
              />
              <path
                d="M199.91,129.22c-.26,0-.5.05-.73.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.47,2.47,0,0,1,1.23-.87A2.15,2.15,0,0,1,199.91,129.22Z"
                fill="#2f6840"
              />
              <path
                d="M198.54,132.43a2,2,0,0,0-.66-1c-.29-.28-.64-.5-1-.81a2.24,2.24,0,0,1,1.21.55,1.64,1.64,0,0,1,.4.57A.94.94,0,0,1,198.54,132.43Z"
                fill="#2f6840"
              />
              <path
                d="M196.58,130.48c-.25.06-.48.09-.7.16a3.45,3.45,0,0,0-.64.22,9.33,9.33,0,0,0-1.25.65,2.27,2.27,0,0,1,1.11-1A2,2,0,0,1,196.58,130.48Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M193.52,139.12c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.23-2.78,2.92-2.16,3.63,3.56,2.65,3.44-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,193.52,139.12Z"
                fill="#2f6840"
              />
              <path
                d="M193,138.78c4.42-.25-4.33.45-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,193,138.78Z"
                fill="#3ba525"
              />
              <path
                d="M193.77,138.75a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.46-1.07-.74a2.22,2.22,0,0,1,1.28.46,1.88,1.88,0,0,1,.48.53A1,1,0,0,1,193.77,138.75Z"
                fill="#2f6840"
              />
              <path
                d="M197.25,138c-.26,0-.5.05-.73.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.45,2.45,0,0,1,1.24-.87A2.13,2.13,0,0,1,197.25,138Z"
                fill="#2f6840"
              />
              <path
                d="M195.88,141.16a2,2,0,0,0-.66-1c-.29-.29-.64-.5-1-.81a2.21,2.21,0,0,1,1.21.55,1.64,1.64,0,0,1,.4.57A.89.89,0,0,1,195.88,141.16Z"
                fill="#2f6840"
              />
              <path
                d="M193.92,139.21a6.56,6.56,0,0,0-.7.16,3.45,3.45,0,0,0-.64.22,9.33,9.33,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2,2,0,0,1,193.92,139.21Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M188.17,134.16c4.42-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,188.17,134.16Z"
                fill="#2f6840"
              />
              <path
                d="M187.66,133.82c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.64,3.44-4.69.05-4.69.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.54-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,187.66,133.82Z"
                fill="#3ba525"
              />
              <path
                d="M188.42,133.79a2.24,2.24,0,0,0-.8-.94c-.32-.26-.71-.45-1.07-.73a2.21,2.21,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,188.42,133.79Z"
                fill="#2f6840"
              />
              <path
                d="M191.89,133c-.25,0-.49,0-.72.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.39,2.39,0,0,1,1.23-.86A2.12,2.12,0,0,1,191.89,133Z"
                fill="#2f6840"
              />
              <path
                d="M190.53,136.2a2,2,0,0,0-.66-1c-.29-.28-.64-.5-1-.8a2.16,2.16,0,0,1,1.21.54,1.78,1.78,0,0,1,.4.57A1,1,0,0,1,190.53,136.2Z"
                fill="#2f6840"
              />
              <path
                d="M188.57,134.25c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,9.34,9.34,0,0,0-1.26.64,2.27,2.27,0,0,1,1.12-1A2,2,0,0,1,188.57,134.25Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M179.83,130.79c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45S181,130,181,130s1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,179.83,130.79Z"
                fill="#2f6840"
              />
              <path
                d="M179.32,130.45c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,179.32,130.45Z"
                fill="#3ba525"
              />
              <path
                d="M180.07,130.42a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.46-1.06-.74a2.27,2.27,0,0,1,1.28.46,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,180.07,130.42Z"
                fill="#2f6840"
              />
              <path
                d="M183.55,129.62c-.26,0-.49,0-.72.1a4,4,0,0,0-.68.18,11.31,11.31,0,0,0-1.35.52,2.5,2.5,0,0,1,1.24-.87A2.12,2.12,0,0,1,183.55,129.62Z"
                fill="#2f6840"
              />
              <path
                d="M182.18,132.83a1.9,1.9,0,0,0-.66-1c-.28-.29-.63-.5-1-.81a2.27,2.27,0,0,1,1.22.55,1.78,1.78,0,0,1,.4.57A.94.94,0,0,1,182.18,132.83Z"
                fill="#2f6840"
              />
              <path
                d="M180.22,130.88c-.24.06-.47.09-.69.16a3.83,3.83,0,0,0-.65.22,10,10,0,0,0-1.25.65,2.36,2.36,0,0,1,1.11-1A2,2,0,0,1,180.22,130.88Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M194.53,146.28c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.23-2.78,2.92-2.16,3.63,3.56,2.65,3.44-4.69.05-4.69.05,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,194.53,146.28Z"
                fill="#2f6840"
              />
              <path
                d="M194,145.94c4.42-.25-4.33.45-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,194,145.94Z"
                fill="#3ba525"
              />
              <path
                d="M194.78,145.91a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.46-1.07-.74a2.22,2.22,0,0,1,1.28.46,1.88,1.88,0,0,1,.48.53A1,1,0,0,1,194.78,145.91Z"
                fill="#2f6840"
              />
              <path
                d="M198.26,145.11c-.26,0-.5,0-.73.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.47,2.47,0,0,1,1.23-.87A2.15,2.15,0,0,1,198.26,145.11Z"
                fill="#2f6840"
              />
              <path
                d="M196.89,148.32a2,2,0,0,0-.66-1c-.29-.29-.64-.5-1-.81a2.21,2.21,0,0,1,1.21.55,1.64,1.64,0,0,1,.4.57A.89.89,0,0,1,196.89,148.32Z"
                fill="#2f6840"
              />
              <path
                d="M194.93,146.37a6.56,6.56,0,0,0-.7.16,3.45,3.45,0,0,0-.64.22,9.33,9.33,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2,2,0,0,1,194.93,146.37Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M181.07,140.71c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,181.07,140.71Z"
                fill="#2f6840"
              />
              <path
                d="M180.57,140.37c4.42-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,180.57,140.37Z"
                fill="#3ba525"
              />
              <path
                d="M181.32,140.34a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.29.46,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,181.32,140.34Z"
                fill="#2f6840"
              />
              <path
                d="M184.8,139.54c-.26,0-.49.05-.73.1a3.67,3.67,0,0,0-.67.18,11.31,11.31,0,0,0-1.35.52,2.5,2.5,0,0,1,1.24-.87A2.12,2.12,0,0,1,184.8,139.54Z"
                fill="#2f6840"
              />
              <path
                d="M183.43,142.75a2,2,0,0,0-.66-1c-.28-.29-.64-.5-1-.81a2.21,2.21,0,0,1,1.21.55,1.81,1.81,0,0,1,.41.57A.94.94,0,0,1,183.43,142.75Z"
                fill="#2f6840"
              />
              <path
                d="M181.47,140.8c-.24.06-.47.09-.7.16a3.45,3.45,0,0,0-.64.22,10,10,0,0,0-1.25.65,2.36,2.36,0,0,1,1.11-1A2,2,0,0,1,181.47,140.8Z"
                fill="#2f6840"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M168.15,134.78c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,168.15,134.78Z"
                fill="#2f6840"
              />
              <path
                d="M167.64,134.44c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,167.64,134.44Z"
                fill="#3ba525"
              />
              <path
                d="M168.39,134.41a2.11,2.11,0,0,0-.8-.94c-.32-.27-.7-.46-1.06-.74a2.34,2.34,0,0,1,1.28.45,1.87,1.87,0,0,1,.47.54A1,1,0,0,1,168.39,134.41Z"
                fill="#2f6840"
              />
              <path
                d="M171.87,133.61c-.26,0-.49,0-.72.1a5.2,5.2,0,0,0-.68.17,13.44,13.44,0,0,0-1.35.53,2.5,2.5,0,0,1,1.24-.87A2.12,2.12,0,0,1,171.87,133.61Z"
                fill="#2f6840"
              />
              <path
                d="M170.5,136.82a1.86,1.86,0,0,0-.66-1c-.28-.29-.63-.5-1-.81a2.2,2.2,0,0,1,1.22.55,1.68,1.68,0,0,1,.4.57A.94.94,0,0,1,170.5,136.82Z"
                fill="#2f6840"
              />
              <path
                d="M168.54,134.87a7,7,0,0,0-.69.16,3.83,3.83,0,0,0-.65.22,10,10,0,0,0-1.25.65,2.31,2.31,0,0,1,1.11-1A2,2,0,0,1,168.54,134.87Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M165.49,143.51c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,165.49,143.51Z"
                fill="#2f6840"
              />
              <path
                d="M165,143.16c4.43-.25-4.33.46-4.35-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.23-2.78,2.92-2.16,3.62,3.56,2.65,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.37A15,15,0,0,1,165,143.16Z"
                fill="#3ba525"
              />
              <path
                d="M165.73,143.14a2.1,2.1,0,0,0-.79-.94c-.33-.27-.71-.46-1.07-.74a2.34,2.34,0,0,1,1.28.45,2,2,0,0,1,.47.53A1,1,0,0,1,165.73,143.14Z"
                fill="#2f6840"
              />
              <path
                d="M169.21,142.34c-.25,0-.49,0-.72.1a5.2,5.2,0,0,0-.68.17,13.44,13.44,0,0,0-1.35.53,2.5,2.5,0,0,1,1.24-.87A2.12,2.12,0,0,1,169.21,142.34Z"
                fill="#2f6840"
              />
              <path
                d="M167.84,145.55a1.86,1.86,0,0,0-.66-1c-.28-.29-.63-.5-1-.81a2.17,2.17,0,0,1,1.22.55,1.68,1.68,0,0,1,.4.57A.94.94,0,0,1,167.84,145.55Z"
                fill="#2f6840"
              />
              <path
                d="M165.89,143.6a6.61,6.61,0,0,0-.7.15,5,5,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2,2,0,0,1,165.89,143.6Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M160.13,138.55c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,160.13,138.55Z"
                fill="#2f6840"
              />
              <path
                d="M159.63,138.21c4.42-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,159.63,138.21Z"
                fill="#3ba525"
              />
              <path
                d="M160.38,138.18a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.29.46,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,160.38,138.18Z"
                fill="#2f6840"
              />
              <path
                d="M163.86,137.38c-.26,0-.49.05-.73.1a3.67,3.67,0,0,0-.67.18,11.31,11.31,0,0,0-1.35.52,2.5,2.5,0,0,1,1.24-.87A2.12,2.12,0,0,1,163.86,137.38Z"
                fill="#2f6840"
              />
              <path
                d="M162.49,140.59a2,2,0,0,0-.66-1c-.28-.29-.64-.5-1-.81a2.21,2.21,0,0,1,1.21.55,1.81,1.81,0,0,1,.41.57A.94.94,0,0,1,162.49,140.59Z"
                fill="#2f6840"
              />
              <path
                d="M160.53,138.64c-.24.06-.47.09-.7.16a3.45,3.45,0,0,0-.64.22,10,10,0,0,0-1.25.65,2.31,2.31,0,0,1,1.11-1A2,2,0,0,1,160.53,138.64Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M151.79,135.18c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.24.27,2.24,1.24-2.77,2.92-2.15,3.63,3.56,2.65,3.44-4.69,0-4.69,0,6,.86,4,1.54-3.31,2-4.36,1.72-1.17-2.9-1.17-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,151.79,135.18Z"
                fill="#2f6840"
              />
              <path
                d="M151.29,134.84c4.42-.26-4.33.45-4.36-.62s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.25,14.25,0,0,1,151.29,134.84Z"
                fill="#3ba525"
              />
              <path
                d="M152,134.81a2.17,2.17,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,2.2,2.2,0,0,1,.48.53A1,1,0,0,1,152,134.81Z"
                fill="#2f6840"
              />
              <path
                d="M155.52,134c-.26,0-.5.05-.73.1a5.2,5.2,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.45,2.45,0,0,1,1.24-.87A2.13,2.13,0,0,1,155.52,134Z"
                fill="#2f6840"
              />
              <path
                d="M154.15,137.22a2,2,0,0,0-.66-1c-.29-.29-.64-.5-1-.81a2.14,2.14,0,0,1,1.21.55,1.55,1.55,0,0,1,.4.57A.89.89,0,0,1,154.15,137.22Z"
                fill="#2f6840"
              />
              <path
                d="M152.19,135.27a6.61,6.61,0,0,0-.7.15,4.41,4.41,0,0,0-.64.23,9.33,9.33,0,0,0-1.25.65,2.22,2.22,0,0,1,1.11-1A2,2,0,0,1,152.19,135.27Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M166.5,150.67c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,166.5,150.67Z"
                fill="#2f6840"
              />
              <path
                d="M166,150.32c4.43-.25-4.33.46-4.35-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.23-2.78,2.92-2.16,3.62,3.56,2.65,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.37A15,15,0,0,1,166,150.32Z"
                fill="#3ba525"
              />
              <path
                d="M166.74,150.3a2.1,2.1,0,0,0-.79-.94c-.33-.27-.71-.46-1.07-.74a2.34,2.34,0,0,1,1.28.45,2,2,0,0,1,.47.53A1,1,0,0,1,166.74,150.3Z"
                fill="#2f6840"
              />
              <path
                d="M170.22,149.5c-.25,0-.49.05-.72.1a5.2,5.2,0,0,0-.68.17,13.44,13.44,0,0,0-1.35.53,2.5,2.5,0,0,1,1.24-.87A2.12,2.12,0,0,1,170.22,149.5Z"
                fill="#2f6840"
              />
              <path
                d="M168.85,152.71a1.86,1.86,0,0,0-.66-1c-.28-.29-.63-.5-1-.81a2.1,2.1,0,0,1,1.22.55,1.68,1.68,0,0,1,.4.57A.94.94,0,0,1,168.85,152.71Z"
                fill="#2f6840"
              />
              <path
                d="M166.89,150.76a7,7,0,0,0-.69.15,5,5,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2,2,0,0,1,166.89,150.76Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M153,145.1c4.43-.25-4.33.46-4.35-.61S153,141.86,154,142s.26,2.24.26,2.24,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,153,145.1Z"
                fill="#2f6840"
              />
              <path
                d="M152.53,144.76c4.43-.26-4.32.45-4.35-.62s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.27-2.07-2.36A14.24,14.24,0,0,1,152.53,144.76Z"
                fill="#3ba525"
              />
              <path
                d="M153.29,144.73a2.17,2.17,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,2,2,0,0,1,.47.53A1,1,0,0,1,153.29,144.73Z"
                fill="#2f6840"
              />
              <path
                d="M156.76,143.93c-.25,0-.49,0-.72.1a5.2,5.2,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.47,2.47,0,0,1,1.23-.87A2.12,2.12,0,0,1,156.76,143.93Z"
                fill="#2f6840"
              />
              <path
                d="M155.4,147.14a2,2,0,0,0-.66-1c-.29-.29-.64-.5-1-.81a2.17,2.17,0,0,1,1.21.55,1.55,1.55,0,0,1,.4.57A.94.94,0,0,1,155.4,147.14Z"
                fill="#2f6840"
              />
              <path
                d="M153.44,145.19a6.61,6.61,0,0,0-.7.15,4.41,4.41,0,0,0-.64.23,10.08,10.08,0,0,0-1.26.65,2.24,2.24,0,0,1,1.12-1A2,2,0,0,1,153.44,145.19Z"
                fill="#2f6840"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M140.76,142.64c4.42-.25-4.33.46-4.35-.61s4.34-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,140.76,142.64Z"
                fill="#2f6840"
              />
              <path
                d="M140.25,142.3c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.92-2.15,3.63,3.56,2.65,3.44-4.69,0-4.69,0,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.92,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,140.25,142.3Z"
                fill="#3ba525"
              />
              <path
                d="M141,142.27a2.15,2.15,0,0,0-.79-.94c-.33-.26-.71-.45-1.07-.73a2.28,2.28,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A.93.93,0,0,1,141,142.27Z"
                fill="#2f6840"
              />
              <path
                d="M144.48,141.48c-.25,0-.49,0-.72.09a4,4,0,0,0-.68.18,12,12,0,0,0-1.35.52,2.46,2.46,0,0,1,1.24-.86A2.07,2.07,0,0,1,144.48,141.48Z"
                fill="#2f6840"
              />
              <path
                d="M143.11,144.69a1.86,1.86,0,0,0-.65-1c-.29-.29-.64-.51-1-.81a2.16,2.16,0,0,1,1.21.54,1.78,1.78,0,0,1,.4.57A1,1,0,0,1,143.11,144.69Z"
                fill="#2f6840"
              />
              <path
                d="M141.16,142.73c-.25.06-.48.09-.7.16a3.15,3.15,0,0,0-.65.23,9.87,9.87,0,0,0-1.25.64,2.27,2.27,0,0,1,1.12-1A2,2,0,0,1,141.16,142.73Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M138.1,151.37c4.42-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,138.1,151.37Z"
                fill="#2f6840"
              />
              <path
                d="M137.59,151c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.64,3.44-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.72-1.16-2.91-1.16-2.91-.92,3.34-3,2.55-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,137.59,151Z"
                fill="#3ba525"
              />
              <path
                d="M138.35,151a2.24,2.24,0,0,0-.8-.94c-.33-.26-.71-.45-1.07-.73a2.21,2.21,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,138.35,151Z"
                fill="#2f6840"
              />
              <path
                d="M141.82,150.2c-.25,0-.49.05-.72.1a4,4,0,0,0-.68.18,12.79,12.79,0,0,0-1.35.52,2.46,2.46,0,0,1,1.24-.86A2.12,2.12,0,0,1,141.82,150.2Z"
                fill="#2f6840"
              />
              <path
                d="M140.45,153.41a1.94,1.94,0,0,0-.65-1c-.29-.28-.64-.5-1-.81a2.24,2.24,0,0,1,1.21.55,1.78,1.78,0,0,1,.4.57A.94.94,0,0,1,140.45,153.41Z"
                fill="#2f6840"
              />
              <path
                d="M138.5,151.46c-.25.06-.48.09-.7.16a3.15,3.15,0,0,0-.65.23,8.71,8.71,0,0,0-1.25.64,2.27,2.27,0,0,1,1.12-1A2,2,0,0,1,138.5,151.46Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M132.75,146.41c4.42-.25-4.33.46-4.36-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.87,14.87,0,0,1,132.75,146.41Z"
                fill="#2f6840"
              />
              <path
                d="M132.24,146.07c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.69.05-4.69.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.17-2.9-1.17-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,132.24,146.07Z"
                fill="#3ba525"
              />
              <path
                d="M133,146a2,2,0,0,0-.8-.93c-.32-.27-.7-.46-1.06-.74a2.34,2.34,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,133,146Z"
                fill="#2f6840"
              />
              <path
                d="M136.47,145.25c-.26,0-.49,0-.72.09a4,4,0,0,0-.68.18,11.31,11.31,0,0,0-1.35.52,2.42,2.42,0,0,1,1.24-.86A2.07,2.07,0,0,1,136.47,145.25Z"
                fill="#2f6840"
              />
              <path
                d="M135.1,148.46a1.82,1.82,0,0,0-.66-1c-.28-.29-.63-.51-1-.81a2.18,2.18,0,0,1,1.22.54,1.78,1.78,0,0,1,.4.57A1,1,0,0,1,135.1,148.46Z"
                fill="#2f6840"
              />
              <path
                d="M133.14,146.5c-.24.06-.47.09-.69.16a3.15,3.15,0,0,0-.65.23,9.87,9.87,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,133.14,146.5Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M124.4,143c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,124.4,143Z"
                fill="#2f6840"
              />
              <path
                d="M123.9,142.7c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.54-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,123.9,142.7Z"
                fill="#3ba525"
              />
              <path
                d="M124.65,142.67a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.26,2.26,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,124.65,142.67Z"
                fill="#2f6840"
              />
              <path
                d="M128.13,141.87c-.26,0-.49,0-.73.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.38,2.38,0,0,1,1.24-.86A2.12,2.12,0,0,1,128.13,141.87Z"
                fill="#2f6840"
              />
              <path
                d="M126.76,145.08a2,2,0,0,0-.66-1c-.28-.28-.64-.5-1-.8a2.13,2.13,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A.89.89,0,0,1,126.76,145.08Z"
                fill="#2f6840"
              />
              <path
                d="M124.8,143.13c-.24.06-.47.09-.7.16a2.87,2.87,0,0,0-.64.23,9.24,9.24,0,0,0-1.25.64,2.24,2.24,0,0,1,1.11-1A2,2,0,0,1,124.8,143.13Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M139.11,158.53c4.42-.25-4.33.46-4.35-.61s4.34-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,139.11,158.53Z"
                fill="#2f6840"
              />
              <path
                d="M138.6,158.19c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.64,3.44-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.72-1.16-2.91-1.16-2.91-.92,3.34-3,2.55-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,138.6,158.19Z"
                fill="#3ba525"
              />
              <path
                d="M139.35,158.16a2.15,2.15,0,0,0-.79-.94c-.33-.26-.71-.45-1.07-.73a2.21,2.21,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A.93.93,0,0,1,139.35,158.16Z"
                fill="#2f6840"
              />
              <path
                d="M142.83,157.36c-.25,0-.49,0-.72.1a4,4,0,0,0-.68.18,12.79,12.79,0,0,0-1.35.52,2.46,2.46,0,0,1,1.24-.86A2.07,2.07,0,0,1,142.83,157.36Z"
                fill="#2f6840"
              />
              <path
                d="M141.46,160.57a1.94,1.94,0,0,0-.65-1c-.29-.28-.64-.5-1-.81a2.24,2.24,0,0,1,1.21.55,1.78,1.78,0,0,1,.4.57A.94.94,0,0,1,141.46,160.57Z"
                fill="#2f6840"
              />
              <path
                d="M139.51,158.62c-.25.06-.48.09-.7.16a3.15,3.15,0,0,0-.65.23,8.71,8.71,0,0,0-1.25.64,2.27,2.27,0,0,1,1.12-1A2,2,0,0,1,139.51,158.62Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M125.65,153c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,125.65,153Z"
                fill="#2f6840"
              />
              <path
                d="M125.15,152.62c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.54-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,125.15,152.62Z"
                fill="#3ba525"
              />
              <path
                d="M125.9,152.59a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.21,2.21,0,0,1,1.28.45,1.88,1.88,0,0,1,.48.53A1,1,0,0,1,125.9,152.59Z"
                fill="#2f6840"
              />
              <path
                d="M129.38,151.79c-.26,0-.5.05-.73.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.38,2.38,0,0,1,1.24-.86A2.12,2.12,0,0,1,129.38,151.79Z"
                fill="#2f6840"
              />
              <path
                d="M128,155a2,2,0,0,0-.66-1c-.29-.28-.64-.5-1-.8a2.13,2.13,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A.89.89,0,0,1,128,155Z"
                fill="#2f6840"
              />
              <path
                d="M126.05,153.05c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,9.24,9.24,0,0,0-1.25.64,2.24,2.24,0,0,1,1.11-1A2,2,0,0,1,126.05,153.05Z"
                fill="#2f6840"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M114.48,153.6c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,114.48,153.6Z"
                fill="#2f6840"
              />
              <path
                d="M114,153.26c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,114,153.26Z"
                fill="#3ba525"
              />
              <path
                d="M114.72,153.23a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.29.46,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,114.72,153.23Z"
                fill="#2f6840"
              />
              <path
                d="M118.2,152.43c-.26,0-.49,0-.72.1a4.83,4.83,0,0,0-.68.17,13.44,13.44,0,0,0-1.35.53,2.5,2.5,0,0,1,1.24-.87A2.12,2.12,0,0,1,118.2,152.43Z"
                fill="#2f6840"
              />
              <path
                d="M116.83,155.64a1.86,1.86,0,0,0-.66-1c-.28-.29-.63-.5-1-.81a2.21,2.21,0,0,1,1.21.55,1.7,1.7,0,0,1,.41.57A.94.94,0,0,1,116.83,155.64Z"
                fill="#2f6840"
              />
              <path
                d="M114.87,153.69a7,7,0,0,0-.69.16,3.83,3.83,0,0,0-.65.22,10,10,0,0,0-1.25.65,2.31,2.31,0,0,1,1.11-1A2,2,0,0,1,114.87,153.69Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M111.82,162.33c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.24.27,2.24,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,111.82,162.33Z"
                fill="#2f6840"
              />
              <path
                d="M111.31,162c4.43-.26-4.33.45-4.35-.62s4.35-2.62,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.34,14.34,0,0,1,111.31,162Z"
                fill="#3ba525"
              />
              <path
                d="M112.06,162a2.11,2.11,0,0,0-.8-.94c-.32-.27-.7-.46-1.06-.74a2.34,2.34,0,0,1,1.28.45,2,2,0,0,1,.47.53A1,1,0,0,1,112.06,162Z"
                fill="#2f6840"
              />
              <path
                d="M115.54,161.16c-.26,0-.49.05-.72.1a5.2,5.2,0,0,0-.68.17,13.44,13.44,0,0,0-1.35.53,2.5,2.5,0,0,1,1.24-.87A2.12,2.12,0,0,1,115.54,161.16Z"
                fill="#2f6840"
              />
              <path
                d="M114.17,164.37a1.86,1.86,0,0,0-.66-1c-.28-.29-.63-.5-1-.81a2.2,2.2,0,0,1,1.22.55,1.68,1.68,0,0,1,.4.57A.94.94,0,0,1,114.17,164.37Z"
                fill="#2f6840"
              />
              <path
                d="M112.21,162.42a7,7,0,0,0-.69.15,5,5,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2,2,0,0,1,112.21,162.42Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M106.46,157.37c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.44-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,106.46,157.37Z"
                fill="#2f6840"
              />
              <path
                d="M106,157c4.42-.25-4.33.45-4.35-.61s4.34-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,106,157Z"
                fill="#3ba525"
              />
              <path
                d="M106.71,157a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.29.46,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,106.71,157Z"
                fill="#2f6840"
              />
              <path
                d="M110.19,156.2c-.26,0-.49.05-.73.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.45,2.45,0,0,1,1.24-.87A2.12,2.12,0,0,1,110.19,156.2Z"
                fill="#2f6840"
              />
              <path
                d="M108.82,159.41a2,2,0,0,0-.66-1c-.28-.29-.64-.5-1-.81a2.21,2.21,0,0,1,1.21.55,1.64,1.64,0,0,1,.4.57A.89.89,0,0,1,108.82,159.41Z"
                fill="#2f6840"
              />
              <path
                d="M106.86,157.46c-.24.06-.47.09-.7.16a3.45,3.45,0,0,0-.64.22,9.33,9.33,0,0,0-1.25.65,2.31,2.31,0,0,1,1.11-1A2,2,0,0,1,106.86,157.46Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M98.12,154c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.23-2.78,2.92-2.16,3.63,3.56,2.65,3.44-4.69.05-4.69.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.17-2.9-1.17-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,98.12,154Z"
                fill="#2f6840"
              />
              <path
                d="M97.62,153.66c4.42-.26-4.33.45-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,97.62,153.66Z"
                fill="#3ba525"
              />
              <path
                d="M98.37,153.63a2.17,2.17,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,2.07,2.07,0,0,1,.48.54A1,1,0,0,1,98.37,153.63Z"
                fill="#2f6840"
              />
              <path
                d="M101.85,152.83c-.26,0-.5,0-.73.1a5.2,5.2,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.47,2.47,0,0,1,1.23-.87A2.15,2.15,0,0,1,101.85,152.83Z"
                fill="#2f6840"
              />
              <path
                d="M100.48,156a2,2,0,0,0-.66-1c-.29-.29-.64-.5-1-.81a2.14,2.14,0,0,1,1.21.55,1.55,1.55,0,0,1,.4.57A.89.89,0,0,1,100.48,156Z"
                fill="#2f6840"
              />
              <path
                d="M98.52,154.09c-.25.06-.48.08-.7.15a4.41,4.41,0,0,0-.64.23,9.33,9.33,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2,2,0,0,1,98.52,154.09Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M112.83,169.49c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,112.83,169.49Z"
                fill="#2f6840"
              />
              <path
                d="M112.32,169.15c4.43-.26-4.33.45-4.35-.62s4.35-2.62,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.37A14.77,14.77,0,0,1,112.32,169.15Z"
                fill="#3ba525"
              />
              <path
                d="M113.07,169.12a2.11,2.11,0,0,0-.8-.94c-.32-.27-.7-.46-1.06-.74a2.34,2.34,0,0,1,1.28.45,2.16,2.16,0,0,1,.47.53A1,1,0,0,1,113.07,169.12Z"
                fill="#2f6840"
              />
              <path
                d="M116.55,168.32c-.26,0-.49.05-.72.1a5.2,5.2,0,0,0-.68.17,13.44,13.44,0,0,0-1.35.53,2.5,2.5,0,0,1,1.24-.87A2.12,2.12,0,0,1,116.55,168.32Z"
                fill="#2f6840"
              />
              <path
                d="M115.18,171.53a1.86,1.86,0,0,0-.66-1c-.28-.29-.63-.5-1-.81a2.2,2.2,0,0,1,1.22.55,1.68,1.68,0,0,1,.4.57A.94.94,0,0,1,115.18,171.53Z"
                fill="#2f6840"
              />
              <path
                d="M113.22,169.58a7,7,0,0,0-.69.15,5,5,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2,2,0,0,1,113.22,169.58Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M99.37,163.92c4.42-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,99.37,163.92Z"
                fill="#2f6840"
              />
              <path
                d="M98.86,163.58c4.43-.26-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25S101.3,160,103,160.6s3.62,3.56,2.64,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.27-2.07-2.36A14.24,14.24,0,0,1,98.86,163.58Z"
                fill="#3ba525"
              />
              <path
                d="M99.62,163.55a2.17,2.17,0,0,0-.8-.94c-.32-.27-.71-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.87,1.87,0,0,1,.47.54A1,1,0,0,1,99.62,163.55Z"
                fill="#2f6840"
              />
              <path
                d="M103.09,162.75c-.25,0-.49.05-.72.1a5.2,5.2,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.47,2.47,0,0,1,1.23-.87A2.12,2.12,0,0,1,103.09,162.75Z"
                fill="#2f6840"
              />
              <path
                d="M101.73,166a2,2,0,0,0-.66-1c-.29-.29-.64-.5-1-.81a2.17,2.17,0,0,1,1.21.55,1.68,1.68,0,0,1,.4.57A.94.94,0,0,1,101.73,166Z"
                fill="#2f6840"
              />
              <path
                d="M99.77,164c-.25.06-.48.08-.7.15a4.41,4.41,0,0,0-.64.23,9.43,9.43,0,0,0-1.26.65,2.29,2.29,0,0,1,1.12-1A2,2,0,0,1,99.77,164Z"
                fill="#2f6840"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M86.65,159.75c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,86.65,159.75Z"
                fill="#2f6840"
              />
              <path
                d="M86.15,159.41c4.42-.25-4.33.46-4.35-.61s4.34-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,86.15,159.41Z"
                fill="#3ba525"
              />
              <path
                d="M86.9,159.38a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,86.9,159.38Z"
                fill="#2f6840"
              />
              <path
                d="M90.38,158.59c-.26,0-.49,0-.73.09a3.67,3.67,0,0,0-.67.18,11.31,11.31,0,0,0-1.35.52,2.42,2.42,0,0,1,1.24-.86A2.07,2.07,0,0,1,90.38,158.59Z"
                fill="#2f6840"
              />
              <path
                d="M89,161.8a1.88,1.88,0,0,0-.66-1c-.28-.29-.64-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.81,1.81,0,0,1,.41.57A1,1,0,0,1,89,161.8Z"
                fill="#2f6840"
              />
              <path
                d="M87.05,159.84c-.24.06-.47.09-.7.16a2.87,2.87,0,0,0-.64.23,9.87,9.87,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,87.05,159.84Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M84,168.48c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,84,168.48Z"
                fill="#2f6840"
              />
              <path
                d="M83.49,168.14c4.42-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.54-3.3,2-4.36,1.72S84,169,84,169s-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,83.49,168.14Z"
                fill="#3ba525"
              />
              <path
                d="M84.24,168.11a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.26,2.26,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,84.24,168.11Z"
                fill="#2f6840"
              />
              <path
                d="M87.72,167.31c-.26,0-.49.05-.73.1a3.67,3.67,0,0,0-.67.18,11.31,11.31,0,0,0-1.35.52,2.42,2.42,0,0,1,1.24-.86A2.12,2.12,0,0,1,87.72,167.31Z"
                fill="#2f6840"
              />
              <path
                d="M86.35,170.52a1.9,1.9,0,0,0-.66-1c-.28-.28-.64-.5-1-.81a2.21,2.21,0,0,1,1.21.55,1.81,1.81,0,0,1,.41.57A.94.94,0,0,1,86.35,170.52Z"
                fill="#2f6840"
              />
              <path
                d="M84.39,168.57c-.24.06-.47.09-.69.16a2.78,2.78,0,0,0-.65.23,9.87,9.87,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,84.39,168.57Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M78.64,163.52c4.43-.25-4.33.46-4.35-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.92,3.34-3,2.55-2.25-2.28-2.08-2.37A15,15,0,0,1,78.64,163.52Z"
                fill="#2f6840"
              />
              <path
                d="M78.14,163.18c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,78.14,163.18Z"
                fill="#3ba525"
              />
              <path
                d="M78.89,163.15a2.09,2.09,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,78.89,163.15Z"
                fill="#2f6840"
              />
              <path
                d="M82.37,162.36c-.26,0-.5,0-.73.09a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.38,2.38,0,0,1,1.24-.86A2.07,2.07,0,0,1,82.37,162.36Z"
                fill="#2f6840"
              />
              <path
                d="M81,165.57a1.94,1.94,0,0,0-.66-1c-.28-.29-.64-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A.92.92,0,0,1,81,165.57Z"
                fill="#2f6840"
              />
              <path
                d="M79,163.61c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,9.24,9.24,0,0,0-1.25.64,2.24,2.24,0,0,1,1.11-1A2,2,0,0,1,79,163.61Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M70.3,160.15c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,70.3,160.15Z"
                fill="#2f6840"
              />
              <path
                d="M69.79,159.81c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.46S71,159,71,159s1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,69.79,159.81Z"
                fill="#3ba525"
              />
              <path
                d="M70.55,159.78a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.21,2.21,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,70.55,159.78Z"
                fill="#2f6840"
              />
              <path
                d="M74,159c-.25,0-.49.05-.72.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.39,2.39,0,0,1,1.23-.86A2.12,2.12,0,0,1,74,159Z"
                fill="#2f6840"
              />
              <path
                d="M72.66,162.19a2,2,0,0,0-.66-1c-.29-.28-.64-.5-1-.8a2.16,2.16,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A.94.94,0,0,1,72.66,162.19Z"
                fill="#2f6840"
              />
              <path
                d="M70.7,160.24c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,10,10,0,0,0-1.26.64,2.27,2.27,0,0,1,1.12-1A2,2,0,0,1,70.7,160.24Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M85,175.64c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,85,175.64Z"
                fill="#2f6840"
              />
              <path
                d="M84.5,175.3c4.42-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.72S85,176.17,85,176.17s-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,84.5,175.3Z"
                fill="#3ba525"
              />
              <path
                d="M85.25,175.27a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.26,2.26,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,85.25,175.27Z"
                fill="#2f6840"
              />
              <path
                d="M88.73,174.47c-.26,0-.49.05-.73.1a3.67,3.67,0,0,0-.67.18,11.31,11.31,0,0,0-1.35.52,2.42,2.42,0,0,1,1.24-.86A2.12,2.12,0,0,1,88.73,174.47Z"
                fill="#2f6840"
              />
              <path
                d="M87.36,177.68a1.9,1.9,0,0,0-.66-1c-.28-.28-.64-.5-1-.81a2.21,2.21,0,0,1,1.21.55,1.81,1.81,0,0,1,.41.57A.94.94,0,0,1,87.36,177.68Z"
                fill="#2f6840"
              />
              <path
                d="M85.4,175.73c-.24.06-.47.09-.69.16a2.78,2.78,0,0,0-.65.23,9.87,9.87,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,85.4,175.73Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M71.55,170.07c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,71.55,170.07Z"
                fill="#2f6840"
              />
              <path
                d="M71,169.73c4.43-.25-4.33.46-4.35-.61S71,166.49,72,166.66s.27,2.25.27,2.25,1.24-2.77,2.92-2.15,3.63,3.56,2.65,3.44-4.69.05-4.69.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.92,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,71,169.73Z"
                fill="#3ba525"
              />
              <path
                d="M71.79,169.7a2.15,2.15,0,0,0-.79-.94c-.33-.26-.71-.45-1.07-.73a2.21,2.21,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A.93.93,0,0,1,71.79,169.7Z"
                fill="#2f6840"
              />
              <path
                d="M75.27,168.9c-.25,0-.49,0-.72.1a4,4,0,0,0-.68.18,12,12,0,0,0-1.35.52,2.46,2.46,0,0,1,1.24-.86A2.12,2.12,0,0,1,75.27,168.9Z"
                fill="#2f6840"
              />
              <path
                d="M73.9,172.11a1.94,1.94,0,0,0-.65-1c-.29-.28-.64-.5-1-.8a2.16,2.16,0,0,1,1.21.54,1.78,1.78,0,0,1,.4.57A.94.94,0,0,1,73.9,172.11Z"
                fill="#2f6840"
              />
              <path
                d="M72,170.16c-.25.06-.48.09-.7.16a3.15,3.15,0,0,0-.65.23,9.87,9.87,0,0,0-1.25.64,2.27,2.27,0,0,1,1.12-1A2,2,0,0,1,72,170.16Z"
                fill="#2f6840"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M58.19,158.35c4.43-.25-4.32.46-4.35-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.28-2.07-2.37A14.86,14.86,0,0,1,58.19,158.35Z"
                fill="#2f6840"
              />
              <path
                d="M57.69,158c4.42-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,57.69,158Z"
                fill="#3ba525"
              />
              <path
                d="M58.44,158a2,2,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,58.44,158Z"
                fill="#2f6840"
              />
              <path
                d="M61.92,157.19c-.26,0-.49,0-.73.09a3.67,3.67,0,0,0-.67.18,11.31,11.31,0,0,0-1.35.52,2.42,2.42,0,0,1,1.24-.86A2.07,2.07,0,0,1,61.92,157.19Z"
                fill="#2f6840"
              />
              <path
                d="M60.55,160.4a1.82,1.82,0,0,0-.66-1c-.28-.29-.64-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.81,1.81,0,0,1,.41.57A1,1,0,0,1,60.55,160.4Z"
                fill="#2f6840"
              />
              <path
                d="M58.59,158.44c-.24.06-.47.09-.69.16a2.78,2.78,0,0,0-.65.23,9.87,9.87,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,58.59,158.44Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M55.54,167.08c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,55.54,167.08Z"
                fill="#2f6840"
              />
              <path
                d="M55,166.74c4.43-.25-4.33.46-4.35-.61S55,163.5,56,163.67s.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,55,166.74Z"
                fill="#3ba525"
              />
              <path
                d="M55.78,166.71a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,55.78,166.71Z"
                fill="#2f6840"
              />
              <path
                d="M59.26,165.92c-.26,0-.49,0-.72.09a3.77,3.77,0,0,0-.68.18,11.31,11.31,0,0,0-1.35.52,2.42,2.42,0,0,1,1.24-.86A2.07,2.07,0,0,1,59.26,165.92Z"
                fill="#2f6840"
              />
              <path
                d="M57.89,169.13a1.88,1.88,0,0,0-.66-1c-.28-.28-.63-.5-1-.8a2.13,2.13,0,0,1,1.21.54,1.81,1.81,0,0,1,.41.57A1,1,0,0,1,57.89,169.13Z"
                fill="#2f6840"
              />
              <path
                d="M55.93,167.17c-.24.06-.47.09-.69.16a3.15,3.15,0,0,0-.65.23,9.87,9.87,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,55.93,167.17Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M50.18,162.13c4.43-.26-4.33.45-4.35-.62s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.27-2.07-2.36A14.24,14.24,0,0,1,50.18,162.13Z"
                fill="#2f6840"
              />
              <path
                d="M49.68,161.78c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,49.68,161.78Z"
                fill="#3ba525"
              />
              <path
                d="M50.43,161.75a2,2,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,50.43,161.75Z"
                fill="#2f6840"
              />
              <path
                d="M53.91,161c-.26,0-.49,0-.73.09a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.44,2.44,0,0,1,1.24-.86A2.07,2.07,0,0,1,53.91,161Z"
                fill="#2f6840"
              />
              <path
                d="M52.54,164.17a1.88,1.88,0,0,0-.66-1c-.28-.29-.64-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A.92.92,0,0,1,52.54,164.17Z"
                fill="#2f6840"
              />
              <path
                d="M50.58,162.21c-.24.06-.47.09-.7.16a2.87,2.87,0,0,0-.64.23,9.24,9.24,0,0,0-1.25.64,2.24,2.24,0,0,1,1.11-1A2,2,0,0,1,50.58,162.21Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M41.84,158.75c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,41.84,158.75Z"
                fill="#2f6840"
              />
              <path
                d="M41.33,158.41c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,41.33,158.41Z"
                fill="#3ba525"
              />
              <path
                d="M42.09,158.38a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.28,2.28,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A.94.94,0,0,1,42.09,158.38Z"
                fill="#2f6840"
              />
              <path
                d="M45.56,157.59c-.25,0-.49,0-.72.09a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.39,2.39,0,0,1,1.23-.86A2.07,2.07,0,0,1,45.56,157.59Z"
                fill="#2f6840"
              />
              <path
                d="M44.2,160.8a1.94,1.94,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.16,2.16,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A1,1,0,0,1,44.2,160.8Z"
                fill="#2f6840"
              />
              <path
                d="M42.24,158.84c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,9.24,9.24,0,0,0-1.25.64,2.2,2.2,0,0,1,1.11-1A2,2,0,0,1,42.24,158.84Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M56.54,174.24c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.55,14.55,0,0,1,56.54,174.24Z"
                fill="#2f6840"
              />
              <path
                d="M56,173.9c4.43-.25-4.33.46-4.35-.61S56,170.66,57,170.83s.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,56,173.9Z"
                fill="#3ba525"
              />
              <path
                d="M56.79,173.87a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.26,2.26,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,56.79,173.87Z"
                fill="#2f6840"
              />
              <path
                d="M60.27,173.07c-.26,0-.49.05-.72.1a3.57,3.57,0,0,0-.68.18,11.31,11.31,0,0,0-1.35.52,2.42,2.42,0,0,1,1.24-.86A2.12,2.12,0,0,1,60.27,173.07Z"
                fill="#2f6840"
              />
              <path
                d="M58.9,176.29a1.88,1.88,0,0,0-.66-1c-.28-.28-.63-.5-1-.8a2.13,2.13,0,0,1,1.21.54,1.81,1.81,0,0,1,.41.57A1,1,0,0,1,58.9,176.29Z"
                fill="#2f6840"
              />
              <path
                d="M56.94,174.33c-.24.06-.47.09-.69.16a3.15,3.15,0,0,0-.65.23,9.87,9.87,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,56.94,174.33Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M43.09,168.67c4.42-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,43.09,168.67Z"
                fill="#2f6840"
              />
              <path
                d="M42.58,168.33c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.56,2.64,3.44-4.69,0-4.69,0,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.92,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,42.58,168.33Z"
                fill="#3ba525"
              />
              <path
                d="M43.34,168.3a2.24,2.24,0,0,0-.8-.94c-.33-.26-.71-.45-1.07-.73a2.28,2.28,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,43.34,168.3Z"
                fill="#2f6840"
              />
              <path
                d="M46.81,167.51c-.25,0-.49,0-.72.09a4,4,0,0,0-.68.18,12.79,12.79,0,0,0-1.35.52,2.46,2.46,0,0,1,1.24-.86A2.07,2.07,0,0,1,46.81,167.51Z"
                fill="#2f6840"
              />
              <path
                d="M45.44,170.72a1.86,1.86,0,0,0-.65-1c-.29-.29-.64-.51-1-.81a2.16,2.16,0,0,1,1.21.54,1.78,1.78,0,0,1,.4.57A1,1,0,0,1,45.44,170.72Z"
                fill="#2f6840"
              />
              <path
                d="M43.49,168.76c-.25.06-.48.09-.7.16a3.15,3.15,0,0,0-.65.23,9.87,9.87,0,0,0-1.25.64,2.27,2.27,0,0,1,1.12-1A2,2,0,0,1,43.49,168.76Z"
                fill="#2f6840"
              />
            </g>
          </g>
        </g>
        <g>
          <path
            d="M79.71,162.55s.72,2.66,2.32,3.41,4.5-.41,3.82.89,2.77,2.66,4.38,2.59,5.64-2.66,5.83-3.7S79.71,162.55,79.71,162.55Z"
            fill="#131b8c"
            opacity="0.63"
          />
          <g>
            <path
              d="M80.05,160.57l-.34,2,2.49,2.62,3.79.66.6,1.63s2.35,1.74,4.35.76a14.3,14.3,0,0,0,3.79-3l.34-2Z"
              fill="#ccae79"
            />
            <path
              d="M83.36,159.82l-3.31.75,2.71,2.64,3.62.64.91,1.73s3.34,1.67,4,.69,3.79-3.07,3.79-3.07l-2.58-1.78Z"
              fill="#ffedc8"
            />
            <polygon
              points="82.76 163.21 82.2 165.17 85.99 165.83 86.38 163.85 82.76 163.21"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M90.29,166.57s.25,1.92-.34,1.93a8.84,8.84,0,0,0,4.78-3.31l.34-2S91.12,166.73,90.29,166.57Z"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M87.9,165.86l.69.27s-.42-.2-.48.65A2,2,0,0,0,87.9,165.86Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M89.48,166.44a5.5,5.5,0,0,0,.92-.5,4.42,4.42,0,0,0,1.15-1.19s-1.89,1.46-1.56,1.78Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M81.64,162.11a13.73,13.73,0,0,1-.25,1.44s.13-1.09.47-1.22Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M87.71,160.58l1.44.25c.1,0-1.13-.2-1.55.39l.11-.64"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M81.72,160.19l.82-.19s-.48.19-.32.28.77.5,1.07.41a1.09,1.09,0,0,1,.71.16Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M253.42,150.15l2.7,1.68a.92.92,0,0,0,.82.06l6.49-2.91a.87.87,0,0,0,.22-1.46h0a.88.88,0,0,0-.69-.21l-9.2,1.22A.88.88,0,0,0,253.42,150.15Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="258.21 143.44 254.56 144.22 251.33 146.69 256.73 148.86 263.35 146.15 258.21 143.44"
              fill="#ffedc8"
            />
            <polygon
              points="251.33 146.69 251.33 148.86 256.52 151.08 263.49 148.25 263.35 146.15 256.73 148.86 251.33 146.69"
              fill="#ccae79"
            />
            <polygon
              points="256.73 148.86 256.52 151.08 263.49 148.25 263.35 146.15 256.73 148.86"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M252.88,147.31a1,1,0,0,1,0,1.11c.24-.35.3-1,.41-.94Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M255.15,148.22a3.08,3.08,0,0,0,1.37-1.38l-1,1.54Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M259.46,147.74a1,1,0,0,1,.54.87l-.16-1Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M261.88,145.38a6.56,6.56,0,0,1-2.14,0,3,3,0,0,1-1.57.1s1.15-.11,1.57.29A8.85,8.85,0,0,1,261.88,145.38Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M247.33,141.3,250,143a.86.86,0,0,0,.82.06l6.49-2.9a.88.88,0,0,0,.22-1.47h0a.86.86,0,0,0-.69-.2l-9.19,1.22A.88.88,0,0,0,247.33,141.3Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="252.13 134.59 248.47 135.36 245.25 137.84 250.65 140 257.26 137.29 252.13 134.59"
              fill="#ffedc8"
            />
            <polygon
              points="245.25 137.84 245.25 140 250.43 142.22 257.4 139.39 257.26 137.29 250.65 140 245.25 137.84"
              fill="#ccae79"
            />
            <polygon
              points="250.65 140 250.43 142.22 257.4 139.39 257.26 137.29 250.65 140"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M246.79,138.46a1,1,0,0,1,0,1.11c.24-.35.3-1,.41-.95Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M249.06,139.37a3.08,3.08,0,0,0,1.37-1.39l-1,1.54Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M253.38,138.88a1,1,0,0,1,.53.88l-.16-1Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M255.79,136.52a6.54,6.54,0,0,1-2.14,0,3.12,3.12,0,0,1-1.57.11s1.15-.11,1.57.28A9.49,9.49,0,0,1,255.79,136.52Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M233.9,134.24l2.7,1.68a.88.88,0,0,0,.82.05l6.49-2.9a.88.88,0,0,0,.22-1.47h0a.89.89,0,0,0-.7-.2l-9.19,1.22A.88.88,0,0,0,233.9,134.24Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="238.69 127.53 235.03 128.3 231.81 130.78 237.21 132.94 243.83 130.24 238.69 127.53"
              fill="#ffedc8"
            />
            <polygon
              points="231.81 130.78 231.81 132.94 237 135.16 243.97 132.33 243.83 130.24 237.21 132.94 231.81 130.78"
              fill="#ccae79"
            />
            <polygon
              points="237.21 132.94 237 135.16 243.97 132.33 243.83 130.24 237.21 132.94"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M233.35,131.4a1,1,0,0,1,0,1.11c.25-.35.3-1,.42-.95Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M235.63,132.31a3,3,0,0,0,1.36-1.38l-1,1.53Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M239.94,131.83a1,1,0,0,1,.54.87l-.16-1Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M242.36,129.46a6.33,6.33,0,0,1-2.15,0,3.09,3.09,0,0,1-1.56.11s1.15-.11,1.56.28A9.54,9.54,0,0,1,242.36,129.46Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M234.43,145l2.7,1.68a.91.91,0,0,0,.82.06l6.49-2.9a.88.88,0,0,0,.21-1.47h0a.87.87,0,0,0-.69-.21l-9.19,1.22A.88.88,0,0,0,234.43,145Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="239.22 138.29 235.56 139.07 232.34 141.54 237.74 143.71 244.36 141 239.22 138.29"
              fill="#ffedc8"
            />
            <polygon
              points="232.34 141.54 232.34 143.71 237.52 145.93 244.5 143.1 244.36 141 237.74 143.71 232.34 141.54"
              fill="#ccae79"
            />
            <polygon
              points="237.74 143.71 237.52 145.93 244.5 143.1 244.36 141 237.74 143.71"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M233.88,142.16a1,1,0,0,1,0,1.11c.25-.35.3-1,.42-.94Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M236.16,143.07a3,3,0,0,0,1.36-1.38l-1,1.54Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M240.47,142.59a1,1,0,0,1,.54.87l-.16-1Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M242.89,140.23a6.62,6.62,0,0,1-2.15,0,3.09,3.09,0,0,1-1.56.11s1.15-.12,1.56.28A9,9,0,0,1,242.89,140.23Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M53.54,170.14l2.7,1.67a.86.86,0,0,0,.82.06l6.49-2.9a.88.88,0,0,0,.22-1.47h0a.89.89,0,0,0-.7-.2l-9.19,1.22A.88.88,0,0,0,53.54,170.14Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="58.33 163.42 54.67 164.2 51.45 166.68 56.85 168.84 63.47 166.13 58.33 163.42"
              fill="#ffedc8"
            />
            <polygon
              points="51.45 166.68 51.45 168.84 56.63 171.06 63.61 168.23 63.47 166.13 56.85 168.84 51.45 166.68"
              fill="#ccae79"
            />
            <polygon
              points="56.85 168.84 56.63 171.06 63.61 168.23 63.47 166.13 56.85 168.84"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M53,167.29a1,1,0,0,1,0,1.12c.25-.35.3-1,.42-.95Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M55.27,168.21a3,3,0,0,0,1.36-1.39l-1,1.54Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M59.58,167.72a1,1,0,0,1,.54.88l-.16-1Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M62,165.36a6.61,6.61,0,0,1-2.15,0,3.09,3.09,0,0,1-1.56.11s1.15-.11,1.56.28A9.54,9.54,0,0,1,62,165.36Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M66.49,165.15l2.7,1.68a.88.88,0,0,0,.82,0L76.5,164a.87.87,0,0,0,.22-1.46h0a.87.87,0,0,0-.69-.21l-9.19,1.22A.88.88,0,0,0,66.49,165.15Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="71.28 158.44 67.63 159.21 64.4 161.69 69.8 163.85 76.42 161.15 71.28 158.44"
              fill="#ffedc8"
            />
            <polygon
              points="64.4 161.69 64.4 163.85 69.59 166.08 76.56 163.25 76.42 161.15 69.8 163.85 64.4 161.69"
              fill="#ccae79"
            />
            <polygon
              points="69.8 163.85 69.59 166.08 76.56 163.25 76.42 161.15 69.8 163.85"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M66,162.31a1,1,0,0,1,0,1.11c.24-.35.3-1,.41-.95Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M68.22,163.22a3.08,3.08,0,0,0,1.37-1.38l-1,1.54Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M72.54,162.74a1,1,0,0,1,.53.87l-.16-1Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M75,160.37a6,6,0,0,1-2.14,0,3.12,3.12,0,0,1-1.57.11s1.15-.11,1.57.28A9.49,9.49,0,0,1,75,160.37Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M70.73,172.32l2.7,1.68a.88.88,0,0,0,.82.05l6.49-2.9a.87.87,0,0,0,.22-1.46h0a.87.87,0,0,0-.69-.21l-9.19,1.22A.88.88,0,0,0,70.73,172.32Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="75.53 165.61 71.87 166.38 68.64 168.86 74.04 171.02 80.66 168.31 75.53 165.61"
              fill="#ffedc8"
            />
            <polygon
              points="68.64 168.86 68.64 171.02 73.83 173.25 80.8 170.41 80.66 168.31 74.04 171.02 68.64 168.86"
              fill="#ccae79"
            />
            <polygon
              points="74.04 171.02 73.83 173.25 80.8 170.41 80.66 168.31 74.04 171.02"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M70.19,169.48a1,1,0,0,1,0,1.11c.24-.35.3-1,.41-1Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M72.46,170.39A3.08,3.08,0,0,0,73.83,169l-1,1.53Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M76.78,169.91a1,1,0,0,1,.53.87l-.16-1Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M79.19,167.54a6,6,0,0,1-2.14,0,3.12,3.12,0,0,1-1.57.11s1.15-.11,1.57.28A9.49,9.49,0,0,1,79.19,167.54Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M125.94,152.7l2,1.25a.63.63,0,0,0,.61,0l4.83-2.16a.65.65,0,0,0,.16-1.09h0a.64.64,0,0,0-.51-.15l-6.85.91A.65.65,0,0,0,125.94,152.7Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="129.52 147.71 126.79 148.28 124.39 150.13 128.41 151.74 133.34 149.72 129.52 147.71"
              fill="#ffedc8"
            />
            <polygon
              points="124.39 150.13 124.39 151.74 128.25 153.39 133.44 151.28 133.34 149.72 128.41 151.74 124.39 150.13"
              fill="#ccae79"
            />
            <polygon
              points="128.41 151.74 128.25 153.39 133.44 151.28 133.34 149.72 128.41 151.74"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M125.54,150.59a.71.71,0,0,1,0,.82c.18-.25.22-.73.31-.7Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M127.24,151.27a2.3,2.3,0,0,0,1-1l-.73,1.14Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M130.45,150.91a.74.74,0,0,1,.4.65l-.12-.77Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M132.25,149.15a5,5,0,0,1-1.6,0,2.29,2.29,0,0,1-1.17.08s.86-.09,1.17.21A7,7,0,0,1,132.25,149.15Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M132.88,147.79l1.5.93a.48.48,0,0,0,.45,0l3.6-1.61a.5.5,0,0,0,.12-.82h0a.49.49,0,0,0-.38-.11l-5.1.68A.48.48,0,0,0,132.88,147.79Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="135.54 144.07 133.51 144.5 131.72 145.88 134.72 147.08 138.38 145.58 135.54 144.07"
              fill="#ffedc8"
            />
            <polygon
              points="131.72 145.88 131.72 147.08 134.6 148.31 138.46 146.74 138.38 145.58 134.72 147.08 131.72 145.88"
              fill="#ccae79"
            />
            <polygon
              points="134.72 147.08 134.6 148.31 138.46 146.74 138.38 145.58 134.72 147.08"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M132.58,146.22a.56.56,0,0,1,0,.62c.13-.2.16-.55.23-.53Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M133.84,146.73a1.78,1.78,0,0,0,.76-.77l-.55.85Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M136.23,146.46a.55.55,0,0,1,.3.48l-.09-.57Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M137.57,145.15a3.72,3.72,0,0,1-1.19,0,1.8,1.8,0,0,1-.87.06s.64-.06.87.15A5.51,5.51,0,0,1,137.57,145.15Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M135.23,141.88l1.5.93a.45.45,0,0,0,.45,0l3.6-1.61a.48.48,0,0,0,.12-.81h0a.48.48,0,0,0-.38-.11l-5.1.67A.49.49,0,0,0,135.23,141.88Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="137.89 138.16 135.86 138.59 134.07 139.96 137.07 141.16 140.73 139.66 137.89 138.16"
              fill="#ffedc8"
            />
            <polygon
              points="134.07 139.96 134.07 141.16 136.95 142.4 140.81 140.83 140.73 139.66 137.07 141.16 134.07 139.96"
              fill="#ccae79"
            />
            <polygon
              points="137.07 141.16 136.95 142.4 140.81 140.83 140.73 139.66 137.07 141.16"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M134.93,140.31a.53.53,0,0,1,0,.61c.13-.19.16-.55.23-.52Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M136.19,140.81a1.71,1.71,0,0,0,.76-.76l-.55.85Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M138.58,140.54a.55.55,0,0,1,.3.49l-.09-.57Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M139.92,139.23a3.44,3.44,0,0,1-1.19,0,1.66,1.66,0,0,1-.87.06s.64-.06.87.16A5.12,5.12,0,0,1,139.92,139.23Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M121.25,146.09l2,1.25a.66.66,0,0,0,.61,0l4.83-2.16a.65.65,0,0,0,.16-1.09h0a.68.68,0,0,0-.51-.16l-6.84.91A.66.66,0,0,0,121.25,146.09Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="124.82 141.09 122.09 141.67 119.69 143.51 123.72 145.13 128.64 143.11 124.82 141.09"
              fill="#ffedc8"
            />
            <polygon
              points="119.69 143.51 119.69 145.13 123.55 146.78 128.75 144.67 128.64 143.11 123.72 145.13 119.69 143.51"
              fill="#ccae79"
            />
            <polygon
              points="123.72 145.13 123.55 146.78 128.75 144.67 128.64 143.11 123.72 145.13"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M120.84,144a.72.72,0,0,1,0,.83c.18-.26.23-.74.31-.7Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M122.54,144.65a2.25,2.25,0,0,0,1-1l-.73,1.15Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M125.75,144.29a.74.74,0,0,1,.4.65l-.12-.76Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M127.55,142.53a4.49,4.49,0,0,1-1.6,0,2.26,2.26,0,0,1-1.16.08s.85-.08,1.16.21A7,7,0,0,1,127.55,142.53Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M252.87,132.48l3.63,2.26a1.19,1.19,0,0,0,1.1.07l8.71-3.89a1.18,1.18,0,0,0,.3-2h0a1.22,1.22,0,0,0-.93-.28l-12.35,1.64A1.18,1.18,0,0,0,252.87,132.48Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="259.31 123.47 254.4 124.51 250.07 127.84 257.32 130.75 266.2 127.11 259.31 123.47"
              fill="#ffedc8"
            />
            <polygon
              points="250.07 127.84 250.07 130.75 257.03 133.73 266.4 129.93 266.2 127.11 257.32 130.75 250.07 127.84"
              fill="#ccae79"
            />
            <polygon
              points="257.32 130.75 257.03 133.73 266.4 129.93 266.2 127.11 257.32 130.75"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M252.14,128.67a1.31,1.31,0,0,1,0,1.49c.33-.47.4-1.33.55-1.27Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M255.2,129.9A4.16,4.16,0,0,0,257,128l-1.32,2.06Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M261,129.24a1.33,1.33,0,0,1,.72,1.18L261.5,129Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M264.24,126.07a8.78,8.78,0,0,1-2.89,0,4.13,4.13,0,0,1-2.1.15s1.54-.15,2.1.37A12.56,12.56,0,0,1,264.24,126.07Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M279.21,138.35l3.62,2.25a1.18,1.18,0,0,0,1.11.08l8.71-3.9a1.18,1.18,0,0,0,.29-2h0a1.14,1.14,0,0,0-.92-.27l-12.35,1.64A1.18,1.18,0,0,0,279.21,138.35Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="285.65 129.34 280.74 130.38 276.41 133.71 283.66 136.61 292.54 132.97 285.65 129.34"
              fill="#ffedc8"
            />
            <polygon
              points="276.41 133.71 276.41 136.61 283.37 139.6 292.74 135.79 292.54 132.97 283.66 136.61 276.41 133.71"
              fill="#ccae79"
            />
            <polygon
              points="283.66 136.61 283.37 139.6 292.74 135.79 292.54 132.97 283.66 136.61"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M278.48,134.54a1.31,1.31,0,0,1,0,1.49c.32-.47.4-1.33.55-1.27Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M281.54,135.76a4.09,4.09,0,0,0,1.83-1.86L282.05,136Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M287.33,135.11a1.35,1.35,0,0,1,.72,1.18l-.22-1.39Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M290.57,131.94a8.7,8.7,0,0,1-2.88,0,4.18,4.18,0,0,1-2.1.14s1.54-.15,2.1.38A12.5,12.5,0,0,1,290.57,131.94Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M260.45,143l2.48,1.53a.8.8,0,0,0,.75.05l5.94-2.65a.81.81,0,0,0,.2-1.35h0a.76.76,0,0,0-.63-.18l-8.42,1.11A.81.81,0,0,0,260.45,143Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="264.85 136.88 261.49 137.59 258.54 139.86 263.49 141.84 269.55 139.36 264.85 136.88"
              fill="#ffedc8"
            />
            <polygon
              points="258.54 139.86 258.54 141.84 263.29 143.88 269.68 141.28 269.55 139.36 263.49 141.84 258.54 139.86"
              fill="#ccae79"
            />
            <polygon
              points="263.49 141.84 263.29 143.88 269.68 141.28 269.55 139.36 263.49 141.84"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M260,140.42a.89.89,0,0,1,0,1c.23-.32.28-.91.38-.86Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M262,141.26a2.79,2.79,0,0,0,1.25-1.27l-.9,1.41Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M266,140.82a.9.9,0,0,1,.49.8l-.14-.94Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M268.21,138.65a5.84,5.84,0,0,1-2,0,2.77,2.77,0,0,1-1.43.1s1.05-.1,1.43.26A8.56,8.56,0,0,1,268.21,138.65Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
      </g>
      <g>
        <path
          d="M1037.66,31.29l2.7,1.68a.92.92,0,0,0,.82.06l6.49-2.9a.88.88,0,0,0,.22-1.47h0a.87.87,0,0,0-.69-.21L1038,29.67A.88.88,0,0,0,1037.66,31.29Z"
          fill="#111160"
          opacity="0.68"
        />
        <g>
          <polygon
            points="1042.45 24.58 1038.8 25.36 1035.57 27.83 1040.97 30 1047.59 27.29 1042.45 24.58"
            fill="#ffedc8"
          />
          <polygon
            points="1035.57 27.83 1035.57 30 1040.76 32.22 1047.73 29.39 1047.59 27.29 1040.97 30 1035.57 27.83"
            fill="#ccae79"
          />
          <polygon
            points="1040.97 30 1040.76 32.22 1047.73 29.39 1047.59 27.29 1040.97 30"
            fill="#0416bf"
            opacity="0.14"
          />
          <path
            d="M1037.12,28.45a1,1,0,0,1,0,1.11c.24-.35.3-1,.41-.94Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M1039.39,29.36a3.08,3.08,0,0,0,1.37-1.38l-1,1.54Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M1043.71,28.88a1,1,0,0,1,.53.87l-.16-1Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M1046.12,26.52a6.56,6.56,0,0,1-2.14,0,3.12,3.12,0,0,1-1.57.11s1.15-.12,1.57.28A8.93,8.93,0,0,1,1046.12,26.52Z"
            fill="#996537"
            opacity="0.51"
          />
        </g>
      </g>
      <g>
        <path
          d="M1055.56,21.14l2.7,1.68a.87.87,0,0,0,.83.06l6.48-2.9a.88.88,0,0,0,.22-1.47h0a.91.91,0,0,0-.69-.21l-9.19,1.23A.87.87,0,0,0,1055.56,21.14Z"
          fill="#111160"
          opacity="0.68"
        />
        <g>
          <polygon
            points="1060.36 14.43 1056.7 15.21 1053.48 17.68 1058.88 19.85 1065.49 17.14 1060.36 14.43"
            fill="#ffedc8"
          />
          <polygon
            points="1053.48 17.68 1053.48 19.85 1058.66 22.07 1065.63 19.24 1065.49 17.14 1058.88 19.85 1053.48 17.68"
            fill="#ccae79"
          />
          <polygon
            points="1058.88 19.85 1058.66 22.07 1065.63 19.24 1065.49 17.14 1058.88 19.85"
            fill="#0416bf"
            opacity="0.14"
          />
          <path
            d="M1055,18.3a1,1,0,0,1,0,1.12c.24-.35.3-1,.41-1Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M1057.3,19.22a3.08,3.08,0,0,0,1.36-1.39l-1,1.54Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M1061.61,18.73a1,1,0,0,1,.54.88l-.16-1Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M1064,16.37a6.62,6.62,0,0,1-2.15,0,3.13,3.13,0,0,1-1.57.11s1.15-.11,1.57.28A9,9,0,0,1,1064,16.37Z"
            fill="#996537"
            opacity="0.51"
          />
        </g>
      </g>
      <g>
        <g>
          <g>
            <path
              d="M1123.29,19.2c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1123.29,19.2Z"
              fill="#2f6840"
            />
            <path
              d="M1122.78,18.86c4.43-.26-4.33.45-4.35-.62s4.35-2.62,5.28-2.45S1124,18,1124,18s1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.34,14.34,0,0,1,1122.78,18.86Z"
              fill="#3ba525"
            />
            <path
              d="M1123.53,18.83a2.11,2.11,0,0,0-.8-.94c-.32-.27-.7-.46-1.06-.74a2.34,2.34,0,0,1,1.28.45,1.87,1.87,0,0,1,.47.54A1,1,0,0,1,1123.53,18.83Z"
              fill="#2f6840"
            />
            <path
              d="M1127,18c-.26,0-.49,0-.72.1a5.2,5.2,0,0,0-.68.17,13.44,13.44,0,0,0-1.35.53,2.5,2.5,0,0,1,1.24-.87A2.12,2.12,0,0,1,1127,18Z"
              fill="#2f6840"
            />
            <path
              d="M1125.64,21.24a1.86,1.86,0,0,0-.66-1c-.28-.29-.63-.5-1-.81a2.2,2.2,0,0,1,1.22.55,1.68,1.68,0,0,1,.4.57A.94.94,0,0,1,1125.64,21.24Z"
              fill="#2f6840"
            />
            <path
              d="M1123.68,19.29a7,7,0,0,0-.69.15,5,5,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.31,2.31,0,0,1,1.11-1A2,2,0,0,1,1123.68,19.29Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1120.63,27.93c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1120.63,27.93Z"
              fill="#2f6840"
            />
            <path
              d="M1120.12,27.58c4.43-.25-4.33.46-4.35-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.23-2.78,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A15,15,0,0,1,1120.12,27.58Z"
              fill="#3ba525"
            />
            <path
              d="M1120.87,27.56a2.1,2.1,0,0,0-.79-.94c-.33-.27-.71-.46-1.07-.74a2.34,2.34,0,0,1,1.28.45,1.83,1.83,0,0,1,.47.53A1,1,0,0,1,1120.87,27.56Z"
              fill="#2f6840"
            />
            <path
              d="M1124.35,26.76c-.25,0-.49,0-.72.1a5.2,5.2,0,0,0-.68.17,13.44,13.44,0,0,0-1.35.53,2.5,2.5,0,0,1,1.24-.87A2.07,2.07,0,0,1,1124.35,26.76Z"
              fill="#2f6840"
            />
            <path
              d="M1123,30a1.86,1.86,0,0,0-.66-1c-.28-.29-.63-.5-1-.81a2.1,2.1,0,0,1,1.22.55,1.68,1.68,0,0,1,.4.57A.94.94,0,0,1,1123,30Z"
              fill="#2f6840"
            />
            <path
              d="M1121,28a6.61,6.61,0,0,0-.7.15,5,5,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2,2,0,0,1,1121,28Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1115.27,23c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1115.27,23Z"
              fill="#2f6840"
            />
            <path
              d="M1114.77,22.63c4.42-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1114.77,22.63Z"
              fill="#3ba525"
            />
            <path
              d="M1115.52,22.6a2.11,2.11,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,2,2,0,0,1,.47.54A1,1,0,0,1,1115.52,22.6Z"
              fill="#2f6840"
            />
            <path
              d="M1119,21.8c-.26,0-.49.05-.73.1a4.69,4.69,0,0,0-.67.17,13.44,13.44,0,0,0-1.35.53,2.5,2.5,0,0,1,1.24-.87A2.12,2.12,0,0,1,1119,21.8Z"
              fill="#2f6840"
            />
            <path
              d="M1117.63,25a1.92,1.92,0,0,0-.66-1c-.28-.29-.64-.5-1-.81a2.21,2.21,0,0,1,1.21.55,1.7,1.7,0,0,1,.41.57A.94.94,0,0,1,1117.63,25Z"
              fill="#2f6840"
            />
            <path
              d="M1115.67,23.06c-.24.06-.47.08-.7.16a3.45,3.45,0,0,0-.64.22,10,10,0,0,0-1.25.65,2.31,2.31,0,0,1,1.11-1A2,2,0,0,1,1115.67,23.06Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1106.93,19.6c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.92-2.15,3.63,3.56,2.65,3.44-4.69.05-4.69.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.17-2.9-1.17-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1106.93,19.6Z"
              fill="#2f6840"
            />
            <path
              d="M1106.43,19.25c4.42-.25-4.33.46-4.36-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.87,14.87,0,0,1,1106.43,19.25Z"
              fill="#3ba525"
            />
            <path
              d="M1107.18,19.23a2.12,2.12,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,2.38,2.38,0,0,1,.47.53A1,1,0,0,1,1107.18,19.23Z"
              fill="#2f6840"
            />
            <path
              d="M1110.66,18.43c-.26,0-.5,0-.73.1a5.2,5.2,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.45,2.45,0,0,1,1.24-.87A2.07,2.07,0,0,1,1110.66,18.43Z"
              fill="#2f6840"
            />
            <path
              d="M1109.29,21.64a2,2,0,0,0-.66-1c-.29-.29-.64-.5-1-.81a2.08,2.08,0,0,1,1.21.55,1.55,1.55,0,0,1,.4.57A.89.89,0,0,1,1109.29,21.64Z"
              fill="#2f6840"
            />
            <path
              d="M1107.33,19.69a6.61,6.61,0,0,0-.7.15,4.41,4.41,0,0,0-.64.23,9.33,9.33,0,0,0-1.25.65,2.22,2.22,0,0,1,1.11-1A2,2,0,0,1,1107.33,19.69Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1121.64,35.09c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.54-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,1121.64,35.09Z"
              fill="#2f6840"
            />
            <path
              d="M1121.13,34.74c4.43-.25-4.33.46-4.35-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.23-2.78,2.92-2.16,3.62,3.56,2.65,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1121.13,34.74Z"
              fill="#3ba525"
            />
            <path
              d="M1121.88,34.72a2.1,2.1,0,0,0-.79-.94c-.33-.27-.71-.46-1.07-.74a2.34,2.34,0,0,1,1.28.45,1.83,1.83,0,0,1,.47.53A1,1,0,0,1,1121.88,34.72Z"
              fill="#2f6840"
            />
            <path
              d="M1125.36,33.92c-.25,0-.49,0-.72.1a4,4,0,0,0-.68.17,13.44,13.44,0,0,0-1.35.53,2.5,2.5,0,0,1,1.24-.87A2.07,2.07,0,0,1,1125.36,33.92Z"
              fill="#2f6840"
            />
            <path
              d="M1124,37.13a1.86,1.86,0,0,0-.66-1c-.28-.29-.63-.5-1-.81a2.1,2.1,0,0,1,1.22.55,1.68,1.68,0,0,1,.4.57A.94.94,0,0,1,1124,37.13Z"
              fill="#2f6840"
            />
            <path
              d="M1122,35.18a6.61,6.61,0,0,0-.7.15,5,5,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2,2,0,0,1,1122,35.18Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1108.18,29.52c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1108.18,29.52Z"
              fill="#2f6840"
            />
            <path
              d="M1107.67,29.17c4.43-.25-4.32.46-4.35-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.28-2.07-2.37A14.86,14.86,0,0,1,1107.67,29.17Z"
              fill="#3ba525"
            />
            <path
              d="M1108.43,29.15a2.12,2.12,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,2,2,0,0,1,.47.53A1,1,0,0,1,1108.43,29.15Z"
              fill="#2f6840"
            />
            <path
              d="M1111.9,28.35c-.25,0-.49,0-.72.1a5.2,5.2,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.47,2.47,0,0,1,1.23-.87A2.07,2.07,0,0,1,1111.9,28.35Z"
              fill="#2f6840"
            />
            <path
              d="M1110.54,31.56a2,2,0,0,0-.66-1c-.29-.29-.64-.5-1-.81a2.1,2.1,0,0,1,1.21.55,1.55,1.55,0,0,1,.4.57A.94.94,0,0,1,1110.54,31.56Z"
              fill="#2f6840"
            />
            <path
              d="M1108.58,29.61a6.61,6.61,0,0,0-.7.15,4.41,4.41,0,0,0-.64.23,10.08,10.08,0,0,0-1.26.65,2.24,2.24,0,0,1,1.12-1A2,2,0,0,1,1108.58,29.61Z"
              fill="#2f6840"
            />
          </g>
        </g>
        <g>
          <g>
            <path
              d="M1099.18,8.69c4.42-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1099.18,8.69Z"
              fill="#2f6840"
            />
            <path
              d="M1098.67,8.34c4.43-.25-4.33.46-4.35-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.92,3.34-3,2.55-2.25-2.28-2.07-2.37A14.86,14.86,0,0,1,1098.67,8.34Z"
              fill="#3ba525"
            />
            <path
              d="M1099.43,8.32a2.18,2.18,0,0,0-.8-.94c-.32-.27-.71-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,2,2,0,0,1,.47.53A1,1,0,0,1,1099.43,8.32Z"
              fill="#2f6840"
            />
            <path
              d="M1102.9,7.52c-.25,0-.49,0-.72.1a5.2,5.2,0,0,0-.68.17c-.45.13-.87.34-1.35.53a2.54,2.54,0,0,1,1.24-.87A2.07,2.07,0,0,1,1102.9,7.52Z"
              fill="#2f6840"
            />
            <path
              d="M1101.53,10.73a1.9,1.9,0,0,0-.65-1c-.29-.29-.64-.5-1-.81a2.1,2.1,0,0,1,1.21.55,1.68,1.68,0,0,1,.4.57A.94.94,0,0,1,1101.53,10.73Z"
              fill="#2f6840"
            />
            <path
              d="M1099.58,8.78a6.61,6.61,0,0,0-.7.15,5,5,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.24,2.24,0,0,1,1.12-1A2,2,0,0,1,1099.58,8.78Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1096.52,17.42c4.42-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.72-1.16-2.91-1.16-2.91-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1096.52,17.42Z"
              fill="#2f6840"
            />
            <path
              d="M1096,17.07c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1096,17.07Z"
              fill="#3ba525"
            />
            <path
              d="M1096.77,17a2.15,2.15,0,0,0-.8-.93c-.32-.27-.71-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.83,1.83,0,0,1,.47.53A1,1,0,0,1,1096.77,17Z"
              fill="#2f6840"
            />
            <path
              d="M1100.24,16.25c-.25,0-.49,0-.72.1a4,4,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.41,2.41,0,0,1,1.23-.87A2.07,2.07,0,0,1,1100.24,16.25Z"
              fill="#2f6840"
            />
            <path
              d="M1098.88,19.46a2,2,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.1,2.1,0,0,1,1.21.55,1.74,1.74,0,0,1,.4.56A1,1,0,0,1,1098.88,19.46Z"
              fill="#2f6840"
            />
            <path
              d="M1096.92,17.5c-.25.06-.48.09-.7.16a4.41,4.41,0,0,0-.64.23,9.43,9.43,0,0,0-1.26.65,2.24,2.24,0,0,1,1.12-1A2,2,0,0,1,1096.92,17.5Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1091.17,12.46c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1091.17,12.46Z"
              fill="#2f6840"
            />
            <path
              d="M1090.66,12.12c4.43-.26-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.23-2.78,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.34,14.34,0,0,1,1090.66,12.12Z"
              fill="#3ba525"
            />
            <path
              d="M1091.41,12.09a2.15,2.15,0,0,0-.79-.94c-.33-.27-.71-.46-1.07-.74a2.34,2.34,0,0,1,1.28.45,1.87,1.87,0,0,1,.47.54A.93.93,0,0,1,1091.41,12.09Z"
              fill="#2f6840"
            />
            <path
              d="M1094.89,11.29c-.25,0-.49.05-.72.1a5.2,5.2,0,0,0-.68.17,13.44,13.44,0,0,0-1.35.53,2.5,2.5,0,0,1,1.24-.87A2.12,2.12,0,0,1,1094.89,11.29Z"
              fill="#2f6840"
            />
            <path
              d="M1093.52,14.5a1.86,1.86,0,0,0-.66-1c-.28-.29-.63-.5-1-.81a2.17,2.17,0,0,1,1.22.55,1.68,1.68,0,0,1,.4.57A.94.94,0,0,1,1093.52,14.5Z"
              fill="#2f6840"
            />
            <path
              d="M1091.57,12.55a6.61,6.61,0,0,0-.7.15,5,5,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.31,2.31,0,0,1,1.11-1A2,2,0,0,1,1091.57,12.55Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1082.82,9.09c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.91-1.16-2.91-.91,3.34-3,2.55-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,1082.82,9.09Z"
              fill="#2f6840"
            />
            <path
              d="M1082.32,8.74c4.42-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1082.32,8.74Z"
              fill="#3ba525"
            />
            <path
              d="M1083.07,8.72a2.06,2.06,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45A2,2,0,0,1,1083,8,1,1,0,0,1,1083.07,8.72Z"
              fill="#2f6840"
            />
            <path
              d="M1086.55,7.92c-.26,0-.49,0-.73.1a3.65,3.65,0,0,0-.67.17,13.44,13.44,0,0,0-1.35.53,2.44,2.44,0,0,1,1.24-.87A2.07,2.07,0,0,1,1086.55,7.92Z"
              fill="#2f6840"
            />
            <path
              d="M1085.18,11.13a1.92,1.92,0,0,0-.66-1c-.28-.29-.64-.51-1-.81a2.08,2.08,0,0,1,1.21.55,1.76,1.76,0,0,1,.41.56A1,1,0,0,1,1085.18,11.13Z"
              fill="#2f6840"
            />
            <path
              d="M1083.22,9.17c-.24.06-.47.09-.7.16a4.41,4.41,0,0,0-.64.23,10,10,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2,2,0,0,1,1083.22,9.17Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1097.53,24.58c4.42-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.72-1.16-2.91-1.16-2.91-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1097.53,24.58Z"
              fill="#2f6840"
            />
            <path
              d="M1097,24.23c4.43-.25-4.33.46-4.35-.61S1097,21,1098,21.17s.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1097,24.23Z"
              fill="#3ba525"
            />
            <path
              d="M1097.78,24.2a2.15,2.15,0,0,0-.8-.93c-.32-.27-.71-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.83,1.83,0,0,1,.47.53A1,1,0,0,1,1097.78,24.2Z"
              fill="#2f6840"
            />
            <path
              d="M1101.25,23.41c-.25,0-.49,0-.72.1a4,4,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.41,2.41,0,0,1,1.23-.87A2.07,2.07,0,0,1,1101.25,23.41Z"
              fill="#2f6840"
            />
            <path
              d="M1099.89,26.62a2,2,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.1,2.1,0,0,1,1.21.55,1.74,1.74,0,0,1,.4.56A1,1,0,0,1,1099.89,26.62Z"
              fill="#2f6840"
            />
            <path
              d="M1097.93,24.66c-.25.06-.48.09-.7.16a4.41,4.41,0,0,0-.64.23,9.43,9.43,0,0,0-1.26.65,2.24,2.24,0,0,1,1.12-1A2,2,0,0,1,1097.93,24.66Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1084.07,19c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.92-2.15,3.63,3.55,2.65,3.44-4.69.05-4.69.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.91-1.16-2.91-.92,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1084.07,19Z"
              fill="#2f6840"
            />
            <path
              d="M1083.57,18.66c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1083.57,18.66Z"
              fill="#3ba525"
            />
            <path
              d="M1084.32,18.64a2.12,2.12,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,2.18,2.18,0,0,1,.47.53A1,1,0,0,1,1084.32,18.64Z"
              fill="#2f6840"
            />
            <path
              d="M1087.8,17.84c-.26,0-.5,0-.73.1a4,4,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.4,2.4,0,0,1,1.24-.87A2.07,2.07,0,0,1,1087.8,17.84Z"
              fill="#2f6840"
            />
            <path
              d="M1086.43,21.05a2,2,0,0,0-.66-1c-.28-.29-.64-.51-1-.81a2.08,2.08,0,0,1,1.21.55,1.6,1.6,0,0,1,.4.56A.92.92,0,0,1,1086.43,21.05Z"
              fill="#2f6840"
            />
            <path
              d="M1084.47,19.09c-.25.06-.48.09-.7.16a4.41,4.41,0,0,0-.64.23,9.33,9.33,0,0,0-1.25.65,2.22,2.22,0,0,1,1.11-1A2,2,0,0,1,1084.47,19.09Z"
              fill="#2f6840"
            />
          </g>
        </g>
        <g>
          <g>
            <path
              d="M1074.74,3.42c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1074.74,3.42Z"
              fill="#2f6840"
            />
            <path
              d="M1074.24,3.08c4.42-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15S1082,3.66,1081,3.55s-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.72S1074.77,4,1074.77,4s-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1074.24,3.08Z"
              fill="#3ba525"
            />
            <path
              d="M1075,3.05a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.26,2.26,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1075,3.05Z"
              fill="#2f6840"
            />
            <path
              d="M1078.47,2.25c-.26,0-.49,0-.73.1a3.67,3.67,0,0,0-.67.18,11.31,11.31,0,0,0-1.35.52,2.42,2.42,0,0,1,1.24-.86A2.07,2.07,0,0,1,1078.47,2.25Z"
              fill="#2f6840"
            />
            <path
              d="M1077.1,5.46a2,2,0,0,0-.66-1c-.28-.28-.64-.5-1-.81a2.21,2.21,0,0,1,1.21.55,1.81,1.81,0,0,1,.41.57A.94.94,0,0,1,1077.1,5.46Z"
              fill="#2f6840"
            />
            <path
              d="M1075.14,3.51c-.24.06-.47.09-.7.16a2.87,2.87,0,0,0-.64.23,8.71,8.71,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,1075.14,3.51Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1072.08,12.15c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1072.08,12.15Z"
              fill="#2f6840"
            />
            <path
              d="M1071.58,11.81c4.42-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1071.58,11.81Z"
              fill="#3ba525"
            />
            <path
              d="M1072.33,11.78a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.29.46,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1072.33,11.78Z"
              fill="#2f6840"
            />
            <path
              d="M1075.81,11c-.26,0-.49,0-.73.1a3.67,3.67,0,0,0-.67.18,11.31,11.31,0,0,0-1.35.52,2.5,2.5,0,0,1,1.24-.87A2.12,2.12,0,0,1,1075.81,11Z"
              fill="#2f6840"
            />
            <path
              d="M1074.44,14.19a1.9,1.9,0,0,0-.66-1c-.28-.29-.64-.5-1-.81a2.21,2.21,0,0,1,1.21.55,1.81,1.81,0,0,1,.41.57A.94.94,0,0,1,1074.44,14.19Z"
              fill="#2f6840"
            />
            <path
              d="M1072.48,12.24c-.24.06-.47.09-.69.16a3.55,3.55,0,0,0-.65.22,10,10,0,0,0-1.25.65,2.31,2.31,0,0,1,1.11-1A2,2,0,0,1,1072.48,12.24Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1066.73,7.19c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.92,3.34-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1066.73,7.19Z"
              fill="#2f6840"
            />
            <path
              d="M1066.23,6.85c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15S1074,7.44,1073,7.32s-4.7,0-4.7,0,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1066.23,6.85Z"
              fill="#3ba525"
            />
            <path
              d="M1067,6.82a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.26,2.26,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1067,6.82Z"
              fill="#2f6840"
            />
            <path
              d="M1070.46,6c-.26,0-.5.05-.73.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52A2.38,2.38,0,0,1,1069,6,2.12,2.12,0,0,1,1070.46,6Z"
              fill="#2f6840"
            />
            <path
              d="M1069.09,9.23a2,2,0,0,0-.66-1c-.28-.28-.64-.5-1-.8a2.13,2.13,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A.89.89,0,0,1,1069.09,9.23Z"
              fill="#2f6840"
            />
            <path
              d="M1067.13,7.28c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,9.24,9.24,0,0,0-1.25.64,2.24,2.24,0,0,1,1.11-1A2,2,0,0,1,1067.13,7.28Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1058.39,3.82c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.37,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1058.39,3.82Z"
              fill="#2f6840"
            />
            <path
              d="M1057.88,3.48c4.43-.25-4.32.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,1057.88,3.48Z"
              fill="#3ba525"
            />
            <path
              d="M1058.64,3.45a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.74a2.22,2.22,0,0,1,1.28.46,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1058.64,3.45Z"
              fill="#2f6840"
            />
            <path
              d="M1062.11,2.65c-.25,0-.49.05-.72.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.47,2.47,0,0,1,1.23-.87A2.12,2.12,0,0,1,1062.11,2.65Z"
              fill="#2f6840"
            />
            <path
              d="M1060.75,5.86a2,2,0,0,0-.66-1c-.29-.28-.64-.5-1-.81a2.24,2.24,0,0,1,1.21.55,1.64,1.64,0,0,1,.4.57A.94.94,0,0,1,1060.75,5.86Z"
              fill="#2f6840"
            />
            <path
              d="M1058.79,3.91c-.25.06-.48.09-.7.16a3.45,3.45,0,0,0-.64.22,10.08,10.08,0,0,0-1.26.65,2.34,2.34,0,0,1,1.12-1A2,2,0,0,1,1058.79,3.91Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1073.09,19.31c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1073.09,19.31Z"
              fill="#2f6840"
            />
            <path
              d="M1072.59,19c4.42-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1072.59,19Z"
              fill="#3ba525"
            />
            <path
              d="M1073.34,18.94a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.29.46,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1073.34,18.94Z"
              fill="#2f6840"
            />
            <path
              d="M1076.82,18.14c-.26,0-.49.05-.73.1a3.67,3.67,0,0,0-.67.18,11.31,11.31,0,0,0-1.35.52,2.5,2.5,0,0,1,1.24-.87A2.12,2.12,0,0,1,1076.82,18.14Z"
              fill="#2f6840"
            />
            <path
              d="M1075.45,21.35a1.9,1.9,0,0,0-.66-1c-.28-.29-.64-.5-1-.81a2.21,2.21,0,0,1,1.21.55,1.81,1.81,0,0,1,.41.57A.94.94,0,0,1,1075.45,21.35Z"
              fill="#2f6840"
            />
            <path
              d="M1073.49,19.4c-.24.06-.47.09-.69.16a3.31,3.31,0,0,0-.65.22,10,10,0,0,0-1.25.65,2.31,2.31,0,0,1,1.11-1A2,2,0,0,1,1073.49,19.4Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1059.64,13.74c4.42-.25-4.33.46-4.35-.61s4.34-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1059.64,13.74Z"
              fill="#2f6840"
            />
            <path
              d="M1059.13,13.4c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.92-2.15,3.63,3.55,2.65,3.44-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.92,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1059.13,13.4Z"
              fill="#3ba525"
            />
            <path
              d="M1059.88,13.37a2.15,2.15,0,0,0-.79-.94c-.33-.26-.71-.45-1.07-.74a2.22,2.22,0,0,1,1.28.46,1.71,1.71,0,0,1,.47.53A.93.93,0,0,1,1059.88,13.37Z"
              fill="#2f6840"
            />
            <path
              d="M1063.36,12.57c-.25,0-.49,0-.72.1a4,4,0,0,0-.68.18,12,12,0,0,0-1.35.52,2.54,2.54,0,0,1,1.24-.87A2.12,2.12,0,0,1,1063.36,12.57Z"
              fill="#2f6840"
            />
            <path
              d="M1062,15.78a1.94,1.94,0,0,0-.65-1c-.29-.28-.64-.5-1-.81a2.24,2.24,0,0,1,1.21.55,1.78,1.78,0,0,1,.4.57A.94.94,0,0,1,1062,15.78Z"
              fill="#2f6840"
            />
            <path
              d="M1060,13.83c-.25.06-.48.09-.7.16a3.83,3.83,0,0,0-.65.22,10,10,0,0,0-1.25.65,2.34,2.34,0,0,1,1.12-1A2,2,0,0,1,1060,13.83Z"
              fill="#2f6840"
            />
          </g>
        </g>
        <g>
          <g>
            <path
              d="M1049.44,16.32c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.23-2.78,2.92-2.16,3.63,3.56,2.65,3.44-4.69.05-4.69.05,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1049.44,16.32Z"
              fill="#2f6840"
            />
            <path
              d="M1048.94,16c4.42-.25-4.33.45-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,1048.94,16Z"
              fill="#3ba525"
            />
            <path
              d="M1049.69,16a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.46-1.07-.74a2.22,2.22,0,0,1,1.28.46,1.88,1.88,0,0,1,.48.53A1,1,0,0,1,1049.69,16Z"
              fill="#2f6840"
            />
            <path
              d="M1053.17,15.15c-.26,0-.5,0-.73.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.47,2.47,0,0,1,1.23-.87A2.15,2.15,0,0,1,1053.17,15.15Z"
              fill="#2f6840"
            />
            <path
              d="M1051.8,18.36a2,2,0,0,0-.66-1c-.29-.29-.64-.5-1-.81a2.21,2.21,0,0,1,1.21.55,1.64,1.64,0,0,1,.4.57A.89.89,0,0,1,1051.8,18.36Z"
              fill="#2f6840"
            />
            <path
              d="M1049.84,16.41c-.25.06-.48.09-.7.16a3.45,3.45,0,0,0-.64.22,9.33,9.33,0,0,0-1.25.65,2.31,2.31,0,0,1,1.11-1A2,2,0,0,1,1049.84,16.41Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1046.78,25.05c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.92-2.16,3.63,3.56,2.65,3.44-4.69.05-4.69.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.17-2.9-1.17-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1046.78,25.05Z"
              fill="#2f6840"
            />
            <path
              d="M1046.28,24.71c4.42-.25-4.33.45-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,1046.28,24.71Z"
              fill="#3ba525"
            />
            <path
              d="M1047,24.68a2.17,2.17,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,2.07,2.07,0,0,1,.48.54A1,1,0,0,1,1047,24.68Z"
              fill="#2f6840"
            />
            <path
              d="M1050.51,23.88c-.26,0-.5.05-.73.1a5.2,5.2,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.45,2.45,0,0,1,1.24-.87A2.13,2.13,0,0,1,1050.51,23.88Z"
              fill="#2f6840"
            />
            <path
              d="M1049.14,27.09a2,2,0,0,0-.66-1c-.29-.29-.64-.5-1-.81a2.14,2.14,0,0,1,1.21.55,1.55,1.55,0,0,1,.4.57A.89.89,0,0,1,1049.14,27.09Z"
              fill="#2f6840"
            />
            <path
              d="M1047.18,25.14a6.56,6.56,0,0,0-.7.16,3.45,3.45,0,0,0-.64.22,9.33,9.33,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2,2,0,0,1,1047.18,25.14Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1041.43,20.09c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.55-3.3,2-4.36,1.71S1042,21,1042,21s-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1041.43,20.09Z"
              fill="#2f6840"
            />
            <path
              d="M1040.92,19.75c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.64,3.44-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.72-1.16-2.91-1.16-2.91-.91,3.34-3,2.55-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,1040.92,19.75Z"
              fill="#3ba525"
            />
            <path
              d="M1041.68,19.72a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.21,2.21,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1041.68,19.72Z"
              fill="#2f6840"
            />
            <path
              d="M1045.15,18.92c-.25,0-.49,0-.72.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.47,2.47,0,0,1,1.23-.87A2.12,2.12,0,0,1,1045.15,18.92Z"
              fill="#2f6840"
            />
            <path
              d="M1043.79,22.13a2,2,0,0,0-.66-1c-.29-.28-.64-.5-1-.81a2.24,2.24,0,0,1,1.21.55,1.78,1.78,0,0,1,.4.57A.94.94,0,0,1,1043.79,22.13Z"
              fill="#2f6840"
            />
            <path
              d="M1041.83,20.18c-.25.06-.48.09-.7.16a3.45,3.45,0,0,0-.64.22,10.08,10.08,0,0,0-1.26.65,2.34,2.34,0,0,1,1.12-1A2,2,0,0,1,1041.83,20.18Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1033.09,16.72c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1033.09,16.72Z"
              fill="#2f6840"
            />
            <path
              d="M1032.58,16.38c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.23-2.77,2.92-2.16,3.62,3.56,2.65,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1032.58,16.38Z"
              fill="#3ba525"
            />
            <path
              d="M1033.33,16.35a2.15,2.15,0,0,0-.79-.94c-.33-.26-.71-.46-1.07-.74a2.34,2.34,0,0,1,1.28.45,1.87,1.87,0,0,1,.47.54A1,1,0,0,1,1033.33,16.35Z"
              fill="#2f6840"
            />
            <path
              d="M1036.81,15.55c-.25,0-.49,0-.72.1a5.2,5.2,0,0,0-.68.17,13.44,13.44,0,0,0-1.35.53,2.5,2.5,0,0,1,1.24-.87A2.12,2.12,0,0,1,1036.81,15.55Z"
              fill="#2f6840"
            />
            <path
              d="M1035.44,18.76a1.86,1.86,0,0,0-.66-1c-.28-.29-.63-.5-1-.81a2.24,2.24,0,0,1,1.22.55,1.68,1.68,0,0,1,.4.57A.94.94,0,0,1,1035.44,18.76Z"
              fill="#2f6840"
            />
            <path
              d="M1033.49,16.81a6.56,6.56,0,0,0-.7.16,3.83,3.83,0,0,0-.65.22,10,10,0,0,0-1.25.65,2.31,2.31,0,0,1,1.11-1A2,2,0,0,1,1033.49,16.81Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1047.79,32.21c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.92-2.16,3.63,3.56,2.65,3.44-4.69,0-4.69,0,6,.86,4,1.54-3.31,2-4.36,1.72-1.17-2.9-1.17-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1047.79,32.21Z"
              fill="#2f6840"
            />
            <path
              d="M1047.29,31.87c4.42-.25-4.33.45-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,1047.29,31.87Z"
              fill="#3ba525"
            />
            <path
              d="M1048,31.84a2.17,2.17,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,2.07,2.07,0,0,1,.48.54A1,1,0,0,1,1048,31.84Z"
              fill="#2f6840"
            />
            <path
              d="M1051.52,31c-.26,0-.5.05-.73.1a5.2,5.2,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53A2.45,2.45,0,0,1,1050,31,2.13,2.13,0,0,1,1051.52,31Z"
              fill="#2f6840"
            />
            <path
              d="M1050.15,34.25a2,2,0,0,0-.66-1c-.29-.29-.64-.5-1-.81a2.14,2.14,0,0,1,1.21.55,1.55,1.55,0,0,1,.4.57A.89.89,0,0,1,1050.15,34.25Z"
              fill="#2f6840"
            />
            <path
              d="M1048.19,32.3a6.56,6.56,0,0,0-.7.16,3.45,3.45,0,0,0-.64.22,9.33,9.33,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2,2,0,0,1,1048.19,32.3Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1034.33,26.64c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1034.33,26.64Z"
              fill="#2f6840"
            />
            <path
              d="M1033.83,26.3c4.42-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1033.83,26.3Z"
              fill="#3ba525"
            />
            <path
              d="M1034.58,26.27a2.11,2.11,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74A2.34,2.34,0,0,1,1034,25a2,2,0,0,1,.47.54A1,1,0,0,1,1034.58,26.27Z"
              fill="#2f6840"
            />
            <path
              d="M1038.06,25.47c-.26,0-.49.05-.73.1a4.69,4.69,0,0,0-.67.17,13.44,13.44,0,0,0-1.35.53,2.5,2.5,0,0,1,1.24-.87A2.12,2.12,0,0,1,1038.06,25.47Z"
              fill="#2f6840"
            />
            <path
              d="M1036.69,28.68a1.86,1.86,0,0,0-.66-1c-.28-.29-.64-.5-1-.81a2.21,2.21,0,0,1,1.21.55,1.7,1.7,0,0,1,.41.57A.94.94,0,0,1,1036.69,28.68Z"
              fill="#2f6840"
            />
            <path
              d="M1034.73,26.73a7,7,0,0,0-.69.16,3.31,3.31,0,0,0-.65.22,10,10,0,0,0-1.25.65,2.31,2.31,0,0,1,1.11-1A2,2,0,0,1,1034.73,26.73Z"
              fill="#2f6840"
            />
          </g>
        </g>
      </g>
      <g>
        <path
          d="M1103.57,30.67l1.84,1.14a.59.59,0,0,0,.56,0l4.41-2a.6.6,0,0,0,.15-1h0a.61.61,0,0,0-.47-.14l-6.25.83A.6.6,0,0,0,1103.57,30.67Z"
          fill="#111160"
          opacity="0.68"
        />
        <g>
          <polygon
            points="1106.83 26.11 1104.35 26.64 1102.16 28.32 1105.83 29.79 1110.32 27.95 1106.83 26.11"
            fill="#ffedc8"
          />
          <polygon
            points="1102.16 28.32 1102.16 29.79 1105.68 31.3 1110.42 29.38 1110.32 27.95 1105.83 29.79 1102.16 28.32"
            fill="#ccae79"
          />
          <polygon
            points="1105.83 29.79 1105.68 31.3 1110.42 29.38 1110.32 27.95 1105.83 29.79"
            fill="#0416bf"
            opacity="0.14"
          />
          <path
            d="M1103.21,28.74a.69.69,0,0,1,0,.76c.16-.24.2-.68.28-.65Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M1104.75,29.36a2.08,2.08,0,0,0,.93-.94l-.67,1Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M1107.68,29a.69.69,0,0,1,.37.6l-.11-.7Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M1109.33,27.43a4.48,4.48,0,0,1-1.46,0,2.1,2.1,0,0,1-1.07.07s.78-.07,1.07.19A6.41,6.41,0,0,1,1109.33,27.43Z"
            fill="#996537"
            opacity="0.51"
          />
        </g>
      </g>
      <g>
        <path
          d="M1079.93,13.94l4,2.49a1.32,1.32,0,0,0,1.22.08l9.62-4.3a1.31,1.31,0,0,0,.32-2.18h0a1.34,1.34,0,0,0-1-.31l-13.64,1.82A1.3,1.3,0,0,0,1079.93,13.94Z"
          fill="#111160"
          opacity="0.68"
        />
        <g>
          <polygon
            points="1087.05 3.98 1081.62 5.13 1076.84 8.81 1084.85 12.02 1094.66 8 1087.05 3.98"
            fill="#ffedc8"
          />
          <polygon
            points="1076.84 8.81 1076.84 12.02 1084.53 15.31 1094.87 11.11 1094.66 8 1084.85 12.02 1076.84 8.81"
            fill="#ccae79"
          />
          <polygon
            points="1084.85 12.02 1084.53 15.31 1094.87 11.11 1094.66 8 1084.85 12.02"
            fill="#0416bf"
            opacity="0.14"
          />
          <path
            d="M1079.12,9.72a1.45,1.45,0,0,1,0,1.65c.37-.52.45-1.47.62-1.4Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M1082.5,11.08a4.59,4.59,0,0,0,2-2.06l-1.46,2.29Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M1088.9,10.36a1.48,1.48,0,0,1,.8,1.3l-.24-1.53Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M1092.49,6.85a9.44,9.44,0,0,1-3.19,0A4.51,4.51,0,0,1,1087,7s1.7-.16,2.32.42A13.93,13.93,0,0,1,1092.49,6.85Z"
            fill="#996537"
            opacity="0.51"
          />
        </g>
      </g>
      <g>
        <path
          d="M1086.2,31.28l3,1.86a1,1,0,0,0,.91.06l7.16-3.2a1,1,0,0,0,.24-1.62h0a.93.93,0,0,0-.76-.23l-10.15,1.35A1,1,0,0,0,1086.2,31.28Z"
          fill="#111160"
          opacity="0.68"
        />
        <g>
          <polygon
            points="1091.5 23.87 1087.46 24.73 1083.9 27.46 1089.87 29.85 1097.17 26.86 1091.5 23.87"
            fill="#ffedc8"
          />
          <polygon
            points="1083.9 27.46 1083.9 29.85 1089.63 32.31 1097.33 29.18 1097.17 26.86 1089.87 29.85 1083.9 27.46"
            fill="#ccae79"
          />
          <polygon
            points="1089.87 29.85 1089.63 32.31 1097.33 29.18 1097.17 26.86 1089.87 29.85"
            fill="#0416bf"
            opacity="0.14"
          />
          <path
            d="M1085.6,28.15a1.05,1.05,0,0,1,0,1.22c.27-.38.34-1.09.46-1Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M1088.12,29.15a3.39,3.39,0,0,0,1.51-1.52l-1.09,1.69Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M1092.88,28.62a1.12,1.12,0,0,1,.6,1l-.18-1.14Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M1095.55,26a7.07,7.07,0,0,1-2.37,0,3.41,3.41,0,0,1-1.73.12s1.27-.12,1.73.31A10.46,10.46,0,0,1,1095.55,26Z"
            fill="#996537"
            opacity="0.51"
          />
        </g>
      </g>
      <g>
        <path
          d="M1057.39,34.94l4,2.49a1.32,1.32,0,0,0,1.22.08l9.62-4.3a1.31,1.31,0,0,0,.32-2.18h0a1.34,1.34,0,0,0-1-.31l-13.63,1.82A1.3,1.3,0,0,0,1057.39,34.94Z"
          fill="#111160"
          opacity="0.68"
        />
        <g>
          <polygon
            points="1064.51 24.98 1059.08 26.13 1054.3 29.81 1062.31 33.02 1072.12 29 1064.51 24.98"
            fill="#ffedc8"
          />
          <polygon
            points="1054.3 29.81 1054.3 33.02 1061.99 36.31 1072.33 32.11 1072.12 29 1062.31 33.02 1054.3 29.81"
            fill="#ccae79"
          />
          <polygon
            points="1062.31 33.02 1061.99 36.31 1072.33 32.11 1072.12 29 1062.31 33.02"
            fill="#0416bf"
            opacity="0.14"
          />
          <path
            d="M1056.59,30.72a1.47,1.47,0,0,1,0,1.65c.36-.52.44-1.47.61-1.4Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M1060,32.08a4.59,4.59,0,0,0,2-2.06l-1.46,2.29Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M1066.36,31.36a1.48,1.48,0,0,1,.8,1.3l-.24-1.53Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M1070,27.85a9.44,9.44,0,0,1-3.19,0,4.51,4.51,0,0,1-2.32.16s1.7-.16,2.32.42A13.93,13.93,0,0,1,1070,27.85Z"
            fill="#996537"
            opacity="0.51"
          />
        </g>
      </g>
      <g>
        <path
          d="M1104.51,21s1.69,3.36,4,3.92,5.91-1.77,5.36.16,4.44,2.8,6.57,2.28,6.83-5.1,6.8-6.55S1104.51,21,1104.51,21Z"
          fill="#131b8c"
          opacity="0.63"
        />
        <g>
          <path
            d="M1104.43,18.28l.08,2.76,4,2.82,5.25-.14,1.25,2s3.63,1.69,6-.16a19.74,19.74,0,0,0,4.24-5.1l-.07-2.76Z"
            fill="#ccae79"
          />
          <path
            d="M1108.65,16.38l-4.22,1.9,4.35,2.81,5-.13,1.68,2.06s4.94,1.33,5.54-.15,4.25-5.15,4.25-5.15l-4-1.68Z"
            fill="#ffedc8"
          />
          <polygon
            points="1108.78 21.09 1108.56 23.86 1113.81 23.72 1113.8 20.96 1108.78 21.09"
            fill="#0416bf"
            opacity="0.14"
          />
          <path
            d="M1119.77,23.54s.87,2.51.08,2.68a12,12,0,0,0,5.49-5.74l-.07-2.76S1120.93,23.52,1119.77,23.54Z"
            fill="#0416bf"
            opacity="0.14"
          />
          <path
            d="M1116.38,23.23l1,.19s-.62-.17-.47,1A2.75,2.75,0,0,0,1116.38,23.23Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M1118.66,23.59c-.11,0,.2,0,1.09-.93a6,6,0,0,0,1.22-1.9s-2.13,2.46-1.6,2.81Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M1107,19.92a16,16,0,0,1,.06,2s-.12-1.5.3-1.76Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M1114.69,16.22l2-.06c.14,0-1.57,0-2,.94l0-.88"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M1106.56,17.32l1-.47s-.59.38-.36.46,1.17.45,1.55.25a1.53,1.53,0,0,1,1,0Z"
            fill="#996537"
            opacity="0.51"
          />
        </g>
      </g>
      <g>
        <g>
          <g>
            <path
              d="M1224.76,491.31c4.43-.25-4.32.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.36,1.72-1.16-2.91-1.16-2.91-.91,3.34-3,2.55-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,1224.76,491.31Z"
              fill="#2f6840"
            />
            <path
              d="M1224.26,491c4.42-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1224.26,491Z"
              fill="#3ba525"
            />
            <path
              d="M1225,490.94a2.06,2.06,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,2,2,0,0,1,.47.53A1,1,0,0,1,1225,490.94Z"
              fill="#2f6840"
            />
            <path
              d="M1228.49,490.14c-.26,0-.49,0-.73.1a3.65,3.65,0,0,0-.67.17,13.44,13.44,0,0,0-1.35.53,2.44,2.44,0,0,1,1.24-.87A2.07,2.07,0,0,1,1228.49,490.14Z"
              fill="#2f6840"
            />
            <path
              d="M1227.12,493.35a1.86,1.86,0,0,0-.66-1c-.28-.29-.64-.51-1-.81a2.08,2.08,0,0,1,1.21.55,1.76,1.76,0,0,1,.41.56A1,1,0,0,1,1227.12,493.35Z"
              fill="#2f6840"
            />
            <path
              d="M1225.16,491.39c-.24.06-.47.09-.69.16a4.14,4.14,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2,2,0,0,1,1225.16,491.39Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1222.11,500c4.42-.25-4.33.45-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,1222.11,500Z"
              fill="#2f6840"
            />
            <path
              d="M1221.6,499.69c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1221.6,499.69Z"
              fill="#3ba525"
            />
            <path
              d="M1222.35,499.66a2.08,2.08,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1222.35,499.66Z"
              fill="#2f6840"
            />
            <path
              d="M1225.83,498.87a5.21,5.21,0,0,0-.72.1,3.08,3.08,0,0,0-.68.17,11.41,11.41,0,0,0-1.35.53,2.44,2.44,0,0,1,1.24-.87A2.07,2.07,0,0,1,1225.83,498.87Z"
              fill="#2f6840"
            />
            <path
              d="M1224.46,502.08a1.86,1.86,0,0,0-.66-1c-.28-.29-.63-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.93,1.93,0,0,1,.41.57A1,1,0,0,1,1224.46,502.08Z"
              fill="#2f6840"
            />
            <path
              d="M1222.5,500.12c-.24.06-.47.09-.69.16a5,5,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2,2,0,0,1,1222.5,500.12Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1216.75,495.08c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.56,2.64,3.44-4.69.05-4.69.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1216.75,495.08Z"
              fill="#2f6840"
            />
            <path
              d="M1216.25,494.73c4.42-.25-4.33.46-4.36-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.87,14.87,0,0,1,1216.25,494.73Z"
              fill="#3ba525"
            />
            <path
              d="M1217,494.71a2.06,2.06,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,2.16,2.16,0,0,1,.47.53A1,1,0,0,1,1217,494.71Z"
              fill="#2f6840"
            />
            <path
              d="M1220.48,493.91c-.26,0-.49,0-.73.1a5.2,5.2,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.45,2.45,0,0,1,1.24-.87A2.07,2.07,0,0,1,1220.48,493.91Z"
              fill="#2f6840"
            />
            <path
              d="M1219.11,497.12a1.92,1.92,0,0,0-.66-1c-.28-.29-.64-.5-1-.81a2.08,2.08,0,0,1,1.21.55,1.55,1.55,0,0,1,.4.57A.89.89,0,0,1,1219.11,497.12Z"
              fill="#2f6840"
            />
            <path
              d="M1217.15,495.17c-.24.05-.47.08-.7.15a4.41,4.41,0,0,0-.64.23,9.33,9.33,0,0,0-1.25.65,2.22,2.22,0,0,1,1.11-1A2,2,0,0,1,1217.15,495.17Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1208.41,491.71c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1208.41,491.71Z"
              fill="#2f6840"
            />
            <path
              d="M1207.9,491.36c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1207.9,491.36Z"
              fill="#3ba525"
            />
            <path
              d="M1208.66,491.33a2.15,2.15,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1208.66,491.33Z"
              fill="#2f6840"
            />
            <path
              d="M1212.13,490.54c-.25,0-.49,0-.72.1a3.22,3.22,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.41,2.41,0,0,1,1.23-.87A2.07,2.07,0,0,1,1212.13,490.54Z"
              fill="#2f6840"
            />
            <path
              d="M1210.77,493.75a2,2,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.1,2.1,0,0,1,1.21.55,1.6,1.6,0,0,1,.4.56A1,1,0,0,1,1210.77,493.75Z"
              fill="#2f6840"
            />
            <path
              d="M1208.81,491.79c-.25.06-.48.09-.7.16a4.41,4.41,0,0,0-.64.23,9.33,9.33,0,0,0-1.25.65,2.18,2.18,0,0,1,1.11-1A2,2,0,0,1,1208.81,491.79Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1223.12,507.2c4.42-.25-4.33.45-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,1223.12,507.2Z"
              fill="#2f6840"
            />
            <path
              d="M1222.61,506.85c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1222.61,506.85Z"
              fill="#3ba525"
            />
            <path
              d="M1223.36,506.82a2.08,2.08,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1223.36,506.82Z"
              fill="#2f6840"
            />
            <path
              d="M1226.84,506a5.21,5.21,0,0,0-.72.1,3,3,0,0,0-.68.17,11.41,11.41,0,0,0-1.35.53,2.44,2.44,0,0,1,1.24-.87A2.07,2.07,0,0,1,1226.84,506Z"
              fill="#2f6840"
            />
            <path
              d="M1225.47,509.24a1.86,1.86,0,0,0-.66-1c-.28-.29-.63-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.93,1.93,0,0,1,.41.57A1,1,0,0,1,1225.47,509.24Z"
              fill="#2f6840"
            />
            <path
              d="M1223.51,507.28c-.24.06-.47.09-.69.16a5,5,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2,2,0,0,1,1223.51,507.28Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1209.66,501.63c4.42-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1209.66,501.63Z"
              fill="#2f6840"
            />
            <path
              d="M1209.15,501.28c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.92,3.34-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1209.15,501.28Z"
              fill="#3ba525"
            />
            <path
              d="M1209.91,501.25a2.21,2.21,0,0,0-.8-.93c-.33-.27-.71-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1209.91,501.25Z"
              fill="#2f6840"
            />
            <path
              d="M1213.38,500.46c-.25,0-.49,0-.72.1a3.22,3.22,0,0,0-.68.17c-.45.13-.87.34-1.35.53a2.48,2.48,0,0,1,1.24-.87A2.07,2.07,0,0,1,1213.38,500.46Z"
              fill="#2f6840"
            />
            <path
              d="M1212,503.67a1.9,1.9,0,0,0-.65-1c-.29-.29-.64-.51-1-.81a2.1,2.1,0,0,1,1.21.55,1.74,1.74,0,0,1,.4.56A1,1,0,0,1,1212,503.67Z"
              fill="#2f6840"
            />
            <path
              d="M1210.06,501.71c-.25.06-.48.09-.7.16a5,5,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.24,2.24,0,0,1,1.12-1A2,2,0,0,1,1210.06,501.71Z"
              fill="#2f6840"
            />
          </g>
        </g>
        <g>
          <g>
            <path
              d="M1250.66,503c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.92,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1250.66,503Z"
              fill="#2f6840"
            />
            <path
              d="M1250.16,502.62c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1250.16,502.62Z"
              fill="#3ba525"
            />
            <path
              d="M1250.91,502.59a2.15,2.15,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,2,2,0,0,1,.47.53A1,1,0,0,1,1250.91,502.59Z"
              fill="#2f6840"
            />
            <path
              d="M1254.39,501.8a5.36,5.36,0,0,0-.73.1,3.22,3.22,0,0,0-.68.17,10.33,10.33,0,0,0-1.34.53,2.4,2.4,0,0,1,1.24-.87A2.07,2.07,0,0,1,1254.39,501.8Z"
              fill="#2f6840"
            />
            <path
              d="M1253,505a1.94,1.94,0,0,0-.66-1c-.28-.29-.64-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A.92.92,0,0,1,1253,505Z"
              fill="#2f6840"
            />
            <path
              d="M1251.06,503.05c-.25.06-.48.09-.7.16a3.48,3.48,0,0,0-.64.23,9.33,9.33,0,0,0-1.25.65,2.22,2.22,0,0,1,1.11-1A2,2,0,0,1,1251.06,503.05Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1248,511.69c4.43-.25-4.33.46-4.35-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.92,3.34-3,2.55-2.25-2.27-2.07-2.37A14.86,14.86,0,0,1,1248,511.69Z"
              fill="#2f6840"
            />
            <path
              d="M1247.5,511.35c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1247.5,511.35Z"
              fill="#3ba525"
            />
            <path
              d="M1248.25,511.32a2,2,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1248.25,511.32Z"
              fill="#2f6840"
            />
            <path
              d="M1251.73,510.53c-.26,0-.5,0-.73.09a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.38,2.38,0,0,1,1.24-.86A2.07,2.07,0,0,1,1251.73,510.53Z"
              fill="#2f6840"
            />
            <path
              d="M1250.36,513.74a1.88,1.88,0,0,0-.66-1c-.28-.29-.64-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A.92.92,0,0,1,1250.36,513.74Z"
              fill="#2f6840"
            />
            <path
              d="M1248.4,511.78c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,9.24,9.24,0,0,0-1.25.64,2.24,2.24,0,0,1,1.11-1A2,2,0,0,1,1248.4,511.78Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1242.65,506.74c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1242.65,506.74Z"
              fill="#2f6840"
            />
            <path
              d="M1242.14,506.39c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1242.14,506.39Z"
              fill="#3ba525"
            />
            <path
              d="M1242.9,506.36a2.15,2.15,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1242.9,506.36Z"
              fill="#2f6840"
            />
            <path
              d="M1246.37,505.57a5.43,5.43,0,0,0-.72.1,3.22,3.22,0,0,0-.68.17,12,12,0,0,0-1.34.53,2.41,2.41,0,0,1,1.23-.87A2.07,2.07,0,0,1,1246.37,505.57Z"
              fill="#2f6840"
            />
            <path
              d="M1245,508.78a2,2,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.16,2.16,0,0,1,1.21.54,1.73,1.73,0,0,1,.4.57A1,1,0,0,1,1245,508.78Z"
              fill="#2f6840"
            />
            <path
              d="M1243.05,506.82c-.25.06-.48.09-.7.16a4.41,4.41,0,0,0-.64.23,9.33,9.33,0,0,0-1.25.65,2.18,2.18,0,0,1,1.11-1A2,2,0,0,1,1243.05,506.82Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1234.31,503.37c4.42-.26-4.33.45-4.35-.62s4.34-2.62,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.34,14.34,0,0,1,1234.31,503.37Z"
              fill="#2f6840"
            />
            <path
              d="M1233.8,503c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.92-2.16,3.63,3.56,2.65,3.44-4.69.05-4.69.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.92,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1233.8,503Z"
              fill="#3ba525"
            />
            <path
              d="M1234.55,503a2.07,2.07,0,0,0-.79-.93c-.33-.27-.71-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A.93.93,0,0,1,1234.55,503Z"
              fill="#2f6840"
            />
            <path
              d="M1238,502.2c-.25,0-.49,0-.72.09a4,4,0,0,0-.68.18,12,12,0,0,0-1.35.52,2.46,2.46,0,0,1,1.24-.86A2.07,2.07,0,0,1,1238,502.2Z"
              fill="#2f6840"
            />
            <path
              d="M1236.66,505.41a1.86,1.86,0,0,0-.65-1c-.29-.29-.64-.51-1-.81a2.16,2.16,0,0,1,1.21.54,1.78,1.78,0,0,1,.4.57A1,1,0,0,1,1236.66,505.41Z"
              fill="#2f6840"
            />
            <path
              d="M1234.71,503.45c-.25.06-.48.09-.7.16a3.15,3.15,0,0,0-.65.23,9.87,9.87,0,0,0-1.25.64,2.27,2.27,0,0,1,1.12-1A2,2,0,0,1,1234.71,503.45Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1249,518.85c4.43-.25-4.33.46-4.35-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.92,3.34-3,2.55-2.25-2.27-2.07-2.37A14.86,14.86,0,0,1,1249,518.85Z"
              fill="#2f6840"
            />
            <path
              d="M1248.51,518.51c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1248.51,518.51Z"
              fill="#3ba525"
            />
            <path
              d="M1249.26,518.48a2,2,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1249.26,518.48Z"
              fill="#2f6840"
            />
            <path
              d="M1252.74,517.69c-.26,0-.5,0-.73.09a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.38,2.38,0,0,1,1.24-.86A2.07,2.07,0,0,1,1252.74,517.69Z"
              fill="#2f6840"
            />
            <path
              d="M1251.37,520.9a1.88,1.88,0,0,0-.66-1c-.28-.29-.64-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A.92.92,0,0,1,1251.37,520.9Z"
              fill="#2f6840"
            />
            <path
              d="M1249.41,518.94c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,9.24,9.24,0,0,0-1.25.64,2.24,2.24,0,0,1,1.11-1A2,2,0,0,1,1249.41,518.94Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1235.56,513.29c4.42-.26-4.33.45-4.36-.62s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.25,14.25,0,0,1,1235.56,513.29Z"
              fill="#2f6840"
            />
            <path
              d="M1235.05,512.94c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.31,2-4.37,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1235.05,512.94Z"
              fill="#3ba525"
            />
            <path
              d="M1235.8,512.91a2,2,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1235.8,512.91Z"
              fill="#2f6840"
            />
            <path
              d="M1239.28,512.12c-.26,0-.49,0-.72.09a4,4,0,0,0-.68.18,11.31,11.31,0,0,0-1.35.52,2.42,2.42,0,0,1,1.24-.86A2.07,2.07,0,0,1,1239.28,512.12Z"
              fill="#2f6840"
            />
            <path
              d="M1237.91,515.33a1.82,1.82,0,0,0-.66-1c-.28-.29-.63-.51-1-.81a2.18,2.18,0,0,1,1.22.54,1.78,1.78,0,0,1,.4.57A1,1,0,0,1,1237.91,515.33Z"
              fill="#2f6840"
            />
            <path
              d="M1236,513.37c-.24.06-.47.09-.69.16a3.15,3.15,0,0,0-.65.23,9.87,9.87,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,1236,513.37Z"
              fill="#2f6840"
            />
          </g>
        </g>
        <g>
          <g>
            <path
              d="M1278.64,504.69c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.23-2.77,2.92-2.15,3.62,3.55,2.65,3.44-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.72-1.17-2.91-1.17-2.91-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1278.64,504.69Z"
              fill="#2f6840"
            />
            <path
              d="M1278.13,504.34c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.55,14.55,0,0,1,1278.13,504.34Z"
              fill="#3ba525"
            />
            <path
              d="M1278.89,504.31a2.15,2.15,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,2,2,0,0,1,.48.53A1,1,0,0,1,1278.89,504.31Z"
              fill="#2f6840"
            />
            <path
              d="M1282.37,503.52c-.26,0-.5,0-.73.1a4,4,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.41,2.41,0,0,1,1.23-.87A2.1,2.1,0,0,1,1282.37,503.52Z"
              fill="#2f6840"
            />
            <path
              d="M1281,506.73a2,2,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.1,2.1,0,0,1,1.21.55,1.6,1.6,0,0,1,.4.56A1,1,0,0,1,1281,506.73Z"
              fill="#2f6840"
            />
            <path
              d="M1279,504.77c-.25.06-.48.09-.7.16a4.41,4.41,0,0,0-.64.23,9.33,9.33,0,0,0-1.25.65,2.18,2.18,0,0,1,1.11-1A2,2,0,0,1,1279,504.77Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1276,513.42c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1276,513.42Z"
              fill="#2f6840"
            />
            <path
              d="M1275.48,513.07c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71S1276,514,1276,514s-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1275.48,513.07Z"
              fill="#3ba525"
            />
            <path
              d="M1276.23,513a2.15,2.15,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.88,1.88,0,0,1,.48.53A1,1,0,0,1,1276.23,513Z"
              fill="#2f6840"
            />
            <path
              d="M1279.71,512.25a5.36,5.36,0,0,0-.73.1,3.22,3.22,0,0,0-.68.17,12,12,0,0,0-1.34.53,2.4,2.4,0,0,1,1.24-.87A2.07,2.07,0,0,1,1279.71,512.25Z"
              fill="#2f6840"
            />
            <path
              d="M1278.34,515.46a2,2,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.73,1.73,0,0,1,.4.57A.92.92,0,0,1,1278.34,515.46Z"
              fill="#2f6840"
            />
            <path
              d="M1276.38,513.5c-.25.06-.48.09-.7.16a4.41,4.41,0,0,0-.64.23,9.33,9.33,0,0,0-1.25.65,2.22,2.22,0,0,1,1.11-1A2,2,0,0,1,1276.38,513.5Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1270.63,508.46c4.42-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.54-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1270.63,508.46Z"
              fill="#2f6840"
            />
            <path
              d="M1270.12,508.11c4.43-.25-4.33.46-4.35-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.28-2.07-2.37A14.86,14.86,0,0,1,1270.12,508.11Z"
              fill="#3ba525"
            />
            <path
              d="M1270.88,508.09a2.12,2.12,0,0,0-.8-.94c-.32-.27-.71-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.83,1.83,0,0,1,.47.53A1,1,0,0,1,1270.88,508.09Z"
              fill="#2f6840"
            />
            <path
              d="M1274.35,507.29c-.25,0-.49,0-.72.1a4,4,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.47,2.47,0,0,1,1.23-.87A2.07,2.07,0,0,1,1274.35,507.29Z"
              fill="#2f6840"
            />
            <path
              d="M1273,510.5a2,2,0,0,0-.66-1c-.29-.29-.64-.5-1-.81a2.1,2.1,0,0,1,1.21.55,1.68,1.68,0,0,1,.4.57A.94.94,0,0,1,1273,510.5Z"
              fill="#2f6840"
            />
            <path
              d="M1271,508.55a6.61,6.61,0,0,0-.7.15,4.41,4.41,0,0,0-.64.23,9.43,9.43,0,0,0-1.26.65,2.24,2.24,0,0,1,1.12-1A2,2,0,0,1,1271,508.55Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1262.29,505.09c4.42-.25-4.33.45-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,1262.29,505.09Z"
              fill="#2f6840"
            />
            <path
              d="M1261.78,504.74c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1261.78,504.74Z"
              fill="#3ba525"
            />
            <path
              d="M1262.53,504.71a2.13,2.13,0,0,0-.79-.93c-.33-.27-.71-.46-1.07-.74a2.34,2.34,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1262.53,504.71Z"
              fill="#2f6840"
            />
            <path
              d="M1266,503.92c-.25,0-.49,0-.72.1a3.22,3.22,0,0,0-.68.17,11.41,11.41,0,0,0-1.35.53,2.44,2.44,0,0,1,1.24-.87A2.07,2.07,0,0,1,1266,503.92Z"
              fill="#2f6840"
            />
            <path
              d="M1264.64,507.13a1.86,1.86,0,0,0-.66-1c-.28-.29-.63-.51-1-.81a2.18,2.18,0,0,1,1.22.54,1.9,1.9,0,0,1,.4.57A1,1,0,0,1,1264.64,507.13Z"
              fill="#2f6840"
            />
            <path
              d="M1262.68,505.17c-.24.06-.47.09-.69.16a5,5,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2,2,0,0,1,1262.68,505.17Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1277,520.58c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.23-2.77,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1277,520.58Z"
              fill="#2f6840"
            />
            <path
              d="M1276.49,520.23c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1276.49,520.23Z"
              fill="#3ba525"
            />
            <path
              d="M1277.24,520.2a2.15,2.15,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.88,1.88,0,0,1,.48.53A1,1,0,0,1,1277.24,520.2Z"
              fill="#2f6840"
            />
            <path
              d="M1280.72,519.41a5.36,5.36,0,0,0-.73.1,3.22,3.22,0,0,0-.68.17,12,12,0,0,0-1.34.53,2.4,2.4,0,0,1,1.24-.87A2.07,2.07,0,0,1,1280.72,519.41Z"
              fill="#2f6840"
            />
            <path
              d="M1279.35,522.62a2,2,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.73,1.73,0,0,1,.4.57A.92.92,0,0,1,1279.35,522.62Z"
              fill="#2f6840"
            />
            <path
              d="M1277.39,520.66c-.25.06-.48.09-.7.16a4.41,4.41,0,0,0-.64.23,9.33,9.33,0,0,0-1.25.65,2.22,2.22,0,0,1,1.11-1A2,2,0,0,1,1277.39,520.66Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1263.53,515c4.43-.25-4.32.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,1263.53,515Z"
              fill="#2f6840"
            />
            <path
              d="M1263,514.66c4.42-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1263,514.66Z"
              fill="#3ba525"
            />
            <path
              d="M1263.78,514.63a2.08,2.08,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1263.78,514.63Z"
              fill="#2f6840"
            />
            <path
              d="M1267.26,513.84c-.26,0-.49,0-.73.1a3,3,0,0,0-.67.17,11.41,11.41,0,0,0-1.35.53,2.44,2.44,0,0,1,1.24-.87A2.07,2.07,0,0,1,1267.26,513.84Z"
              fill="#2f6840"
            />
            <path
              d="M1265.89,517.05a1.92,1.92,0,0,0-.66-1c-.28-.29-.64-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.93,1.93,0,0,1,.41.57A1,1,0,0,1,1265.89,517.05Z"
              fill="#2f6840"
            />
            <path
              d="M1263.93,515.09c-.24.06-.47.09-.7.16a4.41,4.41,0,0,0-.64.23,10,10,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2,2,0,0,1,1263.93,515.09Z"
              fill="#2f6840"
            />
          </g>
        </g>
        <g>
          <g>
            <path
              d="M1291.25,481.06c4.43-.26-4.33.45-4.35-.62s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.37A14.77,14.77,0,0,1,1291.25,481.06Z"
              fill="#2f6840"
            />
            <path
              d="M1290.75,480.71c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1290.75,480.71Z"
              fill="#3ba525"
            />
            <path
              d="M1291.5,480.68a2.09,2.09,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.88,1.88,0,0,1,.48.53A1,1,0,0,1,1291.5,480.68Z"
              fill="#2f6840"
            />
            <path
              d="M1295,479.89c-.26,0-.5,0-.73.09a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.38,2.38,0,0,1,1.24-.86A2.07,2.07,0,0,1,1295,479.89Z"
              fill="#2f6840"
            />
            <path
              d="M1293.61,483.1a1.94,1.94,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A.92.92,0,0,1,1293.61,483.1Z"
              fill="#2f6840"
            />
            <path
              d="M1291.65,481.14c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,9.24,9.24,0,0,0-1.25.64,2.24,2.24,0,0,1,1.11-1A2,2,0,0,1,1291.65,481.14Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1288.59,489.78c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.92,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1288.59,489.78Z"
              fill="#2f6840"
            />
            <path
              d="M1288.09,489.44c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.24.27,2.24,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1288.09,489.44Z"
              fill="#3ba525"
            />
            <path
              d="M1288.84,489.41a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.34,2.34,0,0,1,1.29.45,2,2,0,0,1,.47.53A1,1,0,0,1,1288.84,489.41Z"
              fill="#2f6840"
            />
            <path
              d="M1292.32,488.62c-.26,0-.5,0-.73.09a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.38,2.38,0,0,1,1.24-.86A2.07,2.07,0,0,1,1292.32,488.62Z"
              fill="#2f6840"
            />
            <path
              d="M1291,491.83a1.94,1.94,0,0,0-.66-1c-.28-.29-.64-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A.92.92,0,0,1,1291,491.83Z"
              fill="#2f6840"
            />
            <path
              d="M1289,489.87c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,9.24,9.24,0,0,0-1.25.64,2.24,2.24,0,0,1,1.11-1A2,2,0,0,1,1289,489.87Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1283.24,484.83c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1283.24,484.83Z"
              fill="#2f6840"
            />
            <path
              d="M1282.73,484.48c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1282.73,484.48Z"
              fill="#3ba525"
            />
            <path
              d="M1283.49,484.45a2.15,2.15,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1283.49,484.45Z"
              fill="#2f6840"
            />
            <path
              d="M1287,483.66a5.43,5.43,0,0,0-.72.1,3.22,3.22,0,0,0-.68.17,10.33,10.33,0,0,0-1.34.53,2.41,2.41,0,0,1,1.23-.87A2.07,2.07,0,0,1,1287,483.66Z"
              fill="#2f6840"
            />
            <path
              d="M1285.6,486.87a1.94,1.94,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.16,2.16,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A1,1,0,0,1,1285.6,486.87Z"
              fill="#2f6840"
            />
            <path
              d="M1283.64,484.91c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,11.51,11.51,0,0,0-1.26.64,2.27,2.27,0,0,1,1.12-1A2,2,0,0,1,1283.64,484.91Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1274.9,481.45c4.42-.25-4.33.46-4.36-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.87,14.87,0,0,1,1274.9,481.45Z"
              fill="#2f6840"
            />
            <path
              d="M1274.39,481.11c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.23-2.78,2.92-2.16,3.63,3.56,2.65,3.44-4.69.05-4.69.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.17-2.9-1.17-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1274.39,481.11Z"
              fill="#3ba525"
            />
            <path
              d="M1275.14,481.08a2.07,2.07,0,0,0-.79-.93c-.33-.27-.71-.46-1.07-.74a2.34,2.34,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A.93.93,0,0,1,1275.14,481.08Z"
              fill="#2f6840"
            />
            <path
              d="M1278.62,480.29c-.25,0-.49,0-.72.09a4,4,0,0,0-.68.18,11.31,11.31,0,0,0-1.35.52,2.46,2.46,0,0,1,1.24-.86A2.07,2.07,0,0,1,1278.62,480.29Z"
              fill="#2f6840"
            />
            <path
              d="M1277.25,483.5a1.82,1.82,0,0,0-.66-1c-.28-.29-.63-.51-1-.81a2.15,2.15,0,0,1,1.22.54,1.78,1.78,0,0,1,.4.57A1,1,0,0,1,1277.25,483.5Z"
              fill="#2f6840"
            />
            <path
              d="M1275.3,481.54c-.25.06-.48.09-.7.16a3.15,3.15,0,0,0-.65.23,9.87,9.87,0,0,0-1.25.64,2.27,2.27,0,0,1,1.12-1A2,2,0,0,1,1275.3,481.54Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1289.6,496.94c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.92,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1289.6,496.94Z"
              fill="#2f6840"
            />
            <path
              d="M1289.1,496.6c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1289.1,496.6Z"
              fill="#3ba525"
            />
            <path
              d="M1289.85,496.57a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.34,2.34,0,0,1,1.29.45,2,2,0,0,1,.47.53A1,1,0,0,1,1289.85,496.57Z"
              fill="#2f6840"
            />
            <path
              d="M1293.33,495.78c-.26,0-.5,0-.73.09a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.38,2.38,0,0,1,1.24-.86A2.07,2.07,0,0,1,1293.33,495.78Z"
              fill="#2f6840"
            />
            <path
              d="M1292,499a1.94,1.94,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A.92.92,0,0,1,1292,499Z"
              fill="#2f6840"
            />
            <path
              d="M1290,497c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,9.24,9.24,0,0,0-1.25.64,2.24,2.24,0,0,1,1.11-1A2,2,0,0,1,1290,497Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1276.14,491.37c4.43-.25-4.32.46-4.35-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.86,14.86,0,0,1,1276.14,491.37Z"
              fill="#2f6840"
            />
            <path
              d="M1275.64,491c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1275.64,491Z"
              fill="#3ba525"
            />
            <path
              d="M1276.39,491a2,2,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1276.39,491Z"
              fill="#2f6840"
            />
            <path
              d="M1279.87,490.21c-.26,0-.49,0-.72.09a3.57,3.57,0,0,0-.68.18,11.31,11.31,0,0,0-1.35.52,2.42,2.42,0,0,1,1.24-.86A2.07,2.07,0,0,1,1279.87,490.21Z"
              fill="#2f6840"
            />
            <path
              d="M1278.5,493.42a1.82,1.82,0,0,0-.66-1c-.28-.29-.63-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.81,1.81,0,0,1,.41.57A1,1,0,0,1,1278.5,493.42Z"
              fill="#2f6840"
            />
            <path
              d="M1276.54,491.46c-.24.06-.47.09-.69.16a3,3,0,0,0-.65.23,9.87,9.87,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,1276.54,491.46Z"
              fill="#2f6840"
            />
          </g>
        </g>
        <g>
          <g>
            <path
              d="M1280.86,458c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1280.86,458Z"
              fill="#2f6840"
            />
            <path
              d="M1280.35,457.62c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.44-4.69.05-4.69.05,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1280.35,457.62Z"
              fill="#3ba525"
            />
            <path
              d="M1281.11,457.59a2.15,2.15,0,0,0-.8-.93c-.32-.27-.71-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1281.11,457.59Z"
              fill="#2f6840"
            />
            <path
              d="M1284.58,456.8a5.43,5.43,0,0,0-.72.1,3.22,3.22,0,0,0-.68.17,10.33,10.33,0,0,0-1.34.53,2.41,2.41,0,0,1,1.23-.87A2.07,2.07,0,0,1,1284.58,456.8Z"
              fill="#2f6840"
            />
            <path
              d="M1283.22,460a1.94,1.94,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.16,2.16,0,0,1,1.21.54,1.78,1.78,0,0,1,.4.57A1,1,0,0,1,1283.22,460Z"
              fill="#2f6840"
            />
            <path
              d="M1281.26,458.05c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,10.68,10.68,0,0,0-1.26.64,2.27,2.27,0,0,1,1.12-1A2,2,0,0,1,1281.26,458.05Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1278.2,466.69c4.43-.25-4.33.46-4.35-.61s4.35-2.62,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A15,15,0,0,1,1278.2,466.69Z"
              fill="#2f6840"
            />
            <path
              d="M1277.69,466.35c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1277.69,466.35Z"
              fill="#3ba525"
            />
            <path
              d="M1278.45,466.32a2.09,2.09,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1278.45,466.32Z"
              fill="#2f6840"
            />
            <path
              d="M1281.92,465.53c-.25,0-.49,0-.72.09a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.39,2.39,0,0,1,1.23-.86A2.07,2.07,0,0,1,1281.92,465.53Z"
              fill="#2f6840"
            />
            <path
              d="M1280.56,468.74a1.94,1.94,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.16,2.16,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A1,1,0,0,1,1280.56,468.74Z"
              fill="#2f6840"
            />
            <path
              d="M1278.6,466.78c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,10,10,0,0,0-1.26.64,2.27,2.27,0,0,1,1.12-1A2,2,0,0,1,1278.6,466.78Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1272.85,461.74c4.42-.25-4.33.45-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,1272.85,461.74Z"
              fill="#2f6840"
            />
            <path
              d="M1272.34,461.39c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.92-2.16,3.63,3.56,2.65,3.44-4.69.05-4.69.05,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1272.34,461.39Z"
              fill="#3ba525"
            />
            <path
              d="M1273.09,461.36a2.13,2.13,0,0,0-.79-.93c-.33-.27-.71-.46-1.07-.74a2.31,2.31,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A.94.94,0,0,1,1273.09,461.36Z"
              fill="#2f6840"
            />
            <path
              d="M1276.57,460.57a5.43,5.43,0,0,0-.72.1,3.22,3.22,0,0,0-.68.17,12.12,12.12,0,0,0-1.35.53,2.48,2.48,0,0,1,1.24-.87A2.07,2.07,0,0,1,1276.57,460.57Z"
              fill="#2f6840"
            />
            <path
              d="M1275.2,463.78a1.86,1.86,0,0,0-.66-1c-.28-.29-.63-.51-1-.81a2.16,2.16,0,0,1,1.21.54,1.9,1.9,0,0,1,.4.57A1,1,0,0,1,1275.2,463.78Z"
              fill="#2f6840"
            />
            <path
              d="M1273.25,461.82c-.25.06-.48.09-.7.16a3.87,3.87,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.24,2.24,0,0,1,1.12-1A2,2,0,0,1,1273.25,461.82Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1264.5,458.36c4.43-.25-4.32.46-4.35-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.27-2.07-2.37A14.86,14.86,0,0,1,1264.5,458.36Z"
              fill="#2f6840"
            />
            <path
              d="M1264,458c4.42-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1264,458Z"
              fill="#3ba525"
            />
            <path
              d="M1264.75,458a2,2,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1264.75,458Z"
              fill="#2f6840"
            />
            <path
              d="M1268.23,457.2c-.26,0-.49,0-.73.09a3.67,3.67,0,0,0-.67.18,11.31,11.31,0,0,0-1.35.52,2.42,2.42,0,0,1,1.24-.86A2.07,2.07,0,0,1,1268.23,457.2Z"
              fill="#2f6840"
            />
            <path
              d="M1266.86,460.41a1.82,1.82,0,0,0-.66-1c-.28-.29-.64-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.81,1.81,0,0,1,.41.57A1,1,0,0,1,1266.86,460.41Z"
              fill="#2f6840"
            />
            <path
              d="M1264.9,458.45c-.24.06-.47.09-.69.16a2.78,2.78,0,0,0-.65.23,9.87,9.87,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,1264.9,458.45Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1279.21,473.85c4.43-.25-4.33.46-4.35-.61s4.35-2.62,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A15,15,0,0,1,1279.21,473.85Z"
              fill="#2f6840"
            />
            <path
              d="M1278.7,473.51c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.44-4.69,0-4.69,0,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1278.7,473.51Z"
              fill="#3ba525"
            />
            <path
              d="M1279.46,473.48a2.09,2.09,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1279.46,473.48Z"
              fill="#2f6840"
            />
            <path
              d="M1282.93,472.69c-.25,0-.49,0-.72.09a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.39,2.39,0,0,1,1.23-.86A2.07,2.07,0,0,1,1282.93,472.69Z"
              fill="#2f6840"
            />
            <path
              d="M1281.57,475.9a1.94,1.94,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.16,2.16,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A1,1,0,0,1,1281.57,475.9Z"
              fill="#2f6840"
            />
            <path
              d="M1279.61,473.94c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,10,10,0,0,0-1.26.64,2.27,2.27,0,0,1,1.12-1A2,2,0,0,1,1279.61,473.94Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1265.75,468.28c4.43-.25-4.33.46-4.35-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.92,3.34-3,2.55-2.25-2.27-2.07-2.37A14.86,14.86,0,0,1,1265.75,468.28Z"
              fill="#2f6840"
            />
            <path
              d="M1265.25,467.94c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1265.25,467.94Z"
              fill="#3ba525"
            />
            <path
              d="M1266,467.91a2,2,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1266,467.91Z"
              fill="#2f6840"
            />
            <path
              d="M1269.48,467.12c-.26,0-.5,0-.73.09a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.38,2.38,0,0,1,1.24-.86A2.07,2.07,0,0,1,1269.48,467.12Z"
              fill="#2f6840"
            />
            <path
              d="M1268.11,470.33a1.88,1.88,0,0,0-.66-1c-.28-.29-.64-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A.92.92,0,0,1,1268.11,470.33Z"
              fill="#2f6840"
            />
            <path
              d="M1266.15,468.37c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,9.24,9.24,0,0,0-1.25.64,2.24,2.24,0,0,1,1.11-1A2,2,0,0,1,1266.15,468.37Z"
              fill="#2f6840"
            />
          </g>
        </g>
        <g>
          <g>
            <path
              d="M1254.52,447.25c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.69,0-4.69,0,6,.86,4,1.54-3.31,2-4.36,1.72-1.17-2.9-1.17-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1254.52,447.25Z"
              fill="#2f6840"
            />
            <path
              d="M1254,446.91c4.43-.25-4.32.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,1254,446.91Z"
              fill="#3ba525"
            />
            <path
              d="M1254.77,446.88a2.17,2.17,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.87,1.87,0,0,1,.47.54A.94.94,0,0,1,1254.77,446.88Z"
              fill="#2f6840"
            />
            <path
              d="M1258.24,446.08c-.25,0-.49.05-.72.1a5.2,5.2,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.47,2.47,0,0,1,1.23-.87A2.12,2.12,0,0,1,1258.24,446.08Z"
              fill="#2f6840"
            />
            <path
              d="M1256.88,449.29a2,2,0,0,0-.66-1c-.29-.29-.64-.5-1-.81a2.17,2.17,0,0,1,1.21.55,1.55,1.55,0,0,1,.4.57A.94.94,0,0,1,1256.88,449.29Z"
              fill="#2f6840"
            />
            <path
              d="M1254.92,447.34a6.56,6.56,0,0,0-.7.16,3.45,3.45,0,0,0-.64.22,9.33,9.33,0,0,0-1.25.65,2.22,2.22,0,0,1,1.11-1A2,2,0,0,1,1254.92,447.34Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1251.86,456c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.23-2.77,2.92-2.15,3.63,3.56,2.65,3.44-4.69.05-4.69.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.17-2.9-1.17-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1251.86,456Z"
              fill="#2f6840"
            />
            <path
              d="M1251.36,455.63c4.42-.25-4.33.46-4.36-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.37A14.87,14.87,0,0,1,1251.36,455.63Z"
              fill="#3ba525"
            />
            <path
              d="M1252.11,455.61a2.12,2.12,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,2.2,2.2,0,0,1,.48.53A1,1,0,0,1,1252.11,455.61Z"
              fill="#2f6840"
            />
            <path
              d="M1255.59,454.81c-.26,0-.5.05-.73.1a5.2,5.2,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.47,2.47,0,0,1,1.23-.87A2.15,2.15,0,0,1,1255.59,454.81Z"
              fill="#2f6840"
            />
            <path
              d="M1254.22,458a2,2,0,0,0-.66-1c-.29-.29-.64-.5-1-.81a2.08,2.08,0,0,1,1.21.55,1.55,1.55,0,0,1,.4.57A.89.89,0,0,1,1254.22,458Z"
              fill="#2f6840"
            />
            <path
              d="M1252.26,456.07a6.61,6.61,0,0,0-.7.15,4.41,4.41,0,0,0-.64.23,9.33,9.33,0,0,0-1.25.65,2.22,2.22,0,0,1,1.11-1A2,2,0,0,1,1252.26,456.07Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1246.51,451c4.42-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1246.51,451Z"
              fill="#2f6840"
            />
            <path
              d="M1246,450.68c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.64,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,1246,450.68Z"
              fill="#3ba525"
            />
            <path
              d="M1246.76,450.65a2.24,2.24,0,0,0-.8-.94c-.32-.26-.71-.46-1.07-.74a2.22,2.22,0,0,1,1.28.46,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1246.76,450.65Z"
              fill="#2f6840"
            />
            <path
              d="M1250.23,449.85c-.25,0-.49,0-.72.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.47,2.47,0,0,1,1.23-.87A2.12,2.12,0,0,1,1250.23,449.85Z"
              fill="#2f6840"
            />
            <path
              d="M1248.87,453.06a2,2,0,0,0-.66-1c-.29-.29-.64-.5-1-.81a2.24,2.24,0,0,1,1.21.55,1.78,1.78,0,0,1,.4.57A1,1,0,0,1,1248.87,453.06Z"
              fill="#2f6840"
            />
            <path
              d="M1246.91,451.11a6.56,6.56,0,0,0-.7.16,3.83,3.83,0,0,0-.65.22,10,10,0,0,0-1.25.65,2.29,2.29,0,0,1,1.12-1A2,2,0,0,1,1246.91,451.11Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1238.17,447.65c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.24.27,2.24,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1238.17,447.65Z"
              fill="#2f6840"
            />
            <path
              d="M1237.66,447.31c4.43-.26-4.33.45-4.35-.62s4.35-2.62,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.34,14.34,0,0,1,1237.66,447.31Z"
              fill="#3ba525"
            />
            <path
              d="M1238.41,447.28a2.11,2.11,0,0,0-.8-.94c-.32-.27-.7-.46-1.06-.74a2.34,2.34,0,0,1,1.28.45,2,2,0,0,1,.47.53A1,1,0,0,1,1238.41,447.28Z"
              fill="#2f6840"
            />
            <path
              d="M1241.89,446.48c-.26,0-.49,0-.72.1a5.2,5.2,0,0,0-.68.17,13.44,13.44,0,0,0-1.35.53,2.5,2.5,0,0,1,1.24-.87A2.12,2.12,0,0,1,1241.89,446.48Z"
              fill="#2f6840"
            />
            <path
              d="M1240.52,449.69a1.86,1.86,0,0,0-.66-1c-.28-.29-.63-.5-1-.81a2.2,2.2,0,0,1,1.22.55,1.68,1.68,0,0,1,.4.57A.94.94,0,0,1,1240.52,449.69Z"
              fill="#2f6840"
            />
            <path
              d="M1238.56,447.74a7,7,0,0,0-.69.15,5,5,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2,2,0,0,1,1238.56,447.74Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1252.87,463.14c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.23-2.77,2.92-2.15,3.63,3.56,2.65,3.44-4.69.05-4.69.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.17-2.9-1.17-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1252.87,463.14Z"
              fill="#2f6840"
            />
            <path
              d="M1252.36,462.79c4.43-.25-4.32.46-4.35-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.37A14.86,14.86,0,0,1,1252.36,462.79Z"
              fill="#3ba525"
            />
            <path
              d="M1253.12,462.77a2.12,2.12,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,2.2,2.2,0,0,1,.48.53A1,1,0,0,1,1253.12,462.77Z"
              fill="#2f6840"
            />
            <path
              d="M1256.6,462c-.26,0-.5,0-.73.1a5.2,5.2,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.47,2.47,0,0,1,1.23-.87A2.1,2.1,0,0,1,1256.6,462Z"
              fill="#2f6840"
            />
            <path
              d="M1255.23,465.18a2,2,0,0,0-.66-1c-.29-.29-.64-.5-1-.81a2.1,2.1,0,0,1,1.21.55,1.55,1.55,0,0,1,.4.57A.89.89,0,0,1,1255.23,465.18Z"
              fill="#2f6840"
            />
            <path
              d="M1253.27,463.23a6.61,6.61,0,0,0-.7.15,4.41,4.41,0,0,0-.64.23,9.33,9.33,0,0,0-1.25.65,2.18,2.18,0,0,1,1.11-1A2,2,0,0,1,1253.27,463.23Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1239.41,457.57c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.24.27,2.24,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1239.41,457.57Z"
              fill="#2f6840"
            />
            <path
              d="M1238.91,457.23c4.42-.26-4.33.45-4.35-.62s4.34-2.62,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.34,14.34,0,0,1,1238.91,457.23Z"
              fill="#3ba525"
            />
            <path
              d="M1239.66,457.2a2.11,2.11,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,2.16,2.16,0,0,1,.47.53A1,1,0,0,1,1239.66,457.2Z"
              fill="#2f6840"
            />
            <path
              d="M1243.14,456.4c-.26,0-.49.05-.73.1a4.69,4.69,0,0,0-.67.17,13.44,13.44,0,0,0-1.35.53,2.5,2.5,0,0,1,1.24-.87A2.12,2.12,0,0,1,1243.14,456.4Z"
              fill="#2f6840"
            />
            <path
              d="M1241.77,459.61a1.92,1.92,0,0,0-.66-1c-.28-.29-.64-.5-1-.81a2.14,2.14,0,0,1,1.21.55,1.7,1.7,0,0,1,.41.57A.94.94,0,0,1,1241.77,459.61Z"
              fill="#2f6840"
            />
            <path
              d="M1239.81,457.66c-.24,0-.47.08-.7.15a4.41,4.41,0,0,0-.64.23,10,10,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2,2,0,0,1,1239.81,457.66Z"
              fill="#2f6840"
            />
          </g>
        </g>
        <g>
          <g>
            <path
              d="M1231,435.22c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.23-2.78,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1231,435.22Z"
              fill="#2f6840"
            />
            <path
              d="M1230.52,434.88c4.43-.25-4.32.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.36,1.72-1.16-2.91-1.16-2.91-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.55,14.55,0,0,1,1230.52,434.88Z"
              fill="#3ba525"
            />
            <path
              d="M1231.28,434.85a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.21,2.21,0,0,1,1.28.45,1.88,1.88,0,0,1,.48.53A1,1,0,0,1,1231.28,434.85Z"
              fill="#2f6840"
            />
            <path
              d="M1234.76,434.05c-.26,0-.5.05-.73.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.39,2.39,0,0,1,1.23-.86A2.15,2.15,0,0,1,1234.76,434.05Z"
              fill="#2f6840"
            />
            <path
              d="M1233.39,437.26a2,2,0,0,0-.66-1c-.29-.28-.64-.5-1-.81a2.24,2.24,0,0,1,1.21.55,1.64,1.64,0,0,1,.4.57A.89.89,0,0,1,1233.39,437.26Z"
              fill="#2f6840"
            />
            <path
              d="M1231.43,435.31c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,8.22,8.22,0,0,0-1.25.64,2.2,2.2,0,0,1,1.11-1A2,2,0,0,1,1231.43,435.31Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1228.37,444c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.92-2.16,3.63,3.56,2.65,3.44-4.69.05-4.69.05,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1228.37,444Z"
              fill="#2f6840"
            />
            <path
              d="M1227.87,443.61c4.42-.25-4.33.45-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,1227.87,443.61Z"
              fill="#3ba525"
            />
            <path
              d="M1228.62,443.58a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.46-1.07-.74a2.22,2.22,0,0,1,1.28.46,1.88,1.88,0,0,1,.48.53A1,1,0,0,1,1228.62,443.58Z"
              fill="#2f6840"
            />
            <path
              d="M1232.1,442.78c-.26,0-.5.05-.73.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.45,2.45,0,0,1,1.24-.87A2.13,2.13,0,0,1,1232.1,442.78Z"
              fill="#2f6840"
            />
            <path
              d="M1230.73,446a2,2,0,0,0-.66-1c-.29-.29-.64-.5-1-.81a2.21,2.21,0,0,1,1.21.55,1.64,1.64,0,0,1,.4.57A.89.89,0,0,1,1230.73,446Z"
              fill="#2f6840"
            />
            <path
              d="M1228.77,444c-.25.06-.48.09-.7.16a3.45,3.45,0,0,0-.64.22,9.33,9.33,0,0,0-1.25.65,2.31,2.31,0,0,1,1.11-1A2,2,0,0,1,1228.77,444Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1223,439c4.42-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1223,439Z"
              fill="#2f6840"
            />
            <path
              d="M1222.51,438.65c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.56,2.64,3.44-4.69.05-4.69.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1222.51,438.65Z"
              fill="#3ba525"
            />
            <path
              d="M1223.27,438.62a2.17,2.17,0,0,0-.8-.94c-.32-.26-.71-.45-1.07-.73a2.21,2.21,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1223.27,438.62Z"
              fill="#2f6840"
            />
            <path
              d="M1226.74,437.83c-.25,0-.49,0-.72.09a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.39,2.39,0,0,1,1.23-.86A2.07,2.07,0,0,1,1226.74,437.83Z"
              fill="#2f6840"
            />
            <path
              d="M1225.38,441a2,2,0,0,0-.66-1c-.29-.28-.64-.5-1-.8a2.16,2.16,0,0,1,1.21.54,1.78,1.78,0,0,1,.4.57A1,1,0,0,1,1225.38,441Z"
              fill="#2f6840"
            />
            <path
              d="M1223.42,439.08c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,9.34,9.34,0,0,0-1.26.64,2.27,2.27,0,0,1,1.12-1A2,2,0,0,1,1223.42,439.08Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1214.68,435.62c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1214.68,435.62Z"
              fill="#2f6840"
            />
            <path
              d="M1214.17,435.28c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.23-2.77,2.92-2.15,3.62,3.55,2.65,3.44-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1214.17,435.28Z"
              fill="#3ba525"
            />
            <path
              d="M1214.92,435.25a2.15,2.15,0,0,0-.79-.94c-.33-.26-.71-.45-1.07-.74a2.35,2.35,0,0,1,1.28.46,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1214.92,435.25Z"
              fill="#2f6840"
            />
            <path
              d="M1218.4,434.45c-.25,0-.49.05-.72.1a4,4,0,0,0-.68.18,11.31,11.31,0,0,0-1.35.52,2.5,2.5,0,0,1,1.24-.87A2.12,2.12,0,0,1,1218.4,434.45Z"
              fill="#2f6840"
            />
            <path
              d="M1217,437.66a1.9,1.9,0,0,0-.66-1c-.28-.28-.63-.5-1-.81a2.24,2.24,0,0,1,1.22.55,1.78,1.78,0,0,1,.4.57A.94.94,0,0,1,1217,437.66Z"
              fill="#2f6840"
            />
            <path
              d="M1215.08,435.71c-.25.06-.48.09-.7.16a3.83,3.83,0,0,0-.65.22,10,10,0,0,0-1.25.65,2.36,2.36,0,0,1,1.11-1A2.07,2.07,0,0,1,1215.08,435.71Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1229.38,451.11c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.23-2.78,2.92-2.16,3.63,3.56,2.65,3.44-4.69.05-4.69.05,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1229.38,451.11Z"
              fill="#2f6840"
            />
            <path
              d="M1228.88,450.77c4.42-.25-4.33.45-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,1228.88,450.77Z"
              fill="#3ba525"
            />
            <path
              d="M1229.63,450.74a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.46-1.07-.74a2.22,2.22,0,0,1,1.28.46,1.88,1.88,0,0,1,.48.53A1,1,0,0,1,1229.63,450.74Z"
              fill="#2f6840"
            />
            <path
              d="M1233.11,449.94c-.26,0-.5.05-.73.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.45,2.45,0,0,1,1.24-.87A2.13,2.13,0,0,1,1233.11,449.94Z"
              fill="#2f6840"
            />
            <path
              d="M1231.74,453.15a2,2,0,0,0-.66-1c-.29-.29-.64-.5-1-.81a2.21,2.21,0,0,1,1.21.55,1.64,1.64,0,0,1,.4.57A.89.89,0,0,1,1231.74,453.15Z"
              fill="#2f6840"
            />
            <path
              d="M1229.78,451.2c-.25.06-.48.09-.7.16a3.45,3.45,0,0,0-.64.22,9.33,9.33,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2,2,0,0,1,1229.78,451.2Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1215.92,445.54c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1215.92,445.54Z"
              fill="#2f6840"
            />
            <path
              d="M1215.42,445.2c4.42-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1215.42,445.2Z"
              fill="#3ba525"
            />
            <path
              d="M1216.17,445.17a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.74a2.35,2.35,0,0,1,1.29.46,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1216.17,445.17Z"
              fill="#2f6840"
            />
            <path
              d="M1219.65,444.37c-.26,0-.49.05-.73.1a3.67,3.67,0,0,0-.67.18,11.31,11.31,0,0,0-1.35.52,2.5,2.5,0,0,1,1.24-.87A2.12,2.12,0,0,1,1219.65,444.37Z"
              fill="#2f6840"
            />
            <path
              d="M1218.28,447.58a1.9,1.9,0,0,0-.66-1c-.28-.28-.64-.5-1-.81a2.21,2.21,0,0,1,1.21.55,1.81,1.81,0,0,1,.41.57A.94.94,0,0,1,1218.28,447.58Z"
              fill="#2f6840"
            />
            <path
              d="M1216.32,445.63c-.24.06-.47.09-.69.16a3.31,3.31,0,0,0-.65.22,10,10,0,0,0-1.25.65,2.36,2.36,0,0,1,1.11-1A2,2,0,0,1,1216.32,445.63Z"
              fill="#2f6840"
            />
          </g>
        </g>
      </g>
      <g>
        <g>
          <g>
            <path
              d="M1192,428.52c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.44-4.69.05-4.69.05,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1192,428.52Z"
              fill="#2f6840"
            />
            <path
              d="M1191.52,428.18c4.42-.25-4.33.45-4.35-.61s4.34-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.72-1.16-2.91-1.16-2.91-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1191.52,428.18Z"
              fill="#3ba525"
            />
            <path
              d="M1192.27,428.15a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.26,2.26,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1192.27,428.15Z"
              fill="#2f6840"
            />
            <path
              d="M1195.75,427.35c-.26,0-.49,0-.73.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.45,2.45,0,0,1,1.24-.87A2.12,2.12,0,0,1,1195.75,427.35Z"
              fill="#2f6840"
            />
            <path
              d="M1194.38,430.56a2,2,0,0,0-.66-1c-.28-.28-.64-.5-1-.81a2.21,2.21,0,0,1,1.21.55,1.64,1.64,0,0,1,.4.57A.89.89,0,0,1,1194.38,430.56Z"
              fill="#2f6840"
            />
            <path
              d="M1192.42,428.61c-.24.06-.47.09-.7.16a3.45,3.45,0,0,0-.64.22,9.33,9.33,0,0,0-1.25.65,2.36,2.36,0,0,1,1.11-1A2,2,0,0,1,1192.42,428.61Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1189.36,437.25c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1189.36,437.25Z"
              fill="#2f6840"
            />
            <path
              d="M1188.86,436.91c4.42-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1188.86,436.91Z"
              fill="#3ba525"
            />
            <path
              d="M1189.61,436.88a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.29.46,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1189.61,436.88Z"
              fill="#2f6840"
            />
            <path
              d="M1193.09,436.08c-.26,0-.49.05-.73.1a3.67,3.67,0,0,0-.67.18,11.31,11.31,0,0,0-1.35.52,2.5,2.5,0,0,1,1.24-.87A2.12,2.12,0,0,1,1193.09,436.08Z"
              fill="#2f6840"
            />
            <path
              d="M1191.72,439.29a2,2,0,0,0-.66-1c-.28-.29-.64-.5-1-.81a2.21,2.21,0,0,1,1.21.55,1.81,1.81,0,0,1,.41.57A.94.94,0,0,1,1191.72,439.29Z"
              fill="#2f6840"
            />
            <path
              d="M1189.76,437.34c-.24.06-.47.08-.7.16a3.45,3.45,0,0,0-.64.22,10,10,0,0,0-1.25.65,2.31,2.31,0,0,1,1.11-1A2,2,0,0,1,1189.76,437.34Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1184,432.29c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.92,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1184,432.29Z"
              fill="#2f6840"
            />
            <path
              d="M1183.51,432c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.54-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,1183.51,432Z"
              fill="#3ba525"
            />
            <path
              d="M1184.26,431.92a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.26,2.26,0,0,1,1.29.45,2,2,0,0,1,.47.53A1,1,0,0,1,1184.26,431.92Z"
              fill="#2f6840"
            />
            <path
              d="M1187.74,431.12c-.26,0-.5.05-.73.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.38,2.38,0,0,1,1.24-.86A2.12,2.12,0,0,1,1187.74,431.12Z"
              fill="#2f6840"
            />
            <path
              d="M1186.37,434.33a2,2,0,0,0-.66-1c-.29-.28-.64-.5-1-.8a2.13,2.13,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A.89.89,0,0,1,1186.37,434.33Z"
              fill="#2f6840"
            />
            <path
              d="M1184.41,432.38c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,9.24,9.24,0,0,0-1.25.64,2.24,2.24,0,0,1,1.11-1A2,2,0,0,1,1184.41,432.38Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1175.67,428.92c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1175.67,428.92Z"
              fill="#2f6840"
            />
            <path
              d="M1175.16,428.58c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.64,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,1175.16,428.58Z"
              fill="#3ba525"
            />
            <path
              d="M1175.92,428.55a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.46-1.07-.74a2.22,2.22,0,0,1,1.28.46,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1175.92,428.55Z"
              fill="#2f6840"
            />
            <path
              d="M1179.39,427.75c-.25,0-.49.05-.72.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.47,2.47,0,0,1,1.23-.87A2.12,2.12,0,0,1,1179.39,427.75Z"
              fill="#2f6840"
            />
            <path
              d="M1178,431a2,2,0,0,0-.66-1c-.29-.29-.64-.5-1-.81a2.24,2.24,0,0,1,1.21.55,1.78,1.78,0,0,1,.4.57A.94.94,0,0,1,1178,431Z"
              fill="#2f6840"
            />
            <path
              d="M1176.07,429c-.25.06-.48.09-.7.16a3.45,3.45,0,0,0-.64.22,10.08,10.08,0,0,0-1.26.65,2.34,2.34,0,0,1,1.12-1A2,2,0,0,1,1176.07,429Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1190.37,444.41c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1190.37,444.41Z"
              fill="#2f6840"
            />
            <path
              d="M1189.87,444.07c4.42-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1189.87,444.07Z"
              fill="#3ba525"
            />
            <path
              d="M1190.62,444a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.29.46,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1190.62,444Z"
              fill="#2f6840"
            />
            <path
              d="M1194.1,443.24c-.26,0-.49.05-.73.1a4.69,4.69,0,0,0-.67.17,13.44,13.44,0,0,0-1.35.53,2.5,2.5,0,0,1,1.24-.87A2.12,2.12,0,0,1,1194.1,443.24Z"
              fill="#2f6840"
            />
            <path
              d="M1192.73,446.45a2,2,0,0,0-.66-1c-.28-.29-.64-.5-1-.81a2.21,2.21,0,0,1,1.21.55,1.81,1.81,0,0,1,.41.57A.94.94,0,0,1,1192.73,446.45Z"
              fill="#2f6840"
            />
            <path
              d="M1190.77,444.5c-.24.06-.47.08-.7.16a3.45,3.45,0,0,0-.64.22,10,10,0,0,0-1.25.65,2.31,2.31,0,0,1,1.11-1A2,2,0,0,1,1190.77,444.5Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1176.92,438.84c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1176.92,438.84Z"
              fill="#2f6840"
            />
            <path
              d="M1176.41,438.5c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1176.41,438.5Z"
              fill="#3ba525"
            />
            <path
              d="M1177.16,438.47a2.15,2.15,0,0,0-.79-.94c-.33-.26-.71-.46-1.07-.74a2.27,2.27,0,0,1,1.28.46,1.71,1.71,0,0,1,.47.53A.93.93,0,0,1,1177.16,438.47Z"
              fill="#2f6840"
            />
            <path
              d="M1180.64,437.67c-.25,0-.49.05-.72.1a4,4,0,0,0-.68.18,11.31,11.31,0,0,0-1.35.52,2.54,2.54,0,0,1,1.24-.87A2.12,2.12,0,0,1,1180.64,437.67Z"
              fill="#2f6840"
            />
            <path
              d="M1179.27,440.88a1.9,1.9,0,0,0-.66-1c-.28-.29-.63-.5-1-.81a2.24,2.24,0,0,1,1.22.55,1.78,1.78,0,0,1,.4.57A.94.94,0,0,1,1179.27,440.88Z"
              fill="#2f6840"
            />
            <path
              d="M1177.32,438.93c-.25.06-.48.09-.7.16a3.83,3.83,0,0,0-.65.22,10,10,0,0,0-1.25.65,2.34,2.34,0,0,1,1.12-1A2,2,0,0,1,1177.32,438.93Z"
              fill="#2f6840"
            />
          </g>
        </g>
        <g>
          <g>
            <path
              d="M1170.92,409.89c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1170.92,409.89Z"
              fill="#2f6840"
            />
            <path
              d="M1170.42,409.55c4.42-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.54-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1170.42,409.55Z"
              fill="#3ba525"
            />
            <path
              d="M1171.17,409.52a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.26,2.26,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1171.17,409.52Z"
              fill="#2f6840"
            />
            <path
              d="M1174.65,408.72c-.26,0-.49,0-.73.1a3.67,3.67,0,0,0-.67.18,11.31,11.31,0,0,0-1.35.52,2.42,2.42,0,0,1,1.24-.86A2.12,2.12,0,0,1,1174.65,408.72Z"
              fill="#2f6840"
            />
            <path
              d="M1173.28,411.93a2,2,0,0,0-.66-1c-.28-.28-.64-.5-1-.8a2.13,2.13,0,0,1,1.21.54,1.81,1.81,0,0,1,.41.57A.94.94,0,0,1,1173.28,411.93Z"
              fill="#2f6840"
            />
            <path
              d="M1171.32,410c-.24.06-.47.09-.7.16a2.87,2.87,0,0,0-.64.23,9.87,9.87,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,1171.32,410Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1168.26,418.62c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1168.26,418.62Z"
              fill="#2f6840"
            />
            <path
              d="M1167.76,418.28c4.42-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1167.76,418.28Z"
              fill="#3ba525"
            />
            <path
              d="M1168.51,418.25a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.74a2.35,2.35,0,0,1,1.29.46,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1168.51,418.25Z"
              fill="#2f6840"
            />
            <path
              d="M1172,417.45c-.26,0-.49.05-.73.1a3.67,3.67,0,0,0-.67.18,11.31,11.31,0,0,0-1.35.52,2.5,2.5,0,0,1,1.24-.87A2.12,2.12,0,0,1,1172,417.45Z"
              fill="#2f6840"
            />
            <path
              d="M1170.62,420.66a1.9,1.9,0,0,0-.66-1c-.28-.28-.64-.5-1-.81a2.21,2.21,0,0,1,1.21.55,1.81,1.81,0,0,1,.41.57A.94.94,0,0,1,1170.62,420.66Z"
              fill="#2f6840"
            />
            <path
              d="M1168.66,418.71c-.24.06-.47.09-.69.16a3.55,3.55,0,0,0-.65.22,10,10,0,0,0-1.25.65,2.36,2.36,0,0,1,1.11-1A2,2,0,0,1,1168.66,418.71Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1162.91,413.66c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.92,3.34-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1162.91,413.66Z"
              fill="#2f6840"
            />
            <path
              d="M1162.41,413.32c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1162.41,413.32Z"
              fill="#3ba525"
            />
            <path
              d="M1163.16,413.29a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1163.16,413.29Z"
              fill="#2f6840"
            />
            <path
              d="M1166.64,412.5c-.26,0-.5,0-.73.09a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.38,2.38,0,0,1,1.24-.86A2.07,2.07,0,0,1,1166.64,412.5Z"
              fill="#2f6840"
            />
            <path
              d="M1165.27,415.71a1.88,1.88,0,0,0-.66-1c-.28-.29-.64-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A.92.92,0,0,1,1165.27,415.71Z"
              fill="#2f6840"
            />
            <path
              d="M1163.31,413.75c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,9.24,9.24,0,0,0-1.25.64,2.24,2.24,0,0,1,1.11-1A2,2,0,0,1,1163.31,413.75Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1154.57,410.29c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.55-3.31,2-4.37,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1154.57,410.29Z"
              fill="#2f6840"
            />
            <path
              d="M1154.06,410c4.43-.25-4.32.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.36,1.72-1.16-2.91-1.16-2.91-.91,3.34-3,2.55-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,1154.06,410Z"
              fill="#3ba525"
            />
            <path
              d="M1154.82,409.92a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.21,2.21,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1154.82,409.92Z"
              fill="#2f6840"
            />
            <path
              d="M1158.29,409.12c-.25,0-.49.05-.72.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.47,2.47,0,0,1,1.23-.87A2.12,2.12,0,0,1,1158.29,409.12Z"
              fill="#2f6840"
            />
            <path
              d="M1156.93,412.33a2,2,0,0,0-.66-1c-.29-.28-.64-.5-1-.81a2.24,2.24,0,0,1,1.21.55,1.64,1.64,0,0,1,.4.57A.94.94,0,0,1,1156.93,412.33Z"
              fill="#2f6840"
            />
            <path
              d="M1155,410.38c-.25.06-.48.09-.7.16a3.45,3.45,0,0,0-.64.22,10.08,10.08,0,0,0-1.26.65,2.34,2.34,0,0,1,1.12-1A2,2,0,0,1,1155,410.38Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1169.27,425.78c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1169.27,425.78Z"
              fill="#2f6840"
            />
            <path
              d="M1168.77,425.44c4.42-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1168.77,425.44Z"
              fill="#3ba525"
            />
            <path
              d="M1169.52,425.41a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.74a2.35,2.35,0,0,1,1.29.46,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1169.52,425.41Z"
              fill="#2f6840"
            />
            <path
              d="M1173,424.61c-.26,0-.49.05-.73.1a3.67,3.67,0,0,0-.67.18,11.31,11.31,0,0,0-1.35.52,2.5,2.5,0,0,1,1.24-.87A2.12,2.12,0,0,1,1173,424.61Z"
              fill="#2f6840"
            />
            <path
              d="M1171.63,427.82a1.9,1.9,0,0,0-.66-1c-.28-.28-.64-.5-1-.81a2.21,2.21,0,0,1,1.21.55,1.81,1.81,0,0,1,.41.57A.94.94,0,0,1,1171.63,427.82Z"
              fill="#2f6840"
            />
            <path
              d="M1169.67,425.87c-.24.06-.47.09-.69.16a3.31,3.31,0,0,0-.65.22,10,10,0,0,0-1.25.65,2.36,2.36,0,0,1,1.11-1A2,2,0,0,1,1169.67,425.87Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1155.82,420.21c4.42-.25-4.33.46-4.35-.61s4.34-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1155.82,420.21Z"
              fill="#2f6840"
            />
            <path
              d="M1155.31,419.87c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.92-2.15,3.63,3.55,2.65,3.44-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.72-1.16-2.91-1.16-2.91-.92,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1155.31,419.87Z"
              fill="#3ba525"
            />
            <path
              d="M1156.06,419.84a2.15,2.15,0,0,0-.79-.94c-.33-.26-.71-.45-1.07-.73a2.21,2.21,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A.93.93,0,0,1,1156.06,419.84Z"
              fill="#2f6840"
            />
            <path
              d="M1159.54,419c-.25,0-.49,0-.72.1a4,4,0,0,0-.68.18,12,12,0,0,0-1.35.52A2.54,2.54,0,0,1,1158,419,2.12,2.12,0,0,1,1159.54,419Z"
              fill="#2f6840"
            />
            <path
              d="M1158.17,422.25a1.94,1.94,0,0,0-.65-1c-.29-.28-.64-.5-1-.81a2.24,2.24,0,0,1,1.21.55,1.78,1.78,0,0,1,.4.57A.94.94,0,0,1,1158.17,422.25Z"
              fill="#2f6840"
            />
            <path
              d="M1156.22,420.3c-.25.06-.48.09-.7.16a3.83,3.83,0,0,0-.65.22,10,10,0,0,0-1.25.65,2.34,2.34,0,0,1,1.12-1A2,2,0,0,1,1156.22,420.3Z"
              fill="#2f6840"
            />
          </g>
        </g>
      </g>
      <g>
        <path
          d="M1221.87,457.46l2.26,1.4a.71.71,0,0,0,.68,0l5.42-2.42a.73.73,0,0,0,.18-1.22h0a.76.76,0,0,0-.58-.18l-7.67,1A.73.73,0,0,0,1221.87,457.46Z"
          fill="#111160"
          opacity="0.68"
        />
        <g>
          <polygon
            points="1225.88 451.85 1222.82 452.5 1220.13 454.57 1224.64 456.38 1230.16 454.11 1225.88 451.85"
            fill="#ffedc8"
          />
          <polygon
            points="1220.13 454.57 1220.13 456.38 1224.46 458.23 1230.28 455.87 1230.16 454.11 1224.64 456.38 1220.13 454.57"
            fill="#ccae79"
          />
          <polygon
            points="1224.64 456.38 1224.46 458.23 1230.28 455.87 1230.16 454.11 1224.64 456.38"
            fill="#0416bf"
            opacity="0.14"
          />
          <path
            d="M1221.42,455.08a.83.83,0,0,1,0,.93c.2-.29.25-.83.34-.79Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M1223.32,455.85a2.57,2.57,0,0,0,1.14-1.16l-.82,1.28Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M1226.92,455.44a.84.84,0,0,1,.45.73l-.14-.86Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M1228.94,453.47a5.32,5.32,0,0,1-1.79,0,2.64,2.64,0,0,1-1.31.09s1-.09,1.31.23A8,8,0,0,1,1228.94,453.47Z"
            fill="#996537"
            opacity="0.51"
          />
        </g>
      </g>
      <g>
        <path
          d="M1230.24,507.22l2.25,1.4a.74.74,0,0,0,.69.05l5.42-2.43a.73.73,0,0,0,.18-1.22h0a.72.72,0,0,0-.58-.17l-7.67,1A.73.73,0,0,0,1230.24,507.22Z"
          fill="#111160"
          opacity="0.68"
        />
        <g>
          <polygon
            points="1234.24 501.61 1231.19 502.26 1228.5 504.33 1233.01 506.14 1238.53 503.88 1234.24 501.61"
            fill="#ffedc8"
          />
          <polygon
            points="1228.5 504.33 1228.5 506.14 1232.83 507.99 1238.65 505.63 1238.53 503.88 1233.01 506.14 1228.5 504.33"
            fill="#ccae79"
          />
          <polygon
            points="1233.01 506.14 1232.83 507.99 1238.65 505.63 1238.53 503.88 1233.01 506.14"
            fill="#0416bf"
            opacity="0.14"
          />
          <path
            d="M1229.78,504.85a.79.79,0,0,1,0,.92c.21-.29.26-.82.35-.79Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M1231.69,505.61a2.58,2.58,0,0,0,1.13-1.16l-.81,1.29Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M1235.29,505.2a.84.84,0,0,1,.45.73l-.14-.86Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M1237.31,503.23a5.37,5.37,0,0,1-1.8,0,2.6,2.6,0,0,1-1.3.09s1-.09,1.3.24A7.72,7.72,0,0,1,1237.31,503.23Z"
            fill="#996537"
            opacity="0.51"
          />
        </g>
      </g>
      <g>
        <path
          d="M1242.16,464l3.89,2.42a1.27,1.27,0,0,0,1.18.08l9.34-4.18a1.27,1.27,0,0,0,.32-2.11h0a1.34,1.34,0,0,0-1-.3l-13.23,1.76A1.27,1.27,0,0,0,1242.16,464Z"
          fill="#111160"
          opacity="0.68"
        />
        <g>
          <polygon
            points="1249.06 454.36 1243.8 455.48 1239.16 459.04 1246.93 462.16 1256.45 458.26 1249.06 454.36"
            fill="#ffedc8"
          />
          <polygon
            points="1239.16 459.04 1239.16 462.16 1246.62 465.36 1256.66 461.28 1256.45 458.26 1246.93 462.16 1239.16 459.04"
            fill="#ccae79"
          />
          <polygon
            points="1246.93 462.16 1246.62 465.36 1256.66 461.28 1256.45 458.26 1246.93 462.16"
            fill="#0416bf"
            opacity="0.14"
          />
          <path
            d="M1241.38,459.93a1.41,1.41,0,0,1,0,1.6c.35-.5.43-1.42.59-1.36Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M1244.66,461.25a4.47,4.47,0,0,0,2-2l-1.41,2.22Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M1250.86,460.55a1.44,1.44,0,0,1,.78,1.26l-.23-1.48Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M1254.34,457.15a9.38,9.38,0,0,1-3.09,0,4.43,4.43,0,0,1-2.25.15s1.65-.16,2.25.41A13.28,13.28,0,0,1,1254.34,457.15Z"
            fill="#996537"
            opacity="0.51"
          />
        </g>
      </g>
      <g>
        <path
          d="M1289.6,479.67s-1.6,3.19-3.83,3.72-5.6-1.68-5.08.16-4.2,2.65-6.23,2.15-6.47-4.83-6.45-6.2S1289.6,479.67,1289.6,479.67Z"
          fill="#131b8c"
          opacity="0.63"
        />
        <g>
          <path
            d="M1289.67,477.06l-.07,2.61-3.84,2.68-5-.14-1.18,1.92s-3.44,1.6-5.73-.16a18.62,18.62,0,0,1-4-4.83l.07-2.61Z"
            fill="#ccae79"
          />
          <path
            d="M1285.67,475.26l4,1.8-4.12,2.66-4.76-.13-1.59,2s-4.68,1.27-5.25-.14-4-4.88-4-4.88l3.74-1.6Z"
            fill="#ffedc8"
          />
          <polygon
            points="1285.55 479.72 1285.76 482.35 1280.78 482.21 1280.8 479.59 1285.55 479.72"
            fill="#0416bf"
            opacity="0.14"
          />
          <path
            d="M1275.13,482s-.82,2.38-.07,2.55a11.52,11.52,0,0,1-5.21-5.45l.07-2.61S1274,482,1275.13,482Z"
            fill="#0416bf"
            opacity="0.14"
          />
          <path
            d="M1278.35,481.75l-.95.18s.59-.16.45.94A2.61,2.61,0,0,1,1278.35,481.75Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M1276.19,482.09c.1,0-.19,0-1-.88a5.64,5.64,0,0,1-1.15-1.8s2,2.33,1.52,2.66Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M1287.26,478.62a17.55,17.55,0,0,0,0,1.89s.11-1.43-.28-1.67Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M1280,475.1l-1.89-.05c-.14,0,1.48,0,1.87.89l0-.84"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M1287.66,476.15l-1-.45s.55.36.33.43-1.11.44-1.46.25a1.45,1.45,0,0,0-1,0Z"
            fill="#996537"
            opacity="0.51"
          />
        </g>
      </g>
      <g>
        <path
          d="M1270.52,508.26s-1,2.08-2.5,2.43-3.65-1.1-3.31.1-2.74,1.73-4.06,1.4-4.22-3.14-4.2-4S1270.52,508.26,1270.52,508.26Z"
          fill="#131b8c"
          opacity="0.63"
        />
        <g>
          <path
            d="M1270.57,506.56l0,1.7L1268,510l-3.24-.09-.77,1.25s-2.24,1-3.73-.1a12.07,12.07,0,0,1-2.63-3.16l0-1.7Z"
            fill="#ccae79"
          />
          <path
            d="M1268,505.38l2.61,1.18-2.69,1.74-3.1-.09-1,1.28s-3,.82-3.43-.09a18.56,18.56,0,0,0-2.62-3.19l2.44-1Z"
            fill="#ffedc8"
          />
          <polygon
            points="1267.88 508.3 1268.02 510.01 1264.77 509.92 1264.78 508.21 1267.88 508.3"
            fill="#0416bf"
            opacity="0.14"
          />
          <path
            d="M1261.09,509.81s-.54,1.55,0,1.66a7.49,7.49,0,0,1-3.4-3.56l0-1.7S1260.37,509.8,1261.09,509.81Z"
            fill="#0416bf"
            opacity="0.14"
          />
          <path
            d="M1263.18,509.62l-.61.11s.38-.1.29.62A1.7,1.7,0,0,1,1263.18,509.62Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M1261.77,509.84c.07,0-.12,0-.67-.58a3.56,3.56,0,0,1-.75-1.17s1.31,1.52,1,1.74Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M1269,507.57a10.87,10.87,0,0,0,0,1.24s.07-.93-.19-1.09Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M1264.23,505.28l-1.24,0c-.09,0,1,0,1.22.58v-.55"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M1269.25,506l-.65-.29s.37.23.22.28-.72.28-1,.15a1,1,0,0,0-.62,0Z"
            fill="#996537"
            opacity="0.51"
          />
        </g>
      </g>
    </g>
  );
};

export default Trope4;
